var Ru = Object.defineProperty;
var Du = (e, t, n) => t in e ? Ru(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ki = (e, t, n) => Du(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as c, jsxs as x, Fragment as He } from "react/jsx-runtime";
import * as Ln from "react";
import ae, { useState as ie, useRef as xe, useCallback as we, createContext as cr, useMemo as de, forwardRef as bt, useContext as $n, useEffect as te, createElement as Hi, Children as Ro, cloneElement as ec, isValidElement as tc, useId as Xt, useLayoutEffect as Pu, useImperativeHandle as jr, useSyncExternalStore as Iu, memo as Ri } from "react";
import { twJoin as H, twMerge as ee } from "tailwind-merge";
import * as Bu from "react-dom";
import { createPortal as $u } from "react-dom";
function zt({
  value: e,
  defaultValue: t,
  onStateChange: n
} = {}) {
  const [r, i] = ie(t), { current: o } = xe(e != null), a = o ? e : r, s = we(
    (l) => {
      o || i(l), n == null || n(l);
    },
    [o, n, i]
  );
  return [a, s];
}
const aa = cr({
  disabled: !1,
  expanded: !1
});
function q4({
  expanded: e,
  defaultExpanded: t,
  onChange: n,
  className: r,
  disabled: i = !1,
  fluid: o = !1,
  children: a
}) {
  const [s = !1, l] = zt({
    value: e,
    defaultValue: t,
    onStateChange: n
  }), u = we(() => {
    l(!s);
  }, [l, s]), d = de(
    () => ({
      defaultExpanded: t,
      disabled: i,
      expanded: s && !i,
      toggle: i ? void 0 : u
    }),
    [t, s, i, u]
  );
  return /* @__PURE__ */ c(aa.Provider, { value: d, children: /* @__PURE__ */ c("div", { className: H("bbn-accordion", i && "bbn-accordion-disabled", o && "bbn-accordion-fluid", r), children: a }) });
}
const ze = bt(
  ({
    variant: e = "contained",
    size: t = "large",
    color: n = "primary",
    fluid: r = !1,
    rounded: i = !1,
    className: o,
    disabled: a,
    ...s
  }, l) => /* @__PURE__ */ c(
    "button",
    {
      ...s,
      disabled: a,
      ref: l,
      className: H(
        "bbn-btn",
        `bbn-btn-${e}`,
        `bbn-btn-${n}`,
        `bbn-btn-${t}`,
        r && "bbn-btn-fluid",
        i && "bbn-btn-rounded",
        o
      )
    }
  )
);
ze.displayName = "Button";
const sa = bt(
  ({ variant: e = "outlined", size: t = "large", className: n, ...r }, i) => /* @__PURE__ */ c(
    "button",
    {
      ...r,
      ref: i,
      className: H(
        "bbn-btn-icon",
        `bbn-btn-icon-${e}`,
        `bbn-btn-icon-${t}`,
        n
      )
    }
  )
), nc = bt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ c(
    ze,
    {
      ...t,
      ref: n,
      variant: "contained",
      className: ee(
        "!bg-error-main text-white font-medium !text-sm hover:!bg-error-main/90 transition-colors",
        e
      )
    }
  )
);
nc.displayName = "WalletDisconnectButton";
function U4({
  className: e,
  iconClassName: t,
  iconProps: n,
  children: r,
  renderIcon: i = () => null
}) {
  const { expanded: o, toggle: a } = $n(aa), s = i(o);
  return /* @__PURE__ */ x("div", { className: H("bbn-accordion-summary", e), onClick: a, children: [
    r,
    s && /* @__PURE__ */ c(sa, { className: H("bbn-accordion-icon", t), ...n, children: s })
  ] });
}
function la(e, t) {
  return typeof e != "number" ? typeof t == "number" ? la(t) : t : `${e}px`;
}
function Fu(e = !0) {
  const [t, n] = ie("0px"), [r, i] = ie(), o = xe(null);
  return te(() => {
    const a = new ResizeObserver((s) => {
      const [l] = s;
      n(la(l.target.clientHeight) ?? "0px");
    });
    i(a);
  }, []), te(
    function() {
      const { current: s } = o;
      if (!(!e || !s))
        return r == null || r.observe(s), () => {
          r == null || r.unobserve(s);
        };
    },
    [e, r]
  ), { height: t, ref: o };
}
function W4({
  unmountOnExit: e = !1,
  animationDuration: t = 200,
  className: n,
  wrapperClassName: r,
  children: i
}) {
  const { expanded: o } = $n(aa), [a, s] = ie(o), l = a || !e, { height: u, ref: d } = Fu(l);
  return te(
    function() {
      if (o === a)
        return;
      if (o) {
        s(!0);
        return;
      }
      const h = setTimeout(s, t, !1);
      return () => {
        clearTimeout(h);
      };
    },
    [o, a, t]
  ), /* @__PURE__ */ c(
    "div",
    {
      className: H("bbn-accordion-details", r),
      style: {
        height: o ? u : "0px",
        visibility: a ? "visible" : "hidden",
        transitionDuration: `${t}ms`
      },
      children: l ? /* @__PURE__ */ c("div", { ref: d, "data-expanded": o, className: H("bbn-accordion-content", n), children: i }) : null
    }
  );
}
const Q = bt(
  ({ variant: e = "body1", as: t = "p", children: n, className: r, ...i }, o) => Hi(
    t,
    {
      ...i,
      ref: o,
      className: H(`bbn-text-${e}`, r)
    },
    n
  )
);
Q.displayName = "Text";
const qr = bt(
  ({ variant: e, as: t = e, children: n, className: r, ...i }, o) => Hi(
    t,
    {
      ...i,
      ref: o,
      className: H(`bbn-${e}`, r)
    },
    n
  )
);
qr.displayName = "Heading";
function on({ className: e, style: t, size: n = "large", variant: r = "circular", alt: i, url: o, children: a }) {
  return /* @__PURE__ */ c("div", { style: t, className: H("bbn-avatar", `bbn-avatar-${n}`, `bbn-avatar-${r}`, e), children: o ? /* @__PURE__ */ c("img", { className: "bbn-avatar-img", src: o, alt: i }) : a });
}
const zu = ({
  max: e = 1 / 0,
  className: t,
  children: n,
  avatarClassName: r,
  variant: i,
  ...o
}) => {
  const a = Ro.count(n);
  return /* @__PURE__ */ x("div", { className: H("bbn-avatar-group", t), children: [
    Ro.map(
      n,
      (s, l) => tc(s) && l + 1 <= e ? ec(s, {
        ...o,
        className: ee(r, s.props.className),
        variant: i
      }) : null
    ),
    a > e && /* @__PURE__ */ x(on, { size: o.size, variant: i, className: r, children: [
      "+",
      a - e
    ] })
  ] });
};
function Z4({ url: e, name: t, variant: n = "rounded", size: r = "large", ...i }) {
  return /* @__PURE__ */ c(on, { ...i, url: e, alt: t, variant: n, size: r, children: /* @__PURE__ */ c(Q, { as: "span", className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast", children: (t == null ? void 0 : t.charAt(0).toUpperCase()) || "?" }) });
}
function ju(e) {
  if (!e) return "?";
  const t = e.match(/0x([0-9a-fA-F])/);
  return t ? t[1].toUpperCase() : e.charAt(0).toUpperCase();
}
function X4({ url: e, name: t, variant: n = "circular", size: r = "large", ...i }) {
  return /* @__PURE__ */ c(on, { ...i, url: e, alt: t, variant: n, size: r, children: /* @__PURE__ */ c(
    Q,
    {
      as: "span",
      className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast",
      children: ju(t)
    }
  ) });
}
function qu({ url: e, alt: t, background: n, size: r = "large", className: i }) {
  return n ? /* @__PURE__ */ c(
    on,
    {
      url: e,
      alt: t,
      size: r,
      variant: "rounded",
      style: { backgroundColor: n },
      className: ee("bbn-avatar-inset", i)
    }
  ) : /* @__PURE__ */ c(
    on,
    {
      url: e,
      alt: t,
      size: r,
      variant: "rounded",
      className: ee("!overflow-visible object-contain", i)
    }
  );
}
const rc = bt(function({
  label: t,
  checked: n,
  defaultChecked: r = !1,
  inputProps: i,
  orientation: o = "left",
  disabled: a = !1,
  className: s,
  inputType: l,
  labelClassName: u,
  renderIcon: d,
  onChange: f,
  ...h
}, p) {
  const [b = !1, g] = zt({
    value: n,
    defaultValue: r,
    onStateChange: f
  });
  function v(m) {
    var N;
    g(m.currentTarget.checked), (N = i == null ? void 0 : i.onChange) == null || N.call(i, m);
  }
  const w = /* @__PURE__ */ x("span", { className: H("bbn-switcher", a && "bbn-switcher-disabled", s), children: [
    d(b),
    /* @__PURE__ */ c(
      "input",
      {
        ref: p,
        type: l,
        disabled: a,
        className: "bbn-switcher-input",
        "data-testid": l === "checkbox" ? "checkbox-input" : "radio-input",
        ...h,
        ...i,
        checked: b,
        onChange: v
      }
    )
  ] });
  return t ? /* @__PURE__ */ x(
    Q,
    {
      as: "label",
      variant: "body1",
      className: H(
        "bbn-switcher-label",
        o === "left" ? "bbn-switcher-left" : "bbn-switcher-right",
        u
      ),
      children: [
        w,
        t
      ]
    }
  ) : w;
}), Uu = {
  default: {
    color: "fill-current",
    contrastColor: "fill-accent-contrast"
  },
  primary: {
    color: "fill-primary-main",
    contrastColor: "fill-white"
  },
  secondary: {
    color: "fill-secondary-main",
    contrastColor: "fill-black"
  }
}, Wu = (e) => {
  const t = Uu[e];
  return {
    uncheckedBorderClass: "fill-[#8C8C8C]",
    checkedBorderClass: t.color,
    checkedBackgroundClass: t.color,
    checkmarkClass: t.contrastColor
  };
}, Zu = (e) => {
  const t = Wu(e);
  return {
    false: /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ c(
      "path",
      {
        className: t.uncheckedBorderClass,
        d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      }
    ) }),
    true: /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: [
      /* @__PURE__ */ c(
        "path",
        {
          className: t.checkedBorderClass,
          d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
        }
      ),
      /* @__PURE__ */ c(
        "rect",
        {
          className: t.checkedBackgroundClass,
          x: "3",
          y: "3",
          width: "18",
          height: "18",
          rx: "2"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          className: t.checkmarkClass,
          d: "M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
        }
      )
    ] })
  };
}, Xu = bt(function({ variant: t = "default", showLabel: n = !0, label: r, ...i }, o) {
  const a = Zu(t);
  return /* @__PURE__ */ c(
    rc,
    {
      ref: o,
      ...i,
      label: n ? r : void 0,
      inputType: "checkbox",
      renderIcon: (s) => a[s.toString()]
    }
  );
}), Gu = {
  true: /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ c(
    "path",
    {
      d: "M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) }),
  false: /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ c(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) })
}, Yu = bt(function(t, n) {
  return /* @__PURE__ */ c(rc, { ref: n, ...t, inputType: "radio", renderIcon: (r) => Gu[r.toString()] });
});
var ic = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ns = ae.createContext && /* @__PURE__ */ ae.createContext(ic), Ku = ["attr", "size", "title"];
function Ju(e, t) {
  if (e == null) return {};
  var n = Qu(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Qu(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function vi() {
  return vi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vi.apply(this, arguments);
}
function rs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rs(Object(n), !0).forEach(function(r) {
      e0(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function e0(e, t, n) {
  return t = t0(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function t0(e) {
  var t = n0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function n0(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oc(e) {
  return e && e.map((t, n) => /* @__PURE__ */ ae.createElement(t.tag, bi({
    key: n
  }, t.attr), oc(t.child)));
}
function Se(e) {
  return (t) => /* @__PURE__ */ ae.createElement(r0, vi({
    attr: bi({}, e.attr)
  }, t), oc(e.child));
}
function r0(e) {
  var t = (n) => {
    var {
      attr: r,
      size: i,
      title: o
    } = e, a = Ju(e, Ku), s = i || n.size || "1em", l;
    return n.className && (l = n.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ ae.createElement("svg", vi({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, a, {
      className: l,
      style: bi(bi({
        color: e.color || n.color
      }, n.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ ae.createElement("title", null, o), e.children);
  };
  return ns !== void 0 ? /* @__PURE__ */ ae.createElement(ns.Consumer, null, (n) => t(n)) : t(ic);
}
function i0(e) {
  return Se({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 16L6 10H18L12 16Z" }, child: [] }] })(e);
}
function ac(e) {
  return Se({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" }, child: [] }] })(e);
}
function o0(e) {
  return Se({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 8L18 14H6L12 8Z" }, child: [] }] })(e);
}
function a0(e) {
  return Se({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z" }, child: [] }] })(e);
}
function s0(e) {
  return Se({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z" }, child: [] }] })(e);
}
const Nr = ({
  children: e,
  className: t = "",
  size: n = 40,
  variant: r = "default",
  background: i = !1,
  rounded: o = !1
}) => {
  const a = {
    default: "text-accent-secondary",
    primary: "text-primary-light",
    secondary: "text-accent-secondary",
    error: "text-error-main",
    success: "text-success-main",
    "accent-primary": "text-accent-primary",
    "accent-secondary": "text-accent-secondary"
  };
  return /* @__PURE__ */ c(
    "div",
    {
      className: H(
        "flex items-center justify-center",
        i && {
          default: "bg-accent-secondary/10",
          primary: "bg-primary-light/10 dark:bg-[#47484A]",
          secondary: "bg-accent-secondary/10",
          error: "bg-error-main/10",
          success: "bg-success-main/10",
          "accent-primary": "bg-accent-primary/10",
          "accent-secondary": "bg-accent-secondary/10"
        }[r],
        o && "rounded-full",
        i ? "[&_svg]:h-4 [&_svg]:w-auto" : "[&_svg]:w-full [&_svg]:h-full",
        "[&_svg_path]:fill-current",
        i && "dark:[&_svg_path]:fill-white",
        a[r],
        t
      ),
      style: { width: n, height: n },
      children: e
    }
  );
}, sc = ({
  className: e = "",
  size: t = 24,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t * 0.545 },
      viewBox: "0 0 22 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c("path", { d: "M20 4H11.65C10.83 1.67 8.61 0 6 0C2.69 0 0 2.69 0 6C0 9.31 2.69 12 6 12C8.61 12 10.83 10.33 11.65 8H12L14 10L16 8L18 10L22 5.96L20 4ZM6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9Z", fill: "currentColor" })
    }
  );
}, l0 = ({
  className: e = "",
  size: t = 24,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t * 0.5 },
      viewBox: "0 0 20 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c("path", { d: "M15 0H11V2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM9 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8ZM6 4H14V6H6V4Z", fill: "currentColor" })
    }
  );
}, lc = ({
  className: e = "",
  size: t = 24,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ x(
    "svg",
    {
      style: { width: t, height: t * 1 },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ c("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z", fill: "currentColor" })
      ]
    }
  );
}, Er = ({
  className: e = "",
  size: t = 16,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t * 1.143 },
      viewBox: "0 0 14 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M9.99984 0.666626H1.99984C1.2665 0.666626 0.666504 1.26663 0.666504 1.99996V11.3333H1.99984V1.99996H9.99984V0.666626ZM11.9998 3.33329H4.6665C3.93317 3.33329 3.33317 3.93329 3.33317 4.66663V14C3.33317 14.7333 3.93317 15.3333 4.6665 15.3333H11.9998C12.7332 15.3333 13.3332 14.7333 13.3332 14V4.66663C13.3332 3.93329 12.7332 3.33329 11.9998 3.33329ZM11.9998 14H4.6665V4.66663H11.9998V14Z",
          fill: "currentColor"
        }
      )
    }
  );
}, Fn = ({
  className: e = "",
  size: t = 14,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
          fill: "currentColor"
        }
      )
    }
  );
}, cc = ({
  className: e = "",
  size: t = 22,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n], o = 22 / 20;
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t * o },
      viewBox: "0 0 22 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M0 19.5H22L11 0.5L0 19.5ZM12 16.5H10V14.5H12V16.5ZM12 12.5H10V8.5H12V12.5Z",
          fill: "currentColor"
        }
      )
    }
  );
}, c0 = ({
  className: e = "",
  size: t = 20,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ x(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "3.5",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14.0832 10.5846H5.9165V9.41797H14.0832V10.5846Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}, u0 = ({
  className: e = "",
  size: t = 20,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ x(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "3.5",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14 10.5714H10.5714V14H9.42857V10.5714H6V9.42857H9.42857V6H10.5714V9.42857H14V10.5714Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}, d0 = ({
  className: e = "",
  size: t = 16,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M10 12L6 8L10 4",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}, G4 = ({
  className: e = "",
  size: t = 16,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H(
        "transition-opacity duration-200",
        i,
        e
      ),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M6 4L10 8L6 12",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}, Y4 = ({
  className: e = "",
  size: t = 16,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c("path", { d: "M12.73 0H5.27L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0ZM9 14.3C8.28 14.3 7.7 13.72 7.7 13C7.7 12.28 8.28 11.7 9 11.7C9.72 11.7 10.3 12.28 10.3 13C10.3 13.72 9.72 14.3 9 14.3ZM10 10H8V4H10V10Z", fill: "currentColor" })
    }
  );
}, f0 = ({
  className: e = "",
  size: t = 40,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ x(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", e),
      children: [
        /* @__PURE__ */ c("rect", { width: "40", height: "40", rx: "20", fill: "currentColor", fillOpacity: "0.12" }),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30ZM21 12.07C24.94 12.56 28 15.92 28 20C28 24.08 24.95 27.44 21 27.93V12.07Z",
            fill: "currentColor",
            className: i
          }
        )
      ]
    }
  );
}, h0 = ({
  className: e = "",
  size: t = 20,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H(
        "transition-opacity duration-200",
        i,
        e
      ),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M4.99967 8.33203C4.08301 8.33203 3.33301 9.08203 3.33301 9.9987C3.33301 10.9154 4.08301 11.6654 4.99967 11.6654C5.91634 11.6654 6.66634 10.9154 6.66634 9.9987C6.66634 9.08203 5.91634 8.33203 4.99967 8.33203ZM14.9997 8.33203C14.083 8.33203 13.333 9.08203 13.333 9.9987C13.333 10.9154 14.083 11.6654 14.9997 11.6654C15.9163 11.6654 16.6663 10.9154 16.6663 9.9987C16.6663 9.08203 15.9163 8.33203 14.9997 8.33203ZM9.99967 8.33203C9.08301 8.33203 8.33301 9.08203 8.33301 9.9987C8.33301 10.9154 9.08301 11.6654 9.99967 11.6654C10.9163 11.6654 11.6663 10.9154 11.6663 9.9987C11.6663 9.08203 10.9163 8.33203 9.99967 8.33203Z",
          fill: "currentColor"
        }
      )
    }
  );
}, mn = ({
  className: e = "",
  size: t = 14,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      style: { width: t, height: t * 1 },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M6.33325 3.66634H7.66659V4.99967H6.33325V3.66634ZM6.33325 6.33301H7.66659V10.333H6.33325V6.33301ZM6.99992 0.333008C3.31992 0.333008 0.333252 3.31967 0.333252 6.99967C0.333252 10.6797 3.31992 13.6663 6.99992 13.6663C10.6799 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.6799 0.333008 6.99992 0.333008ZM6.99992 12.333C4.05992 12.333 1.66659 9.93967 1.66659 6.99967C1.66659 4.05967 4.05992 1.66634 6.99992 1.66634C9.93992 1.66634 12.3333 4.05967 12.3333 6.99967C12.3333 9.93967 9.93992 12.333 6.99992 12.333Z",
          fill: "currentColor"
        }
      )
    }
  );
}, is = ({
  className: e = "",
  size: t = 14,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ x(
    "svg",
    {
      style: { width: t, height: t * 1 },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ c("rect", { x: "3", y: "2", width: "2.5", height: "10", rx: "1", fill: "currentColor" }),
        /* @__PURE__ */ c("rect", { x: "8.5", y: "2", width: "2.5", height: "10", rx: "1", fill: "currentColor" })
      ]
    }
  );
}, uc = ({
  className: e = "",
  size: t = 16,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z",
          fill: "currentColor"
        }
      )
    }
  );
}, K4 = ({
  className: e = "",
  size: t = 18,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M0 14V16H6V14H0ZM0 2V4H10V2H0ZM10 18V16H18V14H10V12H8V18H10ZM4 6V8H0V10H4V12H6V6H4ZM18 10V8H8V10H18ZM12 6H14V4H18V2H14V0H12V6Z",
          fill: "currentColor"
        }
      )
    }
  );
};
function J4({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ c("g", { transform: "translate(3, 3)", children: /* @__PURE__ */ c("path", { d: "M0 0V8H8V0H0ZM6 6H2V2H6V6ZM0 10V18H8V10H0ZM6 16H2V12H6V16ZM10 0V8H18V0H10ZM16 6H12V2H16V6ZM10 10V18H18V10H10ZM16 16H12V12H16V16Z", fill: "currentColor" }) })
    }
  );
}
function Q4({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ x("g", { transform: "translate(4, 1)", children: [
        /* @__PURE__ */ c("path", { d: "M2 19V9H14V10C14.7 10 15.37 10.1 16 10.29V9C16 7.9 15.1 7 14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H8.26C7.84 20.4 7.51 19.72 7.29 19H2ZM5 5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5V7H5V5Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { d: "M14 12C11.24 12 9 14.24 9 17C9 19.76 11.24 22 14 22C16.76 22 19 19.76 19 17C19 14.24 16.76 12 14 12ZM15.65 19.35L13.5 17.2V14H14.5V16.79L16.35 18.64L15.65 19.35Z", fill: "currentColor" })
      ] })
    }
  );
}
function e8({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ c("g", { transform: "translate(6.32, 3)", children: /* @__PURE__ */ c("path", { d: "M5.48 7.9C3.21 7.31 2.48 6.7 2.48 5.75C2.48 4.66 3.49 3.9 5.18 3.9C6.96 3.9 7.62 4.75 7.68 6H9.89C9.82 4.28 8.77 2.7 6.68 2.19V0H3.68V2.16C1.74 2.58 0.18 3.84 0.18 5.77C0.18 8.08 2.09 9.23 4.88 9.9C7.38 10.5 7.88 11.38 7.88 12.31C7.88 13 7.39 14.1 5.18 14.1C3.12 14.1 2.31 13.18 2.2 12H0C0.12 14.19 1.76 15.42 3.68 15.83V18H6.68V15.85C8.63 15.48 10.18 14.35 10.18 12.3C10.18 9.46 7.75 8.49 5.48 7.9Z", fill: "currentColor" }) })
    }
  );
}
function t8({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ c("path", { d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z", fill: "currentColor" })
    }
  );
}
function n8({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ c("g", { transform: "translate(3, 4)", children: /* @__PURE__ */ c("path", { d: "M15 0H18V16H15V0ZM0 9H3V16H0V9ZM11 0H14V3H11V0ZM7 1H10V5H7V1ZM4 6H7V10H4V6Z", fill: "currentColor" }) })
    }
  );
}
function r8({ size: e = 24, className: t }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      className: t,
      children: /* @__PURE__ */ c("g", { transform: "translate(2, 2)", children: /* @__PURE__ */ c("path", { d: "M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14V14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6V6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.4 13.65 15.19 13.97 14H16.92C15.96 15.66 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.64 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z", fill: "currentColor" }) })
    }
  );
}
function i8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M8.00065 1.3335C7.12517 1.3335 6.25826 1.50593 5.44943 1.84097C4.64059 2.176 3.90566 2.66706 3.28661 3.28612C2.03636 4.53636 1.33398 6.23205 1.33398 8.00016C1.33398 10.9468 3.24732 13.4468 5.89398 14.3335C6.22732 14.3868 6.33398 14.1802 6.33398 14.0002V12.8735C4.48732 13.2735 4.09398 11.9802 4.09398 11.9802C3.78732 11.2068 3.35398 11.0002 3.35398 11.0002C2.74732 10.5868 3.40065 10.6002 3.40065 10.6002C4.06732 10.6468 4.42065 11.2868 4.42065 11.2868C5.00065 12.3002 5.98065 12.0002 6.36065 11.8402C6.42065 11.4068 6.59398 11.1135 6.78065 10.9468C5.30065 10.7802 3.74732 10.2068 3.74732 7.66683C3.74732 6.92683 4.00065 6.3335 4.43398 5.86016C4.36732 5.6935 4.13398 5.00016 4.50065 4.10016C4.50065 4.10016 5.06065 3.92016 6.33398 4.78016C6.86065 4.6335 7.43398 4.56016 8.00065 4.56016C8.56732 4.56016 9.14065 4.6335 9.66732 4.78016C10.9407 3.92016 11.5007 4.10016 11.5007 4.10016C11.8673 5.00016 11.634 5.6935 11.5673 5.86016C12.0007 6.3335 12.254 6.92683 12.254 7.66683C12.254 10.2135 10.694 10.7735 9.20732 10.9402C9.44732 11.1468 9.66732 11.5535 9.66732 12.1735V14.0002C9.66732 14.1802 9.77398 14.3935 10.114 14.3335C12.7607 13.4402 14.6673 10.9468 14.6673 8.00016C14.6673 7.12468 14.4949 6.25778 14.1598 5.44894C13.8248 4.6401 13.3338 3.90517 12.7147 3.28612C12.0956 2.66706 11.3607 2.176 10.5519 1.84097C9.74304 1.50593 8.87613 1.3335 8.00065 1.3335Z", fill: "currentColor" })
      ]
    }
  );
}
function o8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M8.00065 1.3335C4.32065 1.3335 1.33398 4.32016 1.33398 8.00016C1.33398 11.6802 4.32065 14.6668 8.00065 14.6668C11.6807 14.6668 14.6673 11.6802 14.6673 8.00016C14.6673 4.32016 11.6807 1.3335 8.00065 1.3335ZM11.094 5.86683C10.994 6.92016 10.5607 9.48016 10.3407 10.6602C10.2473 11.1602 10.0607 11.3268 9.88732 11.3468C9.50065 11.3802 9.20732 11.0935 8.83398 10.8468C8.24732 10.4602 7.91398 10.2202 7.34732 9.84683C6.68732 9.4135 7.11398 9.1735 7.49398 8.78683C7.59398 8.68683 9.30065 7.1335 9.33398 6.9935C9.33861 6.97229 9.338 6.95028 9.33219 6.92936C9.32638 6.90845 9.31555 6.88927 9.30065 6.8735C9.26065 6.84016 9.20732 6.8535 9.16065 6.86016C9.10065 6.8735 8.16732 7.4935 6.34732 8.72016C6.08065 8.90016 5.84065 8.9935 5.62732 8.98683C5.38732 8.98016 4.93398 8.8535 4.59398 8.74016C4.17398 8.60683 3.84732 8.5335 3.87398 8.30016C3.88732 8.18016 4.05398 8.06016 4.36732 7.9335C6.31398 7.08683 7.60732 6.52683 8.25398 6.26016C10.1073 5.48683 10.4873 5.3535 10.7407 5.3535C10.794 5.3535 10.9207 5.36683 11.0007 5.4335C11.0673 5.48683 11.0873 5.56016 11.094 5.6135C11.0873 5.6535 11.1007 5.7735 11.094 5.86683Z", fill: "currentColor" })
      ]
    }
  );
}
function a8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M12.6667 2C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667ZM12.3333 12.3333V8.8C12.3333 8.2236 12.1044 7.6708 11.6968 7.26322C11.2892 6.85564 10.7364 6.62667 10.16 6.62667C9.59333 6.62667 8.93333 6.97333 8.61333 7.49333V6.75333H6.75333V12.3333H8.61333V9.04667C8.61333 8.53333 9.02667 8.11333 9.54 8.11333C9.78754 8.11333 10.0249 8.21167 10.2 8.3867C10.375 8.56173 10.4733 8.79913 10.4733 9.04667V12.3333H12.3333ZM4.58667 5.70667C4.88371 5.70667 5.16859 5.58867 5.37863 5.37863C5.58867 5.16859 5.70667 4.88371 5.70667 4.58667C5.70667 3.96667 5.20667 3.46 4.58667 3.46C4.28786 3.46 4.00128 3.5787 3.78999 3.78999C3.5787 4.00128 3.46 4.28786 3.46 4.58667C3.46 5.20667 3.96667 5.70667 4.58667 5.70667ZM5.51333 12.3333V6.75333H3.66667V12.3333H5.51333Z", fill: "currentColor" })
      ]
    }
  );
}
function s8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M2.66732 13.3332C2.30065 13.3332 1.98687 13.2027 1.72598 12.9418C1.4651 12.6809 1.33443 12.3669 1.33398 11.9998V3.99984C1.33398 3.63317 1.46465 3.31939 1.72598 3.0585C1.98732 2.79761 2.3011 2.66695 2.66732 2.6665H13.334C13.7007 2.6665 14.0147 2.79717 14.276 3.0585C14.5373 3.31984 14.6678 3.63362 14.6673 3.99984V11.9998C14.6673 12.3665 14.5369 12.6805 14.276 12.9418C14.0151 13.2032 13.7011 13.3336 13.334 13.3332H2.66732ZM8.00065 8.6665L13.334 5.33317V3.99984L8.00065 7.33317L2.66732 3.99984V5.33317L8.00065 8.6665Z", fill: "currentColor" })
      ]
    }
  );
}
function l8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M12.8474 3.55317C11.9607 3.13984 11.0007 2.83984 10.0007 2.6665C9.98314 2.66675 9.96637 2.67394 9.95406 2.6865C9.83406 2.9065 9.69406 3.19317 9.60073 3.41317C8.54005 3.25327 7.4614 3.25327 6.40073 3.41317C6.3074 3.1865 6.1674 2.9065 6.04073 2.6865C6.03406 2.67317 6.01406 2.6665 5.99406 2.6665C4.99406 2.83984 4.04073 3.13984 3.1474 3.55317C3.14073 3.55317 3.13406 3.55984 3.1274 3.5665C1.31406 6.27984 0.814063 8.91984 1.06073 11.5332C1.06073 11.5465 1.0674 11.5598 1.08073 11.5665C2.28073 12.4465 3.43406 12.9798 4.57406 13.3332C4.59406 13.3398 4.61406 13.3332 4.62073 13.3198C4.8874 12.9532 5.1274 12.5665 5.33406 12.1598C5.3474 12.1332 5.33406 12.1065 5.3074 12.0998C4.9274 11.9532 4.5674 11.7798 4.21406 11.5798C4.1874 11.5665 4.1874 11.5265 4.2074 11.5065C4.28073 11.4532 4.35406 11.3932 4.4274 11.3398C4.44073 11.3265 4.46073 11.3265 4.47406 11.3332C6.7674 12.3798 9.24073 12.3798 11.5074 11.3332C11.5207 11.3265 11.5407 11.3265 11.5541 11.3398C11.6274 11.3998 11.7007 11.4532 11.7741 11.5132C11.8007 11.5332 11.8007 11.5732 11.7674 11.5865C11.4207 11.7932 11.0541 11.9598 10.6741 12.1065C10.6474 12.1132 10.6407 12.1465 10.6474 12.1665C10.8607 12.5732 11.1007 12.9598 11.3607 13.3265C11.3807 13.3332 11.4007 13.3398 11.4207 13.3332C12.5674 12.9798 13.7207 12.4465 14.9207 11.5665C14.9341 11.5598 14.9407 11.5465 14.9407 11.5332C15.2341 8.51317 14.4541 5.89317 12.8741 3.5665C12.8674 3.55984 12.8607 3.55317 12.8474 3.55317ZM5.68073 9.93984C4.99406 9.93984 4.42073 9.3065 4.42073 8.5265C4.42073 7.7465 4.98073 7.11317 5.68073 7.11317C6.3874 7.11317 6.9474 7.75317 6.94073 8.5265C6.94073 9.3065 6.38073 9.93984 5.68073 9.93984ZM10.3274 9.93984C9.64073 9.93984 9.0674 9.3065 9.0674 8.5265C9.0674 7.7465 9.6274 7.11317 10.3274 7.11317C11.0341 7.11317 11.5941 7.75317 11.5874 8.5265C11.5874 9.3065 11.0341 9.93984 10.3274 9.93984Z", fill: "currentColor" })
      ]
    }
  );
}
function c8({ size: e = 16, className: t, title: n }) {
  return /* @__PURE__ */ x(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 14 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": n ? void 0 : !0,
      role: n ? "img" : void 0,
      className: t,
      children: [
        n ? /* @__PURE__ */ c("title", { children: n }) : null,
        /* @__PURE__ */ c("path", { d: "M11.025 0H13.172L8.482 5.0826L14 12H9.68L6.294 7.80549L2.424 12H0.275L5.291 6.56179L0 0.000945763H4.43L7.486 3.83417L11.025 0ZM10.27 10.7818H11.46L3.78 1.15479H2.504L10.27 10.7818Z", fill: "currentColor" })
      ]
    }
  );
}
const u8 = ({
  className: e = "",
  size: t = 24,
  variant: n = "default",
  color: r
}) => {
  const i = r || Je[n];
  return /* @__PURE__ */ c(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: H("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z",
          fill: "currentColor"
        }
      )
    }
  );
}, Je = {
  default: "text-accent-primary",
  primary: "text-primary-light",
  secondary: "text-accent-secondary",
  error: "text-error-main",
  success: "text-success-main",
  "accent-primary": "text-accent-primary",
  "accent-secondary": "text-accent-secondary",
  danger: "text-error-main"
}, dc = cr({
  portalContainer: null
}), fc = () => $n(dc);
function d8({
  children: e,
  portalContainer: t = null
}) {
  return /* @__PURE__ */ c(dc.Provider, { value: { portalContainer: t }, children: e });
}
function Ur({
  children: e,
  mounted: t = !1,
  rootClassName: n = "portal-root",
  inheritViewport: r = !0,
  pointerEvents: i = "auto"
}) {
  const [o, a] = ie(null), { portalContainer: s } = fc(), l = i === "none";
  return te(() => {
    if (!t) {
      a(null);
      return;
    }
    const u = document.createElement("div");
    if (u.className = n, r)
      if (n.includes("popover"))
        u.style.zIndex = "9999", u.style.pointerEvents = l ? "none" : "auto";
      else {
        const f = {
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          pointerEvents: l ? "none" : "auto"
        };
        Object.assign(u.style, f);
      }
    const d = s || document.body;
    return d.appendChild(u), a(u), () => {
      d.contains(u) && d.removeChild(u);
    };
  }, [t, n, r, l, s]), o ? $u(e, o) : null;
}
const p0 = "Escape", hc = cr({
  removeDialog: () => null,
  updateDialog: () => null
});
function f8({ children: e }) {
  const [t, n] = ie({}), r = xe(/* @__PURE__ */ new Map()), i = xe(0), o = de(() => Object.keys(t).length > 0, [t]);
  te(
    function() {
      if (o) {
        const d = document.body.offsetWidth;
        document.body.style.overflow = "hidden", document.body.style.paddingRight = document.body.offsetWidth - d >= 1 ? la(document.body.offsetWidth - d) ?? "" : document.body.style.paddingRight;
      } else
        document.body.style.overflow = "", document.body.style.paddingRight = "";
    },
    [o]
  ), te(function() {
    const d = (f) => {
      if (f.key !== p0 || f.defaultPrevented) return;
      let h;
      for (const p of r.current.values())
        p.open && (!h || p.order > h.order) && (h = p);
      h != null && h.onClose && !h.disableEscapeClose && (f.preventDefault(), h.onClose());
    };
    return document.addEventListener("keydown", d), () => document.removeEventListener("keydown", d);
  }, []);
  const a = we((u) => {
    r.current.delete(u), n((d) => {
      if (!(u in d)) return d;
      const f = { ...d };
      return delete f[u], f;
    });
  }, []), s = we((u, { open: d, visible: f, onClose: h, disableEscapeClose: p }) => {
    const b = r.current.get(u), g = (b == null ? void 0 : b.visible) ?? !1, v = f && !g ? i.current += 1 : (b == null ? void 0 : b.order) ?? 0;
    r.current.set(u, { open: d, visible: f, onClose: h, disableEscapeClose: p, order: v }), g !== f && n((w) => {
      if (f) return { ...w, [u]: !0 };
      if (!(u in w)) return w;
      const m = { ...w };
      return delete m[u], m;
    });
  }, []), l = de(() => ({ removeDialog: a, updateDialog: s }), [a, s]);
  return /* @__PURE__ */ c(hc.Provider, { value: l, children: e });
}
function Wr({ open: e = !1, onClose: t, disableEscapeClose: n } = {}) {
  const r = Xt(), [i, o] = ie(e), { updateDialog: a, removeDialog: s } = $n(hc), l = e || i;
  te(
    () => () => {
      s(r);
    },
    [r]
  ), te(() => {
    a(r, { open: e, visible: l, onClose: t, disableEscapeClose: n });
  }, [r, e, l, t, n, a]), te(() => {
    e && o(!0);
  }, [e]);
  const u = we(() => {
    e || o(!1);
  }, [e]);
  return {
    mounted: i,
    unmount: u
  };
}
const ca = ({ open: e = !1, ...t }) => /* @__PURE__ */ c(
  "div",
  {
    ...t,
    className: H("bbn-backdrop", e ? "animate-backdrop-in" : "animate-backdrop-out", t.className)
  }
), Zr = ({
  children: e,
  open: t = !1,
  className: n,
  onClose: r,
  hasBackdrop: i = !0,
  backdropClassName: o,
  dialogClassName: a,
  disableEscapeClose: s,
  ...l
}) => {
  const { mounted: u, unmount: d } = Wr({ open: t, onClose: r, disableEscapeClose: s });
  return /* @__PURE__ */ x(Ur, { mounted: u, children: [
    /* @__PURE__ */ c("div", { "data-testid": "dialog-wrapper", ...l, className: H("bbn-dialog-wrapper", n), children: /* @__PURE__ */ c(
      "div",
      {
        className: H("bbn-dialog", t ? "animate-modal-in" : "animate-modal-out", a),
        onAnimationEnd: d,
        role: "dialog",
        "data-testid": "dialog",
        children: e
      }
    ) }),
    i && /* @__PURE__ */ c(ca, { className: o, open: t, onClick: r })
  ] });
}, h8 = ({
  children: e,
  open: t = !1,
  className: n,
  onClose: r,
  onBack: i,
  disableEscapeClose: o,
  actions: a,
  closeButtonClassName: s,
  actionsClassName: l,
  ...u
}) => {
  const { mounted: d, unmount: f } = Wr({ open: t, onClose: r, disableEscapeClose: o });
  return /* @__PURE__ */ x(Ur, { mounted: d, children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: H(
          "bbn-dialog-fullscreen",
          t ? "animate-modal-in" : "animate-modal-out"
        ),
        onAnimationEnd: f,
        children: [
          i ? /* @__PURE__ */ c(
            "button",
            {
              onClick: i,
              className: ee(
                "fixed top-4 left-4 z-10 flex size-10 items-center justify-center text-accent-primary transition-colors hover:text-secondary-main",
                s
              ),
              "aria-label": "Back",
              children: /* @__PURE__ */ c(d0, { size: 20, color: "text-inherit" })
            }
          ) : r && /* @__PURE__ */ c(
            "button",
            {
              onClick: r,
              className: ee(
                "fixed top-4 left-4 z-10 flex h-8 w-8 items-center justify-center before:absolute before:-inset-1 before:content-['']",
                s
              ),
              "aria-label": "Close",
              children: /* @__PURE__ */ c(Fn, { size: 16, variant: "accent-primary" })
            }
          ),
          a && /* @__PURE__ */ c(
            "div",
            {
              className: ee(
                "fixed top-4 right-4 z-10 flex items-center",
                l
              ),
              children: a
            }
          ),
          /* @__PURE__ */ c(
            "div",
            {
              ...u,
              className: H("flex min-h-full w-full flex-col", n),
              children: e
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c(ca, { open: t, onClick: r })
  ] });
}, yn = ({
  children: e,
  open: t = !1,
  className: n,
  onClose: r,
  disableEscapeClose: i,
  handle: o = !1,
  backdropClassName: a,
  ...s
}) => {
  const { mounted: l, unmount: u } = Wr({ open: t, onClose: r, disableEscapeClose: i });
  return /* @__PURE__ */ x(Ur, { mounted: l, children: [
    /* @__PURE__ */ x(
      "div",
      {
        ...s,
        className: H(
          "bbn-dialog-mobile",
          t ? "animate-mobile-modal-in" : "animate-mobile-modal-out",
          n
        ),
        onAnimationEnd: u,
        children: [
          o && /* @__PURE__ */ c(
            "span",
            {
              "aria-hidden": "true",
              className: "absolute left-1/2 top-1.5 h-[3px] w-6 -translate-x-1/2 rounded-full bg-accent-primary opacity-[0.24]"
            }
          ),
          r && /* @__PURE__ */ c(
            "button",
            {
              onClick: r,
              className: o ? "sr-only" : "absolute top-4 left-4 z-10 p-1.5 rounded-full bg-surface-tertiary hover:bg-surface-quaternary transition-colors before:absolute before:-inset-[7px] before:content-['']",
              "aria-label": "Close",
              children: /* @__PURE__ */ c(Fn, { size: 14, variant: "accent-primary" })
            }
          ),
          e
        ]
      }
    ),
    /* @__PURE__ */ c(ca, { open: t, onClick: r, className: a })
  ] });
};
var ri = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Di(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ji, os;
function m0() {
  if (os) return Ji;
  os = 1;
  var e = "Expected a function", t = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt, l = typeof ri == "object" && ri && ri.Object === Object && ri, u = typeof self == "object" && self && self.Object === Object && self, d = l || u || Function("return this")(), f = Object.prototype, h = f.toString, p = Math.max, b = Math.min, g = function() {
    return d.Date.now();
  };
  function v(y, L, T) {
    var S, R, V, A, E, P, U = 0, D = !1, z = !1, I = !0;
    if (typeof y != "function")
      throw new TypeError(e);
    L = M(L) || 0, m(T) && (D = !!T.leading, z = "maxWait" in T, V = z ? p(M(T.maxWait) || 0, L) : V, I = "trailing" in T ? !!T.trailing : I);
    function Y(re) {
      var $ = S, oe = R;
      return S = R = void 0, U = re, A = y.apply(oe, $), A;
    }
    function Z(re) {
      return U = re, E = setTimeout(Me, L), D ? Y(re) : A;
    }
    function ne(re) {
      var $ = re - P, oe = re - U, pe = L - $;
      return z ? b(pe, V - oe) : pe;
    }
    function fe(re) {
      var $ = re - P, oe = re - U;
      return P === void 0 || $ >= L || $ < 0 || z && oe >= V;
    }
    function Me() {
      var re = g();
      if (fe(re))
        return Ce(re);
      E = setTimeout(Me, ne(re));
    }
    function Ce(re) {
      return E = void 0, I && S ? Y(re) : (S = R = void 0, A);
    }
    function ke() {
      E !== void 0 && clearTimeout(E), U = 0, S = P = R = E = void 0;
    }
    function he() {
      return E === void 0 ? A : Ce(g());
    }
    function X() {
      var re = g(), $ = fe(re);
      if (S = arguments, R = this, P = re, $) {
        if (E === void 0)
          return Z(P);
        if (z)
          return E = setTimeout(Me, L), Y(P);
      }
      return E === void 0 && (E = setTimeout(Me, L)), A;
    }
    return X.cancel = ke, X.flush = he, X;
  }
  function w(y, L, T) {
    var S = !0, R = !0;
    if (typeof y != "function")
      throw new TypeError(e);
    return m(T) && (S = "leading" in T ? !!T.leading : S, R = "trailing" in T ? !!T.trailing : R), v(y, L, {
      leading: S,
      maxWait: L,
      trailing: R
    });
  }
  function m(y) {
    var L = typeof y;
    return !!y && (L == "object" || L == "function");
  }
  function N(y) {
    return !!y && typeof y == "object";
  }
  function C(y) {
    return typeof y == "symbol" || N(y) && h.call(y) == n;
  }
  function M(y) {
    if (typeof y == "number")
      return y;
    if (C(y))
      return t;
    if (m(y)) {
      var L = typeof y.valueOf == "function" ? y.valueOf() : y;
      y = m(L) ? L + "" : L;
    }
    if (typeof y != "string")
      return y === 0 ? y : +y;
    y = y.replace(r, "");
    var T = o.test(y);
    return T || a.test(y) ? s(y.slice(2), T ? 2 : 8) : i.test(y) ? t : +y;
  }
  return Ji = w, Ji;
}
var g0 = m0();
const pc = /* @__PURE__ */ Di(g0);
function Gt(e = 768, t = 100) {
  const [n, r] = ie(() => typeof window < "u" ? window.innerWidth < e : !1), i = xe(), o = we(() => {
    r(window.innerWidth < e);
  }, [e]);
  return te(() => (i.current = pc(o, t), o(), window.addEventListener("resize", i.current), () => {
    i.current && (window.removeEventListener("resize", i.current), i.current.cancel());
  }), [o, t]), n;
}
function mc({ className: e, ...t }) {
  const r = Gt() ? yn : Zr;
  return /* @__PURE__ */ c(r, { ...t, className: ee("w-[41.25rem] max-w-full", e) });
}
const Xr = ({ className: e, children: t, title: n, onClose: r }) => /* @__PURE__ */ x("div", { className: H("bbn-dialog-header", e), "data-testid": "dialog-header", children: [
  /* @__PURE__ */ x("div", { className: "bbn-dialog-title", children: [
    /* @__PURE__ */ c(qr, { variant: "h5", children: n }),
    !!r && /* @__PURE__ */ c(sa, { className: "shrink-0", onClick: r, "data-testid": "dialog-close-button", children: /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ c(
      "path",
      {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
      }
    ) }) })
  ] }),
  t
] }), ur = (e) => /* @__PURE__ */ c("div", { ...e, className: H("bbn-dialog-body", e.className) }), dr = (e) => /* @__PURE__ */ c("div", { ...e, className: H("bbn-dialog-footer", e.className) }), gc = "(pointer: coarse) and (hover: none)", vc = () => typeof window < "u" && typeof window.matchMedia == "function", v0 = () => vc() && window.matchMedia(gc).matches;
function bc() {
  const [e, t] = ie(v0);
  return te(() => {
    if (!vc()) return;
    const n = window.matchMedia(gc), r = () => t(n.matches);
    return n.addEventListener("change", r), () => n.removeEventListener("change", r);
  }, []), e;
}
const Qn = Math.min, Sn = Math.max, yi = Math.round, ii = Math.floor, It = (e) => ({
  x: e,
  y: e
}), b0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, y0 = {
  start: "end",
  end: "start"
};
function Do(e, t, n) {
  return Sn(e, Qn(t, n));
}
function Gr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Hn(e) {
  return e.split("-")[0];
}
function Yr(e) {
  return e.split("-")[1];
}
function yc(e) {
  return e === "x" ? "y" : "x";
}
function ua(e) {
  return e === "y" ? "height" : "width";
}
const x0 = /* @__PURE__ */ new Set(["top", "bottom"]);
function pn(e) {
  return x0.has(Hn(e)) ? "y" : "x";
}
function da(e) {
  return yc(pn(e));
}
function C0(e, t, n) {
  n === void 0 && (n = !1);
  const r = Yr(e), i = da(e), o = ua(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = xi(a)), [a, xi(a)];
}
function w0(e) {
  const t = xi(e);
  return [Po(e), t, Po(t)];
}
function Po(e) {
  return e.replace(/start|end/g, (t) => y0[t]);
}
const as = ["left", "right"], ss = ["right", "left"], N0 = ["top", "bottom"], _0 = ["bottom", "top"];
function M0(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? ss : as : t ? as : ss;
    case "left":
    case "right":
      return t ? N0 : _0;
    default:
      return [];
  }
}
function L0(e, t, n, r) {
  const i = Yr(e);
  let o = M0(Hn(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(Po)))), o;
}
function xi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => b0[t]);
}
function A0(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function xc(e) {
  return typeof e != "number" ? A0(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ci(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function ls(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = pn(t), a = da(t), s = ua(a), l = Hn(t), u = o === "y", d = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, h = r[s] / 2 - i[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Yr(t)) {
    case "start":
      p[a] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      p[a] += h * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const E0 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: f
  } = ls(u, r, l), h = r, p = {}, b = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: v,
      fn: w
    } = s[g], {
      x: m,
      y: N,
      data: C,
      reset: M
    } = await w({
      x: d,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: p,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = m ?? d, f = N ?? f, p = {
      ...p,
      [v]: {
        ...p[v],
        ...C
      }
    }, M && b <= 50 && (b++, typeof M == "object" && (M.placement && (h = M.placement), M.rects && (u = M.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : M.rects), {
      x: d,
      y: f
    } = ls(u, h, l)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: h,
    strategy: i,
    middlewareData: p
  };
};
async function Cc(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = Gr(t, e), b = xc(p), v = s[h ? f === "floating" ? "reference" : "floating" : f], w = Ci(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(v))) == null || n ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), m = f === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, N = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), C = await (o.isElement == null ? void 0 : o.isElement(N)) ? await (o.getScale == null ? void 0 : o.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, M = Ci(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: m,
    offsetParent: N,
    strategy: l
  }) : m);
  return {
    top: (w.top - M.top + b.top) / C.y,
    bottom: (M.bottom - w.bottom + b.bottom) / C.y,
    left: (w.left - M.left + b.left) / C.x,
    right: (M.right - w.right + b.right) / C.x
  };
}
const S0 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Gr(e, t) || {};
    if (u == null)
      return {};
    const f = xc(d), h = {
      x: n,
      y: r
    }, p = da(i), b = ua(p), g = await a.getDimensions(u), v = p === "y", w = v ? "top" : "left", m = v ? "bottom" : "right", N = v ? "clientHeight" : "clientWidth", C = o.reference[b] + o.reference[p] - h[p] - o.floating[b], M = h[p] - o.reference[p], y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let L = y ? y[N] : 0;
    (!L || !await (a.isElement == null ? void 0 : a.isElement(y))) && (L = s.floating[N] || o.floating[b]);
    const T = C / 2 - M / 2, S = L / 2 - g[b] / 2 - 1, R = Qn(f[w], S), V = Qn(f[m], S), A = R, E = L - g[b] - V, P = L / 2 - g[b] / 2 + T, U = Do(A, P, E), D = !l.arrow && Yr(i) != null && P !== U && o.reference[b] / 2 - (P < A ? R : V) - g[b] / 2 < 0, z = D ? P < A ? P - A : P - E : 0;
    return {
      [p]: h[p] + z,
      data: {
        [p]: U,
        centerOffset: P - U - z,
        ...D && {
          alignmentOffset: z
        }
      },
      reset: D
    };
  }
}), k0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: g = !0,
        ...v
      } = Gr(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const w = Hn(i), m = pn(s), N = Hn(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), M = h || (N || !g ? [xi(s)] : w0(s)), y = b !== "none";
      !h && y && M.push(...L0(s, g, b, C));
      const L = [s, ...M], T = await Cc(t, v), S = [];
      let R = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (d && S.push(T[w]), f) {
        const P = C0(i, a, C);
        S.push(T[P[0]], T[P[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: S
      }], !S.every((P) => P <= 0)) {
        var V, A;
        const P = (((V = o.flip) == null ? void 0 : V.index) || 0) + 1, U = L[P];
        if (U && (!(f === "alignment" ? m !== pn(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((I) => pn(I.placement) === m ? I.overflows[0] > 0 : !0)))
          return {
            data: {
              index: P,
              overflows: R
            },
            reset: {
              placement: U
            }
          };
        let D = (A = R.filter((z) => z.overflows[0] <= 0).sort((z, I) => z.overflows[1] - I.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var E;
              const z = (E = R.filter((I) => {
                if (y) {
                  const Y = pn(I.placement);
                  return Y === m || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((Y) => Y > 0).reduce((Y, Z) => Y + Z, 0)]).sort((I, Y) => I[1] - Y[1])[0]) == null ? void 0 : E[0];
              z && (D = z);
              break;
            }
            case "initialPlacement":
              D = s;
              break;
          }
        if (i !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
}, O0 = /* @__PURE__ */ new Set(["left", "top"]);
async function T0(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Hn(n), s = Yr(n), l = pn(n) === "y", u = O0.has(a) ? -1 : 1, d = o && l ? -1 : 1, f = Gr(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof b == "number" && (p = s === "end" ? b * -1 : b), l ? {
    x: p * d,
    y: h * u
  } : {
    x: h * u,
    y: p * d
  };
}
const V0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await T0(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, H0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: w,
              y: m
            } = v;
            return {
              x: w,
              y: m
            };
          }
        },
        ...l
      } = Gr(e, t), u = {
        x: n,
        y: r
      }, d = await Cc(t, l), f = pn(Hn(i)), h = yc(f);
      let p = u[h], b = u[f];
      if (o) {
        const v = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", m = p + d[v], N = p - d[w];
        p = Do(m, p, N);
      }
      if (a) {
        const v = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", m = b + d[v], N = b - d[w];
        b = Do(m, b, N);
      }
      const g = s.fn({
        ...t,
        [h]: p,
        [f]: b
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [h]: o,
            [f]: a
          }
        }
      };
    }
  };
};
function Pi() {
  return typeof window < "u";
}
function fr(e) {
  return wc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function gt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Yt(e) {
  var t;
  return (t = (wc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function wc(e) {
  return Pi() ? e instanceof Node || e instanceof gt(e).Node : !1;
}
function kt(e) {
  return Pi() ? e instanceof Element || e instanceof gt(e).Element : !1;
}
function jt(e) {
  return Pi() ? e instanceof HTMLElement || e instanceof gt(e).HTMLElement : !1;
}
function cs(e) {
  return !Pi() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof gt(e).ShadowRoot;
}
const R0 = /* @__PURE__ */ new Set(["inline", "contents"]);
function Kr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Ot(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !R0.has(i);
}
const D0 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function P0(e) {
  return D0.has(fr(e));
}
const I0 = [":popover-open", ":modal"];
function Ii(e) {
  return I0.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const B0 = ["transform", "translate", "scale", "rotate", "perspective"], $0 = ["transform", "translate", "scale", "rotate", "perspective", "filter"], F0 = ["paint", "layout", "strict", "content"];
function fa(e) {
  const t = ha(), n = kt(e) ? Ot(e) : e;
  return B0.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || $0.some((r) => (n.willChange || "").includes(r)) || F0.some((r) => (n.contain || "").includes(r));
}
function z0(e) {
  let t = gn(e);
  for (; jt(t) && !er(t); ) {
    if (fa(t))
      return t;
    if (Ii(t))
      return null;
    t = gn(t);
  }
  return null;
}
function ha() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const j0 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function er(e) {
  return j0.has(fr(e));
}
function Ot(e) {
  return gt(e).getComputedStyle(e);
}
function Bi(e) {
  return kt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function gn(e) {
  if (fr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cs(e) && e.host || // Fallback.
    Yt(e)
  );
  return cs(t) ? t.host : t;
}
function Nc(e) {
  const t = gn(e);
  return er(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : jt(t) && Kr(t) ? t : Nc(t);
}
function Sr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Nc(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = gt(i);
  if (o) {
    const s = Io(a);
    return t.concat(a, a.visualViewport || [], Kr(i) ? i : [], s && n ? Sr(s) : []);
  }
  return t.concat(i, Sr(i, [], n));
}
function Io(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function _c(e) {
  const t = Ot(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = jt(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = yi(n) !== o || yi(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function pa(e) {
  return kt(e) ? e : e.contextElement;
}
function Yn(e) {
  const t = pa(e);
  if (!jt(t))
    return It(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = _c(t);
  let a = (o ? yi(n.width) : n.width) / r, s = (o ? yi(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const q0 = /* @__PURE__ */ It(0);
function Mc(e) {
  const t = gt(e);
  return !ha() || !t.visualViewport ? q0 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function U0(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== gt(e) ? !1 : t;
}
function Rn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = pa(e);
  let a = It(1);
  t && (r ? kt(r) && (a = Yn(r)) : a = Yn(e));
  const s = U0(o, n, r) ? Mc(o) : It(0);
  let l = (i.left + s.x) / a.x, u = (i.top + s.y) / a.y, d = i.width / a.x, f = i.height / a.y;
  if (o) {
    const h = gt(o), p = r && kt(r) ? gt(r) : r;
    let b = h, g = Io(b);
    for (; g && r && p !== b; ) {
      const v = Yn(g), w = g.getBoundingClientRect(), m = Ot(g), N = w.left + (g.clientLeft + parseFloat(m.paddingLeft)) * v.x, C = w.top + (g.clientTop + parseFloat(m.paddingTop)) * v.y;
      l *= v.x, u *= v.y, d *= v.x, f *= v.y, l += N, u += C, b = gt(g), g = Io(b);
    }
  }
  return Ci({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function $i(e, t) {
  const n = Bi(e).scrollLeft;
  return t ? t.left + n : Rn(Yt(e)).left + n;
}
function Lc(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - $i(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function W0(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = Yt(r), s = t ? Ii(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = It(1);
  const d = It(0), f = jt(r);
  if ((f || !f && !o) && ((fr(r) !== "body" || Kr(a)) && (l = Bi(r)), jt(r))) {
    const p = Rn(r);
    u = Yn(r), d.x = p.x + r.clientLeft, d.y = p.y + r.clientTop;
  }
  const h = a && !f && !o ? Lc(a, l) : It(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + h.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + h.y
  };
}
function Z0(e) {
  return Array.from(e.getClientRects());
}
function X0(e) {
  const t = Yt(e), n = Bi(e), r = e.ownerDocument.body, i = Sn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Sn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + $i(e);
  const s = -n.scrollTop;
  return Ot(r).direction === "rtl" && (a += Sn(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
const us = 25;
function G0(e, t) {
  const n = gt(e), r = Yt(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const d = ha();
    (!d || d && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  const u = $i(r);
  if (u <= 0) {
    const d = r.ownerDocument, f = d.body, h = getComputedStyle(f), p = d.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, b = Math.abs(r.clientWidth - f.clientWidth - p);
    b <= us && (o -= b);
  } else u <= us && (o += u);
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
const Y0 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function K0(e, t) {
  const n = Rn(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = jt(e) ? Yn(e) : It(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, u = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: u
  };
}
function ds(e, t, n) {
  let r;
  if (t === "viewport")
    r = G0(e, n);
  else if (t === "document")
    r = X0(Yt(e));
  else if (kt(t))
    r = K0(t, n);
  else {
    const i = Mc(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Ci(r);
}
function Ac(e, t) {
  const n = gn(e);
  return n === t || !kt(n) || er(n) ? !1 : Ot(n).position === "fixed" || Ac(n, t);
}
function J0(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Sr(e, [], !1).filter((s) => kt(s) && fr(s) !== "body"), i = null;
  const o = Ot(e).position === "fixed";
  let a = o ? gn(e) : e;
  for (; kt(a) && !er(a); ) {
    const s = Ot(a), l = fa(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && Y0.has(i.position) || Kr(a) && !l && Ac(e, a)) ? r = r.filter((d) => d !== a) : i = s, a = gn(a);
  }
  return t.set(e, r), r;
}
function Q0(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? Ii(t) ? [] : J0(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((u, d) => {
    const f = ds(t, d, i);
    return u.top = Sn(f.top, u.top), u.right = Qn(f.right, u.right), u.bottom = Qn(f.bottom, u.bottom), u.left = Sn(f.left, u.left), u;
  }, ds(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function ed(e) {
  const {
    width: t,
    height: n
  } = _c(e);
  return {
    width: t,
    height: n
  };
}
function td(e, t, n) {
  const r = jt(t), i = Yt(t), o = n === "fixed", a = Rn(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = It(0);
  function u() {
    l.x = $i(i);
  }
  if (r || !r && !o)
    if ((fr(t) !== "body" || Kr(i)) && (s = Bi(t)), r) {
      const p = Rn(t, !0, o, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else i && u();
  o && !r && i && u();
  const d = i && !r && !o ? Lc(i, s) : It(0), f = a.left + s.scrollLeft - l.x - d.x, h = a.top + s.scrollTop - l.y - d.y;
  return {
    x: f,
    y: h,
    width: a.width,
    height: a.height
  };
}
function Qi(e) {
  return Ot(e).position === "static";
}
function fs(e, t) {
  if (!jt(e) || Ot(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Yt(e) === n && (n = n.ownerDocument.body), n;
}
function Ec(e, t) {
  const n = gt(e);
  if (Ii(e))
    return n;
  if (!jt(e)) {
    let i = gn(e);
    for (; i && !er(i); ) {
      if (kt(i) && !Qi(i))
        return i;
      i = gn(i);
    }
    return n;
  }
  let r = fs(e, t);
  for (; r && P0(r) && Qi(r); )
    r = fs(r, t);
  return r && er(r) && Qi(r) && !fa(r) ? n : r || z0(e) || n;
}
const nd = async function(e) {
  const t = this.getOffsetParent || Ec, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: td(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function rd(e) {
  return Ot(e).direction === "rtl";
}
const id = {
  convertOffsetParentRelativeRectToViewportRelativeRect: W0,
  getDocumentElement: Yt,
  getClippingRect: Q0,
  getOffsetParent: Ec,
  getElementRects: nd,
  getClientRects: Z0,
  getDimensions: ed,
  getScale: Yn,
  isElement: kt,
  isRTL: rd
};
function Sc(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function od(e, t) {
  let n = null, r;
  const i = Yt(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: h,
      height: p
    } = u;
    if (s || t(), !h || !p)
      return;
    const b = ii(f), g = ii(i.clientWidth - (d + h)), v = ii(i.clientHeight - (f + p)), w = ii(d), N = {
      rootMargin: -b + "px " + -g + "px " + -v + "px " + -w + "px",
      threshold: Sn(0, Qn(1, l)) || 1
    };
    let C = !0;
    function M(y) {
      const L = y[0].intersectionRatio;
      if (L !== l) {
        if (!C)
          return a();
        L ? a(!1, L) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !Sc(u, e.getBoundingClientRect()) && a(), C = !1;
    }
    try {
      n = new IntersectionObserver(M, {
        ...N,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(M, N);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function ad(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = pa(e), d = i || o ? [...u ? Sr(u) : [], ...Sr(t)] : [];
  d.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), o && w.addEventListener("resize", n);
  });
  const f = u && s ? od(u, n) : null;
  let h = -1, p = null;
  a && (p = new ResizeObserver((w) => {
    let [m] = w;
    m && m.target === u && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var N;
      (N = p) == null || N.observe(t);
    })), n();
  }), u && !l && p.observe(u), p.observe(t));
  let b, g = l ? Rn(e) : null;
  l && v();
  function v() {
    const w = Rn(e);
    g && !Sc(g, w) && n(), g = w, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var w;
    d.forEach((m) => {
      i && m.removeEventListener("scroll", n), o && m.removeEventListener("resize", n);
    }), f == null || f(), (w = p) == null || w.disconnect(), p = null, l && cancelAnimationFrame(b);
  };
}
const sd = V0, ld = H0, cd = k0, ud = S0, hs = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: id,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return E0(e, t, {
    ...i,
    platform: o
  });
};
var eo = { exports: {} };
var ps;
function dd() {
  return ps || (ps = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var o = "", a = 0; a < arguments.length; a++) {
          var s = arguments[a];
          s && (o = i(o, r(s)));
        }
        return o;
      }
      function r(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var a = "";
        for (var s in o)
          t.call(o, s) && o[s] && (a = i(a, s));
        return a;
      }
      function i(o, a) {
        return a ? o ? o + " " + a : o + a : o;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(eo)), eo.exports;
}
var fd = dd();
const qt = /* @__PURE__ */ Di(fd);
const hd = "react-tooltip-core-styles", pd = "react-tooltip-base-styles", ms = { core: !1, base: !1 };
function gs({ css: e, id: t = pd, type: n = "base", ref: r }) {
  var i, o;
  if (!e || typeof document > "u" || ms[n] || n === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = hd), r || (r = {});
  const { insertAt: a } = r;
  if (document.getElementById(t)) return;
  const s = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = t, l.type = "text/css", a === "top" && s.firstChild ? s.insertBefore(l, s.firstChild) : s.appendChild(l), l.styleSheet ? l.styleSheet.cssText = e : l.appendChild(document.createTextNode(e)), ms[n] = !0;
}
const vs = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: i = 10, strategy: o = "absolute", middlewares: a = [sd(Number(i)), cd({ fallbackAxisSideDirection: "start" }), ld({ padding: 5 })], border: s, arrowSize: l = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const u = a;
  return n ? (u.push(ud({ element: n, padding: 5 })), hs(e, t, { placement: r, strategy: o, middleware: u }).then(({ x: d, y: f, placement: h, middlewareData: p }) => {
    var b, g;
    const v = { left: `${d}px`, top: `${f}px`, border: s }, { x: w, y: m } = (b = p.arrow) !== null && b !== void 0 ? b : { x: 0, y: 0 }, N = (g = { top: "bottom", right: "left", bottom: "top", left: "right" }[h.split("-")[0]]) !== null && g !== void 0 ? g : "bottom", C = s && { borderBottom: s, borderRight: s };
    let M = 0;
    if (s) {
      const y = `${s}`.match(/(\d+)px/);
      M = y != null && y[1] ? Number(y[1]) : 1;
    }
    return { tooltipStyles: v, tooltipArrowStyles: { left: w != null ? `${w}px` : "", top: m != null ? `${m}px` : "", right: "", bottom: "", ...C, [N]: `-${l / 2 + M}px` }, place: h };
  })) : hs(e, t, { placement: "bottom", strategy: o, middleware: u }).then(({ x: d, y: f, placement: h }) => ({ tooltipStyles: { left: `${d}px`, top: `${f}px` }, tooltipArrowStyles: {}, place: h }));
}, bs = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), ys = (e, t, n) => {
  let r = null;
  const i = function(...o) {
    const a = () => {
      r = null;
    };
    !r && (e.apply(this, o), r = setTimeout(a, t));
  };
  return i.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, i;
}, xs = (e) => e !== null && !Array.isArray(e) && typeof e == "object", Bo = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((i, o) => Bo(i, t[o]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!xs(e) || !xs(t)) return e === t;
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((i) => Bo(e[i], t[i]));
}, md = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = t.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, Cs = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (md(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, gd = typeof window < "u" ? Pu : te, wt = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, vd = "DEFAULT_TOOLTIP_ID", bd = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, yd = cr({ getTooltipData: () => bd });
function kc(e = vd) {
  return $n(yd).getTooltipData(e);
}
var Wn = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, to = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const xd = ({ forwardRef: e, id: t, className: n, classNameArrow: r, variant: i = "dark", anchorId: o, anchorSelect: a, place: s = "top", offset: l = 10, events: u = ["hover"], openOnClick: d = !1, positionStrategy: f = "absolute", middlewares: h, wrapper: p, delayShow: b = 0, delayHide: g = 0, float: v = !1, hidden: w = !1, noArrow: m = !1, clickable: N = !1, closeOnEsc: C = !1, closeOnScroll: M = !1, closeOnResize: y = !1, openEvents: L, closeEvents: T, globalCloseEvents: S, imperativeModeOnly: R, style: V, position: A, afterShow: E, afterHide: P, disableTooltip: U, content: D, contentWrapperRef: z, isOpen: I, defaultIsOpen: Y = !1, setIsOpen: Z, activeAnchor: ne, setActiveAnchor: fe, border: Me, opacity: Ce, arrowColor: ke, arrowSize: he = 8, role: X = "tooltip" }) => {
  var re;
  const $ = xe(null), oe = xe(null), pe = xe(null), Le = xe(null), Ie = xe(null), [Be, me] = ie({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [Ae, at] = ie(!1), [_, k] = ie(!1), [O, j] = ie(null), F = xe(!1), B = xe(null), { anchorRefs: J, setActiveAnchor: le } = kc(t), be = xe(!1), [ye, Ze] = ie([]), st = xe(!1), yt = d || u.includes("click"), Kt = yt || (L == null ? void 0 : L.click) || (L == null ? void 0 : L.dblclick) || (L == null ? void 0 : L.mousedown), Tt = L ? { ...L } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !L && yt && Object.assign(Tt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const xt = T ? { ...T } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !T && yt && Object.assign(xt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const tt = S ? { ...S } : { escape: C || !1, scroll: M || !1, resize: y || !1, clickOutsideAnchor: Kt || !1 };
  R && (Object.assign(Tt, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(xt, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(tt, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), gd(() => (st.current = !0, () => {
    st.current = !1;
  }), []);
  const ge = (G) => {
    st.current && (G && k(!0), setTimeout(() => {
      st.current && (Z == null || Z(G), I === void 0 && at(G));
    }, 10));
  };
  te(() => {
    if (I === void 0) return () => null;
    I && k(!0);
    const G = setTimeout(() => {
      at(I);
    }, 10);
    return () => {
      clearTimeout(G);
    };
  }, [I]), te(() => {
    if (Ae !== F.current) if (wt(Ie), F.current = Ae, Ae) E == null || E();
    else {
      const G = ((ce) => {
        const ue = ce.match(/^([\d.]+)(ms|s)$/);
        if (!ue) return 0;
        const [, Ue, nt] = ue;
        return Number(Ue) * (nt === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Ie.current = setTimeout(() => {
        k(!1), j(null), P == null || P();
      }, G + 25);
    }
  }, [Ae]);
  const qn = (G) => {
    me((ce) => Bo(ce, G) ? ce : G);
  }, un = (G = b) => {
    wt(pe), _ ? ge(!0) : pe.current = setTimeout(() => {
      ge(!0);
    }, G);
  }, Jt = (G = g) => {
    wt(Le), Le.current = setTimeout(() => {
      be.current || ge(!1);
    }, G);
  }, dn = (G) => {
    var ce;
    if (!G) return;
    const ue = (ce = G.currentTarget) !== null && ce !== void 0 ? ce : G.target;
    if (!(ue != null && ue.isConnected)) return fe(null), void le({ current: null });
    b ? un() : ge(!0), fe(ue), le({ current: ue }), wt(Le);
  }, Qt = () => {
    N ? Jt(g || 100) : g ? Jt() : ge(!1), wt(pe);
  }, W = ({ x: G, y: ce }) => {
    var ue;
    const Ue = { getBoundingClientRect: () => ({ x: G, y: ce, width: 0, height: 0, top: ce, left: G, right: G, bottom: ce }) };
    vs({ place: (ue = O == null ? void 0 : O.place) !== null && ue !== void 0 ? ue : s, offset: l, elementReference: Ue, tooltipReference: $.current, tooltipArrowReference: oe.current, strategy: f, middlewares: h, border: Me, arrowSize: he }).then((nt) => {
      qn(nt);
    });
  }, Oe = (G) => {
    if (!G) return;
    const ce = G, ue = { x: ce.clientX, y: ce.clientY };
    W(ue), B.current = ue;
  }, Fe = (G) => {
    var ce;
    if (!Ae) return;
    const ue = G.target;
    ue.isConnected && (!((ce = $.current) === null || ce === void 0) && ce.contains(ue) || [document.querySelector(`[id='${o}']`), ...ye].some((Ue) => Ue == null ? void 0 : Ue.contains(ue)) || (ge(!1), wt(pe)));
  }, Qe = ys(dn, 50), Ee = ys(Qt, 50), Ve = (G) => {
    Ee.cancel(), Qe(G);
  }, se = () => {
    Qe.cancel(), Ee();
  }, ve = we(() => {
    var G, ce;
    const ue = (G = O == null ? void 0 : O.position) !== null && G !== void 0 ? G : A;
    ue ? W(ue) : v ? B.current && W(B.current) : ne != null && ne.isConnected && vs({ place: (ce = O == null ? void 0 : O.place) !== null && ce !== void 0 ? ce : s, offset: l, elementReference: ne, tooltipReference: $.current, tooltipArrowReference: oe.current, strategy: f, middlewares: h, border: Me, arrowSize: he }).then((Ue) => {
      st.current && qn(Ue);
    });
  }, [Ae, ne, D, V, s, O == null ? void 0 : O.place, l, f, A, O == null ? void 0 : O.position, v, he]);
  te(() => {
    var G, ce;
    const ue = new Set(J);
    ye.forEach((_e) => {
      U != null && U(_e) || ue.add({ current: _e });
    });
    const Ue = document.querySelector(`[id='${o}']`);
    Ue && !(U != null && U(Ue)) && ue.add({ current: Ue });
    const nt = () => {
      ge(!1);
    }, Vt = Cs(ne), Ht = Cs($.current);
    tt.scroll && (window.addEventListener("scroll", nt), Vt == null || Vt.addEventListener("scroll", nt), Ht == null || Ht.addEventListener("scroll", nt));
    let it = null;
    tt.resize ? window.addEventListener("resize", nt) : ne && $.current && (it = ad(ne, $.current, ve, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const Ct = (_e) => {
      _e.key === "Escape" && ge(!1);
    };
    tt.escape && window.addEventListener("keydown", Ct), tt.clickOutsideAnchor && window.addEventListener("click", Fe);
    const De = [], Un = (_e) => !!(_e != null && _e.target && (ne != null && ne.contains(_e.target))), Tu = (_e) => {
      Ae && Un(_e) || dn(_e);
    }, Vu = (_e) => {
      Ae && Un(_e) && Qt();
    }, Ka = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Ja = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Tt).forEach(([_e, en]) => {
      en && (Ka.includes(_e) ? De.push({ event: _e, listener: Ve }) : Ja.includes(_e) && De.push({ event: _e, listener: Tu }));
    }), Object.entries(xt).forEach(([_e, en]) => {
      en && (Ka.includes(_e) ? De.push({ event: _e, listener: se }) : Ja.includes(_e) && De.push({ event: _e, listener: Vu }));
    }), v && De.push({ event: "pointermove", listener: Oe });
    const Qa = () => {
      be.current = !0;
    }, es = () => {
      be.current = !1, Qt();
    }, ts = N && (xt.mouseout || xt.mouseleave);
    return ts && ((G = $.current) === null || G === void 0 || G.addEventListener("mouseover", Qa), (ce = $.current) === null || ce === void 0 || ce.addEventListener("mouseout", es)), De.forEach(({ event: _e, listener: en }) => {
      ue.forEach((Gi) => {
        var br;
        (br = Gi.current) === null || br === void 0 || br.addEventListener(_e, en);
      });
    }), () => {
      var _e, en;
      tt.scroll && (window.removeEventListener("scroll", nt), Vt == null || Vt.removeEventListener("scroll", nt), Ht == null || Ht.removeEventListener("scroll", nt)), tt.resize ? window.removeEventListener("resize", nt) : it == null || it(), tt.clickOutsideAnchor && window.removeEventListener("click", Fe), tt.escape && window.removeEventListener("keydown", Ct), ts && ((_e = $.current) === null || _e === void 0 || _e.removeEventListener("mouseover", Qa), (en = $.current) === null || en === void 0 || en.removeEventListener("mouseout", es)), De.forEach(({ event: Gi, listener: br }) => {
        ue.forEach((Hu) => {
          var Yi;
          (Yi = Hu.current) === null || Yi === void 0 || Yi.removeEventListener(Gi, br);
        });
      });
    };
  }, [ne, ve, _, J, ye, L, T, S, yt, b, g]), te(() => {
    var G, ce;
    let ue = (ce = (G = O == null ? void 0 : O.anchorSelect) !== null && G !== void 0 ? G : a) !== null && ce !== void 0 ? ce : "";
    !ue && t && (ue = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const Ue = new MutationObserver((nt) => {
      const Vt = [], Ht = [];
      nt.forEach((it) => {
        if (it.type === "attributes" && it.attributeName === "data-tooltip-id" && (it.target.getAttribute("data-tooltip-id") === t ? Vt.push(it.target) : it.oldValue === t && Ht.push(it.target)), it.type === "childList") {
          if (ne) {
            const Ct = [...it.removedNodes].filter((De) => De.nodeType === 1);
            if (ue) try {
              Ht.push(...Ct.filter((De) => De.matches(ue))), Ht.push(...Ct.flatMap((De) => [...De.querySelectorAll(ue)]));
            } catch {
            }
            Ct.some((De) => {
              var Un;
              return !!(!((Un = De == null ? void 0 : De.contains) === null || Un === void 0) && Un.call(De, ne)) && (k(!1), ge(!1), fe(null), wt(pe), wt(Le), !0);
            });
          }
          if (ue) try {
            const Ct = [...it.addedNodes].filter((De) => De.nodeType === 1);
            Vt.push(...Ct.filter((De) => De.matches(ue))), Vt.push(...Ct.flatMap((De) => [...De.querySelectorAll(ue)]));
          } catch {
          }
        }
      }), (Vt.length || Ht.length) && Ze((it) => [...it.filter((Ct) => !Ht.includes(Ct)), ...Vt]);
    });
    return Ue.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Ue.disconnect();
    };
  }, [t, a, O == null ? void 0 : O.anchorSelect, ne]), te(() => {
    ve();
  }, [ve]), te(() => {
    if (!(z != null && z.current)) return () => null;
    const G = new ResizeObserver(() => {
      setTimeout(() => ve());
    });
    return G.observe(z.current), () => {
      G.disconnect();
    };
  }, [D, z == null ? void 0 : z.current]), te(() => {
    var G;
    const ce = document.querySelector(`[id='${o}']`), ue = [...ye, ce];
    ne && ue.includes(ne) || fe((G = ye[0]) !== null && G !== void 0 ? G : ce);
  }, [o, ye, ne]), te(() => (Y && ge(!0), () => {
    wt(pe), wt(Le);
  }), []), te(() => {
    var G;
    let ce = (G = O == null ? void 0 : O.anchorSelect) !== null && G !== void 0 ? G : a;
    if (!ce && t && (ce = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), ce) try {
      const ue = Array.from(document.querySelectorAll(ce));
      Ze(ue);
    } catch {
      Ze([]);
    }
  }, [t, a, O == null ? void 0 : O.anchorSelect]), te(() => {
    pe.current && (wt(pe), un(b));
  }, [b]);
  const ft = (re = O == null ? void 0 : O.content) !== null && re !== void 0 ? re : D, Nn = Ae && Object.keys(Be.tooltipStyles).length > 0;
  return jr(e, () => ({ open: (G) => {
    if (G != null && G.anchorSelect) try {
      document.querySelector(G.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${G.anchorSelect}" is not a valid CSS selector`);
    }
    j(G ?? null), G != null && G.delay ? un(G.delay) : ge(!0);
  }, close: (G) => {
    G != null && G.delay ? Jt(G.delay) : ge(!1);
  }, activeAnchor: ne, place: Be.place, isOpen: !!(_ && !w && ft && Nn) })), _ && !w && ft ? ae.createElement(p, { id: t, role: X, className: qt("react-tooltip", Wn.tooltip, to.tooltip, to[i], n, `react-tooltip__place-${Be.place}`, Wn[Nn ? "show" : "closing"], Nn ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && Wn.fixed, N && Wn.clickable), onTransitionEnd: (G) => {
    wt(Ie), Ae || G.propertyName !== "opacity" || (k(!1), j(null), P == null || P());
  }, style: { ...V, ...Be.tooltipStyles, opacity: Ce !== void 0 && Nn ? Ce : void 0 }, ref: $ }, ft, ae.createElement(p, { className: qt("react-tooltip-arrow", Wn.arrow, to.arrow, r, m && Wn.noArrow), style: { ...Be.tooltipArrowStyles, background: ke ? `linear-gradient(to right bottom, transparent 50%, ${ke} 50%)` : void 0, "--rt-arrow-size": `${he}px` }, ref: oe })) : null;
}, Cd = ({ content: e }) => ae.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), ws = ae.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: r, html: i, render: o, className: a, classNameArrow: s, variant: l = "dark", place: u = "top", offset: d = 10, wrapper: f = "div", children: h = null, events: p = ["hover"], openOnClick: b = !1, positionStrategy: g = "absolute", middlewares: v, delayShow: w = 0, delayHide: m = 0, float: N = !1, hidden: C = !1, noArrow: M = !1, clickable: y = !1, closeOnEsc: L = !1, closeOnScroll: T = !1, closeOnResize: S = !1, openEvents: R, closeEvents: V, globalCloseEvents: A, imperativeModeOnly: E = !1, style: P, position: U, isOpen: D, defaultIsOpen: z = !1, disableStyleInjection: I = !1, border: Y, opacity: Z, arrowColor: ne, arrowSize: fe, setIsOpen: Me, afterShow: Ce, afterHide: ke, disableTooltip: he, role: X = "tooltip" }, re) => {
  const [$, oe] = ie(r), [pe, Le] = ie(i), [Ie, Be] = ie(u), [me, Ae] = ie(l), [at, _] = ie(d), [k, O] = ie(w), [j, F] = ie(m), [B, J] = ie(N), [le, be] = ie(C), [ye, Ze] = ie(f), [st, yt] = ie(p), [Kt, Tt] = ie(g), [xt, tt] = ie(null), [ge, qn] = ie(null), un = xe(I), { anchorRefs: Jt, activeAnchor: dn } = kc(e), Qt = (Ee) => Ee == null ? void 0 : Ee.getAttributeNames().reduce((Ve, se) => {
    var ve;
    return se.startsWith("data-tooltip-") && (Ve[se.replace(/^data-tooltip-/, "")] = (ve = Ee == null ? void 0 : Ee.getAttribute(se)) !== null && ve !== void 0 ? ve : null), Ve;
  }, {}), W = (Ee) => {
    const Ve = { place: (se) => {
      var ve;
      Be((ve = se) !== null && ve !== void 0 ? ve : u);
    }, content: (se) => {
      oe(se ?? r);
    }, html: (se) => {
      Le(se ?? i);
    }, variant: (se) => {
      var ve;
      Ae((ve = se) !== null && ve !== void 0 ? ve : l);
    }, offset: (se) => {
      _(se === null ? d : Number(se));
    }, wrapper: (se) => {
      var ve;
      Ze((ve = se) !== null && ve !== void 0 ? ve : f);
    }, events: (se) => {
      const ve = se == null ? void 0 : se.split(" ");
      yt(ve ?? p);
    }, "position-strategy": (se) => {
      var ve;
      Tt((ve = se) !== null && ve !== void 0 ? ve : g);
    }, "delay-show": (se) => {
      O(se === null ? w : Number(se));
    }, "delay-hide": (se) => {
      F(se === null ? m : Number(se));
    }, float: (se) => {
      J(se === null ? N : se === "true");
    }, hidden: (se) => {
      be(se === null ? C : se === "true");
    }, "class-name": (se) => {
      tt(se);
    } };
    Object.values(Ve).forEach((se) => se(null)), Object.entries(Ee).forEach(([se, ve]) => {
      var ft;
      (ft = Ve[se]) === null || ft === void 0 || ft.call(Ve, ve);
    });
  };
  te(() => {
    oe(r);
  }, [r]), te(() => {
    Le(i);
  }, [i]), te(() => {
    Be(u);
  }, [u]), te(() => {
    Ae(l);
  }, [l]), te(() => {
    _(d);
  }, [d]), te(() => {
    O(w);
  }, [w]), te(() => {
    F(m);
  }, [m]), te(() => {
    J(N);
  }, [N]), te(() => {
    be(C);
  }, [C]), te(() => {
    Tt(g);
  }, [g]), te(() => {
    un.current !== I && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [I]), te(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: I === "core", disableBase: I } }));
  }, []), te(() => {
    var Ee;
    const Ve = new Set(Jt);
    let se = n;
    if (!se && e && (se = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), se) try {
      document.querySelectorAll(se).forEach((ce) => {
        Ve.add({ current: ce });
      });
    } catch {
      console.warn(`[react-tooltip] "${se}" is not a valid CSS selector`);
    }
    const ve = document.querySelector(`[id='${t}']`);
    if (ve && Ve.add({ current: ve }), !Ve.size) return () => null;
    const ft = (Ee = ge ?? ve) !== null && Ee !== void 0 ? Ee : dn.current, Nn = new MutationObserver((ce) => {
      ce.forEach((ue) => {
        var Ue;
        if (!ft || ue.type !== "attributes" || !(!((Ue = ue.attributeName) === null || Ue === void 0) && Ue.startsWith("data-tooltip-"))) return;
        const nt = Qt(ft);
        W(nt);
      });
    }), G = { attributes: !0, childList: !1, subtree: !1 };
    if (ft) {
      const ce = Qt(ft);
      W(ce), Nn.observe(ft, G);
    }
    return () => {
      Nn.disconnect();
    };
  }, [Jt, dn, ge, t, n]), te(() => {
    P != null && P.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), Y && !bs("border", `${Y}`) && console.warn(`[react-tooltip] "${Y}" is not a valid \`border\`.`), P != null && P.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), Z && !bs("opacity", `${Z}`) && console.warn(`[react-tooltip] "${Z}" is not a valid \`opacity\`.`);
  }, []);
  let Oe = h;
  const Fe = xe(null);
  if (o) {
    const Ee = o({ content: (ge == null ? void 0 : ge.getAttribute("data-tooltip-content")) || $ || null, activeAnchor: ge });
    Oe = Ee ? ae.createElement("div", { ref: Fe, className: "react-tooltip-content-wrapper" }, Ee) : null;
  } else $ && (Oe = $);
  pe && (Oe = ae.createElement(Cd, { content: pe }));
  const Qe = { forwardRef: re, id: e, anchorId: t, anchorSelect: n, className: qt(a, xt), classNameArrow: s, content: Oe, contentWrapperRef: Fe, place: Ie, variant: me, offset: at, wrapper: ye, events: st, openOnClick: b, positionStrategy: Kt, middlewares: v, delayShow: k, delayHide: j, float: B, hidden: le, noArrow: M, clickable: y, closeOnEsc: L, closeOnScroll: T, closeOnResize: S, openEvents: R, closeEvents: V, globalCloseEvents: A, imperativeModeOnly: E, style: P, position: U, isOpen: D, defaultIsOpen: z, border: Y, opacity: Z, arrowColor: ne, arrowSize: fe, setIsOpen: Me, afterShow: Ce, afterHide: ke, disableTooltip: he, activeAnchor: ge, setActiveAnchor: (Ee) => qn(Ee), role: X };
  return ae.createElement(xd, { ...Qe });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || gs({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || gs({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const Ns = "More information", wd = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', _s = (e) => e.stopPropagation(), Nd = (e) => e == null ? void 0 : e.focus({ preventScroll: !0 }), _d = (e) => {
  if (e.key !== "Tab") return;
  const t = e.currentTarget.querySelectorAll(wd), n = t[0], r = t[t.length - 1], i = document.activeElement;
  if (!n || !r || !i) return;
  const o = i === r || !!(r.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_FOLLOWING);
  (e.shiftKey ? i === n : o) && (e.preventDefault(), (e.shiftKey ? r : n).focus());
}, Md = {
  default: "text-accent-primary",
  warning: "text-warning-main",
  error: "text-error-main"
}, Ld = {
  default: "text-accent-secondary",
  warning: "text-warning-main",
  error: "text-error-main"
};
function kr({
  children: e,
  tooltip: t,
  status: n = "default",
  attachToChildren: r = !1,
  icon: i,
  className: o,
  placement: a = "top",
  tooltipVariant: s = "primary",
  offset: l = [8, 8],
  title: u,
  touchFallback: d = "sheet"
}) {
  const f = Xt(), h = bc(), [p, b] = ie(!1), g = xe(null), v = Md[n], w = {
    name: "customOffset",
    fn: ({ x: C, y: M, placement: y }) => {
      let L = C, T = M;
      return y === "top" ? T = M - l[1] : y === "bottom" ? T = M + l[1] : y === "left" ? L = C - l[0] : y === "right" && (L = C + l[0]), { x: L, y: T };
    }
  };
  if (!t)
    return r ? /* @__PURE__ */ c("span", { className: H("inline-flex items-center gap-1", v, o), children: e }) : /* @__PURE__ */ c("div", { className: H("inline-flex items-center gap-1", v, o), children: e });
  const m = /* @__PURE__ */ c(mn, { size: 16, className: Ld[n] }), N = i || m;
  if (h && r && d === "text")
    return /* @__PURE__ */ x("span", { className: H("inline-flex flex-col gap-1", v, o), children: [
      e,
      /* @__PURE__ */ c(Q, { as: "span", variant: "caption", role: "note", className: "w-0 min-w-full text-accent-secondary", children: t })
    ] });
  if (h) {
    const C = `${f}-title`, M = (S) => {
      S.stopPropagation(), b(!0);
    }, y = () => {
      var S;
      b(!1), (S = g.current) == null || S.focus();
    }, L = /* @__PURE__ */ c("span", { className: "sr-only", children: u ?? Ns }), T = /* @__PURE__ */ c("span", { className: "contents", onClick: _s, onMouseDown: _s, children: /* @__PURE__ */ c(
      yn,
      {
        open: p,
        onClose: y,
        onKeyDown: _d,
        handle: !0,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": u ? C : void 0,
        "aria-label": u ? void 0 : Ns,
        backdropClassName: "bg-[#000000]/40",
        className: "min-h-[7.5rem] rounded-t-lg border-b-0 bg-background-contrast pt-6",
        children: /* @__PURE__ */ x("div", { ref: Nd, tabIndex: -1, className: "flex flex-col gap-2 focus:outline-none", children: [
          u ? /* @__PURE__ */ c(qr, { variant: "h6", as: "p", id: C, className: "text-accent-primary", children: u }) : null,
          /* @__PURE__ */ c(Q, { as: "div", variant: "body2", className: "tracking-[0.17px] text-accent-secondary", children: t })
        ] })
      }
    ) });
    return r ? /* @__PURE__ */ x(He, { children: [
      /* @__PURE__ */ x("span", { className: H("relative inline-flex items-center gap-1", v, o), children: [
        e,
        /* @__PURE__ */ c("button", { ref: g, type: "button", onClick: M, className: "absolute inset-0", children: L })
      ] }),
      T
    ] }) : /* @__PURE__ */ x("span", { className: H("inline-flex items-center gap-1", v, o), children: [
      e,
      /* @__PURE__ */ x(
        "button",
        {
          ref: g,
          type: "button",
          onClick: M,
          className: H(
            "relative inline-flex items-center before:absolute before:-inset-y-3 before:-left-6 before:right-0 before:content-['']",
            v
          ),
          children: [
            N,
            L
          ]
        }
      ),
      T
    ] });
  }
  return r ? /* @__PURE__ */ x("span", { className: H("inline-flex items-center gap-1", v, o), children: [
    /* @__PURE__ */ c(
      "span",
      {
        className: "cursor-default",
        "data-tooltip-id": f,
        "data-tooltip-content": typeof t == "string" ? t : void 0,
        "data-tooltip-place": a,
        "data-tooltip-position-strategy": "fixed",
        "data-tooltip-wrapper": "span",
        children: e
      }
    ),
    /* @__PURE__ */ c(
      ws,
      {
        id: f,
        className: H(
          "react-tooltip",
          s === "secondary" && "react-tooltip--secondary"
        ),
        openOnClick: !1,
        clickable: !0,
        place: a,
        style: { zIndex: 99999 },
        positionStrategy: "fixed",
        middlewares: [w],
        offset: 0,
        children: typeof t != "string" && t
      }
    )
  ] }) : /* @__PURE__ */ x("span", { className: H("inline-flex items-center gap-1", v, o), children: [
    e,
    /* @__PURE__ */ c(
      "span",
      {
        className: H("cursor-default inline-flex items-center", v),
        "data-tooltip-id": f,
        "data-tooltip-content": typeof t == "string" ? t : void 0,
        "data-tooltip-place": a,
        "data-tooltip-position-strategy": "fixed",
        "data-tooltip-wrapper": "span",
        children: N
      }
    ),
    /* @__PURE__ */ c(
      ws,
      {
        id: f,
        className: H(
          "react-tooltip",
          s === "secondary" && "react-tooltip--secondary"
        ),
        openOnClick: !1,
        clickable: !0,
        place: a,
        style: { zIndex: 99999 },
        positionStrategy: "fixed",
        middlewares: [w],
        offset: 0,
        children: typeof t != "string" && t
      }
    )
  ] });
}
var Ms = function(t) {
  return t.reduce(function(n, r) {
    var i = r[0], o = r[1];
    return n[i] = o, n;
  }, {});
}, Ls = typeof window < "u" && window.document && window.document.createElement ? Ln.useLayoutEffect : Ln.useEffect, ut = "top", _t = "bottom", Mt = "right", dt = "left", ma = "auto", Jr = [ut, _t, Mt, dt], tr = "start", Or = "end", Ad = "clippingParents", Oc = "viewport", yr = "popper", Ed = "reference", As = /* @__PURE__ */ Jr.reduce(function(e, t) {
  return e.concat([t + "-" + tr, t + "-" + Or]);
}, []), Tc = /* @__PURE__ */ [].concat(Jr, [ma]).reduce(function(e, t) {
  return e.concat([t, t + "-" + tr, t + "-" + Or]);
}, []), Sd = "beforeRead", kd = "read", Od = "afterRead", Td = "beforeMain", Vd = "main", Hd = "afterMain", Rd = "beforeWrite", Dd = "write", Pd = "afterWrite", Id = [Sd, kd, Od, Td, Vd, Hd, Rd, Dd, Pd];
function Ut(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function vt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Dn(e) {
  var t = vt(e).Element;
  return e instanceof t || e instanceof Element;
}
function Nt(e) {
  var t = vt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ga(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = vt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Bd(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, o = t.elements[n];
    !Nt(o) || !Ut(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(a) {
      var s = i[a];
      s === !1 ? o.removeAttribute(a) : o.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function $d(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], o = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = a.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Nt(i) || !Ut(i) || (Object.assign(i.style, s), Object.keys(o).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const Fd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Bd,
  effect: $d,
  requires: ["computeStyles"]
};
function Bt(e) {
  return e.split("-")[0];
}
var kn = Math.max, wi = Math.min, nr = Math.round;
function $o() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Vc() {
  return !/^((?!chrome|android).)*safari/i.test($o());
}
function rr(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  t && Nt(e) && (i = e.offsetWidth > 0 && nr(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && nr(r.height) / e.offsetHeight || 1);
  var a = Dn(e) ? vt(e) : window, s = a.visualViewport, l = !Vc() && n, u = (r.left + (l && s ? s.offsetLeft : 0)) / i, d = (r.top + (l && s ? s.offsetTop : 0)) / o, f = r.width / i, h = r.height / o;
  return {
    width: f,
    height: h,
    top: d,
    right: u + f,
    bottom: d + h,
    left: u,
    x: u,
    y: d
  };
}
function va(e) {
  var t = rr(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Hc(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ga(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function an(e) {
  return vt(e).getComputedStyle(e);
}
function zd(e) {
  return ["table", "td", "th"].indexOf(Ut(e)) >= 0;
}
function xn(e) {
  return ((Dn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Fi(e) {
  return Ut(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ga(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    xn(e)
  );
}
function Es(e) {
  return !Nt(e) || // https://github.com/popperjs/popper-core/issues/837
  an(e).position === "fixed" ? null : e.offsetParent;
}
function jd(e) {
  var t = /firefox/i.test($o()), n = /Trident/i.test($o());
  if (n && Nt(e)) {
    var r = an(e);
    if (r.position === "fixed")
      return null;
  }
  var i = Fi(e);
  for (ga(i) && (i = i.host); Nt(i) && ["html", "body"].indexOf(Ut(i)) < 0; ) {
    var o = an(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Qr(e) {
  for (var t = vt(e), n = Es(e); n && zd(n) && an(n).position === "static"; )
    n = Es(n);
  return n && (Ut(n) === "html" || Ut(n) === "body" && an(n).position === "static") ? t : n || jd(e) || t;
}
function ba(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function _r(e, t, n) {
  return kn(e, wi(t, n));
}
function qd(e, t, n) {
  var r = _r(e, t, n);
  return r > n ? n : r;
}
function Rc() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Dc(e) {
  return Object.assign({}, Rc(), e);
}
function Pc(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Ud = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Dc(typeof t != "number" ? t : Pc(t, Jr));
};
function Wd(e) {
  var t, n = e.state, r = e.name, i = e.options, o = n.elements.arrow, a = n.modifiersData.popperOffsets, s = Bt(n.placement), l = ba(s), u = [dt, Mt].indexOf(s) >= 0, d = u ? "height" : "width";
  if (!(!o || !a)) {
    var f = Ud(i.padding, n), h = va(o), p = l === "y" ? ut : dt, b = l === "y" ? _t : Mt, g = n.rects.reference[d] + n.rects.reference[l] - a[l] - n.rects.popper[d], v = a[l] - n.rects.reference[l], w = Qr(o), m = w ? l === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, N = g / 2 - v / 2, C = f[p], M = m - h[d] - f[b], y = m / 2 - h[d] / 2 + N, L = _r(C, y, M), T = l;
    n.modifiersData[r] = (t = {}, t[T] = L, t.centerOffset = L - y, t);
  }
}
function Zd(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || Hc(t.elements.popper, i) && (t.elements.arrow = i));
}
const Xd = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Wd,
  effect: Zd,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ir(e) {
  return e.split("-")[1];
}
var Gd = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Yd(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: nr(n * i) / i || 0,
    y: nr(r * i) / i || 0
  };
}
function Ss(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, o = e.variation, a = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = e.isFixed, h = a.x, p = h === void 0 ? 0 : h, b = a.y, g = b === void 0 ? 0 : b, v = typeof d == "function" ? d({
    x: p,
    y: g
  }) : {
    x: p,
    y: g
  };
  p = v.x, g = v.y;
  var w = a.hasOwnProperty("x"), m = a.hasOwnProperty("y"), N = dt, C = ut, M = window;
  if (u) {
    var y = Qr(n), L = "clientHeight", T = "clientWidth";
    if (y === vt(n) && (y = xn(n), an(y).position !== "static" && s === "absolute" && (L = "scrollHeight", T = "scrollWidth")), y = y, i === ut || (i === dt || i === Mt) && o === Or) {
      C = _t;
      var S = f && y === M && M.visualViewport ? M.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[L]
      );
      g -= S - r.height, g *= l ? 1 : -1;
    }
    if (i === dt || (i === ut || i === _t) && o === Or) {
      N = Mt;
      var R = f && y === M && M.visualViewport ? M.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[T]
      );
      p -= R - r.width, p *= l ? 1 : -1;
    }
  }
  var V = Object.assign({
    position: s
  }, u && Gd), A = d === !0 ? Yd({
    x: p,
    y: g
  }, vt(n)) : {
    x: p,
    y: g
  };
  if (p = A.x, g = A.y, l) {
    var E;
    return Object.assign({}, V, (E = {}, E[C] = m ? "0" : "", E[N] = w ? "0" : "", E.transform = (M.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + g + "px)" : "translate3d(" + p + "px, " + g + "px, 0)", E));
  }
  return Object.assign({}, V, (t = {}, t[C] = m ? g + "px" : "", t[N] = w ? p + "px" : "", t.transform = "", t));
}
function Kd(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, a = o === void 0 ? !0 : o, s = n.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Bt(t.placement),
    variation: ir(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ss(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ss(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Jd = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Kd,
  data: {}
};
var oi = {
  passive: !0
};
function Qd(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, o = i === void 0 ? !0 : i, a = r.resize, s = a === void 0 ? !0 : a, l = vt(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, oi);
  }), s && l.addEventListener("resize", n.update, oi), function() {
    o && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, oi);
    }), s && l.removeEventListener("resize", n.update, oi);
  };
}
const e2 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Qd,
  data: {}
};
var t2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function hi(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return t2[t];
  });
}
var n2 = {
  start: "end",
  end: "start"
};
function ks(e) {
  return e.replace(/start|end/g, function(t) {
    return n2[t];
  });
}
function ya(e) {
  var t = vt(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function xa(e) {
  return rr(xn(e)).left + ya(e).scrollLeft;
}
function r2(e, t) {
  var n = vt(e), r = xn(e), i = n.visualViewport, o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    var u = Vc();
    (u || !u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s + xa(e),
    y: l
  };
}
function i2(e) {
  var t, n = xn(e), r = ya(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = kn(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = kn(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + xa(e), l = -r.scrollTop;
  return an(i || n).direction === "rtl" && (s += kn(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function Ca(e) {
  var t = an(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function Ic(e) {
  return ["html", "body", "#document"].indexOf(Ut(e)) >= 0 ? e.ownerDocument.body : Nt(e) && Ca(e) ? e : Ic(Fi(e));
}
function Mr(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Ic(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = vt(r), a = i ? [o].concat(o.visualViewport || [], Ca(r) ? r : []) : r, s = t.concat(a);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Mr(Fi(a)))
  );
}
function Fo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function o2(e, t) {
  var n = rr(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Os(e, t, n) {
  return t === Oc ? Fo(r2(e, n)) : Dn(t) ? o2(t, n) : Fo(i2(xn(e)));
}
function a2(e) {
  var t = Mr(Fi(e)), n = ["absolute", "fixed"].indexOf(an(e).position) >= 0, r = n && Nt(e) ? Qr(e) : e;
  return Dn(r) ? t.filter(function(i) {
    return Dn(i) && Hc(i, r) && Ut(i) !== "body";
  }) : [];
}
function s2(e, t, n, r) {
  var i = t === "clippingParents" ? a2(e) : [].concat(t), o = [].concat(i, [n]), a = o[0], s = o.reduce(function(l, u) {
    var d = Os(e, u, r);
    return l.top = kn(d.top, l.top), l.right = wi(d.right, l.right), l.bottom = wi(d.bottom, l.bottom), l.left = kn(d.left, l.left), l;
  }, Os(e, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Bc(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Bt(r) : null, o = r ? ir(r) : null, a = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (i) {
    case ut:
      l = {
        x: a,
        y: t.y - n.height
      };
      break;
    case _t:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Mt:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case dt:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? ba(i) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (o) {
      case tr:
        l[u] = l[u] - (t[d] / 2 - n[d] / 2);
        break;
      case Or:
        l[u] = l[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function Tr(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, o = n.strategy, a = o === void 0 ? e.strategy : o, s = n.boundary, l = s === void 0 ? Ad : s, u = n.rootBoundary, d = u === void 0 ? Oc : u, f = n.elementContext, h = f === void 0 ? yr : f, p = n.altBoundary, b = p === void 0 ? !1 : p, g = n.padding, v = g === void 0 ? 0 : g, w = Dc(typeof v != "number" ? v : Pc(v, Jr)), m = h === yr ? Ed : yr, N = e.rects.popper, C = e.elements[b ? m : h], M = s2(Dn(C) ? C : C.contextElement || xn(e.elements.popper), l, d, a), y = rr(e.elements.reference), L = Bc({
    reference: y,
    element: N,
    placement: i
  }), T = Fo(Object.assign({}, N, L)), S = h === yr ? T : y, R = {
    top: M.top - S.top + w.top,
    bottom: S.bottom - M.bottom + w.bottom,
    left: M.left - S.left + w.left,
    right: S.right - M.right + w.right
  }, V = e.modifiersData.offset;
  if (h === yr && V) {
    var A = V[i];
    Object.keys(R).forEach(function(E) {
      var P = [Mt, _t].indexOf(E) >= 0 ? 1 : -1, U = [ut, _t].indexOf(E) >= 0 ? "y" : "x";
      R[E] += A[U] * P;
    });
  }
  return R;
}
function l2(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, o = n.rootBoundary, a = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? Tc : l, d = ir(r), f = d ? s ? As : As.filter(function(b) {
    return ir(b) === d;
  }) : Jr, h = f.filter(function(b) {
    return u.indexOf(b) >= 0;
  });
  h.length === 0 && (h = f);
  var p = h.reduce(function(b, g) {
    return b[g] = Tr(e, {
      placement: g,
      boundary: i,
      rootBoundary: o,
      padding: a
    })[Bt(g)], b;
  }, {});
  return Object.keys(p).sort(function(b, g) {
    return p[b] - p[g];
  });
}
function c2(e) {
  if (Bt(e) === ma)
    return [];
  var t = hi(e);
  return [ks(e), t, ks(t)];
}
function u2(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, a = n.altAxis, s = a === void 0 ? !0 : a, l = n.fallbackPlacements, u = n.padding, d = n.boundary, f = n.rootBoundary, h = n.altBoundary, p = n.flipVariations, b = p === void 0 ? !0 : p, g = n.allowedAutoPlacements, v = t.options.placement, w = Bt(v), m = w === v, N = l || (m || !b ? [hi(v)] : c2(v)), C = [v].concat(N).reduce(function(Ce, ke) {
      return Ce.concat(Bt(ke) === ma ? l2(t, {
        placement: ke,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: b,
        allowedAutoPlacements: g
      }) : ke);
    }, []), M = t.rects.reference, y = t.rects.popper, L = /* @__PURE__ */ new Map(), T = !0, S = C[0], R = 0; R < C.length; R++) {
      var V = C[R], A = Bt(V), E = ir(V) === tr, P = [ut, _t].indexOf(A) >= 0, U = P ? "width" : "height", D = Tr(t, {
        placement: V,
        boundary: d,
        rootBoundary: f,
        altBoundary: h,
        padding: u
      }), z = P ? E ? Mt : dt : E ? _t : ut;
      M[U] > y[U] && (z = hi(z));
      var I = hi(z), Y = [];
      if (o && Y.push(D[A] <= 0), s && Y.push(D[z] <= 0, D[I] <= 0), Y.every(function(Ce) {
        return Ce;
      })) {
        S = V, T = !1;
        break;
      }
      L.set(V, Y);
    }
    if (T)
      for (var Z = b ? 3 : 1, ne = function(ke) {
        var he = C.find(function(X) {
          var re = L.get(X);
          if (re)
            return re.slice(0, ke).every(function($) {
              return $;
            });
        });
        if (he)
          return S = he, "break";
      }, fe = Z; fe > 0; fe--) {
        var Me = ne(fe);
        if (Me === "break") break;
      }
    t.placement !== S && (t.modifiersData[r]._skip = !0, t.placement = S, t.reset = !0);
  }
}
const d2 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: u2,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ts(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Vs(e) {
  return [ut, Mt, _t, dt].some(function(t) {
    return e[t] >= 0;
  });
}
function f2(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, a = Tr(t, {
    elementContext: "reference"
  }), s = Tr(t, {
    altBoundary: !0
  }), l = Ts(a, r), u = Ts(s, i, o), d = Vs(l), f = Vs(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const h2 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: f2
};
function p2(e, t, n) {
  var r = Bt(e), i = [dt, ut].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = o[0], s = o[1];
  return a = a || 0, s = (s || 0) * i, [dt, Mt].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function m2(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, o = i === void 0 ? [0, 0] : i, a = Tc.reduce(function(d, f) {
    return d[f] = p2(f, t.rects, o), d;
  }, {}), s = a[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const g2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: m2
};
function v2(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Bc({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const b2 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: v2,
  data: {}
};
function y2(e) {
  return e === "x" ? "y" : "x";
}
function x2(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, o = i === void 0 ? !0 : i, a = n.altAxis, s = a === void 0 ? !1 : a, l = n.boundary, u = n.rootBoundary, d = n.altBoundary, f = n.padding, h = n.tether, p = h === void 0 ? !0 : h, b = n.tetherOffset, g = b === void 0 ? 0 : b, v = Tr(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), w = Bt(t.placement), m = ir(t.placement), N = !m, C = ba(w), M = y2(C), y = t.modifiersData.popperOffsets, L = t.rects.reference, T = t.rects.popper, S = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, R = typeof S == "number" ? {
    mainAxis: S,
    altAxis: S
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, S), V = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, A = {
    x: 0,
    y: 0
  };
  if (y) {
    if (o) {
      var E, P = C === "y" ? ut : dt, U = C === "y" ? _t : Mt, D = C === "y" ? "height" : "width", z = y[C], I = z + v[P], Y = z - v[U], Z = p ? -T[D] / 2 : 0, ne = m === tr ? L[D] : T[D], fe = m === tr ? -T[D] : -L[D], Me = t.elements.arrow, Ce = p && Me ? va(Me) : {
        width: 0,
        height: 0
      }, ke = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Rc(), he = ke[P], X = ke[U], re = _r(0, L[D], Ce[D]), $ = N ? L[D] / 2 - Z - re - he - R.mainAxis : ne - re - he - R.mainAxis, oe = N ? -L[D] / 2 + Z + re + X + R.mainAxis : fe + re + X + R.mainAxis, pe = t.elements.arrow && Qr(t.elements.arrow), Le = pe ? C === "y" ? pe.clientTop || 0 : pe.clientLeft || 0 : 0, Ie = (E = V == null ? void 0 : V[C]) != null ? E : 0, Be = z + $ - Ie - Le, me = z + oe - Ie, Ae = _r(p ? wi(I, Be) : I, z, p ? kn(Y, me) : Y);
      y[C] = Ae, A[C] = Ae - z;
    }
    if (s) {
      var at, _ = C === "x" ? ut : dt, k = C === "x" ? _t : Mt, O = y[M], j = M === "y" ? "height" : "width", F = O + v[_], B = O - v[k], J = [ut, dt].indexOf(w) !== -1, le = (at = V == null ? void 0 : V[M]) != null ? at : 0, be = J ? F : O - L[j] - T[j] - le + R.altAxis, ye = J ? O + L[j] + T[j] - le - R.altAxis : B, Ze = p && J ? qd(be, O, ye) : _r(p ? be : F, O, p ? ye : B);
      y[M] = Ze, A[M] = Ze - O;
    }
    t.modifiersData[r] = A;
  }
}
const C2 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: x2,
  requiresIfExists: ["offset"]
};
function w2(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function N2(e) {
  return e === vt(e) || !Nt(e) ? ya(e) : w2(e);
}
function _2(e) {
  var t = e.getBoundingClientRect(), n = nr(t.width) / e.offsetWidth || 1, r = nr(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function M2(e, t, n) {
  n === void 0 && (n = !1);
  var r = Nt(t), i = Nt(t) && _2(t), o = xn(t), a = rr(e, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Ut(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ca(o)) && (s = N2(t)), Nt(t) ? (l = rr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = xa(o))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function L2(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var a = [].concat(o.requires || [], o.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && i(l);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function A2(e) {
  var t = L2(e);
  return Id.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function E2(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function S2(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Hs = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Rs() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function k2(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, o = i === void 0 ? Hs : i;
  return function(s, l, u) {
    u === void 0 && (u = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Hs, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, p = {
      state: d,
      setOptions: function(w) {
        var m = typeof w == "function" ? w(d.options) : w;
        g(), d.options = Object.assign({}, o, d.options, m), d.scrollParents = {
          reference: Dn(s) ? Mr(s) : s.contextElement ? Mr(s.contextElement) : [],
          popper: Mr(l)
        };
        var N = A2(S2([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = N.filter(function(C) {
          return C.enabled;
        }), b(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var w = d.elements, m = w.reference, N = w.popper;
          if (Rs(m, N)) {
            d.rects = {
              reference: M2(m, Qr(N), d.options.strategy === "fixed"),
              popper: va(N)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(R) {
              return d.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var C = 0; C < d.orderedModifiers.length; C++) {
              if (d.reset === !0) {
                d.reset = !1, C = -1;
                continue;
              }
              var M = d.orderedModifiers[C], y = M.fn, L = M.options, T = L === void 0 ? {} : L, S = M.name;
              typeof y == "function" && (d = y({
                state: d,
                options: T,
                name: S,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: E2(function() {
        return new Promise(function(v) {
          p.forceUpdate(), v(d);
        });
      }),
      destroy: function() {
        g(), h = !0;
      }
    };
    if (!Rs(s, l))
      return p;
    p.setOptions(u).then(function(v) {
      !h && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function b() {
      d.orderedModifiers.forEach(function(v) {
        var w = v.name, m = v.options, N = m === void 0 ? {} : m, C = v.effect;
        if (typeof C == "function") {
          var M = C({
            state: d,
            name: w,
            instance: p,
            options: N
          }), y = function() {
          };
          f.push(M || y);
        }
      });
    }
    function g() {
      f.forEach(function(v) {
        return v();
      }), f = [];
    }
    return p;
  };
}
var O2 = [e2, b2, Jd, Fd, g2, d2, C2, Xd, h2], T2 = /* @__PURE__ */ k2({
  defaultModifiers: O2
}), no, Ds;
function V2() {
  if (Ds) return no;
  Ds = 1;
  var e = typeof Element < "u", t = typeof Map == "function", n = typeof Set == "function", r = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function i(o, a) {
    if (o === a) return !0;
    if (o && a && typeof o == "object" && typeof a == "object") {
      if (o.constructor !== a.constructor) return !1;
      var s, l, u;
      if (Array.isArray(o)) {
        if (s = o.length, s != a.length) return !1;
        for (l = s; l-- !== 0; )
          if (!i(o[l], a[l])) return !1;
        return !0;
      }
      var d;
      if (t && o instanceof Map && a instanceof Map) {
        if (o.size !== a.size) return !1;
        for (d = o.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        for (d = o.entries(); !(l = d.next()).done; )
          if (!i(l.value[1], a.get(l.value[0]))) return !1;
        return !0;
      }
      if (n && o instanceof Set && a instanceof Set) {
        if (o.size !== a.size) return !1;
        for (d = o.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        return !0;
      }
      if (r && ArrayBuffer.isView(o) && ArrayBuffer.isView(a)) {
        if (s = o.length, s != a.length) return !1;
        for (l = s; l-- !== 0; )
          if (o[l] !== a[l]) return !1;
        return !0;
      }
      if (o.constructor === RegExp) return o.source === a.source && o.flags === a.flags;
      if (o.valueOf !== Object.prototype.valueOf && typeof o.valueOf == "function" && typeof a.valueOf == "function") return o.valueOf() === a.valueOf();
      if (o.toString !== Object.prototype.toString && typeof o.toString == "function" && typeof a.toString == "function") return o.toString() === a.toString();
      if (u = Object.keys(o), s = u.length, s !== Object.keys(a).length) return !1;
      for (l = s; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, u[l])) return !1;
      if (e && o instanceof Element) return !1;
      for (l = s; l-- !== 0; )
        if (!((u[l] === "_owner" || u[l] === "__v" || u[l] === "__o") && o.$$typeof) && !i(o[u[l]], a[u[l]]))
          return !1;
      return !0;
    }
    return o !== o && a !== a;
  }
  return no = function(a, s) {
    try {
      return i(a, s);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, no;
}
var H2 = V2();
const R2 = /* @__PURE__ */ Di(H2);
var D2 = [], P2 = function(t, n, r) {
  r === void 0 && (r = {});
  var i = Ln.useRef(null), o = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || D2
  }, a = Ln.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = a[0], l = a[1], u = Ln.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(p) {
        var b = p.state, g = Object.keys(b.elements);
        Bu.flushSync(function() {
          l({
            styles: Ms(g.map(function(v) {
              return [v, b.styles[v] || {}];
            })),
            attributes: Ms(g.map(function(v) {
              return [v, b.attributes[v]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = Ln.useMemo(function() {
    var h = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return R2(i.current, h) ? i.current || h : (i.current = h, h);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, u]), f = Ln.useRef();
  return Ls(function() {
    f.current && f.current.setOptions(d);
  }, [d]), Ls(function() {
    if (!(t == null || n == null)) {
      var h = r.createPopper || T2, p = h(t, n, d);
      return f.current = p, function() {
        p.destroy(), f.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
function I2(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function B2(e) {
  const t = xe(e);
  return I2(t.current, e) || (t.current = e), t.current;
}
function $2(e, t = () => null, { enabled: n = !0 } = {}) {
  const r = Array.isArray(e) ? e : [e], i = B2(r);
  te(() => {
    function o(a) {
      n && i.every((s) => !(s != null && s.contains(a.target))) && t();
    }
    return document.addEventListener("mousedown", o), () => {
      document.removeEventListener("mousedown", o);
    };
  }, [i, n, t]);
}
function ei({
  open: e = !1,
  className: t,
  anchorEl: n,
  placement: r = "bottom-start",
  offset: i = [0, 0],
  children: o,
  style: a,
  onClickOutside: s
}) {
  const [l, u] = ie(null), { styles: d } = P2(n, l, {
    placement: r,
    modifiers: [{ name: "offset", options: { offset: i } }]
  });
  return $2([l, n], s, { enabled: e }), /* @__PURE__ */ c(Ur, { mounted: e, rootClassName: "popover-portal", children: /* @__PURE__ */ c(
    "div",
    {
      ref: u,
      style: { ...d.popper, ...a, pointerEvents: "auto" },
      className: H("bbn-popover", t),
      children: /* @__PURE__ */ c("div", { className: "bbn-popover-content", children: o })
    }
  ) });
}
function $c(e) {
  const [t, n] = ie({ width: 0, height: 0 });
  return te(() => {
    if (!e) {
      n({ width: 0, height: 0 });
      return;
    }
    const r = new ResizeObserver(([i]) => {
      n({
        width: i.target.clientWidth,
        height: i.target.clientHeight
      });
    });
    return r.observe(e), () => {
      r.unobserve(e);
    };
  }, [e]), t;
}
const F2 = (e) => e.label, wa = bt(
  ({
    disabled: e,
    className: t,
    value: n,
    defaultValue: r,
    placeholder: i = "Select option",
    open: o,
    defaultOpen: a,
    options: s = [],
    optionClassName: l,
    popoverClassName: u,
    state: d = "default",
    onOpen: f,
    onSelect: h,
    onClose: p,
    renderSelectedOption: b = F2,
    ...g
  }, v) => {
    const w = xe(null);
    jr(v, () => w.current, []);
    const { width: m } = $c(w.current), N = (A) => {
      if (!A) return i || "";
      const E = b(A);
      return typeof E == "string" ? E : A.label;
    }, [C, M] = zt({
      value: o,
      defaultValue: a,
      onStateChange: (A) => void (A ? f == null ? void 0 : f() : p == null ? void 0 : p())
    }), [y, L] = zt({
      value: n,
      defaultValue: r,
      onStateChange: h
    }), T = de(
      () => s.find((A) => A.value === y),
      [s, y]
    ), S = we(
      (A) => {
        A.disabled || (L(A.value), M(!1));
      },
      [L, M]
    ), R = we(() => {
      M(!1);
    }, [M]), V = we(() => {
      e || M(!C);
    }, [C, e, M]);
    return /* @__PURE__ */ x(He, { children: [
      /* @__PURE__ */ x(
        "div",
        {
          ref: w,
          className: H("bbn-select", e && "bbn-select-disabled", `bbn-select-${d}`, t),
          onClick: V,
          tabIndex: e ? -1 : 0,
          ...g,
          children: [
            /* @__PURE__ */ c("div", { className: "bbn-select-text-container", children: /* @__PURE__ */ c(
              "span",
              {
                className: "bbn-select-text",
                title: N(T),
                children: T ? b(T) : i
              }
            ) }),
            /* @__PURE__ */ c(ac, { className: H("bbn-select-icon", C && "bbn-select-icon-open"), size: 20 })
          ]
        }
      ),
      /* @__PURE__ */ c(
        ei,
        {
          anchorEl: w.current,
          className: H("bbn-select-menu custom-scrollbar", u),
          open: C && !e,
          onClickOutside: R,
          offset: [0, 4],
          placement: "bottom-start",
          style: { width: m },
          children: s.map((A) => /* @__PURE__ */ x(
            "div",
            {
              className: H(
                "bbn-select-option",
                (T == null ? void 0 : T.value) === A.value && "bbn-select-option-selected",
                A.disabled && "bbn-select-option-disabled",
                l
              ),
              onClick: () => S(A),
              "aria-disabled": A.disabled || void 0,
              children: [
                /* @__PURE__ */ c("span", { className: "bbn-select-option-label", children: A.label }),
                A.disabled && A.tooltip && /* @__PURE__ */ c(
                  kr,
                  {
                    tooltip: A.tooltip,
                    status: "warning",
                    placement: "left",
                    className: "bbn-select-option-hint",
                    attachToChildren: !0,
                    children: /* @__PURE__ */ c(
                      a0,
                      {
                        className: "bbn-select-option-warning",
                        size: 16,
                        "aria-label": "Provider unavailable"
                      }
                    )
                  }
                )
              ]
            },
            A.value
          ))
        }
      )
    ] });
  }
);
wa.displayName = "Select";
const z2 = bt(
  ({
    disabled: e,
    className: t,
    value: n,
    defaultValue: r,
    placeholder: i = "Select option",
    open: o,
    defaultOpen: a,
    options: s = [],
    optionClassName: l,
    popoverClassName: u,
    state: d = "default",
    onOpen: f,
    onSelect: h,
    onClose: p,
    ...b
  }, g) => {
    const v = xe(null);
    jr(g, () => v.current, []);
    const { width: w } = $c(v.current), [m, N] = zt({
      value: o,
      defaultValue: a,
      onStateChange: (E) => void (E ? f == null ? void 0 : f() : p == null ? void 0 : p())
    }), [C, M] = zt({
      value: n,
      defaultValue: r,
      onStateChange: h
    }), y = de(
      () => s.find((E) => E.value === C),
      [s, C]
    ), [L, T] = ie(-1);
    te(() => {
      if (m) {
        const E = s.findIndex((P) => P.value === C);
        T(E >= 0 ? E : 0);
      } else
        T(-1);
    }, [m, s, C]);
    const S = we(
      (E) => {
        M(E.value), N(!1);
      },
      [M, N]
    ), R = we(() => {
      N(!1);
    }, [N]), V = we(() => {
      e || N(!m);
    }, [m, e, N]), A = we(
      (E) => {
        if (!e)
          switch (E.key) {
            case "ArrowDown":
              E.preventDefault(), m ? L < s.length - 1 && T(L + 1) : N(!0);
              break;
            case "ArrowUp":
              E.preventDefault(), m ? L > 0 && T(L - 1) : N(!0);
              break;
            case "Home":
              E.preventDefault(), m && s.length > 0 && T(0);
              break;
            case "End":
              E.preventDefault(), m && s.length > 0 && T(s.length - 1);
              break;
            case "Enter":
            case " ":
              E.preventDefault(), m ? L >= 0 && L < s.length && S(s[L]) : N(!0);
              break;
            case "Escape":
              m && (E.preventDefault(), N(!1));
              break;
            case "Tab":
              m && N(!1);
              break;
          }
      },
      [e, m, L, s, N, S]
    );
    return /* @__PURE__ */ x(He, { children: [
      /* @__PURE__ */ x(
        "div",
        {
          ref: v,
          className: H(
            "bbn-select-with-icon",
            e && "bbn-select-with-icon-disabled",
            `bbn-select-with-icon-${d}`,
            t
          ),
          role: "combobox",
          "aria-expanded": m,
          "aria-haspopup": "listbox",
          "aria-label": y ? y.label : i,
          "aria-disabled": e,
          onClick: V,
          onKeyDown: A,
          tabIndex: e ? -1 : 0,
          ...b,
          children: [
            /* @__PURE__ */ x("div", { className: "bbn-select-with-icon-content", children: [
              (y == null ? void 0 : y.icon) && /* @__PURE__ */ c("div", { className: "bbn-select-with-icon-image", children: y.icon }),
              /* @__PURE__ */ c("span", { className: "bbn-select-with-icon-text", title: (y == null ? void 0 : y.label) || i, children: y ? y.label : i })
            ] }),
            /* @__PURE__ */ c(
              ac,
              {
                className: H("bbn-select-with-icon-arrow", m && "bbn-select-with-icon-arrow-open"),
                size: 35
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ c(
        ei,
        {
          anchorEl: v.current,
          className: H("bbn-select-with-icon-menu custom-scrollbar", u),
          open: m && !e,
          onClickOutside: R,
          offset: [0, 4],
          placement: "bottom-start",
          style: { width: w },
          children: /* @__PURE__ */ c("div", { role: "listbox", children: s.map((E, P) => /* @__PURE__ */ x(
            "div",
            {
              role: "option",
              "aria-selected": (y == null ? void 0 : y.value) === E.value,
              className: H(
                "bbn-select-with-icon-option",
                (y == null ? void 0 : y.value) === E.value && "bbn-select-with-icon-option-selected",
                L === P && "bbn-select-with-icon-option-focused",
                l
              ),
              onClick: () => S(E),
              children: [
                E.icon && /* @__PURE__ */ c("div", { className: "bbn-select-with-icon-option-image", children: E.icon }),
                /* @__PURE__ */ c("span", { className: "bbn-select-with-icon-option-text", children: E.label })
              ]
            },
            E.value
          )) })
        }
      )
    ] });
  }
);
z2.displayName = "SelectWithIcon";
const zi = bt(
  ({ className: e, prefix: t, suffix: n, wrapperClassName: r, disabled: i = !1, state: o = "default", ...a }, s) => /* @__PURE__ */ x("div", { className: H("bbn-input", `bbn-input-${o}`, i && "bbn-input-disabled", n && "bbn-input-has-suffix", r), children: [
    t && /* @__PURE__ */ c("div", { className: "bbn-input-prefix", children: t }),
    /* @__PURE__ */ c("input", { ref: s, className: H("bbn-input-field", e), disabled: i, ...a }),
    n && /* @__PURE__ */ c("div", { className: "bbn-input-suffix", children: n })
  ] })
);
zi.displayName = "Input";
function ji({ children: e, label: t, hint: n, state: r = "default", className: i }) {
  return /* @__PURE__ */ x("div", { className: H("bbn-form-control", i), children: [
    t ? /* @__PURE__ */ x("label", { className: "bbn-form-control-label", children: [
      /* @__PURE__ */ c("div", { className: "bbn-form-control-title", children: t }),
      e
    ] }) : e,
    n && /* @__PURE__ */ c("div", { className: H("bbn-form-control-hint", `bbn-form-control-hint-${r}`), children: n })
  ] });
}
function p8({ attributes: e, className: t }) {
  return /* @__PURE__ */ c("div", { className: t, children: e.map((n, r) => /* @__PURE__ */ x(
    "div",
    {
      className: "flex items-center justify-between border-b border-surface-secondary py-4 first:pt-0 last:border-0",
      children: [
        /* @__PURE__ */ c("span", { className: "text-sm text-accent-secondary", children: n.label }),
        /* @__PURE__ */ c("span", { className: "text-sm text-accent-primary font-medium", children: n.value })
      ]
    },
    r
  )) });
}
function m8({ className: e, ...t }) {
  return /* @__PURE__ */ c("span", { ...t, className: H("bbn-chip", e) });
}
function g8({
  children: e,
  className: t,
  disabled: n,
  ...r
}) {
  return /* @__PURE__ */ c(
    "button",
    {
      type: "button",
      disabled: n,
      className: H(
        "bbn-chip m-0 shrink-0 rounded-full border-0 bg-transparent",
        "!bg-primary-light !text-accent-contrast",
        "cursor-pointer disabled:cursor-default",
        n && "opacity-50",
        t
      ),
      ...r,
      children: e
    }
  );
}
function Na({ size: e = 40, className: t }) {
  return /* @__PURE__ */ c("span", { className: ee("bbn-loader text-current", t), style: { width: e, height: e }, children: /* @__PURE__ */ c("svg", { viewBox: "22 22 44 44", children: /* @__PURE__ */ c("circle", { cx: "44", cy: "44", r: "20.2", fill: "none", stroke: "currentColor", strokeWidth: "3.6" }) }) });
}
function j2(e, { onLoadMore: t, hasMore: n = !1, loading: r = !1 } = {}) {
  const [i, o] = ie(!1);
  return te(() => {
    const a = pc((l) => {
      const u = l.target;
      o(u.scrollTop > 0), !r && n && u.scrollHeight - u.scrollTop <= u.clientHeight + 100 && (t == null || t());
    }, 100), s = e.current;
    if (s)
      return s.addEventListener("scroll", a), () => s.removeEventListener("scroll", a);
  }, [r, n, t, e]), {
    isScrolledTop: i
  };
}
function q2(e) {
  const [t, n] = ie(!1), [r, i] = ie(!1);
  return te(() => {
    const o = e.current;
    if (!o) return;
    const a = () => {
      const { scrollLeft: s, scrollWidth: l, clientWidth: u } = o;
      n(s > 0);
      const d = l - u;
      i(d > 0 && s < d);
    };
    return a(), o.addEventListener("scroll", a), () => o.removeEventListener("scroll", a);
  }, [e]), { isLeftScrolled: t, isRightScrolled: r };
}
const Fc = cr({
  data: [],
  columns: [],
  sortStates: {},
  onColumnSort: void 0,
  onRowSelect: void 0,
  onRowClick: void 0,
  selectable: !1,
  selectedRows: [],
  onSelectAll: void 0,
  renderCheckbox: void 0,
  isRowSelectable: void 0,
  checkboxPosition: "left",
  showSelectAll: !0
});
function U2({
  name: e,
  className: t,
  children: n,
  sorter: r,
  frozen: i,
  showFrozenShadow: o,
  ...a
}) {
  const { columns: s, sortStates: l, onColumnSort: u } = $n(Fc), d = l[e ?? ""], f = d == null ? void 0 : d.direction, h = i ? `bbn-table-frozen bbn-table-frozen-${i}` : "";
  return /* @__PURE__ */ c(
    Q,
    {
      variant: "caption",
      as: "th",
      className: H("bbn-cell-left", r && "bbn-table-sortable", h, i && o ? "bbn-frozen-shadow" : "", t),
      onClick: () => {
        if (r && e) {
          const b = s.find((g) => g.key === e);
          u == null || u(e, b == null ? void 0 : b.sorter);
        }
      },
      "data-column": e,
      ...a,
      children: /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-1", children: [
        /* @__PURE__ */ c("span", { children: n }),
        r && /* @__PURE__ */ x("span", { className: "bbn-table-sort-icons", children: [
          /* @__PURE__ */ c(
            o0,
            {
              className: H(
                "bbn-sort-icon bbn-sort-icon-up",
                f === "asc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          ),
          /* @__PURE__ */ c(
            i0,
            {
              className: H(
                "bbn-sort-icon bbn-sort-icon-down",
                f === "desc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          )
        ] })
      ] })
    }
  );
}
const W2 = {
  /**
   * Default table style - alternating colors, hover effects, standard header
   */
  default: {},
  /**
   * Card style - transparent header, card-like rows with gaps
   * Ideal for dashboard cards and modern interfaces
   */
  card: {
    layout: {
      fullWidth: !0,
      rowGap: !0
    },
    header: {
      background: !1
    },
    rows: {
      alternateColors: !1,
      hoverEffect: !1,
      rounded: !0,
      border: !1
    }
  }
};
function Z2(e, t) {
  const [n, r] = ie({}), i = we((a, s) => {
    s && r((l) => {
      var h;
      const u = ((h = l[a]) == null ? void 0 : h.direction) ?? null, d = u === null ? "asc" : u === "asc" ? "desc" : null;
      if (d === null)
        return Object.fromEntries(
          Object.entries(l).filter(([p]) => p !== a).map(([p, b]) => [
            p,
            { ...b, priority: b.priority > l[a].priority ? b.priority - 1 : b.priority }
          ])
        );
      const f = Math.max(0, ...Object.values(l).map((p) => p.priority));
      return {
        ...l,
        [a]: { direction: d, priority: f + 1 }
      };
    });
  }, []), o = de(() => {
    const a = Object.entries(n).filter(([, s]) => s.direction !== null).toSorted((s, l) => l[1].priority - s[1].priority).map(([s, l]) => ({
      column: t.find((u) => u.key === s),
      direction: l.direction
    })).filter(({ column: s }) => s == null ? void 0 : s.sorter);
    return a.length === 0 ? e : e.toSorted((s, l) => {
      for (const { column: u, direction: d } of a) {
        const f = u.sorter(s, l);
        if (f !== 0) return d === "asc" ? f : -f;
      }
      return 0;
    });
  }, [e, t, n]);
  return { sortStates: n, handleColumnSort: i, sortedData: o };
}
function X2({
  className: e,
  render: t,
  value: n,
  columnName: r,
  frozen: i,
  showFrozenShadow: o,
  ...a
}) {
  const s = i ? `bbn-table-frozen bbn-table-frozen-${i}` : "";
  return /* @__PURE__ */ c(
    Q,
    {
      variant: "body2",
      as: "td",
      className: H("bbn-cell-left", s, i && o ? "bbn-frozen-shadow" : "", e),
      "data-column": r,
      ...a,
      children: t ? t(n) : n
    }
  );
}
function G2({
  row: e,
  columns: t,
  isSelected: n,
  isSelectable: r,
  isDisabled: i = !1,
  onSelect: o,
  onRowClick: a,
  isLeftScrolled: s,
  isRightScrolled: l,
  selectable: u = !1,
  renderCheckbox: d,
  checkboxPosition: f = "left"
}) {
  const h = () => {
    a ? a(e) : o && !u && o(e);
  }, b = u ? /* @__PURE__ */ c("td", { className: "bbn-table-cell-checkbox", children: /* @__PURE__ */ c("div", { className: "flex items-center justify-center", onClick: (g) => {
    g.stopPropagation(), r && o && o(e);
  }, children: d ? d(n, e) : /* @__PURE__ */ c(
    "input",
    {
      type: "checkbox",
      checked: n,
      onChange: () => {
      },
      disabled: !r,
      "aria-label": `Select row ${e.id}`
    }
  ) }) }) : null;
  return /* @__PURE__ */ x(
    "tr",
    {
      className: H(
        n && "selected",
        (!!o || !!a) && r && "cursor-pointer",
        (!r || i) && "bbn-table-row-disabled"
      ),
      onClick: h,
      children: [
        f === "left" && b,
        t.map((g) => /* @__PURE__ */ c(
          X2,
          {
            value: e[g.key],
            columnName: g.key,
            className: g.cellClassName,
            frozen: g.frozen,
            showFrozenShadow: g.frozen === "left" && s || g.frozen === "right" && l,
            render: g.render ? (v) => g.render(v, e) : void 0
          },
          g.key
        )),
        f === "right" && b
      ]
    }
  );
}
const Y2 = {
  // Layout
  fullWidth: !1,
  rowGap: !1,
  rowGapSize: void 0,
  // Header
  background: !0,
  backgroundColor: void 0,
  // Rows
  alternateColors: !0,
  hoverEffect: !0,
  rounded: !1,
  border: !1,
  borderRadius: void 0,
  borderColor: void 0,
  rowBackgroundColor: void 0,
  hoverColor: void 0,
  clickable: !1
};
function K2(e, t) {
  return {
    layout: { ...e.layout ?? {}, ...t.layout ?? {} },
    header: { ...e.header ?? {}, ...t.header ?? {} },
    rows: { ...e.rows ?? {}, ...t.rows ?? {} }
  };
}
function J2(e, t) {
  const n = e ? W2[e] ?? {} : {}, r = K2(n, t ?? {});
  return {
    ...Y2,
    ...r.layout,
    ...r.header,
    ...r.rows
  };
}
function Q2({
  data: e,
  columns: t,
  className: n,
  wrapperClassName: r,
  fluid: i = !1,
  hasMore: o = !1,
  loading: a = !1,
  onLoadMore: s,
  onRowSelect: l,
  onRowClick: u,
  isRowSelectable: d,
  isRowDisabled: f,
  stylePreset: h,
  styleConfig: p,
  selectedRow: b,
  defaultSelectedRow: g,
  onSelectedRowChange: v,
  // Multi-select props
  selectable: w = !1,
  selectedRows: m,
  onSelectedRowsChange: N,
  renderCheckbox: C,
  checkboxPosition: M = "left",
  showSelectAll: y = !0,
  ...L
}, T) {
  const S = de(() => J2(h, p), [h, p]), R = xe(null);
  jr(T, () => R.current, []);
  const { sortStates: V, handleColumnSort: A, sortedData: E } = Z2(e, t), { isScrolledTop: P } = j2(R, { onLoadMore: s, hasMore: o, loading: a }), { isLeftScrolled: U, isRightScrolled: D } = q2(R), [z, I] = zt({
    value: b,
    defaultValue: g ?? null,
    onStateChange: v
  }), [Y, Z] = zt({
    value: m,
    defaultValue: [],
    onStateChange: N
  }), ne = Y ?? [], fe = we(
    ($) => {
      if (!l || d && !d($)) return;
      const oe = z === $.id ? null : $.id;
      I(oe), l(oe === null ? null : $);
    },
    [l, d, z, I]
  ), Me = we(
    ($) => {
      if (d && !d($)) return;
      const pe = ne.includes($.id) ? ne.filter((Le) => Le !== $.id) : [...ne, $.id];
      Z(pe);
    },
    [ne, Z, d]
  ), Ce = we(() => {
    if (ne.length === E.length)
      Z([]);
    else {
      const $ = E.filter((oe) => !d || d(oe)).map((oe) => oe.id);
      Z($);
    }
  }, [E, ne.length, Z, d]), ke = de(
    () => ({
      data: E,
      columns: t,
      sortStates: V,
      onColumnSort: A,
      onRowSelect: w ? Me : fe,
      onRowClick: u,
      // Multi-select
      selectable: w,
      selectedRows: ne,
      onSelectAll: Ce,
      renderCheckbox: C,
      isRowSelectable: d,
      checkboxPosition: M,
      showSelectAll: y
    }),
    [
      E,
      t,
      V,
      A,
      fe,
      Me,
      u,
      w,
      ne,
      Ce,
      C,
      d,
      M,
      y
    ]
  ), he = de(() => t.some(($) => $.header && $.header !== ""), [t]), X = de(() => {
    const $ = E.filter((oe) => !d || d(oe));
    return $.length > 0 && $.every((oe) => ne.includes(oe.id));
  }, [E, ne, d]), re = de(() => {
    const $ = {};
    return S.rowGapSize && ($["--bbn-table-row-gap"] = S.rowGapSize), S.backgroundColor && ($["--bbn-table-header-bg"] = S.backgroundColor), S.borderRadius && ($["--bbn-table-row-radius"] = S.borderRadius), S.borderColor && ($["--bbn-table-row-border-color"] = S.borderColor), S.rowBackgroundColor && ($["--bbn-table-row-bg"] = S.rowBackgroundColor), S.hoverColor && ($["--bbn-table-row-hover-bg"] = S.hoverColor), Object.keys($).length > 0 ? $ : void 0;
  }, [S]);
  return /* @__PURE__ */ c(Fc.Provider, { value: ke, children: /* @__PURE__ */ c("div", { ref: R, className: H("bbn-table-wrapper", i && "bbn-table-wrapper-fluid", r), children: /* @__PURE__ */ x(
    "table",
    {
      className: H(
        "bbn-table",
        i && "bbn-table-fluid",
        S.rounded && "bbn-table-rounded",
        S.fullWidth && "bbn-table-fullrow",
        S.rowGap && "bbn-table-row-gap",
        n
      ),
      style: re,
      ...L,
      children: [
        /* @__PURE__ */ c("thead", { className: H("bbn-table-header", !S.background && "bbn-table-header-transparent", P && "scrolled-top", !he && "hidden"), children: /* @__PURE__ */ x("tr", { children: [
          w && M === "left" && /* @__PURE__ */ c("th", { className: "bbn-table-cell-checkbox", children: y && /* @__PURE__ */ c("div", { className: "flex items-center justify-center", children: C ? /* @__PURE__ */ c("div", { onClick: Ce, children: C(X, {}) }) : /* @__PURE__ */ c(
            "input",
            {
              type: "checkbox",
              checked: X,
              onChange: Ce,
              "aria-label": "Select all rows"
            }
          ) }) }),
          t.map(($) => /* @__PURE__ */ c(
            U2,
            {
              className: $.headerClassName,
              name: $.key,
              sorter: $.sorter,
              frozen: $.frozen,
              showFrozenShadow: $.frozen === "left" && U || $.frozen === "right" && D,
              children: $.header
            },
            $.key
          )),
          w && M === "right" && /* @__PURE__ */ c("th", { className: "bbn-table-cell-checkbox", children: y && /* @__PURE__ */ c("div", { className: "flex items-center justify-center", children: C ? /* @__PURE__ */ c("div", { onClick: Ce, children: C(X, {}) }) : /* @__PURE__ */ c(
            "input",
            {
              type: "checkbox",
              checked: X,
              onChange: Ce,
              "aria-label": "Select all rows"
            }
          ) }) })
        ] }) }),
        /* @__PURE__ */ c(
          "tbody",
          {
            className: H(
              "bbn-table-body",
              S.fullWidth && "bbn-table-body-full",
              !S.alternateColors && "bbn-table-body-no-alternate",
              !S.hoverEffect && "bbn-table-body-no-hover",
              S.border ? "bbn-table-body-row-border" : !S.alternateColors && "bbn-table-body-no-border",
              S.clickable && "bbn-table-body-clickable"
            ),
            children: E.map(($) => /* @__PURE__ */ c(
              G2,
              {
                row: $,
                columns: t,
                isSelected: w ? ne.includes($.id) : z === $.id,
                isSelectable: d ? d($) : !0,
                isDisabled: (f == null ? void 0 : f($)) ?? !1,
                onSelect: w ? Me : fe,
                onRowClick: u,
                isLeftScrolled: U,
                isRightScrolled: D,
                selectable: w,
                renderCheckbox: C,
                checkboxPosition: M
              },
              $.id
            ))
          }
        )
      ]
    }
  ) }) });
}
const ef = bt(Q2);
function tf({ as: e = "div", variant: t = "default", className: n, children: r }) {
  return Hi(e, { className: H("bbn-card", `bbn-card-${t}`, n) }, r);
}
function qi(e = {}) {
  const { copiedText: t = "Copied ✓", timeout: n = 2e3 } = e, [r, i] = ie({}), o = xe({}), a = we((d) => {
    d && i((f) => ({ ...f, [d]: !1 }));
  }, []), s = we(
    (d, f) => {
      if (!d || !f) return;
      navigator.clipboard.writeText(f).catch(() => {
      }), i((p) => ({ ...p, [d]: !0 }));
      const h = o.current[d];
      h && clearTimeout(h), n > 0 && (o.current[d] = setTimeout(() => {
        o.current[d] = void 0, a(d);
      }, n));
    },
    [n, a]
  ), l = we(
    (d) => d && r[d] || !1,
    [r]
  ), u = we(
    (d) => d && r[d] ? t : "",
    [r, t]
  );
  return te(() => () => {
    Object.values(o.current).forEach((d) => d && clearTimeout(d)), o.current = {};
  }, []), {
    isCopied: l,
    copiedText: u,
    copyToClipboard: s
  };
}
const zc = ({
  children: e,
  value: t,
  className: n,
  onCopy: r,
  isCopied: i,
  copiedText: o,
  timeout: a = 2e3
}) => {
  const s = Xt(), l = {
    copiedText: o,
    timeout: a
  }, {
    isCopied: u,
    copiedText: d,
    copyToClipboard: f
  } = qi(l), h = i !== void 0, p = h ? i : u(s), b = h ? o || "Copied ✓" : d(s), g = (v) => {
    v.stopPropagation(), h && r ? r(t) : f(s, t);
  };
  return /* @__PURE__ */ c(
    "div",
    {
      className: ee(
        "inline-flex items-center cursor-pointer hover:opacity-100 transition-opacity duration-200",
        n
      ),
      onClick: g,
      children: /* @__PURE__ */ x("div", { className: "relative", children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: ee(
              "transition-opacity duration-300 ease-in-out",
              p && "opacity-0"
            ),
            children: e
          }
        ),
        p && /* @__PURE__ */ c(
          "div",
          {
            className: ee(
              "absolute inset-0 flex items-center transition-opacity duration-300 ease-in-out text-green-600",
              "opacity-100"
            ),
            children: b
          }
        )
      ] })
    }
  );
};
function jc(e, t = 8) {
  if (!e || e.length <= t * 2)
    return e;
  const n = e.slice(0, t), r = e.slice(-t);
  return `${n}...${r}`;
}
function nf(e) {
  return typeof e == "string" && e.length >= 42 ? jc(e) : e;
}
function rf(e) {
  return typeof e == "string" && e.length >= 42;
}
function v8({
  items: e,
  showDivider: t = !0,
  textSize: n = "medium",
  className: r
}) {
  const i = n === "medium" ? "text-[16px]" : "text-[14px]";
  return /* @__PURE__ */ c(
    "div",
    {
      className: ee(
        "flex flex-col gap-6",
        t && "divide-y divide-surface-secondary",
        r
      ),
      children: e.map((o, a) => {
        const s = rf(o.value), l = nf(o.value);
        return /* @__PURE__ */ x("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ c("span", { className: ee(i, "font-normal text-accent-secondary"), children: o.label }),
          /* @__PURE__ */ x("span", { className: ee(
            i,
            "font-normal text-accent-primary",
            s && "flex items-center gap-1.5"
          ), children: [
            l,
            s && typeof o.value == "string" && /* @__PURE__ */ c(
              zc,
              {
                value: o.value,
                className: "shrink-0",
                copiedText: "✓",
                children: /* @__PURE__ */ c(Er, { size: 14, className: "text-accent-secondary" })
              }
            )
          ] })
        ] }, a);
      })
    }
  );
}
const _a = ({
  value: e,
  defaultValue: t = !1,
  onChange: n,
  className: r = "",
  disabled: i = !1,
  "aria-label": o = "Toggle"
}) => {
  const [a = !1, s] = zt({
    value: e,
    defaultValue: t,
    onStateChange: n
  });
  return /* @__PURE__ */ c(
    "button",
    {
      type: "button",
      onClick: () => {
        i || s(!a);
      },
      disabled: i,
      className: H(
        "bbn-toggle",
        a && "bbn-toggle-active",
        i && "bbn-toggle-disabled",
        r
      ),
      "aria-pressed": a,
      "aria-label": o,
      children: /* @__PURE__ */ c(
        "span",
        {
          className: H(
            "bbn-toggle-control",
            a && "bbn-toggle-control-active"
          )
        }
      )
    }
  );
};
function of({
  value: e,
  min: t,
  max: n,
  step: r = 1,
  steps: i,
  maxStepCount: o = 10,
  snapToSteps: a = !0,
  onChange: s,
  onStepsChange: l,
  variant: u = "primary",
  activeColor: d,
  className: f,
  disabled: h = !1,
  showFill: p = !0,
  "aria-label": b
}) {
  const g = de(() => (e - t) / (n - t) * 100, [e, t, n]), v = de(() => {
    if (typeof i == "number") {
      const y = Math.min(i, o), L = (n - t) / (y - 1);
      return Array.from({ length: y }, (T, S) => ({
        value: t + L * S
      }));
    }
    if (Array.isArray(i))
      return i.slice(0, o);
    const C = 5, M = (n - t) / C;
    return Array.from({ length: C }, (y, L) => ({
      value: t + M * L
    }));
  }, [i, t, n, o, r]), w = de(() => v ? v.filter((C) => C.value > t && C.value < n) : [], [v, t, n]), m = de(() => {
    if (a && Array.isArray(i) && v && v.length > 1) {
      const C = v.map((y) => y.value).sort((y, L) => y - L);
      let M = 1 / 0;
      for (let y = 1; y < C.length; y++) {
        const L = C[y] - C[y - 1];
        L > 0 && L < M && (M = L);
      }
      return M !== 1 / 0 ? M : r;
    }
    return r;
  }, [a, i, v, r]), N = (C) => {
    if (a && Array.isArray(i) && v && v.length > 0) {
      const M = v.reduce((y, L) => Math.abs(L.value - C) < Math.abs(y.value - C) ? L : y);
      if (s(M.value), l && v) {
        const y = v.findIndex((L) => L.value === M.value);
        if (y !== -1) {
          const L = v.slice(0, y + 1).map((T) => T.value);
          l(L);
        }
      }
    } else
      s(C);
  };
  return /* @__PURE__ */ x(
    "div",
    {
      className: H(
        "relative flow-root w-full",
        Array.isArray(i) && i.some((C) => C.label) && "mt-4"
      ),
      children: [
        /* @__PURE__ */ c(
          "input",
          {
            type: "range",
            min: t,
            max: n,
            step: m,
            value: e,
            onChange: (C) => N(parseFloat(C.target.value)),
            disabled: h,
            "aria-label": b,
            className: H(
              "bbn-slider",
              `bbn-slider-${u}`,
              p && "bbn-slider-filled",
              h && "bbn-slider-disabled",
              w.length > 0 && "bbn-slider-with-steps",
              f
            ),
            style: {
              "--slider-fill": `${g}%`,
              "--slider-active-color": d
            }
          }
        ),
        w.length > 0 && /* @__PURE__ */ c(
          "div",
          {
            className: "absolute left-0 right-0 pointer-events-none z-10",
            style: { top: "calc(50% - 1px)" },
            children: w.map((C, M) => {
              const y = (C.value - t) / (n - t) * 100;
              return /* @__PURE__ */ c(
                "div",
                {
                  className: "absolute rounded-full bg-white",
                  style: {
                    width: "4px",
                    height: "4px",
                    left: `calc(${y}% - 1px)`
                  },
                  children: C.label && /* @__PURE__ */ c("span", { className: "absolute bottom-full left-1/2 mb-2.5 -translate-x-1/2 whitespace-nowrap rounded bg-primary-contrast px-2 py-1 text-xs text-accent-primary after:absolute after:left-1/2 after:top-full after:-translate-x-1/2 after:border-4 after:border-transparent after:border-t-primary-contrast after:content-['']", children: C.label })
                },
                M
              );
            })
          }
        ),
        u === "rainbow" && /* @__PURE__ */ c(
          "div",
          {
            className: "absolute top-0 h-2 rounded-lg pointer-events-none",
            style: {
              left: `${g}%`,
              right: 0,
              backgroundColor: "var(--unfilled-color)"
            }
          }
        )
      ]
    }
  );
}
function Xe(e) {
  return function() {
    return e;
  };
}
const zo = Math.PI, jo = 2 * zo, _n = 1e-6, af = jo - _n;
function qc(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function sf(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return qc;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class lf {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? qc : sf(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, l = r - t, u = i - n, d = a - t, f = s - n, h = d * d + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > _n) if (!(Math.abs(f * l - u * d) > _n) || !o)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let p = r - a, b = i - s, g = l * l + u * u, v = p * p + b * b, w = Math.sqrt(g), m = Math.sqrt(h), N = o * Math.tan((zo - Math.acos((g + h - v) / (2 * w * m))) / 2), C = N / m, M = N / w;
      Math.abs(C - 1) > _n && this._append`L${t + C * d},${n + C * f}`, this._append`A${o},${o},0,0,${+(f * p > d * b)},${this._x1 = t + M * l},${this._y1 = n + M * u}`;
    }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), l = r * Math.sin(i), u = t + s, d = n + l, f = 1 ^ a, h = a ? i - o : o - i;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > _n || Math.abs(this._y1 - d) > _n) && this._append`L${u},${d}`, r && (h < 0 && (h = h % jo + jo), h > af ? this._append`A${r},${r},0,1,${f},${t - s},${n - l}A${r},${r},0,1,${f},${this._x1 = u},${this._y1 = d}` : h > _n && this._append`A${r},${r},0,${+(h >= zo)},${f},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function Uc(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new lf(t);
}
function Wc(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Zc(e) {
  this._context = e;
}
Zc.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Xc(e) {
  return new Zc(e);
}
function Gc(e) {
  return e[0];
}
function Yc(e) {
  return e[1];
}
function Kc(e, t) {
  var n = Xe(!0), r = null, i = Xc, o = null, a = Uc(s);
  e = typeof e == "function" ? e : e === void 0 ? Gc : Xe(e), t = typeof t == "function" ? t : t === void 0 ? Yc : Xe(t);
  function s(l) {
    var u, d = (l = Wc(l)).length, f, h = !1, p;
    for (r == null && (o = i(p = a())), u = 0; u <= d; ++u)
      !(u < d && n(f = l[u], u, l)) === h && ((h = !h) ? o.lineStart() : o.lineEnd()), h && o.point(+e(f, u, l), +t(f, u, l));
    if (p) return o = null, p + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Xe(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Xe(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Xe(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (i = l, r != null && (o = i(r)), s) : i;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = o = null : o = i(r = l), s) : r;
  }, s;
}
function cf(e, t, n) {
  var r = null, i = Xe(!0), o = null, a = Xc, s = null, l = Uc(u);
  e = typeof e == "function" ? e : e === void 0 ? Gc : Xe(+e), t = typeof t == "function" ? t : Xe(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? Yc : Xe(+n);
  function u(f) {
    var h, p, b, g = (f = Wc(f)).length, v, w = !1, m, N = new Array(g), C = new Array(g);
    for (o == null && (s = a(m = l())), h = 0; h <= g; ++h) {
      if (!(h < g && i(v = f[h], h, f)) === w)
        if (w = !w)
          p = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), b = h - 1; b >= p; --b)
            s.point(N[b], C[b]);
          s.lineEnd(), s.areaEnd();
        }
      w && (N[h] = +e(v, h, f), C[h] = +t(v, h, f), s.point(r ? +r(v, h, f) : N[h], n ? +n(v, h, f) : C[h]));
    }
    if (m) return s = null, m + "" || null;
  }
  function d() {
    return Kc().defined(i).curve(a).context(o);
  }
  return u.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Xe(+f), r = null, u) : e;
  }, u.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Xe(+f), u) : e;
  }, u.x1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Xe(+f), u) : r;
  }, u.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Xe(+f), n = null, u) : t;
  }, u.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Xe(+f), u) : t;
  }, u.y1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Xe(+f), u) : n;
  }, u.lineX0 = u.lineY0 = function() {
    return d().x(e).y(t);
  }, u.lineY1 = function() {
    return d().x(e).y(n);
  }, u.lineX1 = function() {
    return d().x(r).y(t);
  }, u.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : Xe(!!f), u) : i;
  }, u.curve = function(f) {
    return arguments.length ? (a = f, o != null && (s = a(o)), u) : a;
  }, u.context = function(f) {
    return arguments.length ? (f == null ? o = s = null : s = a(o = f), u) : o;
  }, u;
}
function At(e, t) {
  e(t);
}
function uf() {
  let {
    x: e,
    x0: t,
    x1: n,
    y: r,
    y0: i,
    y1: o,
    defined: a,
    curve: s
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const l = cf();
  return e && At(l.x, e), t && At(l.x0, t), n && At(l.x1, n), r && At(l.y, r), i && At(l.y0, i), o && At(l.y1, o), a && l.defined(a), s && l.curve(s), l;
}
function df() {
  let {
    x: e,
    y: t,
    defined: n,
    curve: r
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const i = Kc();
  return e && At(i.x, e), t && At(i.y, t), n && i.defined(n), r && i.curve(r), i;
}
function sn(e) {
  let {
    top: t = 0,
    left: n = 0,
    transform: r,
    className: i,
    children: o,
    innerRef: a,
    ...s
  } = e;
  return /* @__PURE__ */ c("g", {
    ref: a,
    className: qt("visx-group", i),
    transform: r || `translate(${n}, ${t})`,
    ...s,
    children: o
  });
}
function vn(e) {
  let {
    from: t = {
      x: 0,
      y: 0
    },
    to: n = {
      x: 1,
      y: 1
    },
    fill: r = "transparent",
    className: i,
    innerRef: o,
    ...a
  } = e;
  const s = t.x === n.x || t.y === n.y;
  return /* @__PURE__ */ c("line", {
    ref: o,
    className: qt("visx-line", i),
    x1: t.x,
    y1: t.y,
    x2: n.x,
    y2: n.y,
    fill: r,
    shapeRendering: s ? "crispEdges" : "auto",
    ...a
  });
}
function ff(e) {
  let {
    children: t,
    data: n = [],
    x: r,
    y: i,
    fill: o = "transparent",
    className: a,
    curve: s,
    innerRef: l,
    defined: u = () => !0,
    ...d
  } = e;
  const f = df({
    x: r,
    y: i,
    defined: u,
    curve: s
  });
  return t ? /* @__PURE__ */ c(He, {
    children: t({
      path: f
    })
  }) : /* @__PURE__ */ c("path", {
    ref: l,
    className: qt("visx-linepath", a),
    d: f(n) || "",
    fill: o,
    strokeLinecap: "round",
    ...d
  });
}
function hf(e) {
  let {
    x: t,
    x0: n,
    x1: r,
    y: i,
    y1: o,
    y0: a,
    yScale: s,
    data: l = [],
    defined: u = () => !0,
    className: d,
    curve: f,
    innerRef: h,
    children: p,
    ...b
  } = e;
  const g = uf({
    x: t,
    x0: n,
    x1: r,
    defined: u,
    curve: f
  });
  return a == null ? g.y0(s.range()[0]) : At(g.y0, a), i && !o && At(g.y1, i), o && !i && At(g.y1, o), p ? /* @__PURE__ */ c(He, {
    children: p({
      path: g
    })
  }) : /* @__PURE__ */ c("path", {
    ref: h,
    className: qt("visx-area-closed", d),
    d: g(l) || "",
    ...b
  });
}
function or(e) {
  let {
    className: t,
    innerRef: n,
    ...r
  } = e;
  return /* @__PURE__ */ c("rect", {
    ref: n,
    className: qt("visx-bar", t),
    ...r
  });
}
class ar {
  constructor(t) {
    Ki(this, "x", 0);
    Ki(this, "y", 0);
    let {
      x: n = 0,
      y: r = 0
    } = t;
    this.x = n, this.y = r;
  }
  value() {
    return {
      x: this.x,
      y: this.y
    };
  }
  toArray() {
    return [this.x, this.y];
  }
}
function pi(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function pf(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Jc(e) {
  let t, n, r;
  e.length !== 2 ? (t = pi, n = (s, l) => pi(e(s), l), r = (s, l) => e(s) - l) : (t = e === pi || e === pf ? e : mf, n = e, r = e);
  function i(s, l, u = 0, d = s.length) {
    if (u < d) {
      if (t(l, l) !== 0) return d;
      do {
        const f = u + d >>> 1;
        n(s[f], l) < 0 ? u = f + 1 : d = f;
      } while (u < d);
    }
    return u;
  }
  function o(s, l, u = 0, d = s.length) {
    if (u < d) {
      if (t(l, l) !== 0) return d;
      do {
        const f = u + d >>> 1;
        n(s[f], l) <= 0 ? u = f + 1 : d = f;
      } while (u < d);
    }
    return u;
  }
  function a(s, l, u = 0, d = s.length) {
    const f = i(s, l, u, d - 1);
    return f > u && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: i, center: a, right: o };
}
function mf() {
  return 0;
}
function gf(e) {
  return e === null ? NaN : +e;
}
const vf = Jc(pi), bf = vf.right;
Jc(gf).center;
var qo = Math.sqrt(50), Uo = Math.sqrt(10), Wo = Math.sqrt(2);
function yf(e, t, n) {
  var r, i = -1, o, a, s;
  if (t = +t, e = +e, n = +n, e === t && n > 0) return [e];
  if ((r = t < e) && (o = e, e = t, t = o), (s = Qc(e, t, n)) === 0 || !isFinite(s)) return [];
  if (s > 0) {
    let l = Math.round(e / s), u = Math.round(t / s);
    for (l * s < e && ++l, u * s > t && --u, a = new Array(o = u - l + 1); ++i < o; ) a[i] = (l + i) * s;
  } else {
    s = -s;
    let l = Math.round(e * s), u = Math.round(t * s);
    for (l / s < e && ++l, u / s > t && --u, a = new Array(o = u - l + 1); ++i < o; ) a[i] = (l + i) / s;
  }
  return r && a.reverse(), a;
}
function Qc(e, t, n) {
  var r = (t - e) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), o = r / Math.pow(10, i);
  return i >= 0 ? (o >= qo ? 10 : o >= Uo ? 5 : o >= Wo ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= qo ? 10 : o >= Uo ? 5 : o >= Wo ? 2 : 1);
}
function xf(e, t, n) {
  var r = Math.abs(t - e) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / i;
  return o >= qo ? i *= 10 : o >= Uo ? i *= 5 : o >= Wo && (i *= 2), t < e ? -i : i;
}
function Cf(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function hr(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function ti(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Cn() {
}
var Pn = 0.7, sr = 1 / Pn, Kn = "\\s*([+-]?\\d+)\\s*", Vr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $t = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", wf = /^#([0-9a-f]{3,8})$/, Nf = new RegExp(`^rgb\\(${Kn},${Kn},${Kn}\\)$`), _f = new RegExp(`^rgb\\(${$t},${$t},${$t}\\)$`), Mf = new RegExp(`^rgba\\(${Kn},${Kn},${Kn},${Vr}\\)$`), Lf = new RegExp(`^rgba\\(${$t},${$t},${$t},${Vr}\\)$`), Af = new RegExp(`^hsl\\(${Vr},${$t},${$t}\\)$`), Ef = new RegExp(`^hsla\\(${Vr},${$t},${$t},${Vr}\\)$`), Ps = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
hr(Cn, Hr, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Is,
  // Deprecated! Use color.formatHex.
  formatHex: Is,
  formatHex8: Sf,
  formatHsl: kf,
  formatRgb: Bs,
  toString: Bs
});
function Is() {
  return this.rgb().formatHex();
}
function Sf() {
  return this.rgb().formatHex8();
}
function kf() {
  return e1(this).formatHsl();
}
function Bs() {
  return this.rgb().formatRgb();
}
function Hr(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = wf.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? $s(t) : n === 3 ? new Ye(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? ai(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? ai(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Nf.exec(e)) ? new Ye(t[1], t[2], t[3], 1) : (t = _f.exec(e)) ? new Ye(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Mf.exec(e)) ? ai(t[1], t[2], t[3], t[4]) : (t = Lf.exec(e)) ? ai(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Af.exec(e)) ? js(t[1], t[2] / 100, t[3] / 100, 1) : (t = Ef.exec(e)) ? js(t[1], t[2] / 100, t[3] / 100, t[4]) : Ps.hasOwnProperty(e) ? $s(Ps[e]) : e === "transparent" ? new Ye(NaN, NaN, NaN, 0) : null;
}
function $s(e) {
  return new Ye(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function ai(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Ye(e, t, n, r);
}
function Ma(e) {
  return e instanceof Cn || (e = Hr(e)), e ? (e = e.rgb(), new Ye(e.r, e.g, e.b, e.opacity)) : new Ye();
}
function Zo(e, t, n, r) {
  return arguments.length === 1 ? Ma(e) : new Ye(e, t, n, r ?? 1);
}
function Ye(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
hr(Ye, Zo, ti(Cn, {
  brighter(e) {
    return e = e == null ? sr : Math.pow(sr, e), new Ye(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Pn : Math.pow(Pn, e), new Ye(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Ye(On(this.r), On(this.g), On(this.b), Ni(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Fs,
  // Deprecated! Use color.formatHex.
  formatHex: Fs,
  formatHex8: Of,
  formatRgb: zs,
  toString: zs
}));
function Fs() {
  return `#${An(this.r)}${An(this.g)}${An(this.b)}`;
}
function Of() {
  return `#${An(this.r)}${An(this.g)}${An(this.b)}${An((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function zs() {
  const e = Ni(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${On(this.r)}, ${On(this.g)}, ${On(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Ni(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function On(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function An(e) {
  return e = On(e), (e < 16 ? "0" : "") + e.toString(16);
}
function js(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Et(e, t, n, r);
}
function e1(e) {
  if (e instanceof Et) return new Et(e.h, e.s, e.l, e.opacity);
  if (e instanceof Cn || (e = Hr(e)), !e) return new Et();
  if (e instanceof Et) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, l = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + i : 2 - o - i, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Et(a, s, l, e.opacity);
}
function Xo(e, t, n, r) {
  return arguments.length === 1 ? e1(e) : new Et(e, t, n, r ?? 1);
}
function Et(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
hr(Et, Xo, ti(Cn, {
  brighter(e) {
    return e = e == null ? sr : Math.pow(sr, e), new Et(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Pn : Math.pow(Pn, e), new Et(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new Ye(
      ro(e >= 240 ? e - 240 : e + 120, i, r),
      ro(e, i, r),
      ro(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Et(qs(this.h), si(this.s), si(this.l), Ni(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Ni(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${qs(this.h)}, ${si(this.s) * 100}%, ${si(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function qs(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function si(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function ro(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const t1 = Math.PI / 180, n1 = 180 / Math.PI, _i = 18, r1 = 0.96422, i1 = 1, o1 = 0.82521, a1 = 4 / 29, Jn = 6 / 29, s1 = 3 * Jn * Jn, Tf = Jn * Jn * Jn;
function l1(e) {
  if (e instanceof Ft) return new Ft(e.l, e.a, e.b, e.opacity);
  if (e instanceof nn) return c1(e);
  e instanceof Ye || (e = Ma(e));
  var t = so(e.r), n = so(e.g), r = so(e.b), i = io((0.2225045 * t + 0.7168786 * n + 0.0606169 * r) / i1), o, a;
  return t === n && n === r ? o = a = i : (o = io((0.4360747 * t + 0.3850649 * n + 0.1430804 * r) / r1), a = io((0.0139322 * t + 0.0971045 * n + 0.7141733 * r) / o1)), new Ft(116 * i - 16, 500 * (o - i), 200 * (i - a), e.opacity);
}
function Go(e, t, n, r) {
  return arguments.length === 1 ? l1(e) : new Ft(e, t, n, r ?? 1);
}
function Ft(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}
hr(Ft, Go, ti(Cn, {
  brighter(e) {
    return new Ft(this.l + _i * (e ?? 1), this.a, this.b, this.opacity);
  },
  darker(e) {
    return new Ft(this.l - _i * (e ?? 1), this.a, this.b, this.opacity);
  },
  rgb() {
    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, n = isNaN(this.b) ? e : e - this.b / 200;
    return t = r1 * oo(t), e = i1 * oo(e), n = o1 * oo(n), new Ye(
      ao(3.1338561 * t - 1.6168667 * e - 0.4906146 * n),
      ao(-0.9787684 * t + 1.9161415 * e + 0.033454 * n),
      ao(0.0719453 * t - 0.2289914 * e + 1.4052427 * n),
      this.opacity
    );
  }
}));
function io(e) {
  return e > Tf ? Math.pow(e, 1 / 3) : e / s1 + a1;
}
function oo(e) {
  return e > Jn ? e * e * e : s1 * (e - a1);
}
function ao(e) {
  return 255 * (e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055);
}
function so(e) {
  return (e /= 255) <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function Vf(e) {
  if (e instanceof nn) return new nn(e.h, e.c, e.l, e.opacity);
  if (e instanceof Ft || (e = l1(e)), e.a === 0 && e.b === 0) return new nn(NaN, 0 < e.l && e.l < 100 ? 0 : NaN, e.l, e.opacity);
  var t = Math.atan2(e.b, e.a) * n1;
  return new nn(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}
function Yo(e, t, n, r) {
  return arguments.length === 1 ? Vf(e) : new nn(e, t, n, r ?? 1);
}
function nn(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}
function c1(e) {
  if (isNaN(e.h)) return new Ft(e.l, 0, 0, e.opacity);
  var t = e.h * t1;
  return new Ft(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
}
hr(nn, Yo, ti(Cn, {
  brighter(e) {
    return new nn(this.h, this.c, this.l + _i * (e ?? 1), this.opacity);
  },
  darker(e) {
    return new nn(this.h, this.c, this.l - _i * (e ?? 1), this.opacity);
  },
  rgb() {
    return c1(this).rgb();
  }
}));
var u1 = -0.14861, La = 1.78277, Aa = -0.29227, Ui = -0.90649, Rr = 1.97294, Us = Rr * Ui, Ws = Rr * La, Zs = La * Aa - Ui * u1;
function Hf(e) {
  if (e instanceof Tn) return new Tn(e.h, e.s, e.l, e.opacity);
  e instanceof Ye || (e = Ma(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (Zs * r + Us * t - Ws * n) / (Zs + Us - Ws), o = r - i, a = (Rr * (n - i) - Aa * o) / Ui, s = Math.sqrt(a * a + o * o) / (Rr * i * (1 - i)), l = s ? Math.atan2(a, o) * n1 - 120 : NaN;
  return new Tn(l < 0 ? l + 360 : l, s, i, e.opacity);
}
function Ko(e, t, n, r) {
  return arguments.length === 1 ? Hf(e) : new Tn(e, t, n, r ?? 1);
}
function Tn(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
hr(Tn, Ko, ti(Cn, {
  brighter(e) {
    return e = e == null ? sr : Math.pow(sr, e), new Tn(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Pn : Math.pow(Pn, e), new Tn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * t1, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new Ye(
      255 * (t + n * (u1 * r + La * i)),
      255 * (t + n * (Aa * r + Ui * i)),
      255 * (t + n * (Rr * r)),
      this.opacity
    );
  }
}));
const Wi = (e) => () => e;
function d1(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Rf(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Ea(e, t) {
  var n = t - e;
  return n ? d1(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Wi(isNaN(e) ? t : e);
}
function Df(e) {
  return (e = +e) == 1 ? Ke : function(t, n) {
    return n - t ? Rf(t, n, e) : Wi(isNaN(t) ? n : t);
  };
}
function Ke(e, t) {
  var n = t - e;
  return n ? d1(e, n) : Wi(isNaN(e) ? t : e);
}
const Jo = function e(t) {
  var n = Df(t);
  function r(i, o) {
    var a = n((i = Zo(i)).r, (o = Zo(o)).r), s = n(i.g, o.g), l = n(i.b, o.b), u = Ke(i.opacity, o.opacity);
    return function(d) {
      return i.r = a(d), i.g = s(d), i.b = l(d), i.opacity = u(d), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Pf(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function If(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Bf(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = Sa(e[a], t[a]);
  for (; a < n; ++a) o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) o[a] = i[a](s);
    return o;
  };
}
function $f(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Mi(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Ff(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Sa(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var Qo = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, lo = new RegExp(Qo.source, "g");
function zf(e) {
  return function() {
    return e;
  };
}
function jf(e) {
  return function(t) {
    return e(t) + "";
  };
}
function qf(e, t) {
  var n = Qo.lastIndex = lo.lastIndex = 0, r, i, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = Qo.exec(e)) && (i = lo.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, l.push({ i: a, x: Mi(r, i) })), n = lo.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? jf(l[0].x) : zf(t) : (t = l.length, function(u) {
    for (var d = 0, f; d < t; ++d) s[(f = l[d]).i] = f.x(u);
    return s.join("");
  });
}
function Sa(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Wi(t) : (n === "number" ? Mi : n === "string" ? (r = Hr(t)) ? (t = r, Jo) : qf : t instanceof Hr ? Jo : t instanceof Date ? $f : If(t) ? Pf : Array.isArray(t) ? Bf : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Ff : Mi)(e, t);
}
function f1(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function h1(e) {
  return function(t, n) {
    var r = e((t = Xo(t)).h, (n = Xo(n)).h), i = Ke(t.s, n.s), o = Ke(t.l, n.l), a = Ke(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.s = i(s), t.l = o(s), t.opacity = a(s), t + "";
    };
  };
}
const Uf = h1(Ea);
var Wf = h1(Ke);
function Zf(e, t) {
  var n = Ke((e = Go(e)).l, (t = Go(t)).l), r = Ke(e.a, t.a), i = Ke(e.b, t.b), o = Ke(e.opacity, t.opacity);
  return function(a) {
    return e.l = n(a), e.a = r(a), e.b = i(a), e.opacity = o(a), e + "";
  };
}
function p1(e) {
  return function(t, n) {
    var r = e((t = Yo(t)).h, (n = Yo(n)).h), i = Ke(t.c, n.c), o = Ke(t.l, n.l), a = Ke(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.c = i(s), t.l = o(s), t.opacity = a(s), t + "";
    };
  };
}
const Xf = p1(Ea);
var Gf = p1(Ke);
function m1(e) {
  return function t(n) {
    n = +n;
    function r(i, o) {
      var a = e((i = Ko(i)).h, (o = Ko(o)).h), s = Ke(i.s, o.s), l = Ke(i.l, o.l), u = Ke(i.opacity, o.opacity);
      return function(d) {
        return i.h = a(d), i.s = s(d), i.l = l(Math.pow(d, n)), i.opacity = u(d), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const Yf = m1(Ea);
var Kf = m1(Ke);
function Jf(e) {
  return function() {
    return e;
  };
}
function Qf(e) {
  return +e;
}
var Xs = [0, 1];
function Gn(e) {
  return e;
}
function ea(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Jf(isNaN(t) ? NaN : 0.5);
}
function e3(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function t3(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = ea(i, r), o = n(a, o)) : (r = ea(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function n3(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = ea(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = bf(e, s, 1, r) - 1;
    return o[l](i[l](s));
  };
}
function r3(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function i3() {
  var e = Xs, t = Xs, n = Sa, r, i, o, a = Gn, s, l, u;
  function d() {
    var h = Math.min(e.length, t.length);
    return a !== Gn && (a = e3(e[0], e[h - 1])), s = h > 2 ? n3 : t3, l = u = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? o : (l || (l = s(e.map(r), t, n)))(r(a(h)));
  }
  return f.invert = function(h) {
    return a(i((u || (u = s(t, e.map(r), Mi)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, Qf), d()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), d()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = f1, d();
  }, f.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : Gn, d()) : a !== Gn;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, d()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (o = h, f) : o;
  }, function(h, p) {
    return r = h, i = p, d();
  };
}
function o3() {
  return i3()(Gn, Gn);
}
function a3(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Li(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function lr(e) {
  return e = Li(Math.abs(e)), e ? e[1] : NaN;
}
function s3(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function l3(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var c3 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ai(e) {
  if (!(t = c3.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new ka({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ai.prototype = ka.prototype;
function ka(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
ka.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function u3(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var g1;
function d3(e, t) {
  var n = Li(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], o = i - (g1 = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Li(e, Math.max(0, t + o - 1))[0];
}
function Gs(e, t) {
  var n = Li(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Ys = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: a3,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Gs(e * 100, t),
  r: Gs,
  s: d3,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Ks(e) {
  return e;
}
var Js = Array.prototype.map, Qs = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function f3(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Ks : s3(Js.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? Ks : l3(Js.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(f) {
    f = Ai(f);
    var h = f.fill, p = f.align, b = f.sign, g = f.symbol, v = f.zero, w = f.width, m = f.comma, N = f.precision, C = f.trim, M = f.type;
    M === "n" ? (m = !0, M = "g") : Ys[M] || (N === void 0 && (N = 12), C = !0, M = "g"), (v || h === "0" && p === "=") && (v = !0, h = "0", p = "=");
    var y = g === "$" ? n : g === "#" && /[boxX]/.test(M) ? "0" + M.toLowerCase() : "", L = g === "$" ? r : /[%p]/.test(M) ? a : "", T = Ys[M], S = /[defgprs%]/.test(M);
    N = N === void 0 ? 6 : /[gprs]/.test(M) ? Math.max(1, Math.min(21, N)) : Math.max(0, Math.min(20, N));
    function R(V) {
      var A = y, E = L, P, U, D;
      if (M === "c")
        E = T(V) + E, V = "";
      else {
        V = +V;
        var z = V < 0 || 1 / V < 0;
        if (V = isNaN(V) ? l : T(Math.abs(V), N), C && (V = u3(V)), z && +V == 0 && b !== "+" && (z = !1), A = (z ? b === "(" ? b : s : b === "-" || b === "(" ? "" : b) + A, E = (M === "s" ? Qs[8 + g1 / 3] : "") + E + (z && b === "(" ? ")" : ""), S) {
          for (P = -1, U = V.length; ++P < U; )
            if (D = V.charCodeAt(P), 48 > D || D > 57) {
              E = (D === 46 ? i + V.slice(P + 1) : V.slice(P)) + E, V = V.slice(0, P);
              break;
            }
        }
      }
      m && !v && (V = t(V, 1 / 0));
      var I = A.length + V.length + E.length, Y = I < w ? new Array(w - I + 1).join(h) : "";
      switch (m && v && (V = t(Y + V, Y.length ? w - E.length : 1 / 0), Y = ""), p) {
        case "<":
          V = A + V + E + Y;
          break;
        case "=":
          V = A + Y + V + E;
          break;
        case "^":
          V = Y.slice(0, I = Y.length >> 1) + A + V + E + Y.slice(I);
          break;
        default:
          V = Y + A + V + E;
          break;
      }
      return o(V);
    }
    return R.toString = function() {
      return f + "";
    }, R;
  }
  function d(f, h) {
    var p = u((f = Ai(f), f.type = "f", f)), b = Math.max(-8, Math.min(8, Math.floor(lr(h) / 3))) * 3, g = Math.pow(10, -b), v = Qs[8 + b / 3];
    return function(w) {
      return p(g * w) + v;
    };
  }
  return {
    format: u,
    formatPrefix: d
  };
}
var li, v1, b1;
h3({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function h3(e) {
  return li = f3(e), v1 = li.format, b1 = li.formatPrefix, li;
}
function p3(e) {
  return Math.max(0, -lr(Math.abs(e)));
}
function m3(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(lr(t) / 3))) * 3 - lr(Math.abs(e)));
}
function g3(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, lr(t) - lr(e)) + 1;
}
function v3(e, t, n, r) {
  var i = xf(e, t, n), o;
  switch (r = Ai(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = m3(i, a)) && (r.precision = o), b1(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = g3(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = p3(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return v1(r);
}
function b3(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return yf(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return v3(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], l, u, d = 10;
    for (s < a && (u = a, a = s, s = u, u = i, i = o, o = u); d-- > 0; ) {
      if (u = Qc(a, s, n), u === l)
        return r[i] = a, r[o] = s, t(r);
      if (u > 0)
        a = Math.floor(a / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        a = Math.ceil(a * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      l = u;
    }
    return e;
  }, e;
}
function y1() {
  var e = o3();
  return e.copy = function() {
    return r3(e, y1());
  }, Cf.apply(e, arguments), b3(e);
}
const co = /* @__PURE__ */ new Date(), uo = /* @__PURE__ */ new Date();
function et(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const l = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0)) return l;
    let u;
    do
      l.push(u = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (u < o && o < a);
    return l;
  }, i.filter = (o) => et((a) => {
    if (a >= a) for (; e(a), !o(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !o(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !o(a); )
          ;
  }), n && (i.count = (o, a) => (co.setTime(+o), uo.setTime(+a), e(co), e(uo), Math.floor(n(co, uo))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const Dr = 1e3, bn = Dr * 60, Pr = bn * 60, Ir = Pr * 24, x1 = Ir * 7, Oa = et((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Dr);
}, (e, t) => (t - e) / Dr, (e) => e.getUTCSeconds());
Oa.range;
const C1 = et((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Dr);
}, (e, t) => {
  e.setTime(+e + t * bn);
}, (e, t) => (t - e) / bn, (e) => e.getMinutes());
C1.range;
const w1 = et((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * bn);
}, (e, t) => (t - e) / bn, (e) => e.getUTCMinutes());
w1.range;
const N1 = et((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Dr - e.getMinutes() * bn);
}, (e, t) => {
  e.setTime(+e + t * Pr);
}, (e, t) => (t - e) / Pr, (e) => e.getHours());
N1.range;
const _1 = et((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Pr);
}, (e, t) => (t - e) / Pr, (e) => e.getUTCHours());
_1.range;
const M1 = et(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * bn) / Ir,
  (e) => e.getDate() - 1
);
M1.range;
const L1 = et((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ir, (e) => e.getUTCDate() - 1);
L1.range;
const y3 = et((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ir, (e) => Math.floor(e / Ir));
y3.range;
function zn(e) {
  return et((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * bn) / x1);
}
const A1 = zn(0), x3 = zn(1), C3 = zn(2), w3 = zn(3), N3 = zn(4), _3 = zn(5), M3 = zn(6);
A1.range;
x3.range;
C3.range;
w3.range;
N3.range;
_3.range;
M3.range;
function jn(e) {
  return et((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / x1);
}
const E1 = jn(0), L3 = jn(1), A3 = jn(2), E3 = jn(3), S3 = jn(4), k3 = jn(5), O3 = jn(6);
E1.range;
L3.range;
A3.range;
E3.range;
S3.range;
k3.range;
O3.range;
const S1 = et((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
S1.range;
const k1 = et((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
k1.range;
const Ta = et((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Ta.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : et((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Ta.range;
const Va = et((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Va.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : et((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
Va.range;
function T3(e, t) {
  t.domain && ("nice" in e || "quantiles" in e || "padding" in e, e.domain(t.domain));
}
function V3(e, t) {
  t.range && ("padding" in e, e.range(t.range));
}
function H3(e, t) {
  "align" in e && "align" in t && typeof t.align < "u" && e.align(t.align);
}
function R3(e, t) {
  "base" in e && "base" in t && typeof t.base < "u" && e.base(t.base);
}
function D3(e, t) {
  "clamp" in e && "clamp" in t && typeof t.clamp < "u" && e.clamp(t.clamp);
}
function P3(e, t) {
  "constant" in e && "constant" in t && typeof t.constant < "u" && e.constant(t.constant);
}
function I3(e, t) {
  "exponent" in e && "exponent" in t && typeof t.exponent < "u" && e.exponent(t.exponent);
}
const el = {
  lab: Zf,
  hcl: Xf,
  "hcl-long": Gf,
  hsl: Uf,
  "hsl-long": Wf,
  cubehelix: Yf,
  "cubehelix-long": Kf,
  rgb: Jo
};
function B3(e) {
  switch (e) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return el[e];
  }
  const {
    type: t,
    gamma: n
  } = e, r = el[t];
  return typeof n > "u" ? r : r.gamma(n);
}
function $3(e, t) {
  if ("interpolate" in t && "interpolate" in e && typeof t.interpolate < "u") {
    const n = B3(t.interpolate);
    e.interpolate(n);
  }
}
const F3 = new Date(Date.UTC(2020, 1, 2, 3, 4, 5)), z3 = "%Y-%m-%d %H:%M";
function j3(e) {
  return e.tickFormat(1, z3)(F3) === "2020-02-02 03:04";
}
const tl = {
  day: M1,
  hour: N1,
  minute: C1,
  month: S1,
  second: Oa,
  week: A1,
  year: Ta
}, nl = {
  day: L1,
  hour: _1,
  minute: w1,
  month: k1,
  second: Oa,
  week: E1,
  year: Va
};
function q3(e, t) {
  if ("nice" in t && typeof t.nice < "u" && "nice" in e) {
    const {
      nice: n
    } = t;
    if (typeof n == "boolean")
      n && e.nice();
    else if (typeof n == "number")
      e.nice(n);
    else {
      const r = e, i = j3(r);
      if (typeof n == "string")
        r.nice(i ? nl[n] : tl[n]);
      else {
        const {
          interval: o,
          step: a
        } = n, s = (i ? nl[o] : tl[o]).every(a);
        s != null && r.nice(s);
      }
    }
  }
}
function U3(e, t) {
  "padding" in e && "padding" in t && typeof t.padding < "u" && e.padding(t.padding), "paddingInner" in e && "paddingInner" in t && typeof t.paddingInner < "u" && e.paddingInner(t.paddingInner), "paddingOuter" in e && "paddingOuter" in t && typeof t.paddingOuter < "u" && e.paddingOuter(t.paddingOuter);
}
function W3(e, t) {
  if (t.reverse) {
    const n = e.range().slice().reverse();
    "padding" in e, e.range(n);
  }
}
function Z3(e, t) {
  "round" in t && typeof t.round < "u" && (t.round && "interpolate" in t && typeof t.interpolate < "u" ? console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", t) : "round" in e ? e.round(t.round) : "interpolate" in e && t.round && e.interpolate(f1));
}
function X3(e, t) {
  "unknown" in e && "unknown" in t && typeof t.unknown < "u" && e.unknown(t.unknown);
}
function G3(e, t) {
  if ("zero" in t && t.zero === !0) {
    const n = e.domain(), [r, i] = n, o = i < r, [a, s] = o ? [i, r] : [r, i], l = [Math.min(0, a), Math.max(0, s)];
    e.domain(o ? l.reverse() : l);
  }
}
const Y3 = [
  // domain => nice => zero
  "domain",
  "nice",
  "zero",
  // interpolate before round
  "interpolate",
  "round",
  // set range then reverse
  "range",
  "reverse",
  // Order does not matter for these operators
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
], K3 = {
  domain: T3,
  nice: q3,
  zero: G3,
  interpolate: $3,
  round: Z3,
  align: H3,
  base: R3,
  clamp: D3,
  constant: P3,
  exponent: I3,
  padding: U3,
  range: V3,
  reverse: W3,
  unknown: X3
};
function J3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  const r = new Set(t), i = Y3.filter((o) => r.has(o));
  return function(a, s) {
    return typeof s < "u" && i.forEach((l) => {
      K3[l](a, s);
    }), a;
  };
}
const Q3 = J3("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function Wt(e) {
  return Q3(y1(), e);
}
function O1(e) {
  if ((typeof e == "function" || typeof e == "object" && e) && "valueOf" in e) {
    const t = e.valueOf();
    if (typeof t == "number") return t;
  }
  return e;
}
function T1(e, t) {
  const n = e;
  return "ticks" in n ? n.ticks(t) : n.domain().filter((r, i, o) => t == null || o.length <= t || i % Math.round((o.length - 1) / t) === 0);
}
function V1(e) {
  return "bandwidth" in e ? e.bandwidth() : 0;
}
function H1(e) {
  let {
    top: t = 0,
    left: n = 0,
    scale: r,
    width: i,
    stroke: o = "#eaf0f6",
    strokeWidth: a = 1,
    strokeDasharray: s,
    className: l,
    children: u,
    numTicks: d = 10,
    lineStyle: f,
    offset: h,
    tickValues: p,
    ...b
  } = e;
  const g = p ?? T1(r, d), v = (h ?? 0) + V1(r) / 2, w = g.map((m, N) => {
    const C = (O1(r(m)) ?? 0) + v;
    return {
      index: N,
      from: new ar({
        x: 0,
        y: C
      }),
      to: new ar({
        x: i,
        y: C
      })
    };
  });
  return /* @__PURE__ */ c(sn, {
    className: qt("visx-rows", l),
    top: t,
    left: n,
    children: u ? u({
      lines: w
    }) : w.map((m) => {
      let {
        from: N,
        to: C,
        index: M
      } = m;
      return /* @__PURE__ */ c(vn, {
        from: N,
        to: C,
        stroke: o,
        strokeWidth: a,
        strokeDasharray: s,
        style: f,
        ...b
      }, `row-line-${M}`);
    })
  });
}
function Ha(e) {
  let {
    top: t = 0,
    left: n = 0,
    scale: r,
    height: i,
    stroke: o = "#eaf0f6",
    strokeWidth: a = 1,
    strokeDasharray: s,
    className: l,
    numTicks: u = 10,
    lineStyle: d,
    offset: f,
    tickValues: h,
    children: p,
    ...b
  } = e;
  const g = h ?? T1(r, u), v = (f ?? 0) + V1(r) / 2, w = g.map((m, N) => {
    const C = (O1(r(m)) ?? 0) + v;
    return {
      index: N,
      from: new ar({
        x: C,
        y: 0
      }),
      to: new ar({
        x: C,
        y: i
      })
    };
  });
  return /* @__PURE__ */ c(sn, {
    className: qt("visx-columns", l),
    top: t,
    left: n,
    children: p ? p({
      lines: w
    }) : w.map((m) => {
      let {
        from: N,
        to: C,
        index: M
      } = m;
      return /* @__PURE__ */ c(vn, {
        from: N,
        to: C,
        stroke: o,
        strokeWidth: a,
        strokeDasharray: s,
        style: d,
        ...b
      }, `column-line-${M}`);
    })
  });
}
var fo, rl;
function eh() {
  if (rl) return fo;
  rl = 1, fo = e;
  function e(r, i, o) {
    r instanceof RegExp && (r = t(r, o)), i instanceof RegExp && (i = t(i, o));
    var a = n(r, i, o);
    return a && {
      start: a[0],
      end: a[1],
      pre: o.slice(0, a[0]),
      body: o.slice(a[0] + r.length, a[1]),
      post: o.slice(a[1] + i.length)
    };
  }
  function t(r, i) {
    var o = i.match(r);
    return o ? o[0] : null;
  }
  e.range = n;
  function n(r, i, o) {
    var a, s, l, u, d, f = o.indexOf(r), h = o.indexOf(i, f + 1), p = f;
    if (f >= 0 && h > 0) {
      for (a = [], l = o.length; p >= 0 && !d; )
        p == f ? (a.push(p), f = o.indexOf(r, p + 1)) : a.length == 1 ? d = [a.pop(), h] : (s = a.pop(), s < l && (l = s, u = h), h = o.indexOf(i, p + 1)), p = f < h && f >= 0 ? f : h;
      a.length && (d = [l, u]);
    }
    return d;
  }
  return fo;
}
var ho, il;
function th() {
  if (il) return ho;
  il = 1, ho = e;
  function e(r, i, o) {
    r instanceof RegExp && (r = t(r, o)), i instanceof RegExp && (i = t(i, o));
    var a = n(r, i, o);
    return a && {
      start: a[0],
      end: a[1],
      pre: o.slice(0, a[0]),
      body: o.slice(a[0] + r.length, a[1]),
      post: o.slice(a[1] + i.length)
    };
  }
  function t(r, i) {
    var o = i.match(r);
    return o ? o[0] : null;
  }
  e.range = n;
  function n(r, i, o) {
    var a, s, l, u, d, f = o.indexOf(r), h = o.indexOf(i, f + 1), p = f;
    if (f >= 0 && h > 0) {
      if (r === i)
        return [f, h];
      for (a = [], l = o.length; p >= 0 && !d; )
        p == f ? (a.push(p), f = o.indexOf(r, p + 1)) : a.length == 1 ? d = [a.pop(), h] : (s = a.pop(), s < l && (l = s, u = h), h = o.indexOf(i, p + 1)), p = f < h && f >= 0 ? f : h;
      a.length && (d = [l, u]);
    }
    return d;
  }
  return ho;
}
var po, ol;
function nh() {
  if (ol) return po;
  ol = 1;
  var e = th();
  po = t;
  function t(i, o, a) {
    var s = i;
    return n(i, o).reduce(function(l, u) {
      return l.replace(u.functionIdentifier + "(" + u.matches.body + ")", r(u.matches.body, u.functionIdentifier, a, s, o));
    }, i);
  }
  function n(i, o) {
    var a = [], s = typeof o == "string" ? new RegExp("\\b(" + o + ")\\(") : o;
    do {
      var l = s.exec(i);
      if (!l)
        return a;
      if (l[1] === void 0)
        throw new Error("Missing the first couple of parenthesis to get the function identifier in " + o);
      var u = l[1], d = l.index, f = e("(", ")", i.substring(d));
      if (!f || f.start !== l[0].length - 1)
        throw new SyntaxError(u + "(): missing closing ')' in the value '" + i + "'");
      a.push({ matches: f, functionIdentifier: u }), i = f.post;
    } while (s.test(i));
    return a;
  }
  function r(i, o, a, s, l) {
    return a(t(i, l, a), o, s);
  }
  return po;
}
var mo, al;
function rh() {
  if (al) return mo;
  al = 1;
  var e = function(t) {
    this.value = t;
  };
  return e.math = {
    isDegree: !0,
    // mode of calculator
    acos: function(t) {
      return e.math.isDegree ? 180 / Math.PI * Math.acos(t) : Math.acos(t);
    },
    add: function(t, n) {
      return t + n;
    },
    asin: function(t) {
      return e.math.isDegree ? 180 / Math.PI * Math.asin(t) : Math.asin(t);
    },
    atan: function(t) {
      return e.math.isDegree ? 180 / Math.PI * Math.atan(t) : Math.atan(t);
    },
    acosh: function(t) {
      return Math.log(t + Math.sqrt(t * t - 1));
    },
    asinh: function(t) {
      return Math.log(t + Math.sqrt(t * t + 1));
    },
    atanh: function(t) {
      return Math.log((1 + t) / (1 - t));
    },
    C: function(t, n) {
      var r = 1, i = t - n, o = n;
      o < i && (o = i, i = n);
      for (var a = o + 1; a <= t; a++)
        r *= a;
      return r / e.math.fact(i);
    },
    changeSign: function(t) {
      return -t;
    },
    cos: function(t) {
      return e.math.isDegree && (t = e.math.toRadian(t)), Math.cos(t);
    },
    cosh: function(t) {
      return (Math.pow(Math.E, t) + Math.pow(Math.E, -1 * t)) / 2;
    },
    div: function(t, n) {
      return t / n;
    },
    fact: function(t) {
      if (t % 1 !== 0) return "NaN";
      for (var n = 1, r = 2; r <= t; r++)
        n *= r;
      return n;
    },
    inverse: function(t) {
      return 1 / t;
    },
    log: function(t) {
      return Math.log(t) / Math.log(10);
    },
    mod: function(t, n) {
      return t % n;
    },
    mul: function(t, n) {
      return t * n;
    },
    P: function(t, n) {
      for (var r = 1, i = Math.floor(t) - Math.floor(n) + 1; i <= Math.floor(t); i++)
        r *= i;
      return r;
    },
    Pi: function(t, n, r) {
      for (var i = 1, o = t; o <= n; o++)
        i *= Number(r.postfixEval({
          n: o
        }));
      return i;
    },
    pow10x: function(t) {
      for (var n = 1; t--; )
        n *= 10;
      return n;
    },
    sigma: function(t, n, r) {
      for (var i = 0, o = t; o <= n; o++)
        i += Number(r.postfixEval({
          n: o
        }));
      return i;
    },
    sin: function(t) {
      return e.math.isDegree && (t = e.math.toRadian(t)), Math.sin(t);
    },
    sinh: function(t) {
      return (Math.pow(Math.E, t) - Math.pow(Math.E, -1 * t)) / 2;
    },
    sub: function(t, n) {
      return t - n;
    },
    tan: function(t) {
      return e.math.isDegree && (t = e.math.toRadian(t)), Math.tan(t);
    },
    tanh: function(t) {
      return e.sinha(t) / e.cosha(t);
    },
    toRadian: function(t) {
      return t * Math.PI / 180;
    },
    and: function(t, n) {
      return t & n;
    }
  }, e.Exception = function(t) {
    this.message = t;
  }, mo = e, mo;
}
var go, sl;
function ih() {
  if (sl) return go;
  sl = 1;
  var e = rh();
  function t(m, N) {
    for (var C = 0; C < m.length; C++)
      m[C] += N;
    return m;
  }
  for (var n = [
    { token: "sin", show: "sin", type: 0, value: e.math.sin },
    { token: "cos", show: "cos", type: 0, value: e.math.cos },
    { token: "tan", show: "tan", type: 0, value: e.math.tan },
    { token: "pi", show: "&pi;", type: 3, value: "PI" },
    { token: "(", show: "(", type: 4, value: "(" },
    { token: ")", show: ")", type: 5, value: ")" },
    { token: "P", show: "P", type: 10, value: e.math.P },
    { token: "C", show: "C", type: 10, value: e.math.C },
    { token: " ", show: " ", type: 14, value: " ".anchor },
    { token: "asin", show: "asin", type: 0, value: e.math.asin },
    { token: "acos", show: "acos", type: 0, value: e.math.acos },
    { token: "atan", show: "atan", type: 0, value: e.math.atan },
    { token: "7", show: "7", type: 1, value: "7" },
    { token: "8", show: "8", type: 1, value: "8" },
    { token: "9", show: "9", type: 1, value: "9" },
    { token: "int", show: "Int", type: 0, value: Math.floor },
    { token: "cosh", show: "cosh", type: 0, value: e.math.cosh },
    { token: "acosh", show: "acosh", type: 0, value: e.math.acosh },
    { token: "ln", show: " ln", type: 0, value: Math.log },
    { token: "^", show: "^", type: 10, value: Math.pow },
    { token: "root", show: "root", type: 0, value: Math.sqrt },
    { token: "4", show: "4", type: 1, value: "4" },
    { token: "5", show: "5", type: 1, value: "5" },
    { token: "6", show: "6", type: 1, value: "6" },
    { token: "/", show: "&divide;", type: 2, value: e.math.div },
    { token: "!", show: "!", type: 7, value: e.math.fact },
    { token: "tanh", show: "tanh", type: 0, value: e.math.tanh },
    { token: "atanh", show: "atanh", type: 0, value: e.math.atanh },
    { token: "Mod", show: " Mod ", type: 2, value: e.math.mod },
    { token: "1", show: "1", type: 1, value: "1" },
    { token: "2", show: "2", type: 1, value: "2" },
    { token: "3", show: "3", type: 1, value: "3" },
    { token: "*", show: "&times;", type: 2, value: e.math.mul },
    { token: "sinh", show: "sinh", type: 0, value: e.math.sinh },
    { token: "asinh", show: "asinh", type: 0, value: e.math.asinh },
    { token: "e", show: "e", type: 3, value: "E" },
    { token: "log", show: " log", type: 0, value: e.math.log },
    { token: "0", show: "0", type: 1, value: "0" },
    { token: ".", show: ".", type: 6, value: "." },
    { token: "+", show: "+", type: 9, value: e.math.add },
    { token: "-", show: "-", type: 9, value: e.math.sub },
    { token: ",", show: ",", type: 11, value: "," },
    { token: "Sigma", show: "&Sigma;", type: 12, value: e.math.sigma },
    { token: "n", show: "n", type: 13, value: "n" },
    { token: "Pi", show: "&Pi;", type: 12, value: e.math.Pi },
    { token: "pow", show: "pow", type: 8, value: Math.pow, numberOfArguments: 2 },
    { token: "&", show: "&", type: 9, value: e.math.and }
  ], r = {
    0: 11,
    1: 0,
    2: 3,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 11,
    8: 11,
    9: 1,
    10: 10,
    11: 0,
    12: 11,
    13: 0,
    14: -1,
    15: 11
    // will be filtered after lexer
  }, i = 0; i < n.length; i++)
    n[i].precedence = r[n[i].type];
  var o = {
    0: !0,
    1: !0,
    3: !0,
    4: !0,
    6: !0,
    8: !0,
    9: !0,
    12: !0,
    13: !0,
    14: !0,
    15: !0
  }, a = {
    0: !0,
    1: !0,
    2: !0,
    3: !0,
    4: !0,
    5: !0,
    6: !0,
    7: !0,
    8: !0,
    9: !0,
    10: !0,
    11: !0,
    12: !0,
    13: !0,
    15: !0
  }, s = {
    0: !0,
    3: !0,
    4: !0,
    8: !0,
    12: !0,
    13: !0,
    15: !0
  }, l = {}, u = {
    0: !0,
    1: !0,
    3: !0,
    4: !0,
    6: !0,
    8: !0,
    12: !0,
    13: !0,
    15: !0
  }, d = {
    1: !0
  }, f = [
    [],
    [
      "1",
      "2",
      "3",
      "7",
      "8",
      "9",
      "4",
      "5",
      "6",
      "+",
      "-",
      "*",
      "/",
      "(",
      ")",
      "^",
      "!",
      "P",
      "C",
      "e",
      "0",
      ".",
      ",",
      "n",
      " ",
      "&"
    ],
    ["pi", "ln", "Pi"],
    ["sin", "cos", "tan", "Del", "int", "Mod", "log", "pow"],
    ["asin", "acos", "atan", "cosh", "root", "tanh", "sinh"],
    ["acosh", "atanh", "asinh", "Sigma"]
  ];
  function h(m, N, C, M) {
    for (var y = 0; y < M; y++)
      if (m[C + y] !== N[y])
        return !1;
    return !0;
  }
  e.tokenTypes = {
    FUNCTION_WITH_ONE_ARG: 0,
    NUMBER: 1,
    BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
    CONSTANT: 3,
    OPENING_PARENTHESIS: 4,
    CLOSING_PARENTHESIS: 5,
    DECIMAL: 6,
    POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
    FUNCTION_WITH_N_ARGS: 8,
    BINARY_OPERATOR_LOW_PRECENDENCE: 9,
    BINARY_OPERATOR_PERMUTATION: 10,
    COMMA: 11,
    EVALUATED_FUNCTION: 12,
    EVALUATED_FUNCTION_PARAMETER: 13,
    SPACE: 14
  }, e.addToken = function(m) {
    for (var N = 0; N < m.length; N++) {
      var C = m[N].token.length, M = -1;
      m[N].type === e.tokenTypes.FUNCTION_WITH_N_ARGS && m[N].numberOfArguments === void 0 && (m[N].numberOfArguments = 2), f[C] = f[C] || [];
      for (var y = 0; y < f[C].length; y++)
        if (m[N].token === f[C][y]) {
          M = p(f[C][y], n);
          break;
        }
      M === -1 ? (n.push(m[N]), m[N].precedence = r[m[N].type], f.length <= m[N].token.length && (f[m[N].token.length] = []), f[m[N].token.length].push(m[N].token)) : (n[M] = m[N], m[N].precedence = r[m[N].type]);
    }
  };
  function p(m, N) {
    for (var C = 0; C < N.length; C++)
      if (N[C].token === m) return C;
    return -1;
  }
  function b(m) {
    for (var N = [], C = m.length, M, y, L, T = 0; T < C; T++)
      if (!(T < C - 1 && m[T] === " " && m[T + 1] === " ")) {
        for (M = "", y = m.length - T > f.length - 2 ? f.length - 1 : m.length - T; y > 0; y--)
          if (f[y] !== void 0)
            for (L = 0; L < f[y].length; L++)
              h(m, f[y][L], T, y) && (M = f[y][L], L = f[y].length, y = 0);
        if (T += M.length - 1, M === "")
          throw new e.Exception("Can't understand after " + m.slice(T));
        N.push(n[p(M, n)]);
      }
    return N;
  }
  var g = {
    value: e.math.changeSign,
    type: 0,
    pre: 21,
    show: "-"
  }, v = {
    value: ")",
    show: ")",
    type: 5,
    pre: 0
  }, w = {
    value: "(",
    type: 4,
    pre: 0,
    show: "("
  };
  return e.lex = function(m, N) {
    var C = [w], M = [], y = m, L = o, T = 0, S = l, R = "", V;
    typeof N < "u" && e.addToken(N);
    var A = {}, E = b(y);
    for (V = 0; V < E.length; V++) {
      var P = E[V];
      if (P.type === 14) {
        if (V > 0 && V < E.length - 1 && E[V + 1].type === 1 && (E[V - 1].type === 1 || E[V - 1].type === 6))
          throw new e.Exception("Unexpected Space");
        continue;
      }
      var U = P.token, D = P.type, z = P.value, I = P.precedence, Y = P.show, Z = C[C.length - 1], ne;
      for (ne = M.length; ne-- && M[ne] === 0; )
        if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(D) !== -1) {
          if (L[D] !== !0)
            throw new e.Exception(U + " is not allowed after " + R);
          C.push(v), L = a, S = u, M.pop();
        }
      if (L[D] !== !0)
        throw new e.Exception(U + " is not allowed after " + R);
      if (S[D] === !0 && (D = 2, z = e.math.mul, Y = "&times;", I = 3, V = V - 1), A = {
        value: z,
        type: D,
        pre: I,
        show: Y,
        numberOfArguments: P.numberOfArguments
      }, D === 0)
        L = o, S = l, t(M, 2), C.push(A), E[V + 1].type !== 4 && (C.push(w), M.push(2));
      else if (D === 1)
        Z.type === 1 ? (Z.value += z, t(M, 1)) : C.push(A), L = a, S = s;
      else if (D === 2)
        L = o, S = l, t(M, 2), C.push(A);
      else if (D === 3)
        C.push(A), L = a, S = u;
      else if (D === 4)
        t(M, 1), T++, L = o, S = l, C.push(A);
      else if (D === 5) {
        if (!T)
          throw new e.Exception("Closing parenthesis are more than opening one, wait What!!!");
        T--, L = a, S = u, C.push(A), t(M, 1);
      } else if (D === 6) {
        if (Z.hasDec)
          throw new e.Exception("Two decimals are not allowed in one number");
        Z.type !== 1 && (Z = {
          value: 0,
          type: 1,
          pre: 0
        }, C.push(Z)), L = d, t(M, 1), S = l, Z.value += z, Z.hasDec = !0;
      } else D === 7 && (L = a, S = u, t(M, 1), C.push(A));
      D === 8 ? (L = o, S = l, t(M, P.numberOfArguments + 2), C.push(A), E[V + 1].type !== 4 && (C.push(w), M.push(P.numberOfArguments + 2))) : D === 9 ? (Z.type === 9 ? Z.value === e.math.add ? (Z.value = z, Z.show = Y, t(M, 1)) : Z.value === e.math.sub && Y === "-" && (Z.value = e.math.add, Z.show = "+", t(M, 1)) : Z.type !== 5 && Z.type !== 7 && Z.type !== 1 && Z.type !== 3 && Z.type !== 13 ? U === "-" && (L = o, S = l, t(M, 2).push(2), C.push(g), C.push(w)) : (C.push(A), t(M, 2)), L = o, S = l) : D === 10 ? (L = o, S = l, t(M, 2), C.push(A)) : D === 11 ? (L = o, S = l, C.push(A)) : D === 12 ? (L = o, S = l, t(M, 6), C.push(A), E[V + 1].type !== 4 && (C.push(w), M.push(6))) : D === 13 && (L = a, S = u, C.push(A)), t(M, -1), R = U;
    }
    for (ne = M.length; ne--; )
      C.push(v);
    if (L[5] !== !0)
      throw new e.Exception("complete the expression");
    for (; T--; )
      C.push(v);
    return C.push(v), new e(C);
  }, go = e, go;
}
var vo, ll;
function oh() {
  if (ll) return vo;
  ll = 1;
  var e = ih();
  return e.prototype.toPostfix = function() {
    for (var t = [], n, r, i, o, a, s = [{ value: "(", type: 4, pre: 0 }], l = this.value, u = 1; u < l.length; u++)
      if (l[u].type === 1 || l[u].type === 3 || l[u].type === 13)
        l[u].type === 1 && (l[u].value = Number(l[u].value)), t.push(l[u]);
      else if (l[u].type === 4)
        s.push(l[u]);
      else if (l[u].type === 5)
        for (; (r = s.pop()).type !== 4; )
          t.push(r);
      else if (l[u].type === 11) {
        for (; (r = s.pop()).type !== 4; )
          t.push(r);
        s.push(r);
      } else {
        n = l[u], o = n.pre, a = s[s.length - 1], i = a.pre;
        var d = a.value == "Math.pow" && n.value == "Math.pow";
        if (o > i) s.push(n);
        else {
          for (; i >= o && !d || d && o < i; )
            r = s.pop(), a = s[s.length - 1], t.push(r), i = a.pre, d = n.value == "Math.pow" && a.value == "Math.pow";
          s.push(n);
        }
      }
    return new e(t);
  }, vo = e, vo;
}
var bo, cl;
function ah() {
  if (cl) return bo;
  cl = 1;
  var e = oh();
  return e.prototype.postfixEval = function(t) {
    t = t || {}, t.PI = Math.PI, t.E = Math.E;
    for (var n = [], r, i, o, a = this.value, s = typeof t.n < "u", l = 0; l < a.length; l++)
      if (a[l].type === 1)
        n.push({ value: a[l].value, type: 1 });
      else if (a[l].type === 3)
        n.push({ value: t[a[l].value], type: 1 });
      else if (a[l].type === 0)
        typeof n[n.length - 1].type > "u" ? n[n.length - 1].value.push(a[l]) : n[n.length - 1].value = a[l].value(n[n.length - 1].value);
      else if (a[l].type === 7)
        typeof n[n.length - 1].type > "u" ? n[n.length - 1].value.push(a[l]) : n[n.length - 1].value = a[l].value(n[n.length - 1].value);
      else if (a[l].type === 8) {
        for (var u = [], d = 0; d < a[l].numberOfArguments; d++)
          u.push(n.pop().value);
        n.push({ type: 1, value: a[l].value.apply(a[l], u.reverse()) });
      } else a[l].type === 10 ? (r = n.pop(), i = n.pop(), typeof i.type > "u" ? (i.value = i.concat(r), i.value.push(a[l]), n.push(i)) : typeof r.type > "u" ? (r.unshift(i), r.push(a[l]), n.push(r)) : n.push({ type: 1, value: a[l].value(i.value, r.value) })) : a[l].type === 2 || a[l].type === 9 ? (r = n.pop(), i = n.pop(), typeof i.type > "u" ? (i = i.concat(r), i.push(a[l]), n.push(i)) : typeof r.type > "u" ? (r.unshift(i), r.push(a[l]), n.push(r)) : n.push({ type: 1, value: a[l].value(i.value, r.value) })) : a[l].type === 12 ? (r = n.pop(), typeof r.type < "u" && (r = [r]), i = n.pop(), o = n.pop(), n.push({ type: 1, value: a[l].value(o.value, i.value, new e(r)) })) : a[l].type === 13 && (s ? n.push({ value: t[a[l].value], type: 3 }) : n.push([a[l]]));
    if (n.length > 1)
      throw new e.Exception("Uncaught Syntax error");
    return n[0].value > 1e15 ? "Infinity" : parseFloat(n[0].value.toFixed(15));
  }, e.eval = function(t, n, r) {
    return typeof n > "u" ? this.lex(t).toPostfix().postfixEval() : typeof r > "u" ? typeof n.length < "u" ? this.lex(t, n).toPostfix().postfixEval() : this.lex(t).toPostfix().postfixEval(n) : this.lex(t, n).toPostfix().postfixEval(r);
  }, bo = e, bo;
}
var yo, ul;
function sh() {
  if (ul) return yo;
  ul = 1;
  var e = ah();
  return e.prototype.formulaEval = function() {
    for (var t, n, r, i = [], o = this.value, a = 0; a < o.length; a++)
      o[a].type === 1 || o[a].type === 3 ? i.push({ value: o[a].type === 3 ? o[a].show : o[a].value, type: 1 }) : o[a].type === 13 ? i.push({ value: o[a].show, type: 1 }) : o[a].type === 0 ? i[i.length - 1] = { value: o[a].show + (o[a].show != "-" ? "(" : "") + i[i.length - 1].value + (o[a].show != "-" ? ")" : ""), type: 0 } : o[a].type === 7 ? i[i.length - 1] = { value: (i[i.length - 1].type != 1 ? "(" : "") + i[i.length - 1].value + (i[i.length - 1].type != 1 ? ")" : "") + o[a].show, type: 7 } : o[a].type === 10 ? (t = i.pop(), n = i.pop(), o[a].show === "P" || o[a].show === "C" ? i.push({ value: "<sup>" + n.value + "</sup>" + o[a].show + "<sub>" + t.value + "</sub>", type: 10 }) : i.push({ value: (n.type != 1 ? "(" : "") + n.value + (n.type != 1 ? ")" : "") + "<sup>" + t.value + "</sup>", type: 1 })) : o[a].type === 2 || o[a].type === 9 ? (t = i.pop(), n = i.pop(), i.push({ value: (n.type != 1 ? "(" : "") + n.value + (n.type != 1 ? ")" : "") + o[a].show + (t.type != 1 ? "(" : "") + t.value + (t.type != 1 ? ")" : ""), type: o[a].type })) : o[a].type === 12 && (t = i.pop(), n = i.pop(), r = i.pop(), i.push({ value: o[a].show + "(" + r.value + "," + n.value + "," + t.value + ")", type: 12 }));
    return i[0].value;
  }, yo = e, yo;
}
var xo, dl;
function lh() {
  if (dl) return xo;
  dl = 1;
  var e = eh(), t = nh(), n = sh(), r = 100, i = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g, o;
  xo = a;
  function a(l, u) {
    o = 0, u = Math.pow(10, u === void 0 ? 5 : u), l = l.replace(/\n+/g, " ");
    function d(h, p, b) {
      if (o++ > r)
        throw o = 0, new Error("Call stack overflow for " + b);
      if (h === "")
        throw new Error(p + "(): '" + b + "' must contain a non-whitespace string");
      h = f(h, b);
      var g = s(h);
      if (g.length > 1 || h.indexOf("var(") > -1)
        return p + "(" + h + ")";
      var v = g[0] || "";
      v === "%" && (h = h.replace(/\b[0-9\.]+%/g, function(N) {
        return parseFloat(N.slice(0, -1)) * 0.01;
      }));
      var w = h.replace(new RegExp(v, "gi"), ""), m;
      try {
        m = n.eval(w);
      } catch {
        return p + "(" + h + ")";
      }
      return v === "%" && (m *= 100), (p.length || v === "%") && (m = Math.round(m * u) / u), m += v, m;
    }
    function f(h, p) {
      h = h.replace(/((?:\-[a-z]+\-)?calc)/g, "");
      for (var b = "", g = h, v; v = i.exec(g); ) {
        v[0].index > 0 && (b += g.substring(0, v[0].index));
        var w = e("(", ")", g.substring([0].index));
        if (w.body === "")
          throw new Error("'" + h + "' must contain a non-whitespace string");
        var m = d(w.body, "", p);
        b += w.pre + m, g = w.post;
      }
      return b + g;
    }
    return t(l, /((?:\-[a-z]+\-)?calc)\(/, d);
  }
  function s(l) {
    for (var u = [], d = [], f = /[\.0-9]([%a-z]+)/gi, h = f.exec(l); h; )
      !h || !h[1] || (d.indexOf(h[1].toLowerCase()) === -1 && (u.push(h[1]), d.push(h[1].toLowerCase())), h = f.exec(l));
    return u;
  }
  return xo;
}
var ch = lh();
const Co = /* @__PURE__ */ Di(ch);
function uh(e, t) {
  const n = /* @__PURE__ */ new Map();
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    const s = t(...o);
    if (n.has(s)) return n.get(s);
    const l = e.apply(this, o);
    return n.set(s, l), l;
  };
}
const fl = "__react_svg_text_measurement_id";
function dh(e, t) {
  if (typeof document > "u") return null;
  try {
    let n = document.getElementById(fl);
    if (!n) {
      const r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.setAttribute("aria-hidden", "true"), r.style.width = "0", r.style.height = "0", r.style.position = "absolute", r.style.top = "-100%", r.style.left = "-100%", n = document.createElementNS("http://www.w3.org/2000/svg", "text"), n.setAttribute("id", fl), r.appendChild(n), document.body.appendChild(r);
    }
    return Object.assign(n.style, t), n.textContent = e, n.getComputedTextLength();
  } catch {
    return null;
  }
}
const hl = uh(dh, (e, t) => `${e}_${JSON.stringify(t)}`);
function wo(e) {
  return typeof e == "number";
}
function pl(e) {
  return (
    // number that is not NaN or Infinity
    typeof e == "number" && Number.isFinite(e) || // for percentage
    typeof e == "string"
  );
}
function fh(e) {
  const {
    verticalAnchor: t = "end",
    scaleToFit: n = !1,
    angle: r,
    width: i,
    lineHeight: o = "1em",
    capHeight: a = "0.71em",
    // Magic number from d3
    children: s,
    style: l,
    ...u
  } = e, {
    x: d = 0,
    y: f = 0
  } = u, h = !pl(d) || !pl(f), {
    wordsWithWidth: p,
    spaceWidth: b
  } = de(() => ({
    wordsWithWidth: (s == null ? [] : s.toString().split(/(?:(?!\u00A0+)\s+)/)).map((N) => ({
      word: N,
      wordWidth: hl(N, l) || 0
    })),
    spaceWidth: hl(" ", l) || 0
  }), [s, l]), g = de(() => h ? [] : i || n ? p.reduce((m, N) => {
    let {
      word: C,
      wordWidth: M
    } = N;
    const y = m[m.length - 1];
    if (y && (i == null || n || (y.width || 0) + M + b < i))
      y.words.push(C), y.width = y.width || 0, y.width += M + b;
    else {
      const L = {
        words: [C],
        width: M
      };
      m.push(L);
    }
    return m;
  }, []) : [{
    words: s == null ? [] : s.toString().split(/(?:(?!\u00A0+)\s+)/)
  }], [h, i, n, s, p, b]), v = de(() => h ? "" : Co(t === "start" ? `calc(${a})` : t === "middle" ? `calc(${(g.length - 1) / 2} * -${o} + (${a} / 2))` : `calc(${g.length - 1} * -${o})`), [h, t, a, g.length, o]), w = de(() => {
    const m = [];
    if (h)
      return "";
    if (wo(d) && wo(f) && wo(i) && n && g.length > 0) {
      const N = g[0].width || 1, C = n === "shrink-only" ? Math.min(i / N, 1) : i / N, M = C, y = d - C * d, L = f - M * f;
      m.push(`matrix(${C}, 0, 0, ${M}, ${y}, ${L})`);
    }
    return r && m.push(`rotate(${r}, ${d}, ${f})`), m.length > 0 ? m.join(" ") : "";
  }, [h, d, f, i, n, g, r]);
  return {
    wordsByLines: g,
    startDy: v,
    transform: w
  };
}
const hh = {
  overflow: "visible"
};
function pt(e) {
  const {
    dx: t = 0,
    dy: n = 0,
    textAnchor: r = "start",
    innerRef: i,
    innerTextRef: o,
    verticalAnchor: a,
    angle: s,
    lineHeight: l = "1em",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit: u = !1,
    capHeight: d,
    width: f,
    ...h
  } = e, {
    x: p = 0,
    fontSize: b
  } = h, {
    wordsByLines: g,
    startDy: v,
    transform: w
  } = fh(e);
  return /* @__PURE__ */ c("svg", {
    ref: i,
    x: t,
    y: n,
    fontSize: b,
    style: hh,
    children: g.length > 0 ? /* @__PURE__ */ c("text", {
      ref: o,
      transform: w,
      ...h,
      textAnchor: r,
      children: g.map((m, N) => /* @__PURE__ */ c("tspan", {
        x: p,
        dy: N === 0 ? v : l,
        children: m.words.join(" ")
      }, N))
    }) : null
  });
}
const Ra = 2, ph = 6, mh = 2, ml = 4, ci = 2.4, gh = 0.08, vh = 8, bh = 2, yh = 8, xh = 4, gl = 2, Ch = 12, wh = 8, Nh = 1, ui = 2, No = 8, R1 = 8, _h = 76, vl = 54;
function Mh(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    leading: r = !1
  } = n;
  let i, o = null, a;
  function s() {
    for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
      u[d] = arguments[d];
    r && i === void 0 ? (e.apply(this, u), o = null) : (o = u, a = this), clearTimeout(i), i = setTimeout(() => {
      i = void 0, o !== null && (e.apply(a, o), o = null, a = void 0);
    }, t);
  }
  return s.cancel = function() {
    clearTimeout(i), i = void 0, o = null, a = void 0;
  }, s;
}
const Lh = [], bl = {
  width: 0,
  height: 0,
  top: 0,
  left: 0
};
function Ah() {
  let {
    initialSize: e = bl,
    debounceTime: t = 300,
    ignoreDimensions: n = Lh,
    enableDebounceLeadingCall: r = !0,
    resizeObserverPolyfill: i,
    externalRef: o
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const [a, s] = ie(null), l = we((p) => {
    s(p), typeof o == "function" ? o(p) : o != null && (o.current = p);
  }, [o]), u = xe(0), [d, f] = ie({
    ...bl,
    ...e
  }), h = de(() => {
    const p = Array.isArray(n) ? n : [n];
    return Mh((b) => {
      f((g) => Object.keys(g).filter((N) => g[N] !== b[N]).every((N) => p.includes(N)) ? g : b);
    }, t, {
      leading: r
    });
  }, [t, r, n]);
  return te(() => {
    if (!a) {
      h.cancel();
      return;
    }
    const p = i || window.ResizeObserver, b = new p((g) => {
      g.forEach((v) => {
        const {
          left: w,
          top: m,
          width: N,
          height: C
        } = (v == null ? void 0 : v.contentRect) ?? {};
        u.current = window.requestAnimationFrame(() => {
          h({
            width: N,
            height: C,
            top: m,
            left: w
          });
        });
      });
    });
    return b.observe(a), () => {
      window.cancelAnimationFrame(u.current), b.disconnect(), h.cancel();
    };
  }, [a, h, i]), {
    parentRef: l,
    node: a,
    resize: h,
    ...d
  };
}
const _o = "…";
function ln(e) {
  return `${e}px "Px Grotesk", sans-serif`;
}
const Br = 0.4, Eh = 2048, wr = /* @__PURE__ */ new Map();
let D1 = 0, yl = !1;
const Mo = /* @__PURE__ */ new Set();
function xl() {
  return D1;
}
function Sh(e) {
  return !yl && typeof document < "u" && "fonts" in document && (yl = !0, document.fonts.addEventListener("loadingdone", () => {
    wr.clear(), D1 += 1;
    for (const t of Mo) t();
  })), Mo.add(e), () => {
    Mo.delete(e);
  };
}
let di;
function kh() {
  if (di === void 0)
    try {
      di = typeof document > "u" ? null : document.createElement("canvas").getContext("2d");
    } catch {
      di = null;
    }
  return di;
}
function In(e, t, n = 0) {
  const r = kh();
  if (!r) return 0;
  const i = `${t}\0${n}\0${e}`, o = wr.get(i);
  if (o !== void 0) return o;
  wr.size >= Eh && wr.clear(), r.font = t;
  const a = r.measureText(e).width + n * e.length;
  return wr.set(i, a), a;
}
function Ei(e, t, n, r = 0) {
  if (In(e, t, r) <= n) return e;
  if (n <= 0) return "";
  let i = 0, o = e.length - 1;
  for (; i < o; ) {
    const a = Math.ceil((i + o) / 2);
    In(e.slice(0, a) + _o, t, r) <= n ? i = a : o = a - 1;
  }
  return i === 0 ? _o : e.slice(0, i) + _o;
}
const Oh = 1016 / 350, Th = { minRem: 3, cqiPct: 7, maxRem: 4.25 }, Vh = { minRem: 0.625, cqiPct: 1.12, maxRem: 0.75 }, Hh = { minRem: 0.7, cqiPct: 1.3, maxRem: 0.875 }, Rh = { minRem: 0.75, cqiPct: 1.5, maxRem: 1 }, Cl = 16;
let fi = null;
function P1() {
  if (fi !== null) return fi;
  if (typeof document > "u") return Cl;
  const e = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
  return fi = Number.isFinite(e) && e > 0 ? e : Cl, fi;
}
function mi(e, t, n) {
  return Math.min(e.maxRem * n, Math.max(e.minRem * n, e.cqiPct / 100 * t));
}
const wl = 8, Da = 6, Dh = 6, Ph = 12, Ih = 24;
function I1(e) {
  return mi(Vh, e, P1());
}
function Bh(e, t) {
  if (t.length === 0) return 0;
  const n = ln(I1(e));
  return Math.max(...t.map((i) => In(i, n, Br))) + Ih;
}
const cn = 1.2;
function $h(e) {
  const {
    chartWidth: t,
    axisSide: n,
    hasTopLegend: r,
    hasXAxis: i,
    aspectRatio: o = Oh,
    gutterPx: a,
    minPlotHeight: s = 0
  } = e, l = P1(), u = a ?? mi(Th, t, l), d = I1(t), f = mi(Hh, t, l), h = mi(Rh, t, l), p = Math.max(0, t - u), b = Math.max(o > 0 ? p / o : 0, s), g = n === "left" ? u : 0, v = r ? 2 * Dh + Math.round(f * cn) : 0, w = r ? v + Ph : 0, m = i ? Da + Math.round(d * cn) : 0;
  return {
    chartWidth: t,
    gutter: u,
    plotLeft: g,
    plotTop: w,
    plotWidth: p,
    plotHeight: b,
    legendHeight: v,
    svgHeight: w + b + m,
    fontAxis: d,
    fontLabel: f,
    fontAmount: h
  };
}
const Nl = 1016;
function Pa(e) {
  const { parentRef: t, width: n } = Ah({
    debounceTime: 16,
    enableDebounceLeadingCall: !1,
    initialSize: { width: Nl }
  }), r = Iu(Sh, xl, xl), i = n <= 0, o = i ? Nl : n, { axisSide: a, hasTopLegend: s, hasXAxis: l, aspectRatio: u, yAxisLabels: d, minPlotHeight: f } = e, h = de(() => {
    const p = d === void 0 ? void 0 : Bh(o, d);
    return $h({ chartWidth: o, axisSide: a, hasTopLegend: s, hasXAxis: l, aspectRatio: u, gutterPx: p, minPlotHeight: f });
  }, [o, a, s, l, u, d, f, r]);
  return { parentRef: t, layout: h, collapsed: i };
}
const Fh = 120;
function zh(e, t, n, r, i, o, a) {
  if (r) return [];
  const s = t - 2 * xh, l = [];
  return s >= Math.round(i * cn) && l.push({ kind: "label", text: e.label, fontSize: i }), e.state === "liquidated" && a ? (s > vl && l.push({ kind: "liquidated", text: a, fontSize: i }), l) : (!n && e.sublabel && s > _h && l.push({ kind: "sublabel", text: e.sublabel, fontSize: i }), e.amountLabel && s > vl && l.push({ kind: "amount", text: e.amountLabel, fontSize: o }), l);
}
function B1({
  bands: e,
  bandRect: t,
  fontLabel: n,
  fontAmount: r,
  compact: i,
  hideBandLabels: o,
  liquidatedLabel: a,
  isDimmed: s,
  popoverOffsetPx: l = R1
}) {
  var g;
  const u = Xt(), [d, f] = ie(null), h = xe(null), p = () => {
    h.current && (clearTimeout(h.current), h.current = null);
  }, b = () => {
    p(), h.current = setTimeout(() => f(null), Fh);
  };
  return /* @__PURE__ */ x(He, { children: [
    e.map((v, w) => {
      var A;
      const m = t(v), N = s ? s(v) : v.state === "liquidated", C = !!((A = v.popoverMetrics) != null && A.length), M = zh(
        v,
        m.height,
        i,
        o,
        n,
        r,
        a
      ), y = M.map((E) => Math.round(E.fontSize * cn)), L = y.reduce((E, P) => E + P, 0) + Math.max(0, M.length - 1) * gl, T = m.width - 2 * yh, S = `${u}-${w}`, R = [];
      let V = m.y + (m.height - L) / 2;
      for (const E of y)
        R.push(V), V += E + gl;
      return /* @__PURE__ */ x(
        sn,
        {
          className: H(
            "bbn-liq-band",
            N && "bbn-liq-band--liquidated",
            C && "bbn-liq-band--interactive"
          ),
          children: [
            /* @__PURE__ */ c("clipPath", { id: S, children: /* @__PURE__ */ c("rect", { x: m.x, y: m.y, width: m.width, height: m.height }) }),
            /* @__PURE__ */ c(
              or,
              {
                className: H("bbn-liq-band__rect", `bbn-liq-band__rect--tone-${v.tone}`),
                x: m.x,
                y: m.y,
                width: m.width,
                height: m.height,
                "data-testid": `liq-band-${v.key}`,
                tabIndex: C ? 0 : void 0,
                "aria-label": C ? [v.label, v.sublabel ?? v.accessibleDetail, v.amountLabel].filter(Boolean).join(" ") : void 0,
                onMouseEnter: (E) => {
                  var P;
                  p(), (P = v.popoverMetrics) != null && P.length && f({ band: v, anchor: E.currentTarget });
                },
                onMouseLeave: b,
                onFocus: (E) => {
                  var P;
                  p(), (P = v.popoverMetrics) != null && P.length && f({ band: v, anchor: E.currentTarget });
                },
                onBlur: b
              }
            ),
            M.length > 0 ? /* @__PURE__ */ c("g", { className: "bbn-liq-band__text", clipPath: `url(#${S})`, pointerEvents: "none", children: M.map((E, P) => /* @__PURE__ */ c(
              pt,
              {
                x: m.x + m.width / 2,
                y: R[P],
                textAnchor: "middle",
                verticalAnchor: "start",
                fontSize: E.fontSize,
                children: Ei(E.text, ln(E.fontSize), T)
              },
              E.kind
            )) }) : null
          ]
        },
        v.key
      );
    }),
    /* @__PURE__ */ c(
      ei,
      {
        open: !!d,
        anchorEl: (d == null ? void 0 : d.anchor) ?? null,
        placement: "right-start",
        offset: [0, l],
        className: "bbn-liq-popover",
        onClickOutside: () => f(null),
        children: d ? /* @__PURE__ */ x("div", { className: "bbn-liq-popover__inner", onMouseEnter: p, onMouseLeave: b, children: [
          /* @__PURE__ */ c("span", { className: "bbn-liq-popover__chip", children: d.band.label }),
          /* @__PURE__ */ c("dl", { className: "bbn-liq-popover__metrics", children: (g = d.band.popoverMetrics) == null ? void 0 : g.map((v) => /* @__PURE__ */ x("div", { className: "bbn-liq-popover__row", children: [
            /* @__PURE__ */ c("dt", { children: v.label }),
            /* @__PURE__ */ c("dd", { className: v.emphasis ? `bbn-liq-popover__value--tone-${d.band.tone}` : void 0, children: v.value })
          ] }, v.label)) }),
          d.band.cumulativeLabel ? /* @__PURE__ */ x("div", { className: "bbn-liq-popover__row bbn-liq-popover__row--footer", children: [
            /* @__PURE__ */ c("dt", { children: "Cumulative" }),
            /* @__PURE__ */ c("dd", { children: d.band.cumulativeLabel })
          ] }) : null
        ] }) : null
      }
    )
  ] });
}
function jh(e, t, n = 2) {
  const r = /* @__PURE__ */ new Map();
  if (e.length === 0) return r;
  const i = [...e].sort((l, u) => l.center - u.center), o = i.map((l) => l.center), a = i.length, s = (l) => i[l - 1].height / 2 + i[l].height / 2 + n;
  for (let l = 1; l < a; l++)
    o[l] = Math.max(o[l], o[l - 1] + s(l));
  o[a - 1] = Math.min(o[a - 1], t - i[a - 1].height / 2);
  for (let l = a - 2; l >= 0; l--)
    o[l] = Math.min(o[l], o[l + 1] - s(l + 1));
  for (let l = 0; l < a; l++)
    o[l] = Math.max(i[l].height / 2, o[l]), r.set(i[l].key, o[l]);
  return r;
}
const qh = "__current__";
function Uh(e) {
  const { layout: t, levelMarkers: n, currentPricePill: r, currentPriceLabel: i, currentY: o, priceScale: a, priceAxis: s, axisSide: l } = e, u = Math.round(t.fontAxis * cn) + 2 * mh, d = ln(t.fontAxis), f = (n ?? []).map((m) => ({
    key: m.key,
    label: m.label,
    tone: m.tone,
    current: !1,
    center: a(m.price)
  }));
  if (r && f.push({
    key: qh,
    label: i,
    tone: void 0,
    current: !0,
    center: o
  }), f.length === 0)
    return { pills: [], hiddenTickValues: /* @__PURE__ */ new Set() };
  const h = f.map((m) => ({ key: m.key, center: m.center, height: u })), p = jh(h, t.plotHeight), b = /* @__PURE__ */ new Set(), g = Math.round(t.fontAxis * cn), v = (u + g) / 2;
  for (const m of s) {
    const N = a(m.value);
    for (const C of f) {
      const M = p.get(C.key);
      if (M != null && Math.abs(M - N) < v) {
        b.add(m.value);
        break;
      }
    }
  }
  return { pills: f.map((m) => {
    const N = In(m.label, d, Br) + 2 * ph;
    return {
      key: m.key,
      label: m.label,
      tone: m.tone,
      current: m.current,
      x: l === "right" ? t.plotWidth + ml : -(ml + N),
      width: N,
      top: (p.get(m.key) ?? m.center) - u / 2,
      height: u
    };
  }), hiddenTickValues: b };
}
function $1({
  parentRef: e,
  layout: t,
  priceAxis: n,
  priceScale: r,
  currentPrice: i,
  currentPriceLabel: o,
  axisSide: a = "left",
  levelMarkers: s,
  currentPricePill: l = !1,
  showPriceLineLabel: u = !0,
  priceLineCaption: d,
  priceLineColor: f,
  priceLineLabelColor: h,
  plotInsetLeft: p = 0,
  xAxisLabels: b,
  xAxisTicks: g,
  grid: v,
  ariaLabel: w,
  className: m,
  topLegend: N,
  children: C,
  overlay: M
}) {
  const y = (v == null ? void 0 : v.lines) ?? "both", L = (v == null ? void 0 : v.style) ?? "dashed", T = r(i), S = t.plotHeight > 0 && T / t.plotHeight < gh, { pills: R, hiddenTickValues: V } = Uh({
    layout: t,
    levelMarkers: s,
    currentPricePill: l,
    currentPriceLabel: o,
    currentY: T,
    priceScale: r,
    priceAxis: n,
    axisSide: a
  }), A = {
    ...f ? { "--liq-price-line": f } : {},
    ...h ? { "--liq-price-line-label": h } : {}
  }, E = a === "left" ? t.gutter - wl : t.plotWidth + wl, P = t.plotWidth - p, U = g != null && g.length ? g : b != null && b.length ? b.map((I, Y) => ({
    fraction: b.length < 2 ? 0 : Y / (b.length - 1),
    label: I
  })) : void 0, D = w ?? [d, o].filter(Boolean).join(" "), z = { "--liq-axis-letter-spacing": `${Br}px`, ...A };
  return /* @__PURE__ */ c(
    "div",
    {
      ref: e,
      style: z,
      className: H("bbn-liq-chart", `bbn-liq-chart--gridstyle-${L}`, m),
      children: /* @__PURE__ */ x("div", { className: "bbn-liq-chart__canvas", children: [
        /* @__PURE__ */ x(
          "svg",
          {
            className: "bbn-liq-chart__svg",
            width: t.chartWidth,
            height: t.svgHeight,
            role: "img",
            "aria-label": D,
            children: [
              N ? /* @__PURE__ */ c(sn, { left: t.plotLeft, children: N }) : null,
              /* @__PURE__ */ x(sn, { top: t.plotTop, left: t.plotLeft, children: [
                y === "both" || y === "horizontal" ? /* @__PURE__ */ c(
                  H1,
                  {
                    className: "bbn-liq-grid",
                    scale: r,
                    left: p,
                    width: P,
                    tickValues: n.map((I) => I.value),
                    "aria-hidden": !0
                  }
                ) : null,
                s == null ? void 0 : s.map((I) => /* @__PURE__ */ c(
                  vn,
                  {
                    className: H("bbn-liq-level-line", I.tone && `bbn-liq-level-line--tone-${I.tone}`),
                    from: { x: p, y: r(I.price) },
                    to: { x: t.plotWidth, y: r(I.price) },
                    "aria-hidden": !0
                  },
                  I.key
                )),
                C,
                /* @__PURE__ */ x(He, { children: [
                  /* @__PURE__ */ c(
                    vn,
                    {
                      className: "bbn-liq-price-line",
                      from: { x: p, y: T },
                      to: { x: t.plotWidth, y: T },
                      "data-testid": "liq-current-price-line"
                    }
                  ),
                  !l && u ? /* @__PURE__ */ x(He, { children: [
                    d ? /* @__PURE__ */ c(
                      pt,
                      {
                        className: "bbn-liq-price-line-text",
                        x: p,
                        y: S ? T + ci : T - ci,
                        textAnchor: "start",
                        verticalAnchor: S ? "start" : "end",
                        fontSize: t.fontAxis,
                        children: d
                      }
                    ) : null,
                    /* @__PURE__ */ c(
                      pt,
                      {
                        className: "bbn-liq-price-line-text",
                        x: t.plotWidth,
                        y: S ? T + ci : T - ci,
                        textAnchor: "end",
                        verticalAnchor: S ? "start" : "end",
                        fontSize: t.fontAxis,
                        children: o
                      }
                    )
                  ] }) : null
                ] }),
                R.map((I) => /* @__PURE__ */ x("g", { "aria-hidden": !0, children: [
                  /* @__PURE__ */ c(
                    "rect",
                    {
                      className: H(
                        "bbn-liq-pill__rect",
                        I.tone && `bbn-liq-pill__rect--tone-${I.tone}`,
                        I.current && "bbn-liq-pill__rect--current"
                      ),
                      x: I.x,
                      y: I.top,
                      width: I.width,
                      height: I.height,
                      rx: Ra
                    }
                  ),
                  /* @__PURE__ */ c(
                    pt,
                    {
                      className: "bbn-liq-pill__text",
                      x: I.x + I.width / 2,
                      y: I.top + I.height / 2,
                      textAnchor: "middle",
                      verticalAnchor: "middle",
                      fontSize: t.fontAxis,
                      children: I.label
                    }
                  )
                ] }, I.key))
              ] }),
              n.map(
                (I, Y) => V.has(I.value) ? null : /* @__PURE__ */ c(
                  pt,
                  {
                    className: "bbn-liq-axis-text",
                    x: E,
                    y: t.plotTop + r(I.value),
                    textAnchor: a === "left" ? "end" : "start",
                    verticalAnchor: "middle",
                    fontSize: t.fontAxis,
                    "aria-hidden": !0,
                    children: I.label
                  },
                  `${I.value}:${Y}`
                )
              ),
              U == null ? void 0 : U.map((I) => {
                const Y = I.fraction * P, Z = In(I.label, ln(t.fontAxis), Br) / 2, ne = Y - Z <= 0 ? "start" : Y + Z >= P ? "end" : "middle";
                return /* @__PURE__ */ c(
                  pt,
                  {
                    className: "bbn-liq-axis-text",
                    x: t.plotLeft + p + Y,
                    y: t.plotTop + t.plotHeight + Da,
                    textAnchor: ne,
                    verticalAnchor: "start",
                    fontSize: t.fontAxis,
                    "aria-hidden": !0,
                    children: I.label
                  },
                  `${I.label}-${I.fraction}`
                );
              })
            ]
          }
        ),
        M
      ] })
    }
  );
}
const Ia = [1, 0], Ba = [0, 0];
function Wh(e, t) {
  const n = e.length - 1;
  if (n < 1)
    return Wt({ domain: Ia, range: Ba, clamp: !0 });
  const r = e.map((o) => o.value);
  z1(r);
  const i = r.map((o, a) => a / n * t);
  return Wt({ domain: r, range: i, clamp: !0 });
}
function Zh(e, t, n) {
  return !Number.isFinite(e) || !Number.isFinite(t) || e <= t ? Wt({ domain: Ia, range: Ba, clamp: !0 }) : Wt({ domain: [e, t], range: [0, n], clamp: !0 });
}
const F1 = 0.3;
function Xh(e, t) {
  if (e.length === 0) return [];
  if (e.length === 1) return [1];
  const n = e.length - 1, r = n * t, i = 1 - F1;
  if (r <= i)
    return [1 - r, ...new Array(n).fill(t)];
  const o = i / n;
  return [1 - i, ...new Array(n).fill(o)];
}
function Gh(e, t) {
  return e * t / (1 - F1);
}
function Yh(e, t) {
  if (e.length < 2)
    return Wt({ domain: Ia, range: Ba, clamp: !0 });
  const n = e.map((o) => o.price);
  z1(n);
  const r = e.map((o) => o.fraction);
  for (let o = 1; o < r.length; o++)
    if (!(r[o] > r[o - 1]))
      throw new Error(
        `LiquidationChart: anchor fractions must be strictly ascending (top→bottom). Got ${r[o - 1]} at index ${o - 1} followed by ${r[o]} at index ${o}.`
      );
  const i = r.map((o) => o * t);
  return Wt({ domain: n, range: i, clamp: !0 });
}
function z1(e) {
  for (let t = 1; t < e.length; t++)
    if (!(e[t] < e[t - 1]))
      throw new Error(
        `LiquidationChart: priceAxis must be strictly descending (top→bottom). Got ${e[t - 1]} at index ${t - 1} followed by ${e[t]} at index ${t}. Deduplicate and sort ticks in the caller before passing priceAxis.`
      );
}
function Kh({
  bands: e,
  shareScale: t,
  layout: n,
  liquidatedLabel: r
}) {
  const i = Xt();
  return /* @__PURE__ */ c(He, { children: e.map((o, a) => {
    const s = t(o.shareStart), l = a === e.length - 1, u = Math.max(0, t(o.shareEnd) - s - (l ? 0 : bh)), d = o.state === "liquidated", f = (d && r ? r : o.amountLabel) ?? "", h = `${i}-${a}`;
    return /* @__PURE__ */ x("g", { className: H("bbn-liq-legend__seg", d && "bbn-liq-legend__seg--liquidated"), children: [
      /* @__PURE__ */ c("clipPath", { id: h, children: /* @__PURE__ */ c("rect", { x: s, y: 0, width: u, height: n.legendHeight }) }),
      /* @__PURE__ */ c(
        or,
        {
          className: `bbn-liq-legend__rect bbn-liq-legend__rect--tone-${o.tone}`,
          x: s,
          y: 0,
          width: u,
          height: n.legendHeight,
          rx: Ra
        }
      ),
      /* @__PURE__ */ c("g", { clipPath: `url(#${h})`, pointerEvents: "none", children: /* @__PURE__ */ c(
        pt,
        {
          className: "bbn-liq-legend__text",
          x: s + u / 2,
          y: n.legendHeight / 2,
          textAnchor: "middle",
          verticalAnchor: "middle",
          fontSize: n.fontLabel,
          children: Ei(f, ln(n.fontLabel), u - 2 * vh)
        }
      ) })
    ] }, o.key);
  }) });
}
function b8({
  bands: e,
  currentPrice: t,
  currentPriceLabel: n,
  priceAxis: r,
  shareAxisLabels: i,
  shareAxisTicks: o,
  showShareLegend: a = !0,
  variant: s = "full",
  grid: l,
  showPriceLineLabel: u,
  priceLineCaption: d,
  priceLineColor: f,
  priceLineLabelColor: h,
  hideBandLabels: p,
  liquidatedLabel: b,
  className: g
}) {
  const v = s === "compact", w = !v && a && e.length > 0, m = !v && !!(o != null && o.length || i != null && i.length), { parentRef: N, layout: C, collapsed: M } = Pa({ axisSide: "left", hasTopLegend: w, hasXAxis: m }), y = de(
    () => Wh(r, C.plotHeight),
    [r, C.plotHeight]
  ), L = de(
    () => Wt({ domain: [0, 1], range: [0, C.plotWidth], clamp: !0 }),
    [C.plotWidth]
  );
  if (M) return /* @__PURE__ */ c("div", { ref: N, style: { width: "100%" } });
  const T = (S) => {
    const R = L(S.shareStart), V = y(S.priceTop);
    return {
      x: R,
      y: V,
      width: Math.max(0, L(S.shareEnd) - R),
      height: Math.max(0, y(S.priceBottom) - V)
    };
  };
  return /* @__PURE__ */ x(
    $1,
    {
      parentRef: N,
      layout: C,
      priceAxis: r,
      priceScale: y,
      currentPrice: t,
      currentPriceLabel: n,
      xAxisLabels: v ? void 0 : i,
      xAxisTicks: v ? void 0 : o,
      grid: l,
      showPriceLineLabel: u,
      priceLineCaption: d,
      priceLineColor: f,
      priceLineLabelColor: h,
      className: g,
      topLegend: w ? /* @__PURE__ */ c(Kh, { bands: e, shareScale: L, layout: C, liquidatedLabel: b }) : void 0,
      children: [
        ((l == null ? void 0 : l.lines) ?? "both") === "both" || (l == null ? void 0 : l.lines) === "vertical" ? /* @__PURE__ */ c(
          Ha,
          {
            className: "bbn-liq-grid",
            scale: L,
            height: C.plotHeight,
            tickValues: [0, ...e.map((S) => S.shareEnd)],
            "aria-hidden": !0
          }
        ) : null,
        /* @__PURE__ */ c(
          B1,
          {
            bands: e,
            bandRect: T,
            fontLabel: C.fontLabel,
            fontAmount: C.fontAmount,
            compact: v,
            hideBandLabels: !!p,
            liquidatedLabel: b
          }
        )
      ]
    }
  );
}
function Jh(e) {
  return !!e && (e instanceof SVGElement || "ownerSVGElement" in e);
}
function Qh(e) {
  return !!e && "createSVGPoint" in e;
}
function e5(e) {
  return !!e && "getScreenCTM" in e;
}
function t5(e) {
  return !!e && "changedTouches" in e;
}
function n5(e) {
  return !!e && "clientX" in e;
}
function r5(e) {
  return !!e && (e instanceof Event || "nativeEvent" in e && e.nativeEvent instanceof Event);
}
const Lo = {
  x: 0,
  y: 0
};
function i5(e) {
  if (!e) return {
    ...Lo
  };
  if (t5(e))
    return e.changedTouches.length > 0 ? {
      x: e.changedTouches[0].clientX,
      y: e.changedTouches[0].clientY
    } : {
      ...Lo
    };
  if (n5(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  const t = e == null ? void 0 : e.target, n = t && "getBoundingClientRect" in t ? t.getBoundingClientRect() : null;
  return n ? {
    x: n.x + n.width / 2,
    y: n.y + n.height / 2
  } : {
    ...Lo
  };
}
function o5(e, t) {
  if (!e || !t) return null;
  const n = i5(t), r = Jh(e) ? e.ownerSVGElement : e, i = e5(r) ? r.getScreenCTM() : null;
  if (Qh(r) && i) {
    let a = r.createSVGPoint();
    return a.x = n.x, a.y = n.y, a = a.matrixTransform(i.inverse()), new ar({
      x: a.x,
      y: a.y
    });
  }
  const o = e.getBoundingClientRect();
  return new ar({
    x: n.x - o.left - e.clientLeft,
    y: n.y - o.top - e.clientTop
  });
}
function a5(e, t) {
  if (r5(e)) {
    const n = e, r = n.target;
    if (r) return o5(r, n);
  }
  return null;
}
function s5({
  bands: e,
  priceScale: t,
  currentPrice: n,
  width: r,
  plotHeight: i,
  fontAxis: o,
  fontLabel: a,
  fontAmount: s,
  safeZone: l,
  compact: u,
  hideBandLabels: d,
  liquidatedLabel: f,
  popoverOffsetPx: h
}) {
  var V;
  const p = Xt(), b = de(() => {
    const A = /* @__PURE__ */ new Map();
    return e.forEach((E, P) => {
      const U = t(E.priceTop), D = P + 1 < e.length ? t(e[P + 1].priceTop) : i;
      A.set(E.key, { top: U, height: Math.max(0, D - U) });
    }), A;
  }, [e, t, i]), g = e.length ? ((V = b.get(e[0].key)) == null ? void 0 : V.top) ?? 0 : 0, v = (A) => {
    const E = b.get(A.key) ?? { top: 0, height: 0 };
    return { x: 0, y: E.top, width: r, height: E.height };
  }, w = t(n), m = (A) => {
    if (A.state === "liquidated") return !0;
    const E = b.get(A.key);
    return E ? w > E.top : !1;
  }, N = !!l && e.length > 0, C = g - 2 * (wh + Nh), M = Math.round(a * cn), y = Math.round(o * cn), L = M + ((l == null ? void 0 : l.lines.length) ?? 0) * (y + ui), T = N && l && L <= C ? l.lines : [], S = M + T.length * (y + ui), R = r - 2 * Ch;
  return /* @__PURE__ */ x(sn, { clipPath: `url(#${p})`, children: [
    /* @__PURE__ */ c("clipPath", { id: p, children: /* @__PURE__ */ c("rect", { x: 0, y: 0, width: r, height: i }) }),
    N && l ? /* @__PURE__ */ x("g", { children: [
      /* @__PURE__ */ c(or, { className: "bbn-liq-safezone__rect", x: 0, y: 0, width: r, height: g, rx: Ra }),
      /* @__PURE__ */ x("g", { pointerEvents: "none", children: [
        /* @__PURE__ */ c(
          pt,
          {
            className: "bbn-liq-safezone__title",
            x: r / 2,
            y: (g - S) / 2,
            textAnchor: "middle",
            verticalAnchor: "start",
            fontSize: a,
            children: Ei(l.title, ln(a), R)
          }
        ),
        T.map((A, E) => /* @__PURE__ */ c(
          pt,
          {
            className: "bbn-liq-safezone__line",
            x: r / 2,
            y: (g - S) / 2 + M + ui + E * (y + ui),
            textAnchor: "middle",
            verticalAnchor: "start",
            fontSize: o,
            children: Ei(A, ln(o), R)
          },
          A
        ))
      ] })
    ] }) : null,
    /* @__PURE__ */ c(
      B1,
      {
        bands: e,
        bandRect: v,
        fontLabel: a,
        fontAmount: s,
        compact: u,
        hideBandLabels: d,
        liquidatedLabel: f,
        isDimmed: m,
        popoverOffsetPx: h
      }
    )
  ] });
}
const l5 = 0.22, c5 = 0.6, Ao = 10, _l = 0.8, Ml = 1.25, u5 = 4e-3, d5 = 1, f5 = 0.6, h5 = 44, p5 = 2, m5 = 4, g5 = (e) => `$${Math.round(e).toLocaleString("en-US")}`, v5 = (e) => new Date(e).toLocaleDateString("en-US", { month: "short", day: "numeric" });
function b5(e, t, n, r) {
  const i = e.length ? n / e.length : n, o = i * c5, a = Math.max(u5 * r, d5);
  return e.map((s, l) => {
    const u = (l + 0.5) * i, d = t(Math.max(s.open, s.close));
    return {
      key: s.time,
      candle: s,
      center: u,
      bodyLeft: u - o / 2,
      bodyWidth: o,
      wickTop: t(s.high),
      wickBottom: t(s.low),
      bodyTop: d,
      bodyHeight: Math.max(t(Math.min(s.open, s.close)) - d, a),
      bullish: s.close >= s.open
    };
  });
}
function y8({
  bands: e,
  candles: t = [],
  currentPrice: n,
  currentPriceLabel: r,
  priceAxis: i,
  timeAxisLabels: o,
  safeZone: a,
  interactions: s,
  seriesStyle: l = "candles",
  visibleCandles: u,
  formatPrice: d = g5,
  formatTime: f = v5,
  formatReadoutTime: h = f,
  variant: p = "full",
  grid: b,
  hideBandLabels: g,
  liquidatedLabel: v,
  bandPlacement: w = "gutter",
  eventRowPx: m,
  aspectRatio: N,
  priceLineColor: C,
  className: M
}) {
  var dn, Qt;
  const y = p === "compact", L = l === "candles" || l === "candles+line", T = l !== "candles", S = l === "area", R = !y && (t.length > 0 || !!(o != null && o.length)), V = ((dn = i[0]) == null ? void 0 : dn.value) ?? n, A = ((Qt = i[i.length - 1]) == null ? void 0 : Qt.value) ?? 0, E = de(
    () => e.map((W) => W.priceTop).filter((W) => W < V && W > A),
    [e, V, A]
  ), P = m ?? h5, { parentRef: U, layout: D, collapsed: z } = Pa({
    axisSide: "right",
    hasTopLegend: !1,
    hasXAxis: R,
    aspectRatio: N,
    minPlotHeight: m === void 0 ? void 0 : Gh(E.length, m)
  }), I = w === "gutter" ? l5 * D.plotWidth : 0, Y = w === "plot" ? D.plotWidth : I, Z = Math.max(0, D.plotWidth - I), ne = de(() => {
    if (!E.length)
      return Zh(V, A, D.plotHeight);
    const W = [V, ...E, A], Oe = Xh(
      W.slice(1).map((Ee, Ve) => W[Ve] - Ee),
      P / D.plotHeight
    );
    let Fe = 0;
    const Qe = [
      { price: V, fraction: 0 },
      ...W.slice(1).map((Ee, Ve) => (Fe += Oe[Ve], { price: Ee, fraction: Ve === Oe.length - 1 ? 1 : Fe }))
    ];
    return Yh(Qe, D.plotHeight);
  }, [E, V, A, D.plotHeight, P]), fe = !!(s != null && s.zoom) && t.length > Ao, Me = Math.min(u ?? t.length, t.length) || t.length, [Ce, ke] = ie(null), he = Math.max(1, Math.min(Ce ?? Me, t.length) || 1), X = Math.max(0, t.length - he), [re, $] = ie(null), oe = re === null ? X : Math.min(re, X), pe = !!(s != null && s.pan) && t.length > he, [Le, Ie] = ie(null), Be = xe(null), me = xe(null), [Ae, at] = ie(!1), _ = de(
    () => t.slice(oe, oe + he),
    [t, oe, he]
  );
  te(() => {
    Ie(null);
  }, [oe, he]);
  const k = de(
    () => b5(_, ne, Z, D.plotHeight),
    [_, ne, Z, D.plotHeight]
  ), O = we(
    (W) => {
      const Oe = Math.max(Ao, Math.min(Math.round(he * W), t.length)), Fe = oe + he;
      ke(Oe), $(Fe >= t.length ? null : Math.max(0, Fe - Oe));
    },
    [he, t.length, oe]
  ), j = we(() => {
    ke(null), $(null);
  }, []), F = xe({ windowSize: he, candleCount: t.length, zoomBy: O });
  F.current = { windowSize: he, candleCount: t.length, zoomBy: O }, te(() => {
    const W = Be.current;
    if (!W || !fe) return;
    const Oe = (Fe) => {
      const { windowSize: Qe, candleCount: Ee, zoomBy: Ve } = F.current, se = Fe.deltaY > 0;
      (se ? Qe < Ee : Qe > Ao) && (Fe.preventDefault(), Ve(se ? Ml : _l));
    };
    return W.addEventListener("wheel", Oe, { passive: !1 }), () => W.removeEventListener("wheel", Oe);
  }, [fe, z]);
  const B = de(
    () => e.filter((W) => W.priceTop <= V && W.priceTop >= A).map((W) => ({
      key: W.key,
      price: W.priceTop,
      label: d(W.priceTop),
      tone: W.tone
    })),
    [e, d, V, A]
  ), J = !!(s != null && s.crosshair) && t.length > 0, le = de(() => {
    if (y || !_.length) return;
    const W = Math.min(7, _.length), Oe = Array.from({ length: W }, (Qe, Ee) => {
      const Ve = W < 2 ? 0 : Math.round(Ee / (W - 1) * (_.length - 1));
      return { fraction: (Ve + 0.5) / _.length, label: f(_[Ve].time) };
    }), Fe = [];
    return Oe.forEach((Qe, Ee) => {
      const Ve = Fe.length - 1;
      Ve < 0 || Qe.label !== Fe[Ve].label ? Fe.push(Qe) : Ee === Oe.length - 1 && (Fe[Ve] = Qe);
    }), Fe;
  }, [y, _, f]), be = y || _.length ? void 0 : o, ye = (b == null ? void 0 : b.lines) ?? "vertical", Ze = { ...b, lines: ye }, st = le ? le.map((W) => W.fraction) : be && be.length > 1 ? be.map((W, Oe) => Oe / (be.length - 1)).slice(1) : void 0, yt = de(
    () => Wt({ domain: [0, 1], range: [I, I + Z] }),
    [I, Z]
  ), Kt = (W) => {
    const Oe = a5(W);
    return !Oe || Z === 0 ? 0 : Math.min(1, Math.max(0, (Oe.x - D.plotLeft - I) / Z));
  }, Tt = (W) => {
    if (me.current) {
      const Oe = Z === 0 ? 0 : (W.clientX - me.current.x) / Z, Fe = Math.round(Oe * he), Qe = Math.min(X, Math.max(0, me.current.start - Fe));
      $(Qe === X ? null : Qe);
      return;
    }
    if (J) {
      const Oe = Kt(W);
      Ie(Math.min(_.length - 1, Math.max(0, Math.floor(Oe * _.length))));
    }
  }, xt = (W) => {
    pe && (me.current = { x: W.clientX, start: oe }, at(!0), W.currentTarget.setPointerCapture(W.pointerId));
  }, tt = (W) => {
    me.current && W.currentTarget.hasPointerCapture(W.pointerId) && W.currentTarget.releasePointerCapture(W.pointerId), me.current = null, at(!1);
  }, ge = Le != null ? k[Le] ?? null : null, qn = J || pe || fe;
  if (z) return /* @__PURE__ */ c("div", { ref: U, style: { width: "100%" } });
  const un = w === "none" ? null : /* @__PURE__ */ c(
    s5,
    {
      bands: e,
      priceScale: ne,
      currentPrice: n,
      width: Y,
      plotHeight: D.plotHeight,
      fontAxis: D.fontAxis,
      fontLabel: D.fontLabel,
      fontAmount: D.fontAmount,
      safeZone: a,
      compact: y,
      hideBandLabels: !!g,
      liquidatedLabel: v,
      popoverOffsetPx: w === "plot" ? D.gutter + R1 : void 0
    }
  ), Jt = qn ? /* @__PURE__ */ c(
    or,
    {
      innerRef: Be,
      className: "bbn-liq-candles__hit bbn-liq-candles__hit--interactive",
      x: I,
      y: 0,
      width: Z,
      height: D.plotHeight,
      fill: "transparent",
      onPointerMove: Tt,
      onPointerLeave: J ? () => Ie(null) : void 0,
      onPointerDown: pe ? xt : void 0,
      onPointerUp: pe ? tt : void 0,
      onPointerCancel: pe ? tt : void 0,
      onDoubleClick: fe ? j : void 0,
      "data-dragging": pe ? Ae : void 0
    }
  ) : null;
  return /* @__PURE__ */ x(
    $1,
    {
      parentRef: U,
      layout: D,
      priceAxis: i,
      priceScale: ne,
      currentPrice: n,
      currentPriceLabel: r,
      axisSide: "right",
      currentPricePill: !0,
      levelMarkers: B,
      plotInsetLeft: I,
      xAxisLabels: be,
      xAxisTicks: le,
      grid: Ze,
      priceLineColor: C,
      className: H(w === "plot" && "bbn-liq-timeline--plot", M),
      overlay: /* @__PURE__ */ x(He, { children: [
        ge ? /* @__PURE__ */ x(
          "div",
          {
            className: ge.center > f5 * Z ? "bbn-liq-readout bbn-liq-readout--left" : "bbn-liq-readout",
            style: {
              left: D.plotLeft + I + ge.center,
              top: D.plotTop + No,
              fontSize: D.fontAxis
            },
            children: [
              /* @__PURE__ */ c("span", { className: "bbn-liq-readout__time", children: h(ge.candle.time) }),
              /* @__PURE__ */ x("span", { className: "bbn-liq-readout__row", children: [
                /* @__PURE__ */ c("span", { children: "O" }),
                /* @__PURE__ */ c("span", { children: d(ge.candle.open) })
              ] }),
              /* @__PURE__ */ x("span", { className: "bbn-liq-readout__row", children: [
                /* @__PURE__ */ c("span", { children: "H" }),
                /* @__PURE__ */ c("span", { children: d(ge.candle.high) })
              ] }),
              /* @__PURE__ */ x("span", { className: "bbn-liq-readout__row", children: [
                /* @__PURE__ */ c("span", { children: "L" }),
                /* @__PURE__ */ c("span", { children: d(ge.candle.low) })
              ] }),
              /* @__PURE__ */ x("span", { className: "bbn-liq-readout__row", children: [
                /* @__PURE__ */ c("span", { children: "C" }),
                /* @__PURE__ */ c("span", { children: d(ge.candle.close) })
              ] })
            ]
          }
        ) : null,
        fe ? /* @__PURE__ */ x(
          "div",
          {
            className: "bbn-liq-zoom",
            style: {
              top: D.plotTop + No,
              right: D.gutter + No,
              fontSize: D.fontLabel
            },
            children: [
              /* @__PURE__ */ c("button", { type: "button", "aria-label": "Zoom in", onClick: () => O(_l), children: "+" }),
              /* @__PURE__ */ c("button", { type: "button", "aria-label": "Zoom out", onClick: () => O(Ml), children: "−" }),
              /* @__PURE__ */ c("button", { type: "button", "aria-label": "Reset view", onClick: j, children: "⟲" })
            ]
          }
        ) : null
      ] }),
      children: [
        (ye === "both" || ye === "vertical") && (st != null && st.length) ? /* @__PURE__ */ c(
          Ha,
          {
            className: "bbn-liq-grid",
            scale: yt,
            height: D.plotHeight,
            tickValues: st,
            "aria-hidden": !0
          }
        ) : null,
        w === "plot" ? Jt : null,
        w === "plot" ? un : null,
        /* @__PURE__ */ x(sn, { left: I, children: [
          k.length > 0 ? /* @__PURE__ */ x(He, { children: [
            S ? (
              // The fill reaches both region edges via synthetic bottom-corner
              // points, matching the old full-width polygon; the stroked line
              // below spans only the candle centers.
              /* @__PURE__ */ c(
                hf,
                {
                  className: "bbn-liq-series__area",
                  data: [
                    { x: 0, y: D.plotHeight },
                    ...k.map((W) => ({ x: W.center, y: ne(W.candle.close) })),
                    { x: Z, y: D.plotHeight }
                  ],
                  x: (W) => W.x,
                  y: (W) => W.y,
                  y0: D.plotHeight,
                  yScale: ne
                }
              )
            ) : null,
            L ? k.map((W) => /* @__PURE__ */ x(
              sn,
              {
                className: W.bullish ? "bbn-liq-candle--up" : "bbn-liq-candle--down",
                "data-testid": "liq-candle",
                children: [
                  /* @__PURE__ */ c(
                    vn,
                    {
                      className: "bbn-liq-candle__wick",
                      from: { x: W.center, y: W.wickTop },
                      to: { x: W.center, y: W.wickBottom }
                    }
                  ),
                  /* @__PURE__ */ c(
                    or,
                    {
                      className: "bbn-liq-candle__body",
                      x: W.bodyLeft,
                      y: W.bodyTop,
                      width: W.bodyWidth,
                      height: W.bodyHeight,
                      rx: p5
                    }
                  )
                ]
              },
              W.key
            )) : null,
            T ? /* @__PURE__ */ c(
              ff,
              {
                className: L ? "bbn-liq-series__line bbn-liq-series__line--over-candles" : "bbn-liq-series__line",
                data: k,
                x: (W) => W.center,
                y: (W) => ne(W.candle.close)
              }
            ) : null,
            l === "candles+line" ? /* @__PURE__ */ c(
              "circle",
              {
                className: "bbn-liq-series__end-dot",
                cx: k[k.length - 1].center,
                cy: ne(k[k.length - 1].candle.close),
                r: m5
              }
            ) : null
          ] }) : null,
          ge ? /* @__PURE__ */ c(
            vn,
            {
              className: "bbn-liq-crosshair",
              from: { x: ge.center, y: 0 },
              to: { x: ge.center, y: D.plotHeight },
              "aria-hidden": !0
            }
          ) : null
        ] }),
        w === "gutter" ? un : null,
        w === "plot" ? null : Jt
      ]
    }
  );
}
const y5 = 6;
function Ll(e, t) {
  return t === "right" ? e.anchor : e.anchor - e.width;
}
function x5(e, t, n, r, i) {
  return n.every((o) => {
    const a = r.get(o.key) ?? 0;
    return e + t + i <= o.left || e >= o.left + a + i;
  });
}
function C5(e, t, n = y5) {
  const r = [], i = /* @__PURE__ */ new Map();
  for (const o of e) {
    const a = o.side === "right" ? "left" : "right", s = [o.side, a].find((u) => {
      const d = Ll(o, u);
      return d >= 0 && d + o.width <= t && x5(d, o.width, r, i, n);
    }), l = s ? Ll(o, s) : Math.max(
      0,
      Math.min(
        t - o.width,
        r.reduce((u, d) => Math.max(u, d.left + (i.get(d.key) ?? 0) + n), 0)
      )
    );
    i.set(o.key, o.width), r.push({ key: o.key, left: l });
  }
  return r;
}
const Al = 1;
function El(e, t = 0) {
  const n = e.filter(Number.isFinite);
  if (n.length === 0) return [0, Al];
  const r = Math.min(...n), i = Math.max(...n);
  if (r === i) {
    const a = Math.max(Math.abs(r) * t, Al);
    return [r - a, i + a];
  }
  const o = (i - r) * t;
  return [r - o, i + o];
}
function w5(e) {
  return e.filter((t) => Number.isFinite(t.x) && Number.isFinite(t.y)).sort((t, n) => t.x - n.x);
}
function N5(e, t) {
  if (e.length === 0) return "";
  const [n, ...r] = e, i = r.map((o) => t === "step" ? `H${o.x}V${o.y}` : `L${o.x} ${o.y}`);
  return `M${n.x} ${n.y}${i.join("")}`;
}
function _5(e, t) {
  if (e.length === 0) return -1;
  let n = 0, r = e.length - 1;
  for (; n < r; ) {
    const a = n + r >> 1;
    e[a].x < t ? n = a + 1 : r = a;
  }
  const i = n, o = Math.max(0, n - 1);
  return t - e[o].x <= e[i].x - t ? o : i;
}
function Sl(e, t, n) {
  if (e.length === 0) return null;
  if (t <= e[0].x) return e[0].y;
  const r = e[e.length - 1];
  if (t >= r.x) return r.y;
  let i = 0, o = e.length - 1;
  for (; o - i > 1; ) {
    const u = i + o >> 1;
    e[u].x <= t ? i = u : o = u;
  }
  const a = e[i], s = e[o];
  if (n === "step") return a.y;
  const l = s.x - a.x;
  return l === 0 ? a.y : a.y + (t - a.x) / l * (s.y - a.y);
}
const ta = 10, na = 8, j1 = 4, M5 = 8, L5 = 4, kl = 4, A5 = 8, E5 = 0.6, S5 = 0.05;
function k5(e, t, n, r) {
  const i = e.lines ?? [], o = Math.max(
    In(e.title, t),
    ...i.map((s) => In(s, n)),
    0
  ), a = 1 + i.length;
  return {
    lines: i,
    width: o + 2 * ta,
    height: 2 * na + a * r + (a - 1) * j1
  };
}
function x8({
  data: e,
  interpolation: t = "linear",
  xDomain: n,
  yDomain: r,
  yDomainPadding: i = S5,
  yTicks: o,
  xTicks: a,
  markers: s,
  aspectRatio: l,
  minPlotHeight: u,
  grid: d,
  hoverMode: f = "interpolate",
  renderTooltip: h,
  onHoverChange: p,
  color: b,
  animate: g = !1,
  ariaLabel: v,
  className: w
}) {
  const m = de(() => w5(e), [e]), N = !!(a != null && a.length), C = de(() => (o == null ? void 0 : o.map((X) => X.label)) ?? [], [o]), { parentRef: M, layout: y, collapsed: L } = Pa({
    axisSide: "left",
    hasTopLegend: !1,
    hasXAxis: N,
    aspectRatio: l,
    yAxisLabels: C,
    minPlotHeight: u
  }), T = de(() => n ?? El(m.map((X) => X.x)), [n, m]), S = de(
    () => Wt({ domain: T, range: [0, y.plotWidth] }),
    [T, y.plotWidth]
  ), R = de(
    () => Wt({
      domain: r ?? El(m.map((X) => X.y), i),
      range: [y.plotHeight, 0]
    }),
    [r, i, m, y.plotHeight]
  ), V = de(
    () => N5(m.map((X) => ({ x: S(X.x), y: R(X.y) })), t),
    [m, S, R, t]
  ), A = (d == null ? void 0 : d.lines) ?? "both", E = (d == null ? void 0 : d.style) ?? "dashed", P = Math.round(y.fontLabel * cn), U = (() => {
    const [X, re] = T, $ = (s ?? []).filter(
      (me) => Number.isFinite(me.x) && me.x >= Math.min(X, re) && me.x <= Math.max(X, re)
    );
    if ($.length === 0) return [];
    const oe = ln(y.fontLabel), pe = ln(y.fontAxis), Le = $.map((me) => k5(me, oe, pe, P)), Ie = $.map((me, Ae) => ({
      key: me.key,
      anchor: S(me.x),
      width: Le[Ae].width,
      side: me.side ?? "right"
    })), Be = C5(Ie, y.plotWidth);
    return $.map((me, Ae) => {
      const at = Sl(m, me.x, t);
      return {
        marker: me,
        x: S(me.x),
        y: at === null ? null : R(at),
        callout: {
          left: Be[Ae].left,
          top: M5,
          width: Le[Ae].width,
          height: Le[Ae].height,
          lines: Le[Ae].lines
        }
      };
    });
  })(), [D, z] = ie(null), I = de(() => {
    if (D === null || m.length === 0) return null;
    const X = S.invert(D), re = _5(m, X), $ = m[re];
    if (f === "nearest") return { x: $.x, y: $.y, point: $, index: re };
    const oe = Sl(m, X, t);
    return oe === null ? null : { x: X, y: oe, point: $, index: re };
  }, [D, m, S, f, t]), Y = xe(p);
  Y.current = p, te(() => {
    var X;
    (X = Y.current) == null || X.call(Y, I);
  }, [I]);
  const Z = (X) => {
    if (y.plotWidth === 0) return;
    const { left: re } = X.currentTarget.getBoundingClientRect();
    z(Math.min(y.plotWidth, Math.max(0, X.clientX - re)));
  }, ne = (X) => {
    X.pointerType === "mouse" && z(null);
  };
  if (L) return /* @__PURE__ */ c("div", { ref: M, style: { width: "100%" } });
  const fe = I === null ? null : S(I.x), Me = I === null ? null : h == null ? void 0 : h(I), Ce = b ? { "--bbn-line-chart-series": b } : {}, ke = { "--bbn-chart-axis-letter-spacing": `${Br}px` }, he = g ? "bbn-line-chart__enter" : void 0;
  return /* @__PURE__ */ c(
    "div",
    {
      ref: M,
      style: ke,
      className: H("bbn-line-chart", `bbn-line-chart--gridstyle-${E}`, w),
      children: /* @__PURE__ */ x("div", { className: "bbn-line-chart__canvas", children: [
        /* @__PURE__ */ x(
          "svg",
          {
            className: "bbn-line-chart__svg",
            width: y.chartWidth,
            height: y.svgHeight,
            role: "img",
            "aria-label": v,
            children: [
              /* @__PURE__ */ x(sn, { top: y.plotTop, left: y.plotLeft, children: [
                (A === "both" || A === "horizontal") && (o != null && o.length) ? /* @__PURE__ */ c(
                  H1,
                  {
                    className: "bbn-line-chart__grid",
                    scale: R,
                    width: y.plotWidth,
                    tickValues: o.map((X) => X.value),
                    "aria-hidden": !0
                  }
                ) : null,
                (A === "both" || A === "vertical") && (a != null && a.length) ? /* @__PURE__ */ c(
                  Ha,
                  {
                    className: "bbn-line-chart__grid",
                    scale: S,
                    height: y.plotHeight,
                    tickValues: a.map((X) => X.value),
                    "aria-hidden": !0
                  }
                ) : null,
                /* @__PURE__ */ c("g", { className: he, style: Ce, children: /* @__PURE__ */ c("path", { className: "bbn-line-chart__series", d: V }) }),
                U.map(({ marker: X, x: re, y: $, callout: oe }) => {
                  const pe = X.color ? { "--bbn-line-chart-marker": X.color } : {}, Le = X.style === "dashed";
                  return /* @__PURE__ */ x("g", { className: he, style: pe, "aria-hidden": !0, children: [
                    /* @__PURE__ */ c(
                      vn,
                      {
                        className: H("bbn-line-chart__rule", Le && "bbn-line-chart__rule--dashed"),
                        from: { x: re, y: 0 },
                        to: { x: re, y: y.plotHeight }
                      }
                    ),
                    $ === null ? null : /* @__PURE__ */ c("circle", { className: "bbn-line-chart__dot", cx: re, cy: $, r: kl }),
                    /* @__PURE__ */ c(
                      "rect",
                      {
                        className: H("bbn-line-chart__callout", Le && "bbn-line-chart__callout--dashed"),
                        x: oe.left,
                        y: oe.top,
                        width: oe.width,
                        height: oe.height,
                        rx: L5
                      }
                    ),
                    /* @__PURE__ */ c(
                      pt,
                      {
                        className: "bbn-line-chart__callout-title",
                        x: oe.left + ta,
                        y: oe.top + na,
                        verticalAnchor: "start",
                        fontSize: y.fontLabel,
                        children: X.title
                      }
                    ),
                    oe.lines.map((Ie, Be) => /* @__PURE__ */ c(
                      pt,
                      {
                        className: "bbn-line-chart__callout-line",
                        x: oe.left + ta,
                        y: oe.top + na + (Be + 1) * (P + j1),
                        verticalAnchor: "start",
                        fontSize: y.fontAxis,
                        children: Ie
                      },
                      Ie
                    ))
                  ] }, X.key);
                }),
                I !== null && fe !== null ? /* @__PURE__ */ x("g", { "aria-hidden": !0, children: [
                  /* @__PURE__ */ c(
                    vn,
                    {
                      className: "bbn-line-chart__crosshair",
                      from: { x: fe, y: 0 },
                      to: { x: fe, y: y.plotHeight }
                    }
                  ),
                  /* @__PURE__ */ c(
                    "circle",
                    {
                      className: "bbn-line-chart__hover-dot",
                      style: Ce,
                      cx: fe,
                      cy: R(I.y),
                      r: kl
                    }
                  )
                ] }) : null,
                /* @__PURE__ */ c(
                  or,
                  {
                    className: "bbn-line-chart__hit",
                    x: 0,
                    y: 0,
                    width: y.plotWidth,
                    height: y.plotHeight,
                    fill: "transparent",
                    onPointerDown: Z,
                    onPointerMove: Z,
                    onPointerLeave: ne,
                    onPointerCancel: () => z(null),
                    "data-testid": "line-chart-hit"
                  }
                )
              ] }),
              o == null ? void 0 : o.map((X) => /* @__PURE__ */ c(
                pt,
                {
                  className: "bbn-line-chart__axis-text",
                  x: 0,
                  y: y.plotTop + R(X.value),
                  textAnchor: "start",
                  verticalAnchor: "middle",
                  fontSize: y.fontAxis,
                  "aria-hidden": !0,
                  children: X.label
                },
                `y-${X.value}`
              )),
              a == null ? void 0 : a.map((X, re) => /* @__PURE__ */ c(
                pt,
                {
                  className: "bbn-line-chart__axis-text",
                  x: y.plotLeft + S(X.value),
                  y: y.plotTop + y.plotHeight + Da,
                  textAnchor: re === 0 ? "start" : re === a.length - 1 ? "end" : "middle",
                  verticalAnchor: "start",
                  fontSize: y.fontAxis,
                  "aria-hidden": !0,
                  children: X.label
                },
                `x-${X.value}`
              ))
            ]
          }
        ),
        Me ? /* @__PURE__ */ c(
          "div",
          {
            className: H(
              "bbn-line-chart__tooltip",
              fe !== null && fe > E5 * y.plotWidth && "bbn-line-chart__tooltip--left"
            ),
            style: {
              left: y.plotLeft + (fe ?? 0),
              top: y.plotTop + A5,
              fontSize: y.fontAxis
            },
            children: Me
          }
        ) : null
      ] })
    }
  );
}
const O5 = {
  adaptive: "adaptive",
  horizontal: "vertical",
  vertical: "horizontal"
};
function C8({ className: e, orientation: t = "vertical", children: n }) {
  return /* @__PURE__ */ c("div", { className: ee("bbn-list", `bbn-list-${t}`, e), children: Ro.map(
    n,
    (r) => tc(r) ? ec(r, {
      orientation: O5[t]
    }) : r
  ) });
}
function T5({ className: e, orientation: t = "horizontal", title: n, value: r, suffix: i }) {
  return /* @__PURE__ */ x("div", { className: H("bbn-list-item", `bbn-list-item-${t}`, e), children: [
    /* @__PURE__ */ c(
      Q,
      {
        as: "div",
        className: H("bbn-list-title", `bbn-list-title-${t}`),
        variant: t === "horizontal" ? "body1" : "body2",
        children: n
      }
    ),
    /* @__PURE__ */ x(Q, { as: "div", className: H("bbn-list-value", `bbn-list-value-${t}`), variant: "body1", children: [
      r,
      i
    ] })
  ] });
}
function Ol(e) {
  return Se({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" }, child: [] }, { tag: "path", attr: { d: "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" }, child: [] }] })(e);
}
function V5(e) {
  return Se({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
function H5({
  isOpen: e
}) {
  const [t, n] = ie(!1), [r, i] = ie(!1);
  te(() => {
    e && !t && (n(!0), i(!1), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        i(!0);
      });
    }));
  }, [e, t]), te(() => {
    !e && t && i(!1);
  }, [e, t]);
  const o = we(() => {
    !e && t && n(!1);
  }, [e, t]);
  return {
    mounted: t,
    shouldShowOpen: r,
    handleAnimationEnd: o
  };
}
const Tl = "(prefers-reduced-motion: reduce)", Vl = () => typeof window < "u" && typeof window.matchMedia == "function";
function w8() {
  const [e, t] = ie(() => Vl() && window.matchMedia(Tl).matches);
  return te(() => {
    if (!Vl()) return;
    const n = window.matchMedia(Tl), r = () => t(n.matches);
    return typeof n.addEventListener == "function" ? (n.addEventListener("change", r), () => n.removeEventListener("change", r)) : (n.addListener(r), () => n.removeListener(r));
  }, []), e;
}
const N8 = ({
  hidden: e = !1,
  loading: t,
  title: n,
  value: r,
  tooltip: i,
  loadingStyle: o = "spinner",
  ...a
}) => {
  const s = Xt(), l = Gt(), [u, d] = ie(!1), [f, h] = ie(null);
  return te(() => {
    !l && u && d(!1);
  }, [l, u]), e ? null : /* @__PURE__ */ c(
    T5,
    {
      ...a,
      title: n,
      value: t ? /* @__PURE__ */ x("div", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ c("span", { className: "loader size-5" }),
        o === "spinner-and-value" && /* @__PURE__ */ c("span", { className: "opacity-50", children: r })
      ] }) : r,
      suffix: i ? l ? /* @__PURE__ */ x(He, { children: [
        /* @__PURE__ */ c("span", { className: "block size-5 cursor-pointer text-xs", onClick: () => d(!0), children: /* @__PURE__ */ c(Ol, { size: 20 }) }),
        /* @__PURE__ */ x(yn, { open: u, onClose: () => d(!1), children: [
          /* @__PURE__ */ c("div", { className: "px-4 py-2 text-accent-primary", children: i }),
          /* @__PURE__ */ c("div", { className: "p-4", children: /* @__PURE__ */ c(ze, { variant: "contained", fluid: !0, onClick: () => d(!1), children: "Done" }) })
        ] })
      ] }) : /* @__PURE__ */ x(He, { children: [
        /* @__PURE__ */ c(
          "span",
          {
            className: "block size-5 cursor-pointer text-xs",
            onMouseEnter: (g) => h(g.currentTarget),
            onMouseLeave: () => h(null),
            "aria-describedby": s,
            children: /* @__PURE__ */ c(Ol, { size: 20 })
          }
        ),
        /* @__PURE__ */ c(ei, { open: !!f, anchorEl: f, placement: "top", offset: [0, 8], children: /* @__PURE__ */ c("div", { className: "tooltip-wrap", children: i }) })
      ] }) : void 0
    }
  );
};
function R5({
  children: e,
  count: t = 0,
  max: n = 99,
  position: r = "bottom-right",
  color: i = "error",
  className: o,
  badgeClassName: a,
  contentClassName: s
}) {
  const l = typeof t == "number" ? t > 0 : t != null, u = typeof t == "number" && t > n ? `${n}+` : t, d = `bbn-badge-${r}`, f = `bbn-badge-${i}`;
  return /* @__PURE__ */ x("div", { className: H("bbn-badge", o), children: [
    e,
    l && /* @__PURE__ */ c("span", { className: H("bbn-badge-indicator", d, f, a), children: /* @__PURE__ */ c("span", { className: H("bbn-badge-content", s), children: u }) })
  ] });
}
const wn = ({
  children: e,
  style: t,
  variant: n = "contained",
  className: r
}) => /* @__PURE__ */ c(
  "div",
  {
    className: H("bbn-subsection", `bbn-subsection-${n}`, r),
    style: t,
    children: e
  }
);
function D5({ counter: e, max: t, onAdd: n, alwaysShowCounter: r = !1, hidePlusButton: i = !1 }) {
  const o = e < t && !i, a = 0 < e || r && e === 0;
  return /* @__PURE__ */ x(
    "div",
    {
      className: H(
        "bg-primary-highlight flex overflow-hidden rounded-md border border-accent-primary w-fit",
        o && "cursor-pointer",
        !a && !o && "hidden",
        !a && "w-10"
      ),
      onClick: o ? n : void 0,
      children: [
        o && !i && /* @__PURE__ */ c("div", { className: "flex h-10 w-10 items-center justify-center", children: /* @__PURE__ */ c(V5, { size: 20 }) }),
        a && /* @__PURE__ */ x("div", { className: H(
          "flex h-10 items-center px-4 text-base",
          o && "border-l border-accent-primary"
        ), children: [
          e,
          "/",
          t
        ] })
      ]
    }
  );
}
const q1 = cr(void 0), U1 = () => $n(q1), P5 = ({ children: e, value: t }) => /* @__PURE__ */ c(q1.Provider, { value: t, children: e }), W1 = ({
  isOpen: e,
  onClose: t,
  title: n,
  children: r,
  className: i = "",
  titleAlign: o = "left",
  backIcon: a,
  fullHeight: s = !1,
  fullWidth: l = !1,
  showBackButton: u = !0,
  showDivider: d = !0,
  onBackdropClick: f
}) => {
  const { mounted: h, shouldShowOpen: p, handleAnimationEnd: b } = H5({ isOpen: e }), g = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  }, v = () => u || n ? /* @__PURE__ */ x(
    "div",
    {
      className: H(
        "flex items-center p-4",
        d && "border-b border-[#38708533] dark:border-[#404040]"
      ),
      children: [
        u && /* @__PURE__ */ c(
          "button",
          {
            onClick: t,
            className: "relative flex h-8 w-8 flex-shrink-0 items-center justify-center rounded transition-colors hover:bg-accent-secondary/10 before:absolute before:-inset-1 before:content-['']",
            "aria-label": "Go back",
            children: a || /* @__PURE__ */ c(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "text-accent-primary",
                children: /* @__PURE__ */ c(
                  "path",
                  {
                    d: "M10 12L6 8L10 4",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            )
          }
        ),
        n && /* @__PURE__ */ c(
          "h3",
          {
            className: H(
              "flex-1 text-sm font-medium text-accent-primary",
              u ? "ml-3" : "",
              g[o]
            ),
            children: n
          }
        )
      ]
    }
  ) : null, w = () => /* @__PURE__ */ x(He, { children: [
    v(),
    /* @__PURE__ */ c("div", { className: "flex-1 overflow-y-auto", children: r })
  ] });
  return s ? /* @__PURE__ */ x(Ur, { mounted: h, rootClassName: "menu-drawer-portal", children: [
    f && /* @__PURE__ */ c(
      "div",
      {
        className: H(
          "fixed inset-0 z-40 bg-black/50 transition-opacity duration-300",
          p ? "opacity-100" : "pointer-events-none opacity-0"
        ),
        onClick: f
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        className: H(
          "transform transition-transform duration-300 ease-in-out",
          "bg-surface",
          "fixed inset-y-0 right-0 z-50",
          l ? "w-full" : "w-full max-w-sm",
          p ? "translate-x-0" : "translate-x-full",
          i
        ),
        onTransitionEnd: b,
        children: w()
      }
    )
  ] }) : /* @__PURE__ */ c(
    "div",
    {
      className: H(
        "transform transition-transform duration-300 ease-in-out",
        "bg-surface",
        "absolute inset-0 rounded-lg",
        e ? "translate-x-0" : "translate-x-full",
        i
      ),
      children: w()
    }
  );
}, I5 = "rounded-lg border border-[#38708533] bg-surface shadow-lg dark:border-[#404040] min-w-[294px]", B5 = "rounded-lg border border-secondary-strokeLight bg-background-secondary p-[15px] shadow-[0_8px_8px_rgba(0,0,0,0.12)]", $5 = [0, 20], Z1 = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', F5 = "Tab", z5 = (e) => e == null ? void 0 : e.focus({ preventScroll: !0 }), j5 = (e) => {
  if (e.key !== F5) return;
  const t = e.currentTarget, n = t.querySelectorAll(Z1), r = n[0], i = n[n.length - 1], o = document.activeElement;
  if (!r) {
    e.preventDefault();
    return;
  }
  e.shiftKey && (o === r || o === t) ? (e.preventDefault(), i.focus()) : !e.shiftKey && o === i && (e.preventDefault(), r.focus());
}, $a = ({
  children: e,
  trigger: t,
  open: n,
  onOpenChange: r,
  placement: i = "bottom-end",
  offset: o = [0, 8],
  className: a,
  mobileMode: s = "dialog"
}) => {
  const [l, u] = ie(!1), d = xe(null), f = Gt(), h = f && s === "popover", p = Xt(), b = n !== void 0 ? n : l, g = (y) => {
    n === void 0 && u(y), r == null || r(y);
  }, v = () => g(!1), w = h && b, { unmount: m } = Wr({ open: w, onClose: v }), N = xe(!1);
  te(() => {
    var y, L;
    if (w) {
      N.current = !0;
      return;
    }
    m(), N.current && (N.current = !1, document.activeElement === document.body && ((L = (y = d.current) == null ? void 0 : y.querySelector(Z1)) == null || L.focus()));
  }, [w, m]);
  const C = /* @__PURE__ */ c("div", { className: "relative w-full overflow-hidden", children: e }), M = t || /* @__PURE__ */ c("button", { className: "rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-800", onClick: () => g(!b), children: "Menu" });
  return /* @__PURE__ */ x(P5, { value: { isOpen: b, setIsOpen: g, onClose: v, isMobile: f }, children: [
    /* @__PURE__ */ c("div", { ref: d, className: "inline-block", children: ae.isValidElement(M) && ae.cloneElement(M, {
      onClick: () => g(!b),
      "aria-haspopup": h ? "dialog" : "true",
      "aria-expanded": b,
      ...h && { id: p }
    }) }),
    f && !h ? s === "dialog" ? /* @__PURE__ */ c(
      yn,
      {
        open: b,
        onClose: v,
        className: H(
          "bg-surface text-primary-main",
          a
        ),
        children: C
      }
    ) : /* @__PURE__ */ c(
      W1,
      {
        isOpen: b,
        onClose: v,
        onBackdropClick: v,
        fullHeight: !0,
        fullWidth: !0,
        showBackButton: !0,
        showDivider: !1,
        children: C
      }
    ) : /* @__PURE__ */ c(
      ei,
      {
        anchorEl: d.current,
        open: b,
        offset: h ? $5 : o,
        placement: i,
        onClickOutside: v,
        className: H(h ? B5 : I5, a),
        children: h ? /* @__PURE__ */ c(
          "div",
          {
            ref: z5,
            role: "dialog",
            "aria-labelledby": p,
            tabIndex: -1,
            onKeyDown: j5,
            className: "relative w-full focus:outline-none",
            children: e
          }
        ) : C
      }
    )
  ] });
}, X1 = ({
  icon: e,
  name: t,
  description: n,
  onClick: r,
  disabled: i = !1,
  className: o,
  children: a,
  suffix: s,
  selected: l = !1,
  role: u = "menuitem",
  toggle: d
}) => {
  const f = U1(), h = d ? /* @__PURE__ */ c(
    _a,
    {
      value: d.value,
      defaultValue: d.defaultValue,
      onChange: d.onChange,
      "aria-label": d["aria-label"] ?? t
    }
  ) : null, p = h || s, b = () => {
    i || h || (r && r(), f && !p && f.onClose());
  };
  return a ? /* @__PURE__ */ c(
    "button",
    {
      onClick: b,
      disabled: i,
      className: H("w-full text-left", i && "cursor-not-allowed opacity-50", o),
      children: a
    }
  ) : /* @__PURE__ */ x(
    "div",
    {
      className: H(
        "flex w-full items-center justify-between p-6",
        "transition-colors",
        !h && "cursor-pointer hover:bg-accent-secondary/5",
        // Only hover if no toggle
        "text-left",
        l && "bg-accent-secondary/10",
        i && "cursor-not-allowed opacity-50",
        h && "cursor-default",
        // Disable pointer cursor when toggle is present
        o
      ),
      role: u,
      "aria-selected": l,
      onClick: b,
      children: [
        /* @__PURE__ */ x("div", { className: "flex items-center gap-3", children: [
          e && /* @__PURE__ */ c("div", { className: "flex-shrink-0", children: e }),
          /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ c("div", { className: "text-sm font-medium text-accent-primary", children: t }),
            n && /* @__PURE__ */ c("div", { className: "text-xs text-accent-secondary", children: n })
          ] })
        ] }),
        p && /* @__PURE__ */ c("div", { className: "flex-shrink-0", children: p })
      ]
    }
  );
}, q5 = ({
  children: e,
  name: t,
  description: n,
  icon: r,
  backIcon: i,
  suffix: o,
  className: a,
  contentClassName: s,
  titleAlign: l = "left"
}) => {
  const [u, d] = ie(!1), f = U1(), h = /* @__PURE__ */ c(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ c("path", { d: "M10 12L6 8L10 4", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  ), p = /* @__PURE__ */ c(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ c("path", { d: "M6 4L10 8L6 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  );
  return /* @__PURE__ */ x(He, { children: [
    /* @__PURE__ */ x(
      "button",
      {
        onClick: () => d(!0),
        className: H(
          "flex w-full items-center justify-between p-6",
          "transition-colors hover:bg-accent-secondary/5",
          "text-left focus:outline-none",
          a
        ),
        role: "menuitem",
        children: [
          /* @__PURE__ */ x("div", { className: "flex items-center gap-3", children: [
            r && /* @__PURE__ */ c("div", { className: "flex-shrink-0", children: r }),
            /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ c("span", { className: "text-sm font-medium text-accent-primary", children: t }),
              n && /* @__PURE__ */ c("span", { className: "mt-0.5 text-xs text-accent-secondary", children: n })
            ] })
          ] }),
          o || p
        ]
      }
    ),
    /* @__PURE__ */ c(
      W1,
      {
        isOpen: u,
        onClose: () => d(!1),
        title: t || "",
        titleAlign: l,
        backIcon: i || h,
        fullHeight: f == null ? void 0 : f.isMobile,
        fullWidth: f == null ? void 0 : f.isMobile,
        onBackdropClick: f != null && f.isMobile ? void 0 : () => d(!1),
        className: H(f != null && f.isMobile ? "z-60" : "z-50", s),
        children: e
      }
    )
  ] });
}, _8 = ({
  label: e,
  description: t,
  onClick: n,
  selected: r = !1,
  className: i,
  suffix: o,
  disabled: a = !1
}) => {
  const s = /* @__PURE__ */ c("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c(
    "path",
    {
      d: "M16.6667 5L7.5 14.1667L3.33333 10",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
  return /* @__PURE__ */ x(
    "button",
    {
      role: "menuitem",
      onClick: n,
      disabled: a,
      className: H(
        "flex w-full items-center justify-between p-4",
        "transition-colors hover:bg-accent-secondary/5",
        "text-left focus:outline-none",
        r && "bg-accent-secondary/10",
        a && "cursor-not-allowed opacity-50",
        i
      ),
      "aria-selected": r,
      tabIndex: a ? -1 : 0,
      children: [
        /* @__PURE__ */ x("div", { className: "flex flex-col items-start", children: [
          /* @__PURE__ */ c("span", { className: "font-medium text-accent-primary", children: e }),
          t && /* @__PURE__ */ c("span", { className: "text-sm text-accent-secondary", children: t })
        ] }),
        r && (o || s)
      ]
    }
  );
}, M8 = ({
  items: e,
  defaultActiveTab: t,
  activeTab: n,
  onTabChange: r,
  className: i,
  keepMounted: o,
  variant: a = "default"
}) => {
  var p, b;
  const [s, l] = ie(
    t || ((p = e[0]) == null ? void 0 : p.id) || ""
  ), u = n ?? s;
  te(() => {
    n !== void 0 && l(n);
  }, [n]);
  const d = (g) => {
    r ? r(g) : l(g);
  }, f = (b = e.find((g) => g.id === u)) == null ? void 0 : b.content, h = a === "simple";
  return /* @__PURE__ */ x("div", { className: ee("w-full", i), children: [
    /* @__PURE__ */ c("div", { className: "mb-6 flex w-full gap-6", role: "tablist", children: e.map((g) => /* @__PURE__ */ c(
      "button",
      {
        id: `tab-${g.id}`,
        role: "tab",
        "aria-selected": u === g.id,
        "aria-controls": `panel-${g.id}`,
        tabIndex: u === g.id ? 0 : -1,
        className: ee(
          "transition-colors duration-200",
          h ? ee(
            "text-lg font-normal pb-4",
            u === g.id ? "text-accent-primary" : "text-accent-secondary"
          ) : ee(
            "rounded px-4 py-2 text-accent-primary",
            u === g.id ? "bg-secondary-highlight" : "bg-transparent"
          )
        ),
        onClick: () => d(g.id),
        children: g.label
      },
      g.id
    )) }),
    h && /* @__PURE__ */ c("div", { className: "w-full h-[1px] bg-secondary-strokeDark mb-6 -mt-6 opacity-30" }),
    o ? /* @__PURE__ */ c("div", { className: "mt-6", children: e.map((g) => /* @__PURE__ */ c(
      "div",
      {
        role: "tabpanel",
        id: `panel-${g.id}`,
        "aria-labelledby": `tab-${g.id}`,
        className: ee(u === g.id ? "" : "hidden"),
        children: g.content
      },
      g.id
    )) }) : /* @__PURE__ */ c(
      "div",
      {
        role: "tabpanel",
        id: `panel-${u}`,
        "aria-labelledby": `tab-${u}`,
        children: f
      }
    )
  ] });
};
var pr = 1e9, U5 = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, za, Pe = !0, Lt = "[DecimalError] ", Vn = Lt + "Invalid argument: ", Fa = Lt + "Exponent out of range: ", mr = Math.floor, Mn = Math.pow, W5 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, mt, Ge = 1e7, Re = 7, G1 = 9007199254740991, Si = mr(G1 / Re), K = {};
K.absoluteValue = K.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
K.comparedTo = K.cmp = function(e) {
  var t, n, r, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (r = o.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ o.s < 0 ? 1 : -1;
};
K.decimalPlaces = K.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * Re;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
K.dividedBy = K.div = function(e) {
  return rn(this, new this.constructor(e));
};
K.dividedToIntegerBy = K.idiv = function(e) {
  var t = this, n = t.constructor;
  return Te(rn(t, new n(e), 0, 1), n.precision);
};
K.equals = K.eq = function(e) {
  return !this.cmp(e);
};
K.exponent = function() {
  return qe(this);
};
K.greaterThan = K.gt = function(e) {
  return this.cmp(e) > 0;
};
K.greaterThanOrEqualTo = K.gte = function(e) {
  return this.cmp(e) >= 0;
};
K.isInteger = K.isint = function() {
  return this.e > this.d.length - 2;
};
K.isNegative = K.isneg = function() {
  return this.s < 0;
};
K.isPositive = K.ispos = function() {
  return this.s > 0;
};
K.isZero = function() {
  return this.s === 0;
};
K.lessThan = K.lt = function(e) {
  return this.cmp(e) < 0;
};
K.lessThanOrEqualTo = K.lte = function(e) {
  return this.cmp(e) < 1;
};
K.logarithm = K.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, o = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(mt)) throw Error(Lt + "NaN");
  if (n.s < 1) throw Error(Lt + (n.s ? "NaN" : "-Infinity"));
  return n.eq(mt) ? new r(0) : (Pe = !1, t = rn($r(n, o), $r(e, o), o), Pe = !0, Te(t, i));
};
K.minus = K.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? J1(t, e) : Y1(t, (e.s = -e.s, e));
};
K.modulo = K.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(Lt + "NaN");
  return n.s ? (Pe = !1, t = rn(n, e, 0, 1).times(e), Pe = !0, n.minus(t)) : Te(new r(n), i);
};
K.naturalExponential = K.exp = function() {
  return K1(this);
};
K.naturalLogarithm = K.ln = function() {
  return $r(this);
};
K.negated = K.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
K.plus = K.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Y1(t, e) : J1(t, (e.s = -e.s, e));
};
K.precision = K.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Vn + e);
  if (t = qe(i) + 1, r = i.d.length - 1, n = r * Re + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
K.squareRoot = K.sqrt = function() {
  var e, t, n, r, i, o, a, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(Lt + "NaN");
  }
  for (e = qe(s), Pe = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Dt(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = mr((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new l(t)) : r = new l(i.toString()), n = l.precision, i = a = n + 3; ; )
    if (o = r, r = o.plus(rn(s, o, a + 2)).times(0.5), Dt(o.d).slice(0, a) === (t = Dt(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), i == a && t == "4999") {
        if (Te(o, n + 1, 0), o.times(o).eq(s)) {
          r = o;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return Pe = !0, Te(r, n);
};
K.times = K.mul = function(e) {
  var t, n, r, i, o, a, s, l, u, d = this, f = d.constructor, h = d.d, p = (e = new f(e)).d;
  if (!d.s || !e.s) return new f(0);
  for (e.s *= d.s, n = d.e + e.e, l = h.length, u = p.length, l < u && (o = h, h = p, p = o, a = l, l = u, u = a), o = [], a = l + u, r = a; r--; ) o.push(0);
  for (r = u; --r >= 0; ) {
    for (t = 0, i = l + r; i > r; )
      s = o[i] + p[r] * h[i - r - 1] + t, o[i--] = s % Ge | 0, t = s / Ge | 0;
    o[i] = (o[i] + t) % Ge | 0;
  }
  for (; !o[--a]; ) o.pop();
  return t ? ++n : o.shift(), e.d = o, e.e = n, Pe ? Te(e, f.precision) : e;
};
K.toDecimalPlaces = K.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (Zt(e, 0, pr), t === void 0 ? t = r.rounding : Zt(t, 0, 8), Te(n, e + qe(n) + 1, t));
};
K.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = Bn(r, !0) : (Zt(e, 0, pr), t === void 0 ? t = i.rounding : Zt(t, 0, 8), r = Te(new i(r), e + 1, t), n = Bn(r, !0, e + 1)), n;
};
K.toFixed = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? Bn(i) : (Zt(e, 0, pr), t === void 0 ? t = o.rounding : Zt(t, 0, 8), r = Te(new o(i), e + qe(i) + 1, t), n = Bn(r.abs(), !1, e + qe(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
K.toInteger = K.toint = function() {
  var e = this, t = e.constructor;
  return Te(new t(e), qe(e) + 1, t.rounding);
};
K.toNumber = function() {
  return +this;
};
K.toPower = K.pow = function(e) {
  var t, n, r, i, o, a, s = this, l = s.constructor, u = 12, d = +(e = new l(e));
  if (!e.s) return new l(mt);
  if (s = new l(s), !s.s) {
    if (e.s < 1) throw Error(Lt + "Infinity");
    return s;
  }
  if (s.eq(mt)) return s;
  if (r = l.precision, e.eq(mt)) return Te(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, o = s.s, a) {
    if ((n = d < 0 ? -d : d) <= G1) {
      for (i = new l(mt), t = Math.ceil(r / Re + 4), Pe = !1; n % 2 && (i = i.times(s), Rl(i.d, t)), n = mr(n / 2), n !== 0; )
        s = s.times(s), Rl(s.d, t);
      return Pe = !0, e.s < 0 ? new l(mt).div(i) : Te(i, r);
    }
  } else if (o < 0) throw Error(Lt + "NaN");
  return o = o < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, Pe = !1, i = e.times($r(s, r + u)), Pe = !0, i = K1(i), i.s = o, i;
};
K.toPrecision = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? (n = qe(i), r = Bn(i, n <= o.toExpNeg || n >= o.toExpPos)) : (Zt(e, 1, pr), t === void 0 ? t = o.rounding : Zt(t, 0, 8), i = Te(new o(i), e, t), n = qe(i), r = Bn(i, e <= n || n <= o.toExpNeg, e)), r;
};
K.toSignificantDigits = K.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (Zt(e, 1, pr), t === void 0 ? t = r.rounding : Zt(t, 0, 8)), Te(new r(n), e, t);
};
K.toString = K.valueOf = K.val = K.toJSON = K[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = qe(e), n = e.constructor;
  return Bn(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function Y1(e, t) {
  var n, r, i, o, a, s, l, u, d = e.constructor, f = d.precision;
  if (!e.s || !t.s)
    return t.s || (t = new d(e)), Pe ? Te(t, f) : t;
  if (l = e.d, u = t.d, a = e.e, i = t.e, l = l.slice(), o = a - i, o) {
    for (o < 0 ? (r = l, o = -o, s = u.length) : (r = u, i = a, s = l.length), a = Math.ceil(f / Re), s = a > s ? a + 1 : s + 1, o > s && (o = s, r.length = 1), r.reverse(); o--; ) r.push(0);
    r.reverse();
  }
  for (s = l.length, o = u.length, s - o < 0 && (o = s, r = u, u = l, l = r), n = 0; o; )
    n = (l[--o] = l[o] + u[o] + n) / Ge | 0, l[o] %= Ge;
  for (n && (l.unshift(n), ++i), s = l.length; l[--s] == 0; ) l.pop();
  return t.d = l, t.e = i, Pe ? Te(t, f) : t;
}
function Zt(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Vn + e);
}
function Dt(e) {
  var t, n, r, i = e.length - 1, o = "", a = e[0];
  if (i > 0) {
    for (o += a, t = 1; t < i; t++)
      r = e[t] + "", n = Re - r.length, n && (o += fn(n)), o += r;
    a = e[t], r = a + "", n = Re - r.length, n && (o += fn(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return o + a;
}
var rn = /* @__PURE__ */ function() {
  function e(r, i) {
    var o, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      o = r[s] * i + a, r[s] = o % Ge | 0, a = o / Ge | 0;
    return a && r.unshift(a), r;
  }
  function t(r, i, o, a) {
    var s, l;
    if (o != a)
      l = o > a ? 1 : -1;
    else
      for (s = l = 0; s < o; s++)
        if (r[s] != i[s]) {
          l = r[s] > i[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, i, o) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * Ge + r[o] - i[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, o, a) {
    var s, l, u, d, f, h, p, b, g, v, w, m, N, C, M, y, L, T, S = r.constructor, R = r.s == i.s ? 1 : -1, V = r.d, A = i.d;
    if (!r.s) return new S(r);
    if (!i.s) throw Error(Lt + "Division by zero");
    for (l = r.e - i.e, L = A.length, M = V.length, p = new S(R), b = p.d = [], u = 0; A[u] == (V[u] || 0); ) ++u;
    if (A[u] > (V[u] || 0) && --l, o == null ? m = o = S.precision : a ? m = o + (qe(r) - qe(i)) + 1 : m = o, m < 0) return new S(0);
    if (m = m / Re + 2 | 0, u = 0, L == 1)
      for (d = 0, A = A[0], m++; (u < M || d) && m--; u++)
        N = d * Ge + (V[u] || 0), b[u] = N / A | 0, d = N % A | 0;
    else {
      for (d = Ge / (A[0] + 1) | 0, d > 1 && (A = e(A, d), V = e(V, d), L = A.length, M = V.length), C = L, g = V.slice(0, L), v = g.length; v < L; ) g[v++] = 0;
      T = A.slice(), T.unshift(0), y = A[0], A[1] >= Ge / 2 && ++y;
      do
        d = 0, s = t(A, g, L, v), s < 0 ? (w = g[0], L != v && (w = w * Ge + (g[1] || 0)), d = w / y | 0, d > 1 ? (d >= Ge && (d = Ge - 1), f = e(A, d), h = f.length, v = g.length, s = t(f, g, h, v), s == 1 && (d--, n(f, L < h ? T : A, h))) : (d == 0 && (s = d = 1), f = A.slice()), h = f.length, h < v && f.unshift(0), n(g, f, v), s == -1 && (v = g.length, s = t(A, g, L, v), s < 1 && (d++, n(g, L < v ? T : A, v))), v = g.length) : s === 0 && (d++, g = [0]), b[u++] = d, s && g[0] ? g[v++] = V[C] || 0 : (g = [V[C]], v = 1);
      while ((C++ < M || g[0] !== void 0) && m--);
    }
    return b[0] || b.shift(), p.e = l, Te(p, a ? o + qe(p) + 1 : o);
  };
}();
function K1(e, t) {
  var n, r, i, o, a, s, l = 0, u = 0, d = e.constructor, f = d.precision;
  if (qe(e) > 16) throw Error(Fa + qe(e));
  if (!e.s) return new d(mt);
  for (Pe = !1, s = f, a = new d(0.03125); e.abs().gte(0.1); )
    e = e.times(a), u += 5;
  for (r = Math.log(Mn(2, u)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = o = new d(mt), d.precision = s; ; ) {
    if (i = Te(i.times(e), s), n = n.times(++l), a = o.plus(rn(i, n, s)), Dt(a.d).slice(0, s) === Dt(o.d).slice(0, s)) {
      for (; u--; ) o = Te(o.times(o), s);
      return d.precision = f, t == null ? (Pe = !0, Te(o, f)) : o;
    }
    o = a;
  }
}
function qe(e) {
  for (var t = e.e * Re, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function Eo(e, t, n) {
  if (t > e.LN10.sd())
    throw Pe = !0, n && (e.precision = n), Error(Lt + "LN10 precision limit exceeded");
  return Te(new e(e.LN10), t);
}
function fn(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function $r(e, t) {
  var n, r, i, o, a, s, l, u, d, f = 1, h = 10, p = e, b = p.d, g = p.constructor, v = g.precision;
  if (p.s < 1) throw Error(Lt + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(mt)) return new g(0);
  if (t == null ? (Pe = !1, u = v) : u = t, p.eq(10))
    return t == null && (Pe = !0), Eo(g, u);
  if (u += h, g.precision = u, n = Dt(b), r = n.charAt(0), o = qe(p), Math.abs(o) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      p = p.times(e), n = Dt(p.d), r = n.charAt(0), f++;
    o = qe(p), r > 1 ? (p = new g("0." + n), o++) : p = new g(r + "." + n.slice(1));
  } else
    return l = Eo(g, u + 2, v).times(o + ""), p = $r(new g(r + "." + n.slice(1)), u - h).plus(l), g.precision = v, t == null ? (Pe = !0, Te(p, v)) : p;
  for (s = a = p = rn(p.minus(mt), p.plus(mt), u), d = Te(p.times(p), u), i = 3; ; ) {
    if (a = Te(a.times(d), u), l = s.plus(rn(a, new g(i), u)), Dt(l.d).slice(0, u) === Dt(s.d).slice(0, u))
      return s = s.times(2), o !== 0 && (s = s.plus(Eo(g, u + 2, v).times(o + ""))), s = rn(s, new g(f), u), g.precision = v, t == null ? (Pe = !0, Te(s, v)) : s;
    s = l, i += 2;
  }
}
function Hl(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = mr(n / Re), e.d = [], r = (n + 1) % Re, n < 0 && (r += Re), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= Re; r < i; ) e.d.push(+t.slice(r, r += Re));
      t = t.slice(r), r = Re - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), Pe && (e.e > Si || e.e < -Si)) throw Error(Fa + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Te(e, t, n) {
  var r, i, o, a, s, l, u, d, f = e.d;
  for (a = 1, o = f[0]; o >= 10; o /= 10) a++;
  if (r = t - a, r < 0)
    r += Re, i = t, u = f[d = 0];
  else {
    if (d = Math.ceil((r + 1) / Re), o = f.length, d >= o) return e;
    for (u = o = f[d], a = 1; o >= 10; o /= 10) a++;
    r %= Re, i = r - Re + a;
  }
  if (n !== void 0 && (o = Mn(10, a - i - 1), s = u / o % 10 | 0, l = t < 0 || f[d + 1] !== void 0 || u % o, l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? u / Mn(10, a - i) : 0 : f[d - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (o = qe(e), f.length = 1, t = t - o - 1, f[0] = Mn(10, (Re - t % Re) % Re), e.e = mr(-t / Re) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (r == 0 ? (f.length = d, o = 1, d--) : (f.length = d + 1, o = Mn(10, Re - r), f[d] = i > 0 ? (u / Mn(10, a - i) % Mn(10, i) | 0) * o : 0), l)
    for (; ; )
      if (d == 0) {
        (f[0] += o) == Ge && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[d] += o, f[d] != Ge) break;
        f[d--] = 0, o = 1;
      }
  for (r = f.length; f[--r] === 0; ) f.pop();
  if (Pe && (e.e > Si || e.e < -Si))
    throw Error(Fa + qe(e));
  return e;
}
function J1(e, t) {
  var n, r, i, o, a, s, l, u, d, f, h = e.constructor, p = h.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new h(e), Pe ? Te(t, p) : t;
  if (l = e.d, f = t.d, r = t.e, u = e.e, l = l.slice(), a = u - r, a) {
    for (d = a < 0, d ? (n = l, a = -a, s = f.length) : (n = f, r = u, s = l.length), i = Math.max(Math.ceil(p / Re), s) + 2, a > i && (a = i, n.length = 1), n.reverse(), i = a; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = l.length, s = f.length, d = i < s, d && (s = i), i = 0; i < s; i++)
      if (l[i] != f[i]) {
        d = l[i] < f[i];
        break;
      }
    a = 0;
  }
  for (d && (n = l, l = f, f = n, t.s = -t.s), s = l.length, i = f.length - s; i > 0; --i) l[s++] = 0;
  for (i = f.length; i > a; ) {
    if (l[--i] < f[i]) {
      for (o = i; o && l[--o] === 0; ) l[o] = Ge - 1;
      --l[o], l[i] += Ge;
    }
    l[i] -= f[i];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (t.d = l, t.e = r, Pe ? Te(t, p) : t) : new h(0);
}
function Bn(e, t, n) {
  var r, i = qe(e), o = Dt(e.d), a = o.length;
  return t ? (n && (r = n - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + fn(r) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + fn(-i - 1) + o, n && (r = n - a) > 0 && (o += fn(r))) : i >= a ? (o += fn(i + 1 - a), n && (r = n - i - 1) > 0 && (o = o + "." + fn(r))) : ((r = i + 1) < a && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (o += "."), o += fn(r))), e.s < 0 ? "-" + o : o;
}
function Rl(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function Q1(e) {
  var t, n, r;
  function i(o) {
    var a = this;
    if (!(a instanceof i)) return new i(o);
    if (a.constructor = i, o instanceof i) {
      a.s = o.s, a.e = o.e, a.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Vn + o);
      if (o > 0)
        a.s = 1;
      else if (o < 0)
        o = -o, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        a.e = 0, a.d = [o];
        return;
      }
      return Hl(a, o.toString());
    } else if (typeof o != "string")
      throw Error(Vn + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), a.s = -1) : a.s = 1, W5.test(o)) Hl(a, o);
    else throw Error(Vn + o);
  }
  if (i.prototype = K, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = Q1, i.config = i.set = Z5, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function Z5(e) {
  if (!e || typeof e != "object")
    throw Error(Lt + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    pr,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if (mr(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Vn + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Vn + n + ": " + r);
  return this;
}
var za = Q1(U5);
mt = new za(1);
const X5 = {
  prefix: "$",
  precision: 2,
  zeroDisplay: "-",
  format: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
function G5(e, t) {
  const n = (e == null ? void 0 : e.minimumFractionDigits) ?? t;
  return Math.pow(10, -n);
}
function Y5(e, t = {}) {
  const { prefix: n, precision: r, zeroDisplay: i, format: o } = {
    ...X5,
    ...t
  };
  if (e === 0) return i;
  const a = G5(o, r);
  if (e > 0 && e < a)
    return `< ${n}${a.toFixed((o == null ? void 0 : o.minimumFractionDigits) ?? r)}`;
  const s = e.toLocaleString("en", o ?? { maximumFractionDigits: r });
  return `${n}${s}`;
}
function eu(e, t, n) {
  const r = e * t;
  return Y5(r, n);
}
const Dl = (e, t, n) => new za(e).toDecimalPlaces(t, n).toNumber(), L8 = (e) => {
  let t = "";
  for (let n = 0; n < e.length; n++) {
    const r = e[n].toLowerCase();
    r >= "a" && r <= "z" || r >= "0" && r <= "9" ? t += r : t.length > 0 && t[t.length - 1] !== "-" && (t += "-");
  }
  return t.endsWith("-") && (t = t.slice(0, -1)), t;
};
function A8(e, t = 8) {
  return (n) => `${n.toLocaleString(void 0, {
    minimumFractionDigits: Math.min(2, t),
    maximumFractionDigits: t
  })} ${e}`;
}
function E8(e, t = 8) {
  return e.toLocaleString(void 0, {
    minimumFractionDigits: 0,
    maximumFractionDigits: t
  });
}
function S8(e) {
  return parseFloat(e.replace(/,/g, "")) || 0;
}
function tu(e) {
  const t = e.replace(/,/g, ".");
  if (t === "") return t;
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (i === ".") {
      if (n++, n > 1) return;
    } else if (i < "0" || i > "9")
      return;
  }
  return t;
}
const ja = ({
  amount: e,
  currencyIcon: t,
  currencyName: n,
  placeholder: r = "Enter Amount",
  displayBalance: i,
  balanceDetails: o,
  autoFocus: a,
  onChange: s,
  onKeyDown: l,
  amountUsd: u,
  disabled: d = !1,
  readOnly: f = !1,
  maxDecimals: h = 8,
  onMaxClick: p
}) => /* @__PURE__ */ x(He, { children: [
  /* @__PURE__ */ x("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
    /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ c("img", { src: t, alt: n, className: "h-10 max-h-[2.5rem] w-10 max-w-[2.5rem]" }),
      /* @__PURE__ */ c("div", { className: "text-lg", children: n })
    ] }),
    /* @__PURE__ */ c(
      "input",
      {
        type: "text",
        inputMode: "decimal",
        value: e ?? "",
        onChange: (v) => {
          let w = tu(v.target.value);
          if (w === void 0) {
            v.target.value = String(e ?? "");
            return;
          }
          if (h !== void 0 && h >= 0) {
            const [m, N] = w.split(".", 2);
            N !== void 0 && N.length > h && (w = m + "." + N.slice(0, h));
          }
          v.target.value = w, s(v);
        },
        onKeyDown: (v) => {
          (v.key === "ArrowUp" || v.key === "ArrowDown") && v.preventDefault(), l && l(v);
        },
        disabled: d,
        readOnly: f,
        placeholder: r,
        autoFocus: a,
        className: "w-2/3 appearance-none bg-transparent text-right text-lg outline-none"
      }
    )
  ] }),
  o && i ? /* @__PURE__ */ x("div", { className: "flex w-full flex-row content-center items-center justify-between text-sm text-accent-secondary", children: [
    /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          onClick: p,
          disabled: d || !p,
          className: "cursor-pointer rounded bg-secondary-strokeLight px-2 py-0.5 text-xs text-accent-secondary transition-all hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50",
          children: "Max"
        }
      ),
      /* @__PURE__ */ x("span", { children: [
        typeof o.balance == "number" ? o.balance.toLocaleString("en-US", {
          minimumFractionDigits: o.decimals ?? 8,
          maximumFractionDigits: o.decimals ?? 8
        }) : o.balance,
        " ",
        o.symbol
      ] })
    ] }),
    o.displayUSD && o.price !== void 0 && /* @__PURE__ */ x("div", { children: [
      u,
      " USD"
    ] })
  ] }) : null
] }), So = ({ title: e, amount: t, symbol: n, caption: r, className: i }) => /* @__PURE__ */ x(wn, { className: H("bbn-co-staking-amount-item", i), children: [
  /* @__PURE__ */ x("div", { className: "bbn-co-staking-amount-item-header", children: [
    /* @__PURE__ */ c(Q, { variant: "body1", children: e }),
    /* @__PURE__ */ x(Q, { variant: "body1", children: [
      t,
      " ",
      n
    ] })
  ] }),
  /* @__PURE__ */ c(Q, { variant: "caption", className: "bbn-co-staking-amount-item-caption", children: r })
] }), nu = ({
  value: e,
  symbols: t = 8,
  size: n = "body2",
  className: r
}) => e ? /* @__PURE__ */ c(Q, { variant: n, className: H("text-accent-primary", r), children: /* @__PURE__ */ c("span", { children: jc(e, t) ?? e }) }) : null;
function K5(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }, child: [] }] })(e);
}
function J5(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" }, child: [] }] })(e);
}
function Q5(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" }, child: [] }] })(e);
}
function e6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z" }, child: [] }] })(e);
}
function t6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93V4.07z" }, child: [] }] })(e);
}
function n6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" }, child: [] }] })(e);
}
function r6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }, child: [] }] })(e);
}
function i6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }, child: [] }] })(e);
}
function o6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" }, child: [] }] })(e);
}
const Pl = {
  error: "bg-error-main",
  warning: "bg-warning-main",
  success: "bg-success-main",
  info: "bg-info-main",
  // Deeper navy accent for prominent, non-urgent prompts (e.g. opt-in nudges).
  infoStrong: "bg-info-dark",
  accent: "bg-secondary-main"
}, a6 = 24, s6 = {
  error: /* @__PURE__ */ c(Fn, { size: 14, color: "text-accent-contrast" }),
  warning: /* @__PURE__ */ c(K5, { size: a6, className: "text-accent-contrast" }),
  success: /* @__PURE__ */ c(uc, { size: 14, color: "text-accent-contrast" }),
  info: /* @__PURE__ */ c(mn, { size: 14, color: "text-accent-contrast" }),
  infoStrong: /* @__PURE__ */ c(mn, { size: 14, color: "text-accent-contrast" }),
  accent: /* @__PURE__ */ c(mn, { size: 14, color: "text-accent-contrast" })
}, Il = "flex h-9 items-center justify-center rounded-lg px-4 text-sm transition-opacity disabled:cursor-not-allowed disabled:opacity-50";
function k8({
  variant: e,
  title: t,
  icon: n,
  actions: r,
  className: i,
  children: o,
  role: a,
  ...s
}) {
  const l = a ?? (e === "error" ? "alert" : "status"), u = !!(r && r.length > 0);
  return /* @__PURE__ */ x(
    "div",
    {
      role: l,
      className: ee(
        "flex w-full items-start gap-4 rounded-lg border border-secondary-strokeLight bg-secondary-highlight p-4",
        i
      ),
      ...s,
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            "aria-hidden": "true",
            className: ee(
              "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg",
              Pl[e]
            ),
            children: n ?? s6[e]
          }
        ),
        /* @__PURE__ */ x(
          "div",
          {
            className: ee(
              "flex min-w-0 flex-1 flex-col",
              u ? "gap-4" : "gap-1"
            ),
            children: [
              /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-col gap-1", children: [
                t && /* @__PURE__ */ c(Q, { variant: "body1", className: "break-words text-accent-primary", children: t }),
                /* @__PURE__ */ c(
                  Q,
                  {
                    as: "div",
                    variant: "body2",
                    className: "break-words text-accent-secondary",
                    children: o
                  }
                )
              ] }),
              u && /* @__PURE__ */ c("div", { className: "flex items-center gap-4", children: r == null ? void 0 : r.map((d, f) => {
                const { label: h, emphasis: p = "primary", onClick: b, disabled: g } = d, v = p === "primary" ? ee(
                  Il,
                  Pl[e],
                  "text-accent-contrast hover:opacity-90"
                ) : ee(
                  Il,
                  "border border-secondary-strokeLight text-accent-primary hover:opacity-80"
                );
                return /* @__PURE__ */ c(
                  "button",
                  {
                    type: "button",
                    onClick: b,
                    disabled: g,
                    className: v,
                    children: h
                  },
                  f
                );
              }) })
            ]
          }
        )
      ]
    }
  );
}
const Bl = "rounded-full px-4 py-2 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50";
function l6({
  action: e,
  accentBg: t,
  onAccent: n,
  className: r
}) {
  const { label: i, emphasis: o = "primary", onClick: a, disabled: s } = e, l = o === "primary" ? ee(Bl, t, n, "hover:opacity-90", r) : ee(
    Bl,
    "border border-secondary-strokeLight text-accent-primary hover:bg-neutral-200",
    r
  );
  return /* @__PURE__ */ c(
    "button",
    {
      type: "button",
      onClick: a,
      disabled: s,
      className: l,
      children: i
    }
  );
}
const c6 = "border-[#ffb300]", u6 = "bg-[#ffb300]", Zn = "text-accent-contrast", d6 = "text-primary-main", f6 = {
  error: {
    border: "border-error-main",
    accentBg: "bg-error-main",
    onAccent: Zn,
    // High-urgency variant gets a subtle red wash over the neutral card.
    tint: "bg-gradient-to-r from-error-main/[0.06] to-error-main/[0.06]"
  },
  warning: {
    border: "border-warning-main",
    accentBg: "bg-warning-main",
    onAccent: Zn,
    tint: ""
  },
  info: {
    border: "border-info-main",
    accentBg: "bg-info-main",
    onAccent: Zn,
    tint: ""
  },
  success: {
    border: "border-success-main",
    accentBg: "bg-success-main",
    onAccent: Zn,
    tint: ""
  },
  paused: {
    border: "border-info-light",
    accentBg: "bg-info-light",
    onAccent: Zn,
    tint: ""
  },
  halted: {
    border: "border-error-light",
    accentBg: "bg-error-light",
    onAccent: Zn,
    tint: ""
  },
  suggestion: {
    border: c6,
    accentBg: u6,
    onAccent: d6,
    tint: ""
  }
}, h6 = 24, p6 = 14, m6 = {
  error: cc,
  warning: mn,
  info: mn,
  success: uc,
  paused: is,
  halted: is,
  suggestion: mn
}, ko = (e) => e != null && e !== !1;
function O8({
  variant: e,
  title: t,
  icon: n,
  actions: r,
  actionsPlacement: i = "inline",
  suggestion: o,
  onClose: a,
  className: s,
  children: l,
  role: u,
  ...d
}) {
  const f = f6[e], h = u ?? (e === "error" || e === "halted" ? "alert" : "status"), p = m6[e], b = n === null ? null : n ?? /* @__PURE__ */ c(p, { size: h6, color: f.onAccent }), g = !!(r && r.length > 0), v = g && i === "inline", w = g && i === "below", N = v && !o && !a ? "items-center" : "items-start", C = r == null ? void 0 : r.map((M, y) => /* @__PURE__ */ c(
    l6,
    {
      action: M,
      accentBg: f.accentBg,
      onAccent: f.onAccent
    },
    y
  ));
  return /* @__PURE__ */ x(
    "div",
    {
      role: h,
      className: ee(
        "flex w-full gap-6 rounded-lg border-l-4 bg-secondary-highlight p-6",
        f.tint,
        f.border,
        N,
        s
      ),
      ...d,
      children: [
        /* @__PURE__ */ x("div", { className: ee("flex min-w-0 flex-1 gap-4", N), children: [
          b && /* @__PURE__ */ c(
            "div",
            {
              "aria-hidden": "true",
              className: ee(
                "flex shrink-0 items-center justify-center rounded-lg p-2.5",
                f.accentBg
              ),
              children: b
            }
          ),
          /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-1 flex-col gap-4", children: [
            /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-col gap-1", children: [
              ko(t) && /* @__PURE__ */ c("div", { className: "break-words text-xl font-bold tracking-0.15 text-accent-primary", children: t }),
              ko(l) && /* @__PURE__ */ c(
                Q,
                {
                  as: "div",
                  variant: "body2",
                  className: "break-words text-accent-secondary",
                  children: l
                }
              )
            ] }),
            ko(o) && /* @__PURE__ */ c("div", { className: "flex w-full flex-col gap-2 rounded-lg bg-neutral-200 p-4 text-accent-secondary", children: o }),
            w && /* @__PURE__ */ c("div", { className: "flex flex-wrap items-center gap-2", children: C })
          ] })
        ] }),
        v && /* @__PURE__ */ c("div", { className: "flex shrink-0 flex-wrap items-center justify-end gap-2", children: C }),
        a && /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            onClick: a,
            "aria-label": "Dismiss notification",
            className: "relative -mr-1 -mt-1 flex shrink-0 items-center justify-center rounded p-1 text-accent-secondary transition-colors hover:text-accent-primary before:absolute before:-inset-[9px] before:content-['']",
            children: /* @__PURE__ */ c(Fn, { size: p6 })
          }
        )
      ]
    }
  );
}
function g6({ children: e, className: t, iconClassName: n, messageClassName: r }) {
  return /* @__PURE__ */ x("div", { className: H("bbn-warning", t), children: [
    /* @__PURE__ */ c(
      cc,
      {
        variant: "secondary",
        size: 22,
        className: H("bbn-warning-icon", n)
      }
    ),
    /* @__PURE__ */ c("p", { className: H("bbn-warning-message", r), children: e })
  ] });
}
const T8 = ({
  icon: e,
  title: t,
  content: n,
  onCloseClick: r,
  className: i,
  style: o
}) => /* @__PURE__ */ x(wn, { className: ee("flex gap-3", i), style: o, children: [
  e,
  /* @__PURE__ */ x("div", { className: "flex flex-col gap-1", children: [
    typeof t == "string" ? /* @__PURE__ */ c(Q, { variant: "subtitle1", className: "text-accent-primary", children: t }) : t,
    typeof n == "string" ? /* @__PURE__ */ c(Q, { variant: "body1", className: "text-accent-secondary", children: n }) : n
  ] }),
  /* @__PURE__ */ c(
    "button",
    {
      type: "button",
      className: "cursor-pointer self-start",
      "aria-label": "Dismiss subsection",
      onClick: r,
      children: /* @__PURE__ */ c(Fn, { size: 14, variant: "accent-primary" })
    }
  )
] }), V8 = ({
  visible: e,
  message: t,
  onClick: n,
  onDismiss: r,
  className: i,
  icon: o,
  role: a
}) => {
  if (!e)
    return null;
  const s = (u) => {
    u.stopPropagation(), r == null || r();
  }, l = !!n;
  return /* @__PURE__ */ x(
    "div",
    {
      className: H(
        "bbn-top-banner",
        !l && "!cursor-default",
        i
      ),
      onClick: n,
      role: a ?? (l ? "button" : void 0),
      tabIndex: l ? 0 : void 0,
      children: [
        /* @__PURE__ */ x("div", { className: "bbn-top-banner-content", children: [
          o,
          /* @__PURE__ */ c(Q, { variant: "body2", className: "bbn-top-banner-message", children: t })
        ] }),
        r && /* @__PURE__ */ c(
          "button",
          {
            onClick: s,
            className: "bbn-top-banner-dismiss-btn",
            "aria-label": "Dismiss banner",
            type: "button",
            children: /* @__PURE__ */ c(Fn, { size: 16, className: "bbn-top-banner-dismiss-icon" })
          }
        )
      ]
    }
  );
};
function H8({ children: e, className: t, icon: n, role: r, variant: i = "critical", ...o }) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: H("bbn-banner", `bbn-banner-${i}`, t),
      role: r ?? (i === "critical" ? "alert" : "status"),
      ...o,
      children: /* @__PURE__ */ x("div", { className: "bbn-banner-content", children: [
        n && /* @__PURE__ */ c("div", { className: "bbn-banner-icon", children: n }),
        e
      ] })
    }
  );
}
function v6(e) {
  return Se({ attr: { viewBox: "0 0 256 256", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M196,136a16,16,0,1,1-16-16A16,16,0,0,1,196,136Zm40-36v80a32,32,0,0,1-32,32H60a32,32,0,0,1-32-32V60.92A32,32,0,0,1,60,28H192a12,12,0,0,1,0,24H60a8,8,0,0,0-8,8.26v.08A8.32,8.32,0,0,0,60.48,68H204A32,32,0,0,1,236,100Zm-24,0a8,8,0,0,0-8-8H60.48A33.72,33.72,0,0,1,52,90.92V180a8,8,0,0,0,8,8H204a8,8,0,0,0,8-8Z" }, child: [] }] })(e);
}
function b6(e) {
  return Se({ attr: { viewBox: "0 0 256 256", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, child: [] }] })(e);
}
const R8 = ({ visible: e }) => e ? /* @__PURE__ */ c("div", { className: "bbn-testing-banner", children: /* @__PURE__ */ x("div", { className: "bbn-testing-banner-content", children: [
  /* @__PURE__ */ c(b6, { className: "bbn-testing-banner-icon" }),
  /* @__PURE__ */ x(Q, { variant: "body1", children: [
    /* @__PURE__ */ c("strong", { children: "This is a testing app" }),
    /* @__PURE__ */ c("br", {}),
    "The app may contain bugs. Use it after conducting your own research and making an informed decision. Tokens are for testing only and do not carry any monetary value and the testnet is not incentivized."
  ] })
] }) }) : null;
function ru(e) {
  return Se({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "square", strokeMiterlimit: "10", strokeWidth: "44", d: "M416 128 192 384l-96-96" }, child: [] }] })(e);
}
function y6(e) {
  return Se({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M240 240H32V32h208zm240 0H272V32h208zM240 480H32V272h208zm240 0H272V272h208z" }, child: [] }] })(e);
}
const x6 = (e, t) => t > e ? /* @__PURE__ */ c("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-light", children: /* @__PURE__ */ c(ru, { size: 24, className: "text-accent-contrast" }) }) : t === e ? /* @__PURE__ */ c("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-main", children: /* @__PURE__ */ c(Na, { size: 24, className: "text-accent-contrast" }) }) : /* @__PURE__ */ c("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-main", children: /* @__PURE__ */ c(Q, { variant: "body1", className: "text-accent-contrast", children: e }) });
function D8({ step: e, currentStep: t, children: n, className: r }) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: ee(
        "flex w-full flex-row items-center gap-3 self-stretch rounded border border-secondary-strokeLight bg-surface p-4",
        !(e === t) && "opacity-25",
        r
      ),
      children: [
        x6(e, t),
        /* @__PURE__ */ x(Q, { variant: "body1", className: "text-accent-primary", children: [
          "Step ",
          e,
          ": ",
          n
        ] })
      ]
    }
  );
}
function $l(e, t) {
  const n = e + 1;
  return n < t ? "completed" : n === t ? "active" : "pending";
}
function C6({
  state: e,
  number: t
}) {
  const n = "flex h-8 w-8 shrink-0 items-center justify-center rounded-full";
  return e === "completed" ? /* @__PURE__ */ c("div", { className: ee(n, "bg-primary-light"), children: /* @__PURE__ */ c(ru, { size: 16, className: "text-accent-contrast" }) }) : e === "active" ? /* @__PURE__ */ c("div", { className: ee(n, "bg-secondary-main"), children: /* @__PURE__ */ c(Na, { size: 16, className: "text-accent-contrast" }) }) : /* @__PURE__ */ c(
    "div",
    {
      className: ee(
        n,
        "border-2 border-secondary-strokeDark"
      ),
      children: /* @__PURE__ */ c(
        Q,
        {
          as: "span",
          variant: "body2",
          className: "font-medium text-accent-secondary",
          children: t
        }
      )
    }
  );
}
function w6({ state: e }) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: ee(
        "ml-[15px] h-6 w-0",
        e === "pending" ? "border-l-2 border-dashed border-secondary-strokeLight" : "border-l-2 border-solid border-secondary-strokeDark"
      )
    }
  );
}
function N6({ steps: e, currentStep: t, className: n }) {
  return /* @__PURE__ */ c("div", { className: ee("flex flex-col", n), children: e.map((r, i) => {
    const o = $l(i, t), a = i === e.length - 1;
    return /* @__PURE__ */ x("div", { children: [
      /* @__PURE__ */ x("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ c(C6, { state: o, number: i + 1 }),
        /* @__PURE__ */ x("div", { className: "flex items-baseline gap-2", children: [
          /* @__PURE__ */ c(
            Q,
            {
              as: "span",
              variant: "body1",
              className: ee(
                "font-medium",
                o === "pending" ? "text-accent-secondary" : "text-accent-primary"
              ),
              children: r.label
            }
          ),
          r.description && /* @__PURE__ */ c(
            Q,
            {
              as: "span",
              variant: "body2",
              className: "text-accent-secondary",
              children: r.description
            }
          )
        ] })
      ] }),
      !a && /* @__PURE__ */ c(
        w6,
        {
          state: $l(i + 1, t)
        }
      )
    ] }, i);
  }) });
}
function P8({
  open: e,
  onClose: t,
  icon: n,
  title: r,
  description: i,
  primaryAction: o,
  secondaryAction: a,
  className: s
}) {
  return /* @__PURE__ */ x(mc, { open: e, onClose: t, className: s, children: [
    /* @__PURE__ */ x(ur, { className: "flex flex-col items-center gap-4 px-6 pb-4 pt-6", children: [
      n && /* @__PURE__ */ c("div", { className: "mb-2", children: n }),
      /* @__PURE__ */ c(qr, { variant: "h5", className: "text-center text-accent-primary", children: r }),
      /* @__PURE__ */ c(
        Q,
        {
          variant: "body1",
          className: "text-center text-accent-secondary",
          children: i
        }
      )
    ] }),
    /* @__PURE__ */ x(
      dr,
      {
        className: ee(
          "flex flex-col gap-2 px-6 pb-6",
          !a && "pt-2"
        ),
        children: [
          /* @__PURE__ */ c(
            ze,
            {
              variant: "contained",
              color: "secondary",
              fluid: !0,
              disabled: o.disabled,
              onClick: o.onClick,
              children: o.label
            }
          ),
          a && /* @__PURE__ */ c(
            ze,
            {
              variant: "ghost",
              color: "primary",
              fluid: !0,
              onClick: a.onClick,
              children: a.label
            }
          )
        ]
      }
    )
  ] });
}
function I8({
  open: e,
  onClose: t,
  title: n,
  steps: r,
  currentStep: i,
  actionLabel: o,
  onAction: a,
  actionDisabled: s,
  className: l
}) {
  return /* @__PURE__ */ x(mc, { open: e, onClose: t, className: l, children: [
    /* @__PURE__ */ c(
      Xr,
      {
        title: n,
        onClose: t,
        className: "text-accent-primary"
      }
    ),
    /* @__PURE__ */ c(ur, { className: ee("px-6 pb-6 pt-4"), children: /* @__PURE__ */ c(N6, { steps: r, currentStep: i }) }),
    o && a && /* @__PURE__ */ c(dr, { className: "px-6 pb-6", children: /* @__PURE__ */ c(
      ze,
      {
        variant: "contained",
        color: "secondary",
        fluid: !0,
        disabled: s,
        onClick: a,
        children: o
      }
    ) })
  ] });
}
const iu = ({
  as: e = "div",
  className: t,
  children: n
}) => Hi(
  e,
  { className: ee("container px-4 mx-auto sm:px-0", t) },
  n
), _6 = ({ className: e }) => /* @__PURE__ */ x(
  "svg",
  {
    viewBox: "0 0 367 91",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Babylon",
    className: ee("text-accent-contrast", e),
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M0 7.10867C0 5.15111 0.694596 3.4756 2.08532 2.08521C3.47605 0.694815 5.14874 0 7.10645 0C9.06417 0 10.7384 0.696344 12.1283 2.08521C13.5168 3.4756 14.2137 5.15111 14.2137 7.10867V16.5869C14.2137 17.3452 14.4651 17.9299 14.9709 18.3404C15.476 18.7524 16.0132 18.9564 16.5817 18.9564H30.7946C32.7524 18.9564 34.4266 19.6528 35.8165 21.0417C37.205 22.4321 37.9019 24.1076 37.9019 26.0651C37.9019 26.7615 38.1219 27.3302 38.5644 27.7712C39.006 28.2138 39.5745 28.4347 40.2699 28.4347C42.2276 28.4347 43.9018 29.131 45.2918 30.5199C46.6802 31.9103 47.3764 33.5858 47.3764 35.5433V54.4998C47.3764 56.4589 46.681 58.1344 45.2918 59.5233C43.9026 60.9121 42.2269 61.6085 40.2699 61.6085C39.7014 61.6085 39.1642 61.8141 38.6591 62.2245C38.1533 62.6365 37.9019 63.2198 37.9019 63.978C37.9019 65.9371 37.2057 67.6126 35.8165 69.0015C34.4273 70.3903 32.7516 71.0867 30.7946 71.0867H7.10645C5.14874 71.0867 3.47375 70.3919 2.08532 69.0015C0.69536 67.6126 0 65.9371 0 63.978V7.10867ZM30.7946 56.8693C31.3632 56.8693 31.8996 56.6798 32.4054 56.3007C32.9105 55.9215 33.1635 55.3215 33.1635 54.4998V35.5433C33.1635 34.9127 32.9411 34.3586 32.5002 33.8847C32.0578 33.4107 31.4892 33.1738 30.7946 33.1738H16.5817C15.8864 33.1738 15.3178 33.4268 14.8762 33.932C14.4337 34.4388 14.2137 34.9746 14.2137 35.5433V54.4998C14.2137 55.1961 14.4506 55.7648 14.9243 56.2059C15.3981 56.6484 15.9506 56.8693 16.5825 56.8693H30.7946Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M47.3818 45.0261C47.3818 43.0685 48.0764 41.393 49.4672 40.0026C50.8579 38.6122 52.5306 37.9174 54.4883 37.9174H78.1765C78.6824 37.9174 79.2035 37.7133 79.7407 37.3013C80.2763 36.8908 80.5468 36.3061 80.5468 35.5478C80.5468 34.7896 80.2763 34.2064 79.7407 33.7944C79.2035 33.3839 78.6824 33.1783 78.1765 33.1783H54.4883C52.5306 33.1783 50.8556 32.4835 49.4672 31.0931C48.0772 29.7042 47.3818 28.0287 47.3818 26.0696C47.3818 24.1105 48.0764 22.4365 49.4672 21.0461C50.8579 19.6558 52.5306 18.9609 54.4883 18.9609H78.1765C80.1342 18.9609 81.8092 19.6573 83.1984 21.0461C84.5876 22.4365 85.2837 24.112 85.2837 26.0696C85.2837 26.8279 85.5527 27.4126 86.0899 27.8231C86.6255 28.2351 87.1467 28.4392 87.6525 28.4392C89.6103 28.4392 91.2852 29.1355 92.6744 30.5244C94.0636 31.9148 94.7598 33.5903 94.7598 35.5478V63.9825C94.7598 65.9416 94.0644 67.6171 92.6744 69.006C91.2852 70.3963 89.6103 71.0912 87.6525 71.0912H63.9643C62.0059 71.0912 60.3309 70.3963 58.9424 69.006C57.5525 67.6171 56.8579 65.9416 56.8579 63.9825C56.8579 63.2877 56.605 62.719 56.0999 62.2764C55.594 61.8354 55.0576 61.6129 54.4891 61.6129C52.5314 61.6129 50.8564 60.9181 49.4679 59.5277C48.078 58.1389 47.3826 56.4634 47.3826 54.5043V45.0261H47.3818ZM78.1765 56.8738C78.745 56.8738 79.2807 56.6529 79.7881 56.2104C80.2924 55.7693 80.5461 55.2006 80.5461 54.5043C80.5461 53.9356 80.3237 53.3998 79.8821 52.893C79.4404 52.3877 78.8719 52.1347 78.1765 52.1347H63.9636C63.2682 52.1347 62.6997 52.3877 62.258 52.893C61.8156 53.3998 61.5955 53.9356 61.5955 54.5043C61.5955 55.2006 61.8469 55.7693 62.3528 56.2104C62.8579 56.6529 63.3951 56.8738 63.9636 56.8738H78.1765Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M94.7637 7.10867C94.7637 5.15111 95.4575 3.4756 96.8482 2.08521C98.239 0.694815 99.9117 0 101.87 0C103.829 0 105.502 0.696344 106.892 2.08521C108.28 3.4756 108.977 5.15111 108.977 7.10867V16.5869C108.977 17.3452 109.229 17.9299 109.735 18.3404C110.24 18.7524 110.777 18.9564 111.345 18.9564H125.558C127.516 18.9564 129.19 19.6528 130.58 21.0417C131.969 22.4321 132.665 24.1076 132.665 26.0651C132.665 26.7615 132.886 27.3302 133.328 27.7712C133.769 28.2138 134.337 28.4347 135.034 28.4347C136.991 28.4347 138.666 29.131 140.055 30.5199C141.444 31.9103 142.14 33.5858 142.14 35.5433V54.4998C142.14 56.4589 141.445 58.1344 140.055 59.5233C138.666 60.9121 136.991 61.6085 135.034 61.6085C134.465 61.6085 133.928 61.8141 133.423 62.2245C132.917 62.6365 132.665 63.2198 132.665 63.978C132.665 65.9371 131.969 67.6126 130.58 69.0015C129.191 70.3903 127.515 71.0867 125.558 71.0867H101.87C99.9117 71.0867 98.2367 70.3919 96.8482 69.0015C95.4583 67.6126 94.7637 65.9371 94.7637 63.978V7.10867ZM125.558 56.8693C126.127 56.8693 126.663 56.6798 127.169 56.3007C127.673 55.9215 127.927 55.3215 127.927 54.4998V35.5433C127.927 34.9127 127.705 34.3586 127.264 33.8847C126.821 33.4107 126.253 33.1738 125.558 33.1738H111.345C110.649 33.1738 110.081 33.4268 109.64 33.932C109.197 34.4388 108.977 34.9746 108.977 35.5433V54.4998C108.977 55.1961 109.214 55.7648 109.688 56.2059C110.162 56.6484 110.714 56.8693 111.346 56.8693H125.558Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M172.925 75.8303C173.619 75.8303 174.188 75.6079 174.63 75.1668C175.071 74.7242 175.293 74.1555 175.293 73.4607C175.293 72.7659 175.071 72.1957 174.63 71.7546C174.188 71.3121 173.619 71.0912 172.925 71.0912H158.712C156.753 71.0912 155.078 70.3964 153.69 69.006C152.3 67.6171 151.605 65.9416 151.605 63.9825C151.605 63.3519 151.383 62.7977 150.942 62.3238C150.499 61.8499 149.931 61.6129 149.236 61.6129C147.278 61.6129 145.603 60.9181 144.214 59.5277C142.824 58.1389 142.13 56.4634 142.13 54.5043V26.0696C142.13 24.112 142.824 22.4365 144.214 21.0461C145.605 19.6558 147.278 18.9609 149.236 18.9609C151.195 18.9609 152.868 19.6573 154.258 21.0461C155.647 22.4365 156.343 24.112 156.343 26.0696V54.5043C156.343 55.2006 156.564 55.7693 157.006 56.2104C157.447 56.6529 158.015 56.8738 158.712 56.8738H172.925C173.619 56.8738 174.188 56.6529 174.63 56.2104C175.071 55.7693 175.293 55.2006 175.293 54.5043V26.0696C175.293 24.112 175.987 22.4365 177.378 21.0461C178.769 19.6558 180.441 18.9609 182.4 18.9609C184.358 18.9609 186.032 19.6573 187.422 21.0461C188.81 22.4365 189.506 24.112 189.506 26.0696V73.4607C189.506 75.4183 188.811 77.0938 187.422 78.4842C186.032 79.873 184.357 80.5694 182.4 80.5694C181.704 80.5694 181.135 80.8064 180.694 81.2803C180.252 81.7542 180.031 82.3068 180.031 82.939C180.031 84.8965 179.336 86.572 177.946 87.9624C176.556 89.3513 174.881 90.0476 172.925 90.0476H149.236C147.278 90.0476 145.603 89.3513 144.214 87.9624C142.826 86.5735 142.13 84.8965 142.13 82.939C142.13 80.9814 142.824 79.3044 144.214 77.9155C145.603 76.5251 147.278 75.8303 149.236 75.8303H172.925Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M189.5 7.10867C189.5 5.15111 190.193 3.4756 191.584 2.08521C192.975 0.694815 194.647 0 196.606 0C198.564 0 200.238 0.696344 201.628 2.08521C203.016 3.4756 203.712 5.15111 203.712 7.10867V54.4998C203.712 55.2581 203.965 55.8428 204.47 56.2533C204.976 56.6653 205.513 56.8693 206.081 56.8693H210.819C212.776 56.8693 214.45 57.5657 215.84 58.9546C217.228 60.3449 217.925 62.0205 217.925 63.978C217.925 65.9356 217.229 67.6126 215.84 69.0015C214.451 70.3903 212.775 71.0867 210.819 71.0867H206.081C204.123 71.0867 202.448 70.3919 201.059 69.0015C199.669 67.6126 198.975 65.9371 198.975 63.978C198.975 63.2198 198.721 62.6365 198.217 62.2245C197.71 61.8141 197.174 61.6085 196.606 61.6085C194.647 61.6085 192.973 60.9136 191.584 59.5233C190.194 58.1344 189.5 56.4589 189.5 54.4998V7.10867Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M214.239 35.5478C214.239 33.5903 214.933 31.9148 216.323 30.5244C217.714 29.134 219.387 28.4392 221.345 28.4392C222.04 28.4392 222.608 28.1877 223.051 27.6809C223.492 27.1757 223.714 26.6383 223.714 26.0696C223.714 24.112 224.408 22.4365 225.799 21.0461C227.189 19.6558 228.862 18.9609 230.821 18.9609H245.033C246.991 18.9609 248.665 19.6573 250.055 21.0461C251.444 22.4365 252.14 24.112 252.14 26.0696C252.14 26.7659 252.378 27.3346 252.851 27.7757C253.325 28.2183 253.878 28.4392 254.509 28.4392C256.467 28.4392 258.141 29.1355 259.531 30.5244C260.92 31.9148 261.616 33.5903 261.616 35.5478V54.5043C261.616 56.4634 260.921 58.1389 259.531 59.5277C258.142 60.9166 256.466 61.6129 254.509 61.6129C253.751 61.6129 253.166 61.8828 252.757 62.4186C252.345 62.9559 252.14 63.4772 252.14 63.9825C252.14 65.9416 251.445 67.6171 250.055 69.006C248.666 70.3948 246.99 71.0912 245.033 71.0912H230.821C228.862 71.0912 227.187 70.3963 225.799 69.006C224.409 67.6171 223.714 65.9416 223.714 63.9825C223.714 63.2877 223.492 62.719 223.051 62.2764C222.608 61.8354 222.04 61.6129 221.345 61.6129C219.387 61.6129 217.712 60.9181 216.323 59.5277C214.933 58.1389 214.239 56.4634 214.239 54.5043V35.5478ZM245.033 56.8738C245.602 56.8738 246.138 56.6843 246.644 56.3051C247.149 55.926 247.402 55.326 247.402 54.5043V35.5478C247.402 34.9172 247.18 34.3631 246.739 33.8891C246.297 33.4152 245.728 33.1783 245.033 33.1783H230.821C230.124 33.1783 229.556 33.4313 229.115 33.9365C228.673 34.4433 228.452 34.9791 228.452 35.5478V54.5043C228.452 55.2006 228.689 55.7693 229.163 56.2104C229.637 56.6529 230.189 56.8738 230.821 56.8738H245.033Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M261.608 26.0696C261.608 24.112 262.302 22.4365 263.693 21.0461C265.084 19.6558 266.756 18.9609 268.715 18.9609H287.665C289.623 18.9609 291.297 19.6573 292.687 21.0461C294.076 22.4365 294.773 24.112 294.773 26.0696C294.773 26.8279 295.01 27.4126 295.483 27.8231C295.957 28.2351 296.51 28.4392 297.141 28.4392C298.34 28.4392 299.383 28.6761 300.268 29.15C301.152 29.6239 301.894 30.2087 302.495 30.9035C303.095 31.5998 303.537 32.3581 303.822 33.1783C304.106 34 304.248 34.7896 304.248 35.5478V63.9825C304.248 65.9416 303.553 67.6171 302.163 69.006C300.774 70.3948 299.098 71.0912 297.141 71.0912C295.185 71.0912 293.508 70.3963 292.12 69.006C290.73 67.6171 290.035 65.9416 290.035 63.9825V35.5478C290.035 34.853 289.782 34.2843 289.277 33.8417C288.77 33.4007 288.235 33.1783 287.666 33.1783H278.192C277.496 33.1783 276.927 33.4152 276.486 33.8891C276.044 34.3631 275.823 34.9172 275.823 35.5478V63.9825C275.823 65.9416 275.127 67.6171 273.738 69.006C272.349 70.3948 270.673 71.0912 268.716 71.0912C266.759 71.0912 265.083 70.3963 263.694 69.006C262.305 67.6171 261.61 65.9416 261.61 63.9825V26.0696H261.608Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M318.727 8.91004C318.491 8.27077 318.649 7.55278 319.131 7.0709L325.69 0.511563C326.171 0.029677 326.889 -0.127847 327.529 0.107966L341.514 5.24587C341.857 5.37211 342.086 5.69931 342.086 6.06544V9.12744C342.086 9.35904 341.994 9.5811 341.83 9.74481L338.426 13.1489C338.185 13.3898 337.826 13.4686 337.506 13.3506L333.749 11.9651L329.622 10.442C329.272 10.313 328.932 10.6531 329.061 11.0026L331.97 18.8876C332.088 19.2072 332.009 19.5663 331.768 19.8072L328.742 22.8328C328.401 23.1737 328.401 23.7266 328.742 24.0676L331.784 27.1099C332.025 27.3508 332.104 27.7098 331.986 28.0295L329.077 35.9138C328.948 36.2634 329.288 36.6034 329.638 36.4745L337.522 33.5659C337.842 33.4479 338.201 33.5267 338.442 33.7676L341.83 37.1555C341.994 37.3193 342.086 37.5414 342.086 37.7729V40.8359C342.086 41.2015 341.858 41.5285 341.515 41.655L327.545 46.8084C326.906 47.0442 326.188 46.8867 325.706 46.4049L319.147 39.8453C318.665 39.3635 318.507 38.6454 318.743 38.0062L323.879 24.0844C324.023 23.6943 324.023 23.2657 323.879 22.8756L318.727 8.91004Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M366.892 38.0062C367.128 38.6454 366.97 39.3634 366.488 39.8453L359.929 46.4047C359.448 46.8866 358.729 47.0441 358.09 46.8083L344.105 41.6704C343.762 41.5442 343.533 41.217 343.533 40.8508V37.7888C343.533 37.5572 343.625 37.3352 343.789 37.1715L347.193 33.7674C347.434 33.5265 347.793 33.4477 348.113 33.5657L351.869 34.9511L355.997 36.4743C356.347 36.6033 356.687 36.2632 356.558 35.9137L353.649 28.0287C353.531 27.709 353.61 27.35 353.851 27.1091L356.877 24.0835C357.218 23.7426 357.218 23.1897 356.877 22.8487L353.835 19.8064C353.594 19.5655 353.515 19.2064 353.633 18.8868L356.542 11.0025C356.671 10.6528 356.331 10.3128 355.981 10.4418L348.097 13.3504C347.777 13.4683 347.418 13.3895 347.177 13.1486L343.789 9.76074C343.625 9.59703 343.533 9.3749 343.533 9.14338V6.08043C343.533 5.71474 343.761 5.38783 344.104 5.2613L358.073 0.107968C358.713 -0.127845 359.431 0.0296791 359.913 0.511492L366.472 7.07097C366.954 7.55278 367.112 8.27085 366.876 8.91011L361.74 22.8319C361.596 23.222 361.596 23.6506 361.74 24.0407L366.892 38.0061L366.892 38.0062Z",
          className: "fill-current"
        }
      )
    ]
  }
), M6 = ({ className: e }) => /* @__PURE__ */ c("a", { href: "/", children: /* @__PURE__ */ c(_6, { className: e }) }), ou = () => /* @__PURE__ */ c("a", { href: "/", children: /* @__PURE__ */ x(
  "svg",
  {
    width: "164",
    height: "40",
    viewBox: "0 0 164 40",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-accent-primary",
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M0 3.15782C0 2.28823 0.308554 1.54393 0.926343 0.926293C1.54413 0.308651 2.28718 0 3.15683 0C4.02649 0 4.77021 0.30933 5.38766 0.926293C6.00443 1.54393 6.31401 2.28823 6.31401 3.15782V7.36824C6.31401 7.70507 6.42568 7.96483 6.6504 8.14717C6.87477 8.33019 7.1134 8.42085 7.36595 8.42085H13.6796C14.5493 8.42085 15.293 8.73018 15.9104 9.34714C16.5272 9.96478 16.8368 10.7091 16.8368 11.5787C16.8368 11.888 16.9345 12.1406 17.1311 12.3365C17.3273 12.5331 17.5798 12.6313 17.8887 12.6313C18.7584 12.6313 19.5021 12.9406 20.1196 13.5576C20.7363 14.1752 21.0456 14.9195 21.0456 15.7891V24.2099C21.0456 25.0802 20.7367 25.8245 20.1196 26.4415C19.5024 27.0584 18.758 27.3678 17.8887 27.3678C17.6362 27.3678 17.3976 27.4591 17.1732 27.6414C16.9485 27.8244 16.8368 28.0835 16.8368 28.4204C16.8368 29.2906 16.5276 30.0349 15.9104 30.6519C15.2933 31.2688 14.5489 31.5782 13.6796 31.5782H3.15683C2.28718 31.5782 1.54311 31.2695 0.926343 30.6519C0.308893 30.0349 0 29.2906 0 28.4204V3.15782ZM13.6796 25.2625C13.9322 25.2625 14.1705 25.1783 14.3952 25.0099C14.6195 24.8415 14.7319 24.575 14.7319 24.2099V15.7891C14.7319 15.509 14.6331 15.2628 14.4373 15.0523C14.2407 14.8417 13.9882 14.7365 13.6796 14.7365H7.36595C7.05705 14.7365 6.8045 14.8489 6.6083 15.0733C6.41177 15.2984 6.31401 15.5365 6.31401 15.7891V24.2099C6.31401 24.5193 6.41924 24.7719 6.62969 24.9678C6.84015 25.1644 7.08556 25.2625 7.36628 25.2625H13.6796Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M21.0485 20.0005C21.0485 19.1309 21.357 18.3867 21.9748 17.769C22.5926 17.1514 23.3356 16.8427 24.2053 16.8427H34.7281C34.9528 16.8427 35.1843 16.7521 35.4229 16.569C35.6609 16.3867 35.781 16.1269 35.781 15.7901C35.781 15.4533 35.6609 15.1942 35.4229 15.0112C35.1843 14.8288 34.9528 14.7375 34.7281 14.7375H24.2053C23.3356 14.7375 22.5916 14.4289 21.9748 13.8112C21.3574 13.1943 21.0485 12.45 21.0485 11.5797C21.0485 10.7094 21.357 9.96581 21.9748 9.34817C22.5926 8.73053 23.3356 8.42188 24.2053 8.42188H34.7281C35.5977 8.42188 36.3418 8.73121 36.9589 9.34817C37.576 9.96581 37.8853 10.7101 37.8853 11.5797C37.8853 11.9165 38.0047 12.1763 38.2434 12.3586C38.4813 12.5416 38.7128 12.6323 38.9375 12.6323C39.8072 12.6323 40.5513 12.9416 41.1684 13.5586C41.7855 14.1762 42.0947 14.9205 42.0947 15.7901V28.4214C42.0947 29.2916 41.7858 30.0359 41.1684 30.6529C40.5513 31.2705 39.8072 31.5792 38.9375 31.5792H28.4148C27.5448 31.5792 26.8007 31.2705 26.1839 30.6529C25.5665 30.0359 25.2579 29.2916 25.2579 28.4214C25.2579 28.1127 25.1456 27.8601 24.9212 27.6635C24.6965 27.4676 24.4582 27.3688 24.2056 27.3688C23.336 27.3688 22.5919 27.0601 21.9751 26.4425C21.3577 25.8255 21.0488 25.0812 21.0488 24.211V20.0005H21.0485ZM34.7281 25.2636C34.9806 25.2636 35.2186 25.1654 35.444 24.9688C35.668 24.7729 35.7807 24.5203 35.7807 24.211C35.7807 23.9583 35.6819 23.7203 35.4857 23.4952C35.2895 23.2707 35.037 23.1584 34.7281 23.1584H28.4144C28.1055 23.1584 27.853 23.2707 27.6568 23.4952C27.4602 23.7203 27.3625 23.9583 27.3625 24.211C27.3625 24.5203 27.4742 24.7729 27.6989 24.9688C27.9232 25.1654 28.1619 25.2636 28.4144 25.2636H34.7281Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M42.095 3.15782C42.095 2.28823 42.4032 1.54393 43.021 0.926293C43.6388 0.308651 44.3819 0 45.2519 0C46.1219 0 46.8652 0.30933 47.4827 0.926293C48.0995 1.54393 48.4087 2.28823 48.4087 3.15782V7.36824C48.4087 7.70507 48.5207 7.96483 48.7454 8.14717C48.9698 8.33019 49.2084 8.42085 49.461 8.42085H55.7747C56.6443 8.42085 57.388 8.73018 58.0055 9.34714C58.6222 9.96478 58.9315 10.7091 58.9315 11.5787C58.9315 11.888 59.0296 12.1406 59.2261 12.3365C59.422 12.5331 59.6745 12.6313 59.9838 12.6313C60.8534 12.6313 61.5971 12.9406 62.2146 13.5576C62.8314 14.1752 63.1406 14.9195 63.1406 15.7891V24.2099C63.1406 25.0802 62.8317 25.8245 62.2146 26.4415C61.5975 27.0584 60.8531 27.3678 59.9838 27.3678C59.7312 27.3678 59.4926 27.4591 59.2682 27.6414C59.0435 27.8244 58.9315 28.0835 58.9315 28.4204C58.9315 29.2906 58.6226 30.0349 58.0055 30.6519C57.3884 31.2688 56.644 31.5782 55.7747 31.5782H45.2519C44.3819 31.5782 43.6378 31.2695 43.021 30.6519C42.4036 30.0349 42.095 29.2906 42.095 28.4204V3.15782ZM55.7747 25.2625C56.0272 25.2625 56.2651 25.1783 56.4902 25.0099C56.7142 24.8415 56.8269 24.575 56.8269 24.2099V15.7891C56.8269 15.509 56.7281 15.2628 56.5323 15.0523C56.3358 14.8417 56.0832 14.7365 55.7747 14.7365H49.461C49.1517 14.7365 48.8992 14.8489 48.7033 15.0733C48.5068 15.2984 48.4087 15.5365 48.4087 15.7891V24.2099C48.4087 24.5193 48.5143 24.7719 48.7247 24.9678C48.9352 25.1644 49.1806 25.2625 49.4613 25.2625H55.7747Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M76.8172 33.6844C77.1258 33.6844 77.3784 33.5856 77.5749 33.3897C77.7708 33.1931 77.8695 32.9405 77.8695 32.6318C77.8695 32.3232 77.7708 32.0699 77.5749 31.8739C77.3784 31.6773 77.1258 31.5792 76.8172 31.5792H70.5036C69.6336 31.5792 68.8895 31.2706 68.2727 30.6529C67.6553 30.0359 67.3467 29.2917 67.3467 28.4214C67.3467 28.1413 67.248 27.8951 67.0521 27.6846C66.8556 27.474 66.603 27.3688 66.2945 27.3688C65.4245 27.3688 64.6804 27.0601 64.0636 26.4425C63.4462 25.8255 63.1376 25.0812 63.1376 24.211V11.5797C63.1376 10.7101 63.4458 9.96581 64.0636 9.34817C64.6814 8.73053 65.4245 8.42188 66.2945 8.42188C67.1645 8.42188 67.9079 8.73121 68.5253 9.34817C69.1421 9.96581 69.4513 10.7101 69.4513 11.5797V24.211C69.4513 24.5203 69.5494 24.7729 69.7459 24.9688C69.9418 25.1654 70.1944 25.2636 70.5036 25.2636H76.8172C77.1258 25.2636 77.3784 25.1654 77.5749 24.9688C77.7708 24.7729 77.8695 24.5203 77.8695 24.211V11.5797C77.8695 10.7101 78.1777 9.96581 78.7955 9.34817C79.4133 8.73053 80.1564 8.42188 81.0264 8.42188C81.8964 8.42188 82.6397 8.73121 83.2572 9.34817C83.874 9.96581 84.1832 10.7101 84.1832 11.5797V32.6318C84.1832 33.5014 83.8743 34.2457 83.2572 34.8633C82.6397 35.4803 81.8957 35.7896 81.0264 35.7896C80.7171 35.7896 80.4646 35.8949 80.2687 36.1054C80.0722 36.3159 79.9741 36.5614 79.9741 36.8422C79.9741 37.7118 79.6652 38.4561 79.0481 39.0738C78.4306 39.6907 77.6866 40 76.8172 40H66.2945C65.4245 40 64.6804 39.6907 64.0636 39.0738C63.4469 38.4568 63.1376 37.7118 63.1376 36.8422C63.1376 35.9726 63.4458 35.2277 64.0636 34.6107C64.6804 33.9931 65.4245 33.6844 66.2945 33.6844H76.8172Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M84.1783 3.15782C84.1783 2.28823 84.4866 1.54393 85.1043 0.926293C85.7221 0.308651 86.4652 0 87.3352 0C88.2052 0 88.9486 0.30933 89.566 0.926293C90.1828 1.54393 90.492 2.28823 90.492 3.15782V24.2099C90.492 24.5468 90.604 24.8065 90.8287 24.9889C91.0531 25.1719 91.2917 25.2625 91.5443 25.2625H93.6488C94.5182 25.2625 95.2619 25.5719 95.8793 26.1888C96.4961 26.8065 96.8057 27.5508 96.8057 28.4204C96.8057 29.2899 96.4965 30.0349 95.8793 30.6519C95.2622 31.2688 94.5178 31.5782 93.6488 31.5782H91.5443C90.6743 31.5782 89.9302 31.2695 89.3135 30.6519C88.696 30.0349 88.3875 29.2906 88.3875 28.4204C88.3875 28.0835 88.2748 27.8244 88.0507 27.6414C87.8257 27.4591 87.5877 27.3678 87.3352 27.3678C86.4652 27.3678 85.7211 27.0591 85.1043 26.4415C84.4869 25.8245 84.1783 25.0802 84.1783 24.2099V3.15782Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M95.1696 15.7901C95.1696 14.9205 95.4778 14.1762 96.0956 13.5586C96.7133 12.9409 97.4564 12.6323 98.3264 12.6323C98.635 12.6323 98.8875 12.5206 99.084 12.2955C99.2799 12.071 99.3787 11.8323 99.3787 11.5797C99.3787 10.7101 99.6869 9.96581 100.305 9.34817C100.922 8.73053 101.666 8.42188 102.536 8.42188H108.849C109.719 8.42188 110.463 8.73121 111.08 9.34817C111.697 9.96581 112.006 10.7101 112.006 11.5797C112.006 11.889 112.112 12.1416 112.322 12.3376C112.532 12.5342 112.778 12.6323 113.059 12.6323C113.928 12.6323 114.672 12.9416 115.289 13.5586C115.906 14.1762 116.215 14.9205 116.215 15.7901V24.211C116.215 25.0812 115.907 25.8255 115.289 26.4425C114.672 27.0594 113.928 27.3688 113.059 27.3688C112.722 27.3688 112.462 27.4886 112.28 27.7267C112.097 27.9654 112.006 28.1969 112.006 28.4214C112.006 29.2916 111.697 30.0359 111.08 30.6529C110.463 31.2699 109.718 31.5792 108.849 31.5792H102.536C101.666 31.5792 100.921 31.2705 100.305 30.6529C99.6872 30.0359 99.3787 29.2916 99.3787 28.4214C99.3787 28.1127 99.2799 27.8601 99.084 27.6635C98.8875 27.4676 98.635 27.3688 98.3264 27.3688C97.4564 27.3688 96.7123 27.0601 96.0956 26.4425C95.4781 25.8255 95.1696 25.0812 95.1696 24.211V15.7901ZM108.849 25.2636C109.102 25.2636 109.34 25.1794 109.565 25.0109C109.789 24.8425 109.901 24.576 109.901 24.211V15.7901C109.901 15.51 109.803 15.2638 109.607 15.0533C109.41 14.8428 109.158 14.7375 108.849 14.7375H102.536C102.226 14.7375 101.974 14.8499 101.778 15.0743C101.581 15.2995 101.483 15.5375 101.483 15.7901V24.211C101.483 24.5203 101.589 24.7729 101.799 24.9688C102.01 25.1644 102.255 25.2636 102.536 25.2636H108.849Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M116.212 11.5797C116.212 10.7101 116.52 9.96581 117.138 9.34817C117.756 8.73053 118.499 8.42188 119.369 8.42188H127.787C128.657 8.42188 129.401 8.73121 130.018 9.34817C130.635 9.96581 130.944 10.7101 130.944 11.5797C130.944 11.9165 131.05 12.1763 131.26 12.3586C131.471 12.5416 131.716 12.6323 131.997 12.6323C132.529 12.6323 132.993 12.7376 133.386 12.9481C133.778 13.1586 134.108 13.4184 134.375 13.727C134.641 14.0363 134.838 14.3732 134.964 14.7375C135.09 15.1025 135.154 15.4533 135.154 15.7901V28.4214C135.154 29.2916 134.845 30.0359 134.228 30.6529C133.61 31.2699 132.866 31.5792 131.997 31.5792C131.127 31.5792 130.383 31.2705 129.766 30.6529C129.148 30.0359 128.84 29.2916 128.84 28.4214V15.7901C128.84 15.4815 128.728 15.2288 128.503 15.0322C128.278 14.8363 128.04 14.7375 127.788 14.7375H123.579C123.27 14.7375 123.017 14.8428 122.821 15.0533C122.625 15.2638 122.527 15.51 122.527 15.7901V28.4214C122.527 29.2916 122.218 30.0359 121.601 30.6529C120.983 31.2699 120.239 31.5792 119.37 31.5792C118.5 31.5792 117.756 31.2705 117.139 30.6529C116.521 30.0359 116.213 29.2916 116.213 28.4214V11.5797H116.212Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M141.589 3.95802C141.485 3.67405 141.555 3.3551 141.769 3.14104L144.682 0.227247C144.896 0.0131831 145.215 -0.0567923 145.499 0.0479608L151.712 2.33033C151.864 2.3864 151.966 2.53175 151.966 2.69439V4.0546C151.966 4.15748 151.925 4.25612 151.852 4.32884L150.34 5.84099C150.233 5.94801 150.074 5.98301 149.932 5.93062L148.263 5.31516L146.429 4.63855C146.274 4.58124 146.123 4.73231 146.18 4.88758L147.472 8.39027C147.525 8.53225 147.49 8.69176 147.382 8.79878L146.038 10.1428C145.887 10.2942 145.887 10.5399 146.038 10.6913L147.39 12.0428C147.497 12.1498 147.532 12.3093 147.479 12.4513L146.187 15.9537C146.13 16.109 146.281 16.26 146.436 16.2027L149.939 14.9107C150.081 14.8583 150.24 14.8933 150.347 15.0003L151.852 16.5053C151.925 16.578 151.966 16.6767 151.966 16.7795V18.1401C151.966 18.3026 151.865 18.4478 151.712 18.504L145.507 20.7933C145.223 20.898 144.904 20.828 144.69 20.614L141.776 17.7001C141.562 17.4861 141.492 17.1671 141.597 16.8831L143.878 10.6988C143.942 10.5255 143.942 10.3351 143.878 10.1618L141.589 3.95802Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M162.985 16.8831C163.09 17.1671 163.02 17.486 162.806 17.7001L159.892 20.6139C159.678 20.828 159.359 20.898 159.075 20.7932L152.863 18.5109C152.71 18.4548 152.608 18.3094 152.608 18.1468V16.7866C152.608 16.6837 152.649 16.5851 152.722 16.5123L154.234 15.0002C154.341 14.8932 154.501 14.8582 154.643 14.9106L156.312 15.526L158.145 16.2026C158.3 16.2599 158.451 16.1089 158.394 15.9536L157.102 12.4509C157.05 12.3089 157.085 12.1494 157.192 12.0424L158.536 10.6984C158.688 10.5469 158.688 10.3013 158.536 10.1499L157.185 8.79842C157.078 8.6914 157.043 8.5319 157.095 8.38991L158.387 4.88752C158.444 4.73221 158.293 4.58118 158.138 4.63845L154.636 5.93052C154.494 5.98292 154.334 5.94791 154.227 5.8409L152.722 4.33592C152.649 4.2632 152.608 4.16452 152.608 4.06168V2.70105C152.608 2.5386 152.71 2.39338 152.862 2.33718L159.067 0.0479617C159.351 -0.0567914 159.67 0.0131841 159.884 0.227215L162.798 3.14107C163.012 3.3551 163.082 3.67408 162.978 3.95806L160.696 10.1424C160.632 10.3157 160.632 10.5061 160.696 10.6794L162.985 16.8831L162.985 16.8831Z",
          className: "fill-current"
        }
      )
    ]
  }
) }), L6 = () => /* @__PURE__ */ c("a", { href: "/", children: /* @__PURE__ */ x(
  "svg",
  {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-accent-primary",
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M0.0915035 7.59655C-0.108345 7.05153 0.0251545 6.43939 0.433423 6.02854L5.99194 0.436178C6.40027 0.0253318 7.00888 -0.10897 7.55065 0.0920797L19.4025 4.47256C19.6937 4.58019 19.8872 4.85915 19.8872 5.1713V7.78191C19.8872 7.97936 19.8093 8.16869 19.6705 8.30826L16.7857 11.2105C16.5815 11.4159 16.2773 11.4831 16.0064 11.3825L9.32443 8.90267C9.02814 8.79268 8.73993 9.08262 8.84926 9.38063L11.3143 16.1032C11.4143 16.3757 11.3475 16.6819 11.1433 16.8873L8.57869 19.4668C8.28967 19.7575 8.28967 20.2289 8.57869 20.5196L11.1569 23.1134C11.3611 23.3188 11.4279 23.6249 11.3279 23.8974L8.86283 30.6195C8.75356 30.9175 9.04171 31.2074 9.338 31.0975L16.0199 28.6176C16.2908 28.5171 16.5951 28.5843 16.7993 28.7897L19.6705 31.6781C19.8092 31.8177 19.8872 32.0071 19.8872 32.2045V34.8159C19.8872 35.1277 19.6941 35.4064 19.4034 35.5143L7.56477 39.9079C7.023 40.109 6.41445 39.9747 6.00612 39.5639L0.44705 33.9714C0.0387203 33.5606 -0.0947793 32.9484 0.105069 32.4034L4.45771 20.5339C4.57968 20.2013 4.57968 19.8359 4.45771 19.5033L0.0915035 7.59655Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M40.9085 32.4033C41.1083 32.9483 40.9748 33.5605 40.5666 33.9713L35.0081 39.5638C34.5997 39.9746 33.9912 40.1089 33.4494 39.9079L21.5975 35.5274C21.3063 35.4198 21.1128 35.1408 21.1128 34.8286V32.218C21.1128 32.0206 21.1907 31.8313 21.3295 31.6917L24.2143 28.7894C24.4185 28.5841 24.7227 28.5169 24.9936 28.6174L31.6756 31.0973C31.9719 31.2073 32.2601 30.9173 32.1507 30.6193L29.6856 23.8967C29.5857 23.6242 29.6525 23.3181 29.8567 23.1127L32.4213 20.5331C32.7103 20.2424 32.7103 19.7711 32.4213 19.4804L29.8431 16.8866C29.6389 16.6812 29.5721 16.375 29.6721 16.1025L32.1372 9.38048C32.2464 9.08241 31.9583 8.79253 31.662 8.90245L24.9801 11.3823C24.7092 11.4829 24.4049 11.4157 24.2007 11.2103L21.3295 8.32182C21.1908 8.18225 21.1128 7.99286 21.1128 7.79547V5.18405C21.1128 4.87227 21.3059 4.59356 21.5966 4.48568L33.4352 0.0920516C33.9769 -0.108998 34.5855 0.0253039 34.9938 0.436088L40.5529 6.02857C40.9612 6.43936 41.0947 7.05156 40.8949 7.59659L36.5422 19.466C36.4203 19.7986 36.4203 20.164 36.5422 20.4966L40.9085 32.4033Z",
          className: "fill-current"
        }
      )
    ]
  }
) }), B8 = () => /* @__PURE__ */ c("span", { className: "mx-2 inline-block h-[24px] w-auto", children: /* @__PURE__ */ c(ou, {}) }), $8 = ({ children: e }) => /* @__PURE__ */ c("nav", { className: "flex items-center justify-center gap-5 lg:gap-14", children: e }), F8 = ({ title: e, href: t, onClick: n, isActive: r }) => /* @__PURE__ */ c(
  "a",
  {
    href: t,
    onClick: n,
    className: H(
      "flex h-10 w-fit items-center justify-center whitespace-nowrap text-center",
      r ? "text-accent-primary" : "text-accent-secondary"
    ),
    children: e
  }
), A6 = ({
  id: e,
  top: t,
  onClose: n,
  children: r
}) => {
  const i = xe(null);
  return Wr({ open: !0, onClose: n }), te(() => {
    var a;
    (a = i.current) == null || a.focus();
  }, []), /* @__PURE__ */ c(
    "nav",
    {
      ref: i,
      id: e,
      "aria-label": "Menu",
      tabIndex: -1,
      className: "fixed inset-x-0 bottom-0 z-50 flex flex-col overflow-y-auto bg-surface p-4 focus:outline-none",
      style: { top: t },
      children: /* @__PURE__ */ c("div", { className: "flex flex-1 flex-col gap-9", onClick: (a) => {
        a.target.closest("a") && n();
      }, children: r })
    }
  );
}, E6 = {
  sm: "mb-8",
  md: "mb-20",
  lg: "mb-32"
}, z8 = ({
  navigation: e,
  mobileNavigation: t,
  logo: n,
  mobileLogo: r,
  mobileTitle: i,
  rightActions: o,
  className: a,
  containerClassName: s,
  showMobileMenu: l = !0,
  size: u = "md"
}) => {
  const d = Gt(), { portalContainer: f } = fc(), [h, p] = ie(null), b = xe(null), g = xe(null), v = l && !!t, w = Xt(), m = d && h !== null, N = we(
    () => {
      var L;
      return ((L = b.current) == null ? void 0 : L.getBoundingClientRect().bottom) ?? 0;
    },
    []
  ), C = () => p(N());
  te(() => {
    d || p(null);
  }, [d]), te(() => {
    if (!m) return;
    let L = requestAnimationFrame(function T() {
      const S = N();
      p(
        (R) => R === null || R === S ? R : S
      ), L = requestAnimationFrame(T);
    });
    return () => cancelAnimationFrame(L);
  }, [m, N]), te(() => {
    if (!m) return;
    const L = (T) => {
      var V;
      const S = T.target, R = document.getElementById(w);
      R != null && R.contains(S) || (V = g.current) != null && V.contains(S) || p(null);
    };
    return document.addEventListener("pointerdown", L), document.addEventListener("focusin", L), () => {
      document.removeEventListener("pointerdown", L), document.removeEventListener("focusin", L);
    };
  }, [m, w]), te(() => {
    if (!m || !b.current) return;
    const L = [], T = (V) => {
      V.hasAttribute("inert") || (V.setAttribute("inert", ""), L.push(V));
    }, S = new MutationObserver((V) => {
      for (const A of V)
        for (const E of Array.from(A.addedNodes))
          E instanceof Element && T(E);
    });
    let R = b.current;
    for (; R !== document.body && R.parentElement; ) {
      const V = R.parentElement;
      if (V !== document.body && V !== f) {
        for (const A of Array.from(V.children))
          A !== R && T(A);
        S.observe(V, { childList: !0 });
      }
      R = V;
    }
    return () => {
      S.disconnect();
      for (const V of L) V.removeAttribute("inert");
    };
  }, [m, f]);
  const M = () => {
    var L;
    p(null), (L = g.current) == null || L.focus();
  }, y = v && /* @__PURE__ */ c(
    "button",
    {
      ref: g,
      type: "button",
      "aria-label": m ? "Close menu" : "Open menu",
      "aria-expanded": m,
      "aria-controls": w,
      "data-testid": "header-menu-button",
      className: "cursor-pointer text-accent-primary",
      onClick: m ? M : C,
      children: m ? /* @__PURE__ */ c(i6, { size: 32 }) : /* @__PURE__ */ c(o6, { size: 32 })
    }
  );
  return /* @__PURE__ */ x(
    "header",
    {
      ref: b,
      className: ee(
        E6[u],
        a,
        m && "bg-surface"
      ),
      children: [
        /* @__PURE__ */ x(
          iu,
          {
            className: ee(
              "relative flex h-20 items-center justify-between",
              s
            ),
            children: [
              /* @__PURE__ */ c(
                "div",
                {
                  className: H(
                    "flex min-w-0 items-center",
                    d && i ? "gap-2" : "gap-4"
                  ),
                  children: d ? i ? /* @__PURE__ */ x(He, { children: [
                    y,
                    i
                  ] }) : /* @__PURE__ */ x(He, { children: [
                    r || /* @__PURE__ */ c(L6, {}),
                    y
                  ] }) : n || /* @__PURE__ */ c(ou, {})
                }
              ),
              !d && e && /* @__PURE__ */ c("div", { className: "absolute left-1/2 -translate-x-1/2 transform", children: e }),
              /* @__PURE__ */ c("div", { className: "flex items-center gap-4", children: o })
            ]
          }
        ),
        m && /* @__PURE__ */ c(
          A6,
          {
            id: w,
            top: h,
            onClose: M,
            children: t
          }
        )
      ]
    }
  );
};
function S6(e) {
  return Se({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612" }, child: [] }] })(e);
}
function k6(e) {
  return Se({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" }, child: [] }] })(e);
}
function O6(e) {
  return Se({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" }, child: [] }] })(e);
}
function T6(e) {
  return Se({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09" }, child: [] }] })(e);
}
function V6(e) {
  return Se({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" }, child: [] }] })(e);
}
function H6(e) {
  return Se({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" }, child: [] }] })(e);
}
function R6(e) {
  return Se({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z" }, child: [] }] })(e);
}
function D6(e) {
  return Se({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z" }, child: [] }] })(e);
}
const P6 = [
  {
    name: "Website",
    url: "https://babylonlabs.io",
    Icon: R6
  },
  {
    name: "X",
    url: "https://x.com/babylonlabs_io",
    Icon: V6
  },
  {
    name: "GitHub",
    url: "https://github.com/babylonlabs-io",
    Icon: k6
  },
  {
    name: "Telegram",
    url: "https://t.me/babylonofficialcommunity",
    Icon: T6
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/babylon-labs-official",
    Icon: O6
  },
  {
    name: "Docs",
    url: "https://docs.babylonlabs.io/",
    Icon: D6
  },
  {
    name: "Forum",
    url: "https://forum.babylon.foundation/",
    Icon: Q5
  },
  {
    name: "Email",
    url: "mailto:contact@babylonlabs.io",
    Icon: J5
  },
  {
    name: "Discord",
    url: "https://discord.gg/babylonglobal",
    Icon: S6
  }
], j8 = ({
  socialLinks: e = P6,
  logo: t,
  className: n,
  socialClassName: r,
  copyrightYear: i = (/* @__PURE__ */ new Date()).getFullYear()
}) => /* @__PURE__ */ c(
  "footer",
  {
    className: ee(
      "relative mt-24 flex bg-primary-light py-10 text-accent-contrast before:absolute before:-top-2 before:left-1/4 before:h-3 before:w-2/3 before:bg-primary-light dark:bg-primary-main dark:before:bg-primary-main md:py-20",
      n
    ),
    children: /* @__PURE__ */ x(iu, { className: "flex flex-col items-center md:flex-row-reverse md:items-start md:justify-between", children: [
      t || /* @__PURE__ */ c(M6, { className: "h-[61px] w-[250px] lg:h-[90px] lg:w-[367px]" }),
      /* @__PURE__ */ x("div", { className: ee("mt-10 md:mt-0", r), children: [
        /* @__PURE__ */ c("div", { className: "mb:pt-0 flex flex-wrap justify-center gap-x-4 gap-y-8 pb-10 pt-2 md:justify-start md:pb-8", children: e.map(({ name: o, url: a, Icon: s }) => /* @__PURE__ */ c(
          "a",
          {
            href: a,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "transition-colors hover:text-secondary-main",
            children: /* @__PURE__ */ c(s, { size: 32, title: o })
          },
          o
        )) }),
        /* @__PURE__ */ x(Q, { variant: "body2", className: "text-center text-accent-secondary md:text-left", children: [
          /* @__PURE__ */ c(
            "a",
            {
              href: "https://babylonlabs.io/terms-of-use",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-secondary-main",
              children: "Terms of Use"
            }
          ),
          " ",
          "-",
          " ",
          /* @__PURE__ */ c(
            "a",
            {
              href: "https://babylonlabs.io/privacy-policy",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-secondary-main",
              children: "Privacy Policy"
            }
          ),
          " ",
          "- ",
          i,
          " Babylon Labs. All rights reserved."
        ] })
      ] })
    ] })
  }
), q8 = ({ brand: e, children: t, footer: n, className: r }) => /* @__PURE__ */ x(
  "aside",
  {
    className: ee(
      "sticky top-0 flex h-svh w-[242px] shrink-0 flex-col items-start border-r border-secondary-strokeLight bg-surface p-6",
      r
    ),
    children: [
      /* @__PURE__ */ c("div", { className: "w-full", children: e }),
      /* @__PURE__ */ c("nav", { className: "mt-10 flex w-full flex-1 flex-col gap-10 overflow-y-auto", children: t }),
      n
    ]
  }
), U8 = ({
  icon: e,
  label: t,
  isActive: n = !1,
  trailing: r,
  className: i
}) => /* @__PURE__ */ x(
  "div",
  {
    className: H(
      "flex h-10 items-center gap-2 rounded py-2 text-base tracking-[0.15px] transition-colors",
      n ? "text-accent-primary" : "text-accent-secondary hover:text-secondary-main",
      i
    ),
    children: [
      /* @__PURE__ */ c("span", { className: "flex size-6 shrink-0 items-center justify-center", children: e }),
      /* @__PURE__ */ c("span", { children: t }),
      r != null && /* @__PURE__ */ c("span", { className: "ml-auto flex shrink-0", children: r })
    ]
  }
);
function W8({
  className: e,
  wordmarkClassName: t,
  width: n = 194,
  height: r = 24,
  ...i
}) {
  return /* @__PURE__ */ x("svg", { viewBox: "0 0 194 24.2502", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: n, height: r, className: e, "aria-label": "Babylon Aave", role: "img", ...i, children: [
    /* @__PURE__ */ x("g", { id: "Logo Section", children: [
      /* @__PURE__ */ x("g", { id: "Logo", className: t, children: [
        /* @__PURE__ */ x("g", { id: "Vector", children: [
          /* @__PURE__ */ c("path", { d: "M0 2.14517C0 1.62342 0.183581 1.17684 0.551149 0.806258C0.918716 0.435675 1.36081 0.250485 1.87823 0.250485C2.39565 0.250485 2.83815 0.436082 3.20551 0.806258C3.57247 1.17684 3.75666 1.62342 3.75666 2.14517V4.67141C3.75666 4.87351 3.8231 5.02936 3.9568 5.13876C4.0903 5.24857 4.23228 5.30297 4.38254 5.30297H8.13899C8.65642 5.30297 9.09891 5.48857 9.46628 5.85874C9.83324 6.22933 10.0174 6.6759 10.0174 7.19765C10.0174 7.38325 10.0756 7.53482 10.1925 7.65238C10.3093 7.77033 10.4595 7.82921 10.6433 7.82921C11.1607 7.82921 11.6032 8.01481 11.9706 8.38499C12.3375 8.75557 12.5215 9.20214 12.5215 9.72389V14.7764C12.5215 15.2985 12.3377 15.7451 11.9706 16.1153C11.6034 16.4855 11.1605 16.6711 10.6433 16.6711C10.493 16.6711 10.3511 16.7259 10.2176 16.8353C10.0839 16.9451 10.0174 17.1005 10.0174 17.3026C10.0174 17.8248 9.83344 18.2714 9.46628 18.6415C9.09911 19.0117 8.65621 19.1973 8.13899 19.1973H1.87823C1.36081 19.1973 0.91811 19.0121 0.551149 18.6415C0.183783 18.2714 0 17.8248 0 17.3026V2.14517ZM8.13899 15.4079C8.28925 15.4079 8.43103 15.3574 8.56473 15.2564C8.69822 15.1553 8.76507 14.9954 8.76507 14.7764V9.72389C8.76507 9.55582 8.7063 9.40811 8.58977 9.2818C8.47283 9.15549 8.32258 9.09233 8.13899 9.09233H4.38254C4.19875 9.09233 4.04849 9.15977 3.93176 9.29443C3.81482 9.4295 3.75666 9.57232 3.75666 9.72389V14.7764C3.75666 14.962 3.81927 15.1135 3.94448 15.2311C4.0697 15.3491 4.21572 15.4079 4.38274 15.4079H8.13899Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M12.5233 12.2505C12.5233 11.7288 12.7068 11.2822 13.0744 10.9116C13.442 10.5411 13.8841 10.3559 14.4015 10.3559H20.6623C20.796 10.3559 20.9337 10.3015 21.0757 10.1917C21.2172 10.0823 21.2887 9.9264 21.2887 9.7243C21.2887 9.5222 21.2172 9.36676 21.0757 9.25695C20.9337 9.14754 20.796 9.09274 20.6623 9.09274H14.4015C13.8841 9.09274 13.4414 8.90755 13.0744 8.53697C12.707 8.16679 12.5233 7.72022 12.5233 7.19806C12.5233 6.6759 12.7068 6.22973 13.0744 5.85915C13.442 5.48857 13.8841 5.30338 14.4015 5.30338H20.6623C21.1797 5.30338 21.6224 5.48897 21.9895 5.85915C22.3567 6.22973 22.5407 6.67631 22.5407 7.19806C22.5407 7.40016 22.6118 7.55601 22.7538 7.66541C22.8953 7.77522 23.0331 7.82962 23.1668 7.82962C23.6842 7.82962 24.1269 8.01522 24.4941 8.38539C24.8612 8.75598 25.0452 9.20255 25.0452 9.7243V17.303C25.0452 17.8252 24.8614 18.2718 24.4941 18.6419C24.1269 19.0125 23.6842 19.1977 23.1668 19.1977H16.906C16.3884 19.1977 15.9457 19.0125 15.5787 18.6419C15.2114 18.2718 15.0278 17.8252 15.0278 17.303C15.0278 17.1178 14.9609 16.9663 14.8274 16.8483C14.6937 16.7308 14.552 16.6715 14.4017 16.6715C13.8843 16.6715 13.4416 16.4863 13.0746 16.1157C12.7073 15.7455 12.5235 15.2989 12.5235 14.7768L12.5233 12.2505ZM20.6623 15.4083C20.8125 15.4083 20.9541 15.3495 21.0882 15.2315C21.2215 15.114 21.2885 14.9624 21.2885 14.7768C21.2885 14.6252 21.2298 14.4824 21.113 14.3473C20.9963 14.2127 20.846 14.1452 20.6623 14.1452H16.9058C16.722 14.1452 16.5718 14.2127 16.455 14.3473C16.3381 14.4824 16.2799 14.6252 16.2799 14.7768C16.2799 14.9624 16.3464 15.114 16.4801 15.2315C16.6136 15.3495 16.7555 15.4083 16.9058 15.4083H20.6623Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M25.0454 2.14517C25.0454 1.62342 25.2288 1.17684 25.5963 0.806259C25.9639 0.435675 26.406 0.250485 26.9236 0.250485C27.4412 0.250485 27.8835 0.436083 28.2509 0.806259C28.6178 1.17684 28.8018 1.62342 28.8018 2.14517V4.67141C28.8018 4.87351 28.8685 5.02936 29.0022 5.13876C29.1357 5.24857 29.2777 5.30297 29.4279 5.30297H33.1844C33.7018 5.30297 34.1443 5.48857 34.5117 5.85874C34.8786 6.22933 35.0626 6.6759 35.0626 7.19765C35.0626 7.38325 35.121 7.53482 35.2379 7.65238C35.3544 7.77033 35.5047 7.82921 35.6887 7.82921C36.2061 7.82921 36.6486 8.01481 37.016 8.38499C37.3829 8.75557 37.5669 9.20214 37.5669 9.72389V14.7764C37.5669 15.2985 37.3831 15.7451 37.016 16.1153C36.6488 16.4855 36.2059 16.6711 35.6887 16.6711C35.5384 16.6711 35.3964 16.7259 35.2629 16.8353C35.1292 16.9451 35.0626 17.1005 35.0626 17.3026C35.0626 17.8248 34.8788 18.2714 34.5117 18.6415C34.1445 19.0117 33.7016 19.1973 33.1844 19.1973H26.9236C26.406 19.1973 25.9633 19.0121 25.5963 18.6415C25.229 18.2714 25.0452 17.8252 25.0452 17.303L25.0454 2.14517ZM33.1844 15.4079C33.3346 15.4079 33.4762 15.3574 33.6101 15.2564C33.7434 15.1553 33.8104 14.9954 33.8104 14.7764V9.72389C33.8104 9.55582 33.7517 9.40811 33.6351 9.2818C33.5182 9.15549 33.368 9.09233 33.1844 9.09233H29.4279C29.2439 9.09233 29.0937 9.15977 28.9771 9.29443C28.8602 9.4295 28.8018 9.57232 28.8018 9.72389V14.7764C28.8018 14.962 28.8646 15.1135 28.9899 15.2311C29.1151 15.3491 29.2611 15.4079 29.4281 15.4079H33.1844Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M45.7042 20.4608C45.8877 20.4608 46.038 20.4015 46.1549 20.284C46.2715 20.166 46.3302 20.0145 46.3302 19.8293C46.3302 19.6441 46.2715 19.4921 46.1549 19.3745C46.038 19.2566 45.8877 19.1977 45.7042 19.1977H41.9477C41.4301 19.1977 40.9874 19.0125 40.6204 18.6419C40.2531 18.2718 40.0695 17.8252 40.0695 17.303C40.0695 17.135 40.0107 16.9872 39.8942 16.8609C39.7772 16.7346 39.627 16.6715 39.4434 16.6715C38.9258 16.6715 38.4831 16.4863 38.1161 16.1157C37.7488 15.7455 37.5652 15.2989 37.5652 14.7768V7.19806C37.5652 6.67631 37.7486 6.22973 38.1161 5.85915C38.4837 5.48857 38.9258 5.30338 39.4434 5.30338C39.961 5.30338 40.4033 5.48897 40.7707 5.85915C41.1376 6.22973 41.3216 6.67631 41.3216 7.19806V14.7768C41.3216 14.9624 41.38 15.114 41.4969 15.2315C41.6135 15.3495 41.7637 15.4083 41.9477 15.4083H45.7042C45.8877 15.4083 46.038 15.3495 46.1549 15.2315C46.2715 15.114 46.3302 14.9624 46.3302 14.7768V7.19806C46.3302 6.67631 46.5136 6.22973 46.8812 5.85915C47.2488 5.48857 47.6909 5.30338 48.2085 5.30338C48.7261 5.30338 49.1684 5.48897 49.5358 5.85915C49.9027 6.22973 50.0867 6.67631 50.0867 7.19806V19.8293C50.0867 20.351 49.9029 20.7976 49.5358 21.1682C49.1684 21.5384 48.7257 21.724 48.2085 21.724C48.0245 21.724 47.8742 21.7871 47.7577 21.9134C47.6408 22.0397 47.5824 22.187 47.5824 22.3555C47.5824 22.8773 47.3986 23.3238 47.0315 23.6944C46.6641 24.0646 46.2214 24.2502 45.7042 24.2502H39.4434C38.9258 24.2502 38.4831 24.0646 38.1161 23.6944C37.7492 23.3242 37.5652 22.8773 37.5652 22.3555C37.5652 21.8338 37.7486 21.3868 38.1161 21.0166C38.4831 20.646 38.9258 20.4608 39.4434 20.4608H45.7042Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M50.0838 2.14517C50.0838 1.62342 50.2672 1.17684 50.6348 0.806259C51.0023 0.435675 51.4444 0.250485 51.962 0.250485C52.4797 0.250485 52.922 0.436083 53.2893 0.806259C53.6563 1.17684 53.8403 1.62342 53.8403 2.14517V14.7764C53.8403 14.9785 53.9069 15.1343 54.0406 15.2437C54.1741 15.3535 54.3161 15.4079 54.4664 15.4079H55.7185C56.2357 15.4079 56.6782 15.5935 57.0456 15.9637C57.4125 16.3343 57.5967 16.7809 57.5967 17.3026C57.5967 17.8244 57.4127 18.2714 57.0456 18.6415C56.6784 19.0117 56.2355 19.1973 55.7185 19.1973H54.4664C53.9487 19.1973 53.506 19.0121 53.1391 18.6415C52.7717 18.2714 52.5881 17.8248 52.5881 17.3026C52.5881 17.1005 52.5211 16.9451 52.3878 16.8353C52.2539 16.7259 52.1123 16.6711 51.962 16.6711C51.4444 16.6711 51.0017 16.4859 50.6348 16.1153C50.2674 15.7451 50.0838 15.2985 50.0838 14.7764V2.14517Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M56.6233 9.7243C56.6233 9.20255 56.8066 8.75598 57.1742 8.38539C57.5418 8.01481 57.9839 7.82962 58.5015 7.82962C58.6851 7.82962 58.8353 7.76259 58.9523 7.62752C59.0688 7.49285 59.1276 7.34963 59.1276 7.19806C59.1276 6.67631 59.311 6.22973 59.6785 5.85915C60.0461 5.48857 60.4882 5.30338 61.0058 5.30338H64.7623C65.2797 5.30338 65.7222 5.48897 66.0895 5.85915C66.4565 6.22973 66.6405 6.67631 66.6405 7.19806C66.6405 7.38366 66.7033 7.53523 66.8285 7.65278C66.9537 7.77074 67.0998 7.82962 67.2668 7.82962C67.7842 7.82962 68.2267 8.01522 68.5941 8.38539C68.961 8.75598 69.145 9.20255 69.145 9.7243V14.7768C69.145 15.2989 68.9612 15.7455 68.5941 16.1157C68.2269 16.4859 67.784 16.6715 67.2668 16.6715C67.0664 16.6715 66.9117 16.7434 66.8035 16.8862C66.6946 17.0294 66.6405 17.1684 66.6405 17.303C66.6405 17.8252 66.4567 18.2718 66.0895 18.6419C65.7224 19.0121 65.2795 19.1977 64.7623 19.1977H61.0058C60.4882 19.1977 60.0455 19.0125 59.6785 18.6419C59.3112 18.2718 59.1276 17.8252 59.1276 17.303C59.1276 17.1178 59.0688 16.9663 58.9523 16.8483C58.8353 16.7308 58.6851 16.6715 58.5015 16.6715C57.9839 16.6715 57.5412 16.4863 57.1742 16.1157C56.8068 15.7455 56.6233 15.2989 56.6233 14.7768V9.7243ZM64.7623 15.4083C64.9125 15.4083 65.0541 15.3578 65.188 15.2568C65.3213 15.1557 65.3883 14.9958 65.3883 14.7768V9.7243C65.3883 9.55622 65.3296 9.40852 65.213 9.28221C65.0961 9.1559 64.9458 9.09274 64.7623 9.09274H61.0058C60.8218 9.09274 60.6716 9.16017 60.555 9.29484C60.4381 9.42991 60.3797 9.57273 60.3797 9.7243V14.7768C60.3797 14.9624 60.4425 15.114 60.5677 15.2315C60.693 15.3495 60.839 15.4083 61.006 15.4083H64.7623Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M69.1431 7.19806C69.1431 6.67631 69.3264 6.22973 69.694 5.85915C70.0616 5.48857 70.5037 5.30338 71.0213 5.30338H76.0299C76.5473 5.30338 76.9898 5.48897 77.3572 5.85915C77.7242 6.22973 77.9083 6.67631 77.9083 7.19806C77.9083 7.40016 77.9709 7.55601 78.0962 7.66541C78.2214 7.77522 78.3674 7.82962 78.5344 7.82962C78.8513 7.82962 79.127 7.89278 79.3608 8.01909C79.5945 8.1454 79.7906 8.30125 79.9494 8.48644C80.1079 8.67204 80.2248 8.87414 80.3 9.09274C80.3751 9.31175 80.4126 9.5222 80.4126 9.7243V17.303C80.4126 17.8252 80.2289 18.2718 79.8617 18.6419C79.4945 19.0121 79.0516 19.1977 78.5344 19.1977C78.0172 19.1977 77.5741 19.0125 77.2071 18.6419C76.8398 18.2718 76.6562 17.8252 76.6562 17.303V9.7243C76.6562 9.53911 76.5893 9.38754 76.4558 9.26958C76.3219 9.15203 76.1804 9.09274 76.0301 9.09274H73.526C73.342 9.09274 73.1918 9.1559 73.0752 9.28221C72.9583 9.40852 72.8999 9.55622 72.8999 9.7243V17.303C72.8999 17.8252 72.7161 18.2718 72.349 18.6419C71.9818 19.0121 71.5389 19.1977 71.0217 19.1977C70.5045 19.1977 70.0614 19.0125 69.6944 18.6419C69.3271 18.2718 69.1435 17.8252 69.1435 17.303L69.1431 7.19806Z", fill: "currentColor" })
        ] }),
        /* @__PURE__ */ x("g", { id: "Vector_2", children: [
          /* @__PURE__ */ c("path", { d: "M84.2418 2.6248C84.1795 2.45442 84.2212 2.26305 84.3485 2.13461L86.082 0.386347C86.2093 0.25791 86.3991 0.215925 86.5681 0.278776L90.2643 1.64819C90.3551 1.68183 90.4155 1.76904 90.4155 1.86663V2.68275C90.4155 2.74447 90.3912 2.80366 90.3479 2.84729L89.4482 3.75458C89.3845 3.81879 89.2897 3.83979 89.2052 3.80836L87.1213 3.03312C87.0289 2.99873 86.939 3.08937 86.9731 3.18254L87.7419 5.28414C87.7731 5.36933 87.7522 5.46503 87.6885 5.52924L86.8887 6.33565C86.7986 6.42652 86.7986 6.57388 86.8887 6.66476L87.6928 7.47562C87.7565 7.53983 87.7773 7.63553 87.7461 7.72073L86.9773 9.82215C86.9433 9.91534 87.0331 10.006 87.1255 9.97159L89.2094 9.19635C89.2939 9.16492 89.3888 9.18592 89.4525 9.25013L90.3479 10.1531C90.3912 10.1967 90.4155 10.2559 90.4155 10.3177V11.134C90.4155 11.2315 90.3553 11.3186 90.2646 11.3524L86.5725 12.7259C86.4036 12.7887 86.2138 12.7468 86.0864 12.6183L84.3527 10.87C84.2254 10.7416 84.1837 10.5502 84.2461 10.3798L85.6035 6.66924C85.6416 6.56527 85.6416 6.45103 85.6035 6.34707L84.2418 2.6248Z", fill: "currentColor" }),
          /* @__PURE__ */ c("path", { d: "M96.9715 10.3798C97.0338 10.5502 96.9921 10.7416 96.8648 10.87L95.1313 12.6183C95.004 12.7467 94.8142 12.7887 94.6452 12.7259L90.949 11.3565C90.8582 11.3228 90.7978 11.2356 90.7978 11.138V10.3219C90.7978 10.2602 90.8221 10.201 90.8654 10.1574L91.7651 9.25007C91.8288 9.18586 91.9236 9.16486 92.0081 9.19629L94.092 9.97153C94.1844 10.0059 94.2743 9.91528 94.2402 9.82211L93.4714 7.72051C93.4402 7.63532 93.4611 7.53962 93.5248 7.47541L94.3246 6.66901C94.4147 6.57813 94.4147 6.43077 94.3246 6.33989L93.5205 5.52903C93.4568 5.46482 93.436 5.36912 93.4672 5.28392L94.236 3.1825C94.27 3.08932 94.1802 2.99869 94.0878 3.03306L92.0039 3.8083C91.9194 3.83973 91.8245 3.81873 91.7608 3.75452L90.8654 2.85154C90.8221 2.80791 90.7978 2.7487 90.7978 2.687V1.87062C90.7978 1.77316 90.858 1.68602 90.9487 1.6523L94.6408 0.278777C94.8097 0.215925 94.9995 0.25791 95.1269 0.386329L96.8606 2.13463C96.9879 2.26305 97.0295 2.45444 96.9672 2.62482L95.6098 6.33541C95.5717 6.43938 95.5717 6.55362 95.6098 6.65758L96.9715 10.3798Z", fill: "currentColor" })
        ] })
      ] }),
      /* @__PURE__ */ c("path", { id: "Line 13", d: "M105.25 0.25C105.25 0.111929 105.138 0 105 0C104.862 0 104.75 0.111929 104.75 0.25H105H105.25ZM105 24.25H105.25V0.25H105H104.75V24.25H105Z", className: "fill-[#CCCCCC] dark:fill-[#5A5A5A]" }),
      /* @__PURE__ */ x("g", { id: "Logo-purple 1", clipPath: "url(#sidebarBrandClip)", children: [
        /* @__PURE__ */ c("path", { id: "Vector_3", d: "M187.306 16.3542C185.568 16.3542 184.024 15.0502 183.626 13.2498H193.943C193.943 13.2498 193.998 12.5975 193.998 12.3667C193.998 8.54552 190.997 5.43594 187.307 5.43594C183.618 5.43594 180.617 8.54487 180.617 12.3667C180.617 16.1886 183.601 19.2253 187.307 19.2253C191.013 19.2253 193.177 16.3974 193.717 14.3502H190.573C190.573 14.3502 189.573 16.3542 187.306 16.3542ZM187.307 8.30572C188.973 8.30572 190.42 9.44538 190.915 11.1439H183.7C184.193 9.44538 185.64 8.30572 187.307 8.30572Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_4", d: "M147.939 19.2253C144.25 19.2253 141.356 16.1486 141.356 12.3667C141.356 8.58484 144.358 5.43594 148.047 5.43594C151.736 5.43594 154.738 8.66735 154.738 12.33C154.738 13.8906 154.738 18.8818 154.738 18.8818H152.14V16.6952L151.951 16.6437C151.493 17.8053 149.836 19.2253 147.939 19.2253H147.939ZM148.047 8.30572C145.963 8.30572 144.268 10.1177 144.268 12.3455C144.268 14.5732 145.963 16.3549 148.047 16.3549C150.131 16.3549 151.826 14.5565 151.826 12.3455C151.826 10.1345 150.131 8.30572 148.047 8.30572Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_5", d: "M162.154 19.2253C158.465 19.2253 155.571 16.1486 155.571 12.3667C155.571 8.58484 158.573 5.43594 162.262 5.43594C165.951 5.43594 168.952 8.66735 168.952 12.33C168.952 13.8906 168.952 18.8818 168.952 18.8818H166.355V16.6952L166.166 16.6437C165.708 17.8053 164.051 19.2253 162.153 19.2253H162.154ZM162.262 8.30572C160.178 8.30572 158.482 10.1177 158.482 12.3455C158.482 14.5732 160.178 16.3549 162.262 16.3549C164.346 16.3549 166.041 14.5565 166.041 12.3455C166.041 10.1345 164.346 8.30572 162.262 8.30572Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_6", d: "M173.313 18.8747L167.981 5.775H170.898L174.806 15.4247L178.714 5.775H181.63L176.3 18.8747H173.313Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_7", d: "M122.483 19.2012C123.934 19.2012 125.11 17.983 125.11 16.4802C125.11 14.9776 123.934 13.7594 122.483 13.7594C121.032 13.7594 119.856 14.9776 119.856 16.4802C119.856 17.983 121.032 19.2012 122.483 19.2012Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_8", d: "M129.35 19.2012C130.801 19.2012 131.977 17.983 131.977 16.4802C131.977 14.9776 130.801 13.7594 129.35 13.7594C127.899 13.7594 126.723 14.9776 126.723 16.4802C126.723 17.983 127.899 19.2012 129.35 19.2012Z", fill: "currentColor" }),
        /* @__PURE__ */ c("path", { id: "Vector_9", d: "M125.913 5.25C118.781 5.25 112.998 11.3538 113 18.8809H116.299C116.299 13.2399 120.569 8.6664 125.913 8.6664C131.257 8.6664 135.528 13.2399 135.528 18.8809H138.827C138.828 11.3538 133.045 5.25 125.913 5.25Z", fill: "currentColor" })
      ] })
    ] }),
    /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "sidebarBrandClip", children: /* @__PURE__ */ c("rect", { width: "81", height: "14", transform: "translate(113 5.25)" }) }) })
  ] });
}
const Z8 = ({
  loading: e = !1,
  connected: t = !1,
  onClick: n,
  text: r = "Connect",
  loadingText: i = "Loading...",
  className: o,
  disabled: a = !1
}) => t ? null : /* @__PURE__ */ x(
  ze,
  {
    size: "large",
    className: o || "h-[2.5rem] min-h-[2.5rem] rounded-full px-6 py-2 text-base text-white md:rounded",
    onClick: n,
    color: "secondary",
    disabled: a || e,
    "data-testid": "connect-wallet-button",
    children: [
      /* @__PURE__ */ c(v6, { size: 20, className: "flex md:hidden" }),
      /* @__PURE__ */ c("span", { className: "hidden md:flex", children: e ? i : r })
    ]
  }
), I6 = {
  lg: {
    logo: "size-10",
    badge: "!min-w-5 !h-5",
    badgeText: "!text-xs"
  },
  md: {
    logo: "size-6",
    badge: "!min-w-4 !h-4 !px-0.5",
    badgeText: "!text-[10px]"
  },
  sm: {
    logo: "size-5",
    badge: "!min-w-3 !h-3 !px-0.5",
    badgeText: "!text-[8px]"
  }
}, Fl = ({ logoUrl: e, rank: t, moniker: n, size: r = "md", className: i }) => {
  const [o, a] = ie(!1), s = I6[r], l = typeof t == "number" && !Number.isNaN(t), u = (n == null ? void 0 : n.charAt(0).toUpperCase()) ?? (l ? String(t) : "?");
  return /* @__PURE__ */ c(
    R5,
    {
      count: l ? t : void 0,
      position: "bottom-right",
      color: "secondary",
      className: ee(s.logo, i),
      badgeClassName: ee("border border-accent-contrast overflow-hidden", s.badge),
      contentClassName: s.badgeText,
      max: 99,
      children: e && !o ? /* @__PURE__ */ c(
        "img",
        {
          src: e,
          alt: n || (l ? `Finality Provider ${t}` : "Finality Provider"),
          className: "h-full w-full rounded-full object-cover",
          onError: () => a(!0)
        }
      ) : /* @__PURE__ */ c(
        Q,
        {
          as: "span",
          className: "inline-flex h-full w-full items-center justify-center rounded-full bg-secondary-main text-[1rem] text-accent-contrast",
          children: u
        }
      )
    }
  );
};
function au({ bsnId: e, bsnName: t, bsnLogoUrl: n, address: r, provider: i, onRemove: o, showChain: a = !0 }) {
  var p;
  if (!i) return null;
  const s = (p = i.description) == null ? void 0 : p.moniker, l = (t == null ? void 0 : t.charAt(0).toUpperCase()) || "?", u = (b) => !b || b.length <= 12 ? b : `${b.slice(0, 6)}...${b.slice(-6)}`, d = () => /* @__PURE__ */ x("div", { className: "flex items-center text-xs text-accent-secondary", children: [
    /* @__PURE__ */ c(
      Fl,
      {
        logoUrl: i.logo_url,
        rank: i.rank,
        moniker: s,
        size: "sm",
        className: "mr-1"
      }
    ),
    s
  ] }), f = () => a ? r ? /* @__PURE__ */ x(Q, { as: "div", className: "flex items-center gap-1 text-base font-medium text-accent-primary", children: [
    u(r),
    /* @__PURE__ */ c(zc, { value: r, className: "cursor-pointer", copiedText: "✓", children: /* @__PURE__ */ c(Er, { size: 12 }) })
  ] }) : /* @__PURE__ */ c(Q, { as: "div", className: "text-base font-medium text-accent-primary", children: t }) : /* @__PURE__ */ c(Q, { as: "div", className: "text-base font-medium text-accent-primary", children: s });
  return /* @__PURE__ */ x("div", { className: "flex flex-row items-center justify-between", children: [
    /* @__PURE__ */ x("div", { className: "flex h-10 flex-row gap-2", children: [
      /* @__PURE__ */ c("div", { className: "shrink-0", children: a ? n ? /* @__PURE__ */ c(on, { url: n, alt: t, variant: "rounded", size: "large" }) : /* @__PURE__ */ c(on, { variant: "rounded", size: "large", children: /* @__PURE__ */ c(
        Q,
        {
          as: "span",
          className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast",
          children: l
        }
      ) }) : /* @__PURE__ */ c(
        Fl,
        {
          logoUrl: i.logo_url,
          rank: i.rank,
          moniker: s,
          size: "lg"
        }
      ) }),
      /* @__PURE__ */ x("div", { className: "flex flex-col justify-center text-accent-primary", children: [
        a && d(),
        f()
      ] })
    ] }),
    o ? /* @__PURE__ */ c(
      "button",
      {
        onClick: () => o(e),
        className: "ml-[10px] flex items-center justify-center cursor-pointer p-1",
        children: /* @__PURE__ */ c(Fn, { size: 12 })
      }
    ) : null
  ] });
}
const zl = {
  active: "bg-success-main",
  pending: "bg-warning-main",
  inactive: "bg-accent-disabled",
  warning: "bg-accent-disabled",
  default: "bg-info-main"
};
function X8({
  status: e,
  label: t,
  className: n = ""
}) {
  const r = t || e.charAt(0).toUpperCase() + e.slice(1);
  return /* @__PURE__ */ x(
    "span",
    {
      className: `inline-flex items-center gap-2 ${n}`,
      children: [
        /* @__PURE__ */ c(
          "span",
          {
            className: `w-2 h-2 rounded-full flex-shrink-0 ${zl[e] || zl.default}`
          }
        ),
        /* @__PURE__ */ c("span", { className: "text-sm text-accent-primary font-normal", children: r })
      ]
    }
  );
}
function G8({
  id: e,
  title: t,
  details: n,
  actions: r = [],
  onAction: i
}) {
  return /* @__PURE__ */ x(tf, { className: "flex flex-col p-4", children: [
    /* @__PURE__ */ x("div", { className: "flex items-center justify-between pb-3", children: [
      /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
        t.icons.length > 0 && /* @__PURE__ */ c(zu, { size: "small", children: t.icons.map((o, a) => /* @__PURE__ */ c(
          on,
          {
            url: o,
            alt: `Icon ${a + 1}`,
            size: "small",
            variant: "circular"
          },
          a
        )) }),
        /* @__PURE__ */ c("span", { className: "text-base font-semibold text-accent-primary", children: t.text })
      ] }),
      r.length > 0 && /* @__PURE__ */ c(
        $a,
        {
          trigger: /* @__PURE__ */ c(
            "button",
            {
              className: "rounded p-1 hover:bg-surface-secondary",
              "aria-label": "Actions",
              children: /* @__PURE__ */ c(h0, { size: 20, variant: "accent-primary" })
            }
          ),
          placement: "bottom-end",
          children: r.map((o) => /* @__PURE__ */ c(
            X1,
            {
              name: o.name,
              onClick: () => i == null ? void 0 : i(e, o.action)
            },
            o.action
          ))
        }
      )
    ] }),
    /* @__PURE__ */ c("div", { className: "border-t border-surface-secondary mb-3" }),
    /* @__PURE__ */ c("div", { className: "flex flex-col gap-3", children: n.map((o, a) => /* @__PURE__ */ x("div", { className: "flex items-start justify-between gap-4", children: [
      /* @__PURE__ */ c("span", { className: "text-xs text-accent-secondary whitespace-nowrap", children: o.label }),
      /* @__PURE__ */ c("div", { className: "flex-1 flex justify-end text-right", children: typeof o.value == "string" ? /* @__PURE__ */ c("span", { className: "text-sm text-accent-primary", children: o.value }) : o.value })
    ] }, a)) })
  ] });
}
function B6(e) {
  const t = e.match(/^(.*?)([MKB])$/);
  return t ? { value: t[1], unit: t[2] } : { value: e, unit: "" };
}
function Y8({ title: e, amount: t, subtitle: n }) {
  const { value: r, unit: i } = B6(t);
  return /* @__PURE__ */ x("div", { className: "flex flex-col gap-[2px]", children: [
    /* @__PURE__ */ c("p", { className: "text-[12px] font-normal text-accent-secondary", style: { letterSpacing: "0.4px" }, children: e }),
    /* @__PURE__ */ x("div", { className: "flex items-baseline gap-0.5", children: [
      /* @__PURE__ */ c("span", { className: "text-[24px] font-normal text-accent-primary", children: r }),
      i && /* @__PURE__ */ c("span", { className: "text-[24px] font-normal text-accent-secondary", children: i })
    ] }),
    n && /* @__PURE__ */ c("p", { className: "text-[14px] font-normal text-accent-primary", children: n })
  ] });
}
function K8({
  id: e,
  name: t,
  icon: n,
  isSelected: r,
  onToggle: i,
  className: o
}) {
  return /* @__PURE__ */ x("div", { className: ee(
    "flex items-center justify-between p-4 rounded-lg bg-secondary-highlight dark:bg-primary-main",
    o
  ), children: [
    /* @__PURE__ */ x("div", { className: "flex items-center gap-3", children: [
      n && /* @__PURE__ */ c("div", { className: "flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-primary-main", children: n }),
      /* @__PURE__ */ c(Q, { variant: "body1", className: "text-lg font-medium text-accent-primary", children: t })
    ] }),
    /* @__PURE__ */ c(
      ze,
      {
        size: "small",
        variant: r ? "contained" : "outlined",
        color: "primary",
        rounded: !0,
        onClick: () => i(e),
        className: "min-w-[100px] text-sm",
        children: r ? "Selected" : "Select"
      }
    )
  ] });
}
var ni = (e) => e.type === "checkbox", En = (e) => e instanceof Date, ot = (e) => e == null;
const su = (e) => typeof e == "object";
var je = (e) => !ot(e) && !Array.isArray(e) && su(e) && !En(e), lu = (e) => je(e) && e.target ? ni(e.target) ? e.target.checked : e.target.value : e, $6 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, cu = (e, t) => e.has($6(t)), F6 = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return je(t) && t.hasOwnProperty("isPrototypeOf");
}, qa = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function lt(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(qa && (e instanceof Blob || r)) && (n || je(e)))
    if (t = n ? [] : {}, !n && !F6(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = lt(e[i]));
  else
    return e;
  return t;
}
var Zi = (e) => Array.isArray(e) ? e.filter(Boolean) : [], $e = (e) => e === void 0, q = (e, t, n) => {
  if (!t || !je(e))
    return n;
  const r = Zi(t.split(/[,[\].]+?/)).reduce((i, o) => ot(i) ? i : i[o], e);
  return $e(r) || r === e ? $e(e[t]) ? n : e[t] : r;
}, ht = (e) => typeof e == "boolean", Ua = (e) => /^\w*$/.test(e), uu = (e) => Zi(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Ne = (e, t, n) => {
  let r = -1;
  const i = Ua(t) ? [t] : uu(t), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = n;
    if (r !== a) {
      const u = e[s];
      l = je(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
  return e;
};
const ki = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, St = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, tn = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, du = ae.createContext(null), gr = () => ae.useContext(du), z6 = (e) => {
  const { children: t, ...n } = e;
  return ae.createElement(du.Provider, { value: n }, t);
};
var fu = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return t._proxyFormState[a] !== St.all && (t._proxyFormState[a] = !r || St.all), n && (n[a] = !0), e[a];
      }
    });
  return i;
}, ct = (e) => je(e) && !Object.keys(e).length, hu = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return ct(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((a) => t[a] === (!r || St.all));
}, Lr = (e) => Array.isArray(e) ? e : [e], pu = (e, t, n) => !e || !t || e === t || Lr(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function Wa(e) {
  const t = ae.useRef(e);
  t.current = e, ae.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function mu(e) {
  const t = gr(), { control: n = t.control, disabled: r, name: i, exact: o } = e || {}, [a, s] = ae.useState(n._formState), l = ae.useRef(!0), u = ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), d = ae.useRef(i);
  return d.current = i, Wa({
    disabled: r,
    next: (f) => l.current && pu(d.current, f.name, o) && hu(f, u.current, n._updateFormState) && s({
      ...n._formState,
      ...f
    }),
    subject: n._subjects.state
  }), ae.useEffect(() => (l.current = !0, u.current.isValid && n._updateValid(!0), () => {
    l.current = !1;
  }), [n]), ae.useMemo(() => fu(a, n, u.current, !1), [a, n]);
}
var Pt = (e) => typeof e == "string", gu = (e, t, n, r, i) => Pt(e) ? (r && t.watch.add(e), q(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), q(n, o))) : (r && (t.watchAll = !0), n);
function vu(e) {
  const t = gr(), { control: n = t.control, name: r, defaultValue: i, disabled: o, exact: a } = e || {}, s = ae.useRef(r);
  s.current = r, Wa({
    disabled: o,
    subject: n._subjects.values,
    next: (d) => {
      pu(s.current, d.name, a) && u(lt(gu(s.current, n._names, d.values || n._formValues, !1, i)));
    }
  });
  const [l, u] = ae.useState(n._getWatch(r, i));
  return ae.useEffect(() => n._removeUnmounted()), l;
}
function j6(e) {
  const t = gr(), { name: n, disabled: r, control: i = t.control, shouldUnregister: o } = e, a = cu(i._names.array, n), s = vu({
    control: i,
    name: n,
    defaultValue: q(i._formValues, n, q(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), l = mu({
    control: i,
    name: n,
    exact: !0
  }), u = ae.useRef(i.register(n, {
    ...e.rules,
    value: s,
    ...ht(e.disabled) ? { disabled: e.disabled } : {}
  })), d = ae.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!q(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!q(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!q(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!q(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => q(l.errors, n)
    }
  }), [l, n]), f = ae.useMemo(() => ({
    name: n,
    value: s,
    ...ht(r) || l.disabled ? { disabled: l.disabled || r } : {},
    onChange: (h) => u.current.onChange({
      target: {
        value: lu(h),
        name: n
      },
      type: ki.CHANGE
    }),
    onBlur: () => u.current.onBlur({
      target: {
        value: q(i._formValues, n),
        name: n
      },
      type: ki.BLUR
    }),
    ref: (h) => {
      const p = q(i._fields, n);
      p && h && (p._f.ref = {
        focus: () => h.focus(),
        select: () => h.select(),
        setCustomValidity: (b) => h.setCustomValidity(b),
        reportValidity: () => h.reportValidity()
      });
    }
  }), [
    n,
    i._formValues,
    r,
    l.disabled,
    s,
    i._fields
  ]);
  return ae.useEffect(() => {
    const h = i._options.shouldUnregister || o, p = (b, g) => {
      const v = q(i._fields, b);
      v && v._f && (v._f.mount = g);
    };
    if (p(n, !0), h) {
      const b = lt(q(i._options.defaultValues, n));
      Ne(i._defaultValues, n, b), $e(q(i._formValues, n)) && Ne(i._formValues, n, b);
    }
    return () => {
      (a ? h && !i._state.action : h) ? i.unregister(n) : p(n, !1);
    };
  }, [n, i, a, o]), ae.useEffect(() => {
    ht(r) && q(i._fields, n) && i._updateDisabledField({
      disabled: r,
      fields: i._fields,
      name: n,
      value: q(i._fields, n)._f.value
    });
  }, [r, n, i]), ae.useMemo(() => ({
    field: f,
    formState: l,
    fieldState: d
  }), [f, l, d]);
}
var bu = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, jl = (e) => ({
  isOnSubmit: !e || e === St.onSubmit,
  isOnBlur: e === St.onBlur,
  isOnChange: e === St.onChange,
  isOnAll: e === St.all,
  isOnTouch: e === St.onTouched
}), ql = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const Ar = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = q(e, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], i) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (Ar(s, t))
          break;
      } else if (je(s) && Ar(s, t))
        break;
    }
  }
};
var q6 = (e, t, n) => {
  const r = Lr(q(e, n));
  return Ne(r, "root", t[n]), Ne(e, n, r), e;
}, Za = (e) => e.type === "file", Rt = (e) => typeof e == "function", Oi = (e) => {
  if (!qa)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, gi = (e) => Pt(e), Xa = (e) => e.type === "radio", Ti = (e) => e instanceof RegExp;
const Ul = {
  value: !1,
  isValid: !1
}, Wl = { value: !0, isValid: !0 };
var yu = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !$e(e[0].attributes.value) ? $e(e[0].value) || e[0].value === "" ? Wl : { value: e[0].value, isValid: !0 } : Wl
    ) : Ul;
  }
  return Ul;
};
const Zl = {
  isValid: !1,
  value: null
};
var xu = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, Zl) : Zl;
function Xl(e, t, n = "validate") {
  if (gi(e) || Array.isArray(e) && e.every(gi) || ht(e) && !e)
    return {
      type: n,
      message: gi(e) ? e : "",
      ref: t
    };
}
var Xn = (e) => je(e) && !Ti(e) ? e : {
  value: e,
  message: ""
}, Gl = async (e, t, n, r, i) => {
  const { ref: o, refs: a, required: s, maxLength: l, minLength: u, min: d, max: f, pattern: h, validate: p, name: b, valueAsNumber: g, mount: v, disabled: w } = e._f, m = q(t, b);
  if (!v || w)
    return {};
  const N = a ? a[0] : o, C = (A) => {
    r && N.reportValidity && (N.setCustomValidity(ht(A) ? "" : A || ""), N.reportValidity());
  }, M = {}, y = Xa(o), L = ni(o), T = y || L, S = (g || Za(o)) && $e(o.value) && $e(m) || Oi(o) && o.value === "" || m === "" || Array.isArray(m) && !m.length, R = bu.bind(null, b, n, M), V = (A, E, P, U = tn.maxLength, D = tn.minLength) => {
    const z = A ? E : P;
    M[b] = {
      type: A ? U : D,
      message: z,
      ref: o,
      ...R(A ? U : D, z)
    };
  };
  if (i ? !Array.isArray(m) || !m.length : s && (!T && (S || ot(m)) || ht(m) && !m || L && !yu(a).isValid || y && !xu(a).isValid)) {
    const { value: A, message: E } = gi(s) ? { value: !!s, message: s } : Xn(s);
    if (A && (M[b] = {
      type: tn.required,
      message: E,
      ref: N,
      ...R(tn.required, E)
    }, !n))
      return C(E), M;
  }
  if (!S && (!ot(d) || !ot(f))) {
    let A, E;
    const P = Xn(f), U = Xn(d);
    if (!ot(m) && !isNaN(m)) {
      const D = o.valueAsNumber || m && +m;
      ot(P.value) || (A = D > P.value), ot(U.value) || (E = D < U.value);
    } else {
      const D = o.valueAsDate || new Date(m), z = (Z) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Z), I = o.type == "time", Y = o.type == "week";
      Pt(P.value) && m && (A = I ? z(m) > z(P.value) : Y ? m > P.value : D > new Date(P.value)), Pt(U.value) && m && (E = I ? z(m) < z(U.value) : Y ? m < U.value : D < new Date(U.value));
    }
    if ((A || E) && (V(!!A, P.message, U.message, tn.max, tn.min), !n))
      return C(M[b].message), M;
  }
  if ((l || u) && !S && (Pt(m) || i && Array.isArray(m))) {
    const A = Xn(l), E = Xn(u), P = !ot(A.value) && m.length > +A.value, U = !ot(E.value) && m.length < +E.value;
    if ((P || U) && (V(P, A.message, E.message), !n))
      return C(M[b].message), M;
  }
  if (h && !S && Pt(m)) {
    const { value: A, message: E } = Xn(h);
    if (Ti(A) && !m.match(A) && (M[b] = {
      type: tn.pattern,
      message: E,
      ref: o,
      ...R(tn.pattern, E)
    }, !n))
      return C(E), M;
  }
  if (p) {
    if (Rt(p)) {
      const A = await p(m, t), E = Xl(A, N);
      if (E && (M[b] = {
        ...E,
        ...R(tn.validate, E.message)
      }, !n))
        return C(E.message), M;
    } else if (je(p)) {
      let A = {};
      for (const E in p) {
        if (!ct(A) && !n)
          break;
        const P = Xl(await p[E](m, t), N, E);
        P && (A = {
          ...P,
          ...R(E, P.message)
        }, C(P.message), n && (M[b] = A));
      }
      if (!ct(A) && (M[b] = {
        ref: N,
        ...A
      }, !n))
        return M;
    }
  }
  return C(!0), M;
};
function U6(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = $e(e) ? r++ : e[t[r++]];
  return e;
}
function W6(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !$e(e[t]))
      return !1;
  return !0;
}
function We(e, t) {
  const n = Array.isArray(t) ? t : Ua(t) ? [t] : uu(t), r = n.length === 1 ? e : U6(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (je(r) && ct(r) || Array.isArray(r) && W6(r)) && We(e, n.slice(0, -1)), e;
}
var Oo = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ra = (e) => ot(e) || !su(e);
function hn(e, t) {
  if (ra(e) || ra(t))
    return e === t;
  if (En(e) && En(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n) {
    const o = e[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const a = t[i];
      if (En(o) && En(a) || je(o) && je(a) || Array.isArray(o) && Array.isArray(a) ? !hn(o, a) : o !== a)
        return !1;
    }
  }
  return !0;
}
var Cu = (e) => e.type === "select-multiple", Z6 = (e) => Xa(e) || ni(e), To = (e) => Oi(e) && e.isConnected, wu = (e) => {
  for (const t in e)
    if (Rt(e[t]))
      return !0;
  return !1;
};
function Vi(e, t = {}) {
  const n = Array.isArray(e);
  if (je(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || je(e[r]) && !wu(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Vi(e[r], t[r])) : ot(e[r]) || (t[r] = !0);
  return t;
}
function Nu(e, t, n) {
  const r = Array.isArray(e);
  if (je(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || je(e[i]) && !wu(e[i]) ? $e(t) || ra(n[i]) ? n[i] = Array.isArray(e[i]) ? Vi(e[i], []) : { ...Vi(e[i]) } : Nu(e[i], ot(t) ? {} : t[i], n[i]) : n[i] = !hn(e[i], t[i]);
  return n;
}
var xr = (e, t) => Nu(e, t, Vi(t)), _u = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => $e(e) ? e : t ? e === "" ? NaN : e && +e : n && Pt(e) ? new Date(e) : r ? r(e) : e;
function Vo(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return Za(t) ? t.files : Xa(t) ? xu(e.refs).value : Cu(t) ? [...t.selectedOptions].map(({ value: n }) => n) : ni(t) ? yu(e.refs).value : _u($e(t.value) ? e.ref.value : t.value, e);
}
var X6 = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const a = q(t, o);
    a && Ne(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Cr = (e) => $e(e) ? e : Ti(e) ? e.source : je(e) ? Ti(e.value) ? e.value.source : e.value : e;
const Yl = "AsyncFunction";
var G6 = (e) => !!e && !!e.validate && !!(Rt(e.validate) && e.validate.constructor.name === Yl || je(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === Yl)), Y6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Kl(e, t, n) {
  const r = q(e, n);
  if (r || Ua(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = q(t, o), s = q(e, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    i.pop();
  }
  return {
    name: n
  };
}
var K6 = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, J6 = (e, t) => !Zi(q(e, t)).length && We(e, t);
const Q6 = {
  mode: St.onSubmit,
  reValidateMode: St.onChange,
  shouldFocusError: !0
};
function e4(e = {}) {
  let t = {
    ...Q6,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Rt(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = je(t.defaultValues) || je(t.values) ? lt(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : lt(i), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: Oo(),
    array: Oo(),
    state: Oo()
  }, h = jl(t.mode), p = jl(t.reValidateMode), b = t.criteriaMode === St.all, g = (_) => (k) => {
    clearTimeout(u), u = setTimeout(_, k);
  }, v = async (_) => {
    if (!t.disabled && (d.isValid || _)) {
      const k = t.resolver ? ct((await T()).errors) : await R(r, !0);
      k !== n.isValid && f.state.next({
        isValid: k
      });
    }
  }, w = (_, k) => {
    !t.disabled && (d.isValidating || d.validatingFields) && ((_ || Array.from(s.mount)).forEach((O) => {
      O && (k ? Ne(n.validatingFields, O, k) : We(n.validatingFields, O));
    }), f.state.next({
      validatingFields: n.validatingFields,
      isValidating: !ct(n.validatingFields)
    }));
  }, m = (_, k = [], O, j, F = !0, B = !0) => {
    if (j && O && !t.disabled) {
      if (a.action = !0, B && Array.isArray(q(r, _))) {
        const J = O(q(r, _), j.argA, j.argB);
        F && Ne(r, _, J);
      }
      if (B && Array.isArray(q(n.errors, _))) {
        const J = O(q(n.errors, _), j.argA, j.argB);
        F && Ne(n.errors, _, J), J6(n.errors, _);
      }
      if (d.touchedFields && B && Array.isArray(q(n.touchedFields, _))) {
        const J = O(q(n.touchedFields, _), j.argA, j.argB);
        F && Ne(n.touchedFields, _, J);
      }
      d.dirtyFields && (n.dirtyFields = xr(i, o)), f.state.next({
        name: _,
        isDirty: A(_, k),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Ne(o, _, k);
  }, N = (_, k) => {
    Ne(n.errors, _, k), f.state.next({
      errors: n.errors
    });
  }, C = (_) => {
    n.errors = _, f.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, M = (_, k, O, j) => {
    const F = q(r, _);
    if (F) {
      const B = q(o, _, $e(O) ? q(i, _) : O);
      $e(B) || j && j.defaultChecked || k ? Ne(o, _, k ? B : Vo(F._f)) : U(_, B), a.mount && v();
    }
  }, y = (_, k, O, j, F) => {
    let B = !1, J = !1;
    const le = {
      name: _
    };
    if (!t.disabled) {
      const be = !!(q(r, _) && q(r, _)._f && q(r, _)._f.disabled);
      if (!O || j) {
        d.isDirty && (J = n.isDirty, n.isDirty = le.isDirty = A(), B = J !== le.isDirty);
        const ye = be || hn(q(i, _), k);
        J = !!(!be && q(n.dirtyFields, _)), ye || be ? We(n.dirtyFields, _) : Ne(n.dirtyFields, _, !0), le.dirtyFields = n.dirtyFields, B = B || d.dirtyFields && J !== !ye;
      }
      if (O) {
        const ye = q(n.touchedFields, _);
        ye || (Ne(n.touchedFields, _, O), le.touchedFields = n.touchedFields, B = B || d.touchedFields && ye !== O);
      }
      B && F && f.state.next(le);
    }
    return B ? le : {};
  }, L = (_, k, O, j) => {
    const F = q(n.errors, _), B = d.isValid && ht(k) && n.isValid !== k;
    if (t.delayError && O ? (l = g(() => N(_, O)), l(t.delayError)) : (clearTimeout(u), l = null, O ? Ne(n.errors, _, O) : We(n.errors, _)), (O ? !hn(F, O) : F) || !ct(j) || B) {
      const J = {
        ...j,
        ...B && ht(k) ? { isValid: k } : {},
        errors: n.errors,
        name: _
      };
      n = {
        ...n,
        ...J
      }, f.state.next(J);
    }
  }, T = async (_) => {
    w(_, !0);
    const k = await t.resolver(o, t.context, X6(_ || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return w(_), k;
  }, S = async (_) => {
    const { errors: k } = await T(_);
    if (_)
      for (const O of _) {
        const j = q(k, O);
        j ? Ne(n.errors, O, j) : We(n.errors, O);
      }
    else
      n.errors = k;
    return k;
  }, R = async (_, k, O = {
    valid: !0
  }) => {
    for (const j in _) {
      const F = _[j];
      if (F) {
        const { _f: B, ...J } = F;
        if (B) {
          const le = s.array.has(B.name), be = F._f && G6(F._f);
          be && d.validatingFields && w([j], !0);
          const ye = await Gl(F, o, b, t.shouldUseNativeValidation && !k, le);
          if (be && d.validatingFields && w([j]), ye[B.name] && (O.valid = !1, k))
            break;
          !k && (q(ye, B.name) ? le ? q6(n.errors, ye, B.name) : Ne(n.errors, B.name, ye[B.name]) : We(n.errors, B.name));
        }
        !ct(J) && await R(J, k, O);
      }
    }
    return O.valid;
  }, V = () => {
    for (const _ of s.unMount) {
      const k = q(r, _);
      k && (k._f.refs ? k._f.refs.every((O) => !To(O)) : !To(k._f.ref)) && he(_);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, A = (_, k) => !t.disabled && (_ && k && Ne(o, _, k), !hn(ne(), i)), E = (_, k, O) => gu(_, s, {
    ...a.mount ? o : $e(k) ? i : Pt(_) ? { [_]: k } : k
  }, O, k), P = (_) => Zi(q(a.mount ? o : i, _, t.shouldUnregister ? q(i, _, []) : [])), U = (_, k, O = {}) => {
    const j = q(r, _);
    let F = k;
    if (j) {
      const B = j._f;
      B && (!B.disabled && Ne(o, _, _u(k, B)), F = Oi(B.ref) && ot(k) ? "" : k, Cu(B.ref) ? [...B.ref.options].forEach((J) => J.selected = F.includes(J.value)) : B.refs ? ni(B.ref) ? B.refs.length > 1 ? B.refs.forEach((J) => (!J.defaultChecked || !J.disabled) && (J.checked = Array.isArray(F) ? !!F.find((le) => le === J.value) : F === J.value)) : B.refs[0] && (B.refs[0].checked = !!F) : B.refs.forEach((J) => J.checked = J.value === F) : Za(B.ref) ? B.ref.value = "" : (B.ref.value = F, B.ref.type || f.values.next({
        name: _,
        values: { ...o }
      })));
    }
    (O.shouldDirty || O.shouldTouch) && y(_, F, O.shouldTouch, O.shouldDirty, !0), O.shouldValidate && Z(_);
  }, D = (_, k, O) => {
    for (const j in k) {
      const F = k[j], B = `${_}.${j}`, J = q(r, B);
      (s.array.has(_) || je(F) || J && !J._f) && !En(F) ? D(B, F, O) : U(B, F, O);
    }
  }, z = (_, k, O = {}) => {
    const j = q(r, _), F = s.array.has(_), B = lt(k);
    Ne(o, _, B), F ? (f.array.next({
      name: _,
      values: { ...o }
    }), (d.isDirty || d.dirtyFields) && O.shouldDirty && f.state.next({
      name: _,
      dirtyFields: xr(i, o),
      isDirty: A(_, B)
    })) : j && !j._f && !ot(B) ? D(_, B, O) : U(_, B, O), ql(_, s) && f.state.next({ ...n }), f.values.next({
      name: a.mount ? _ : void 0,
      values: { ...o }
    });
  }, I = async (_) => {
    a.mount = !0;
    const k = _.target;
    let O = k.name, j = !0;
    const F = q(r, O), B = () => k.type ? Vo(F._f) : lu(_), J = (le) => {
      j = Number.isNaN(le) || En(le) && isNaN(le.getTime()) || hn(le, q(o, O, le));
    };
    if (F) {
      let le, be;
      const ye = B(), Ze = _.type === ki.BLUR || _.type === ki.FOCUS_OUT, st = !Y6(F._f) && !t.resolver && !q(n.errors, O) && !F._f.deps || K6(Ze, q(n.touchedFields, O), n.isSubmitted, p, h), yt = ql(O, s, Ze);
      Ne(o, O, ye), Ze ? (F._f.onBlur && F._f.onBlur(_), l && l(0)) : F._f.onChange && F._f.onChange(_);
      const Kt = y(O, ye, Ze, !1), Tt = !ct(Kt) || yt;
      if (!Ze && f.values.next({
        name: O,
        type: _.type,
        values: { ...o }
      }), st)
        return d.isValid && (t.mode === "onBlur" ? Ze && v() : v()), Tt && f.state.next({ name: O, ...yt ? {} : Kt });
      if (!Ze && yt && f.state.next({ ...n }), t.resolver) {
        const { errors: xt } = await T([O]);
        if (J(ye), j) {
          const tt = Kl(n.errors, r, O), ge = Kl(xt, r, tt.name || O);
          le = ge.error, O = ge.name, be = ct(xt);
        }
      } else
        w([O], !0), le = (await Gl(F, o, b, t.shouldUseNativeValidation))[O], w([O]), J(ye), j && (le ? be = !1 : d.isValid && (be = await R(r, !0)));
      j && (F._f.deps && Z(F._f.deps), L(O, be, le, Kt));
    }
  }, Y = (_, k) => {
    if (q(n.errors, k) && _.focus)
      return _.focus(), 1;
  }, Z = async (_, k = {}) => {
    let O, j;
    const F = Lr(_);
    if (t.resolver) {
      const B = await S($e(_) ? _ : F);
      O = ct(B), j = _ ? !F.some((J) => q(B, J)) : O;
    } else _ ? (j = (await Promise.all(F.map(async (B) => {
      const J = q(r, B);
      return await R(J && J._f ? { [B]: J } : J);
    }))).every(Boolean), !(!j && !n.isValid) && v()) : j = O = await R(r);
    return f.state.next({
      ...!Pt(_) || d.isValid && O !== n.isValid ? {} : { name: _ },
      ...t.resolver || !_ ? { isValid: O } : {},
      errors: n.errors
    }), k.shouldFocus && !j && Ar(r, Y, _ ? F : s.mount), j;
  }, ne = (_) => {
    const k = {
      ...a.mount ? o : i
    };
    return $e(_) ? k : Pt(_) ? q(k, _) : _.map((O) => q(k, O));
  }, fe = (_, k) => ({
    invalid: !!q((k || n).errors, _),
    isDirty: !!q((k || n).dirtyFields, _),
    error: q((k || n).errors, _),
    isValidating: !!q(n.validatingFields, _),
    isTouched: !!q((k || n).touchedFields, _)
  }), Me = (_) => {
    _ && Lr(_).forEach((k) => We(n.errors, k)), f.state.next({
      errors: _ ? n.errors : {}
    });
  }, Ce = (_, k, O) => {
    const j = (q(r, _, { _f: {} })._f || {}).ref, F = q(n.errors, _) || {}, { ref: B, message: J, type: le, ...be } = F;
    Ne(n.errors, _, {
      ...be,
      ...k,
      ref: j
    }), f.state.next({
      name: _,
      errors: n.errors,
      isValid: !1
    }), O && O.shouldFocus && j && j.focus && j.focus();
  }, ke = (_, k) => Rt(_) ? f.values.subscribe({
    next: (O) => _(E(void 0, k), O)
  }) : E(_, k, !0), he = (_, k = {}) => {
    for (const O of _ ? Lr(_) : s.mount)
      s.mount.delete(O), s.array.delete(O), k.keepValue || (We(r, O), We(o, O)), !k.keepError && We(n.errors, O), !k.keepDirty && We(n.dirtyFields, O), !k.keepTouched && We(n.touchedFields, O), !k.keepIsValidating && We(n.validatingFields, O), !t.shouldUnregister && !k.keepDefaultValue && We(i, O);
    f.values.next({
      values: { ...o }
    }), f.state.next({
      ...n,
      ...k.keepDirty ? { isDirty: A() } : {}
    }), !k.keepIsValid && v();
  }, X = ({ disabled: _, name: k, field: O, fields: j, value: F }) => {
    if (ht(_) && a.mount || _) {
      const B = _ ? void 0 : $e(F) ? Vo(O ? O._f : q(j, k)._f) : F;
      (_ || !_ && !$e(B)) && Ne(o, k, B), y(k, B, !1, !1, !0);
    }
  }, re = (_, k = {}) => {
    let O = q(r, _);
    const j = ht(k.disabled) || ht(t.disabled);
    return Ne(r, _, {
      ...O || {},
      _f: {
        ...O && O._f ? O._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...k
      }
    }), s.mount.add(_), O ? X({
      field: O,
      disabled: ht(k.disabled) ? k.disabled : t.disabled,
      name: _,
      value: k.value
    }) : M(_, !0, k.value), {
      ...j ? { disabled: k.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!k.required,
        min: Cr(k.min),
        max: Cr(k.max),
        minLength: Cr(k.minLength),
        maxLength: Cr(k.maxLength),
        pattern: Cr(k.pattern)
      } : {},
      name: _,
      onChange: I,
      onBlur: I,
      ref: (F) => {
        if (F) {
          re(_, k), O = q(r, _);
          const B = $e(F.value) && F.querySelectorAll && F.querySelectorAll("input,select,textarea")[0] || F, J = Z6(B), le = O._f.refs || [];
          if (J ? le.find((be) => be === B) : B === O._f.ref)
            return;
          Ne(r, _, {
            _f: {
              ...O._f,
              ...J ? {
                refs: [
                  ...le.filter(To),
                  B,
                  ...Array.isArray(q(i, _)) ? [{}] : []
                ],
                ref: { type: B.type, name: _ }
              } : { ref: B }
            }
          }), M(_, !1, void 0, B);
        } else
          O = q(r, _, {}), O._f && (O._f.mount = !1), (t.shouldUnregister || k.shouldUnregister) && !(cu(s.array, _) && a.action) && s.unMount.add(_);
      }
    };
  }, $ = () => t.shouldFocusError && Ar(r, Y, s.mount), oe = (_) => {
    ht(_) && (f.state.next({ disabled: _ }), Ar(r, (k, O) => {
      const j = q(r, O);
      j && (k.disabled = j._f.disabled || _, Array.isArray(j._f.refs) && j._f.refs.forEach((F) => {
        F.disabled = j._f.disabled || _;
      }));
    }, 0, !1));
  }, pe = (_, k) => async (O) => {
    let j;
    if (O && (O.preventDefault && O.preventDefault(), O.persist && O.persist()), t.disabled) {
      k && await k({ ...n.errors }, O);
      return;
    }
    let F = lt(o);
    if (f.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: B, values: J } = await T();
      n.errors = B, F = J;
    } else
      await R(r);
    if (We(n.errors, "root"), ct(n.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await _(F, O);
      } catch (B) {
        j = B;
      }
    } else
      k && await k({ ...n.errors }, O), $(), setTimeout($);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ct(n.errors) && !j,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), j)
      throw j;
  }, Le = (_, k = {}) => {
    q(r, _) && ($e(k.defaultValue) ? z(_, lt(q(i, _))) : (z(_, k.defaultValue), Ne(i, _, lt(k.defaultValue))), k.keepTouched || We(n.touchedFields, _), k.keepDirty || (We(n.dirtyFields, _), n.isDirty = k.defaultValue ? A(_, lt(q(i, _))) : A()), k.keepError || (We(n.errors, _), d.isValid && v()), f.state.next({ ...n }));
  }, Ie = (_, k = {}) => {
    const O = _ ? lt(_) : i, j = lt(O), F = ct(_), B = F ? i : j;
    if (k.keepDefaultValues || (i = O), !k.keepValues) {
      if (k.keepDirtyValues) {
        const J = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(xr(i, o))
        ]);
        for (const le of Array.from(J))
          q(n.dirtyFields, le) ? Ne(B, le, q(o, le)) : z(le, q(B, le));
      } else {
        if (qa && $e(_))
          for (const J of s.mount) {
            const le = q(r, J);
            if (le && le._f) {
              const be = Array.isArray(le._f.refs) ? le._f.refs[0] : le._f.ref;
              if (Oi(be)) {
                const ye = be.closest("form");
                if (ye) {
                  ye.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      o = t.shouldUnregister ? k.keepDefaultValues ? lt(i) : {} : lt(B), f.array.next({
        values: { ...B }
      }), f.values.next({
        values: { ...B }
      });
    }
    s = {
      mount: k.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !d.isValid || !!k.keepIsValid || !!k.keepDirtyValues, a.watch = !!t.shouldUnregister, f.state.next({
      submitCount: k.keepSubmitCount ? n.submitCount : 0,
      isDirty: F ? !1 : k.keepDirty ? n.isDirty : !!(k.keepDefaultValues && !hn(_, i)),
      isSubmitted: k.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: F ? {} : k.keepDirtyValues ? k.keepDefaultValues && o ? xr(i, o) : n.dirtyFields : k.keepDefaultValues && _ ? xr(i, _) : k.keepDirty ? n.dirtyFields : {},
      touchedFields: k.keepTouched ? n.touchedFields : {},
      errors: k.keepErrors ? n.errors : {},
      isSubmitSuccessful: k.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Be = (_, k) => Ie(Rt(_) ? _(o) : _, k);
  return {
    control: {
      register: re,
      unregister: he,
      getFieldState: fe,
      handleSubmit: pe,
      setError: Ce,
      _executeSchema: T,
      _getWatch: E,
      _getDirty: A,
      _updateValid: v,
      _removeUnmounted: V,
      _updateFieldArray: m,
      _updateDisabledField: X,
      _getFieldArray: P,
      _reset: Ie,
      _resetDefaultValues: () => Rt(t.defaultValues) && t.defaultValues().then((_) => {
        Be(_, t.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (_) => {
        n = {
          ...n,
          ..._
        };
      },
      _disableForm: oe,
      _subjects: f,
      _proxyFormState: d,
      _setErrors: C,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return a;
      },
      set _state(_) {
        a = _;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(_) {
        s = _;
      },
      get _formState() {
        return n;
      },
      set _formState(_) {
        n = _;
      },
      get _options() {
        return t;
      },
      set _options(_) {
        t = {
          ...t,
          ..._
        };
      }
    },
    trigger: Z,
    register: re,
    handleSubmit: pe,
    watch: ke,
    setValue: z,
    getValues: ne,
    reset: Be,
    resetField: Le,
    clearErrors: Me,
    unregister: he,
    setError: Ce,
    setFocus: (_, k = {}) => {
      const O = q(r, _), j = O && O._f;
      if (j) {
        const F = j.refs ? j.refs[0] : j.ref;
        F.focus && (F.focus(), k.shouldSelect && Rt(F.select) && F.select());
      }
    },
    getFieldState: fe
  };
}
function t4(e = {}) {
  const t = ae.useRef(), n = ae.useRef(), [r, i] = ae.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Rt(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Rt(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...e4(e),
    formState: r
  });
  const o = t.current.control;
  return o._options = e, Wa({
    subject: o._subjects.state,
    next: (a) => {
      hu(a, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), ae.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), ae.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const a = o._getDirty();
      a !== r.isDirty && o._subjects.state.next({
        isDirty: a
      });
    }
  }, [o, r.isDirty]), ae.useEffect(() => {
    e.values && !hn(e.values, n.current) ? (o._reset(e.values, o._options.resetOptions), n.current = e.values, i((a) => ({ ...a }))) : o._resetDefaultValues();
  }, [e.values, o]), ae.useEffect(() => {
    e.errors && o._setErrors(e.errors);
  }, [e.errors, o]), ae.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), ae.useEffect(() => {
    e.shouldUnregister && o._subjects.values.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), ae.useMemo(() => ({
    ...t.current,
    formState: fu(r, o)
  }), [r, o]);
}
const Jl = (e, t, n) => {
  if (e && "reportValidity" in e) {
    const r = q(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, Mu = (e, t) => {
  for (const n in t.fields) {
    const r = t.fields[n];
    r && r.ref && "reportValidity" in r.ref ? Jl(r.ref, n, e) : r.refs && r.refs.forEach((i) => Jl(i, n, e));
  }
}, n4 = (e, t) => {
  t.shouldUseNativeValidation && Mu(e, t);
  const n = {};
  for (const r in e) {
    const i = q(t.fields, r), o = Object.assign(e[r] || {}, { ref: i && i.ref });
    if (r4(t.names || Object.keys(e), r)) {
      const a = Object.assign({}, q(n, r));
      Ne(a, "root", o), Ne(n, r, a);
    } else Ne(n, r, o);
  }
  return n;
}, r4 = (e, t) => e.some((n) => n.startsWith(t + "."));
function i4(e, t, n) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), function(r, i, o) {
    try {
      return Promise.resolve(function(a, s) {
        try {
          var l = (t.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(e[n.mode === "sync" ? "validateSync" : "validate"](r, Object.assign({ abortEarly: !1 }, t, { context: i }))).then(function(u) {
            return o.shouldUseNativeValidation && Mu({}, o), { values: n.raw ? r : u, errors: {} };
          }));
        } catch (u) {
          return s(u);
        }
        return l && l.then ? l.then(void 0, s) : l;
      }(0, function(a) {
        if (!a.inner) throw a;
        return { values: {}, errors: n4((s = a, l = !o.shouldUseNativeValidation && o.criteriaMode === "all", (s.inner || []).reduce(function(u, d) {
          if (u[d.path] || (u[d.path] = { message: d.message, type: d.type }), l) {
            var f = u[d.path].types, h = f && f[d.type];
            u[d.path] = bu(d.path, l, u, d.type, h ? [].concat(h, d.message) : d.message);
          }
          return u;
        }, {})), o) };
        var s, l;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
}
function o4({
  className: e,
  name: t,
  children: n,
  mode: r = "onBlur",
  reValidateMode: i = "onBlur",
  defaultValues: o,
  schema: a,
  formProps: s,
  onSubmit: l = () => null,
  onChange: u
}, d) {
  const f = t4({
    mode: r,
    reValidateMode: i,
    defaultValues: o,
    resolver: a ? i4(a) : void 0
  });
  return jr(d, () => f, [f]), te(() => {
    if (!u) return;
    const { unsubscribe: h } = f.watch(u);
    return h;
  }, [u, f.watch]), /* @__PURE__ */ c(z6, { ...f, children: /* @__PURE__ */ c(
    "form",
    {
      className: H("bbn-form", e),
      name: t,
      onSubmit: f.handleSubmit(l),
      ...s,
      children: n
    }
  ) });
}
const J8 = bt(o4);
function vr({
  name: e,
  defaultValue: t,
  disabled: n = !1,
  autoFocus: r = !1,
  shouldUnregister: i = !1,
  validateOnMount: o = !0
}) {
  const { setFocus: a, trigger: s } = gr(), { field: l, fieldState: u } = j6({ name: e, defaultValue: t, disabled: n, shouldUnregister: i }), { invalid: d, isTouched: f, error: h } = u;
  return te(() => {
    o ? s(e, { shouldFocus: r }) : r && a(e);
  }, [e, o]), {
    ...l,
    value: l.value,
    invalid: d && f,
    error: (h == null ? void 0 : h.message) ?? ""
  };
}
function Q8(e) {
  const { getFieldState: t } = gr(), n = mu({ name: e });
  return Array.isArray(e) ? e.map((i) => t(i, n)) : t(e, n);
}
const a4 = /^-?\d*\.?\d*$/;
function e7({
  name: e,
  id: t = e,
  label: n,
  hint: r,
  className: i,
  controlClassName: o,
  disabled: a,
  autoFocus: s,
  defaultValue: l,
  placeholder: u,
  type: d,
  suffix: f,
  prefix: h,
  shouldUnregister: p,
  state: b,
  validateOnMount: g
}) {
  const {
    ref: v,
    value: w = "",
    error: m,
    invalid: N,
    onChange: C,
    onBlur: M
  } = vr({ name: e, defaultValue: l, autoFocus: s, shouldUnregister: p, validateOnMount: g }), y = N ? "error" : b;
  return /* @__PURE__ */ c(ji, { label: n, className: o, state: y, hint: N ? m : r, children: /* @__PURE__ */ c(
    zi,
    {
      inputMode: "decimal",
      pattern: "^-?\\d*\\.?\\d*$",
      ref: v,
      value: w,
      id: t,
      name: e,
      type: d,
      className: i,
      disabled: a,
      autoFocus: s,
      placeholder: u,
      suffix: f,
      prefix: h,
      state: y,
      onChange: (S) => {
        a4.test(S.target.value) && C(S.target.value);
      },
      onBlur: M
    }
  ) });
}
function t7({
  name: e,
  id: t = e,
  label: n,
  hint: r,
  className: i,
  controlClassName: o,
  disabled: a,
  autoFocus: s,
  defaultValue: l,
  placeholder: u,
  type: d,
  suffix: f,
  prefix: h,
  shouldUnregister: p,
  state: b,
  validateOnMount: g
}) {
  const {
    ref: v,
    value: w = "",
    error: m,
    invalid: N,
    onChange: C,
    onBlur: M
  } = vr({ name: e, defaultValue: l, autoFocus: s, shouldUnregister: p, validateOnMount: g }), y = N ? "error" : b;
  return /* @__PURE__ */ c(ji, { label: n, className: o, state: y, hint: N ? m : r, children: /* @__PURE__ */ c(
    zi,
    {
      ref: v,
      value: w,
      id: t,
      name: e,
      type: d,
      className: i,
      disabled: a,
      autoFocus: s,
      placeholder: u,
      suffix: f,
      prefix: h,
      state: y,
      onChange: C,
      onBlur: M
    }
  ) });
}
function n7({
  name: e,
  id: t = e,
  label: n,
  className: r,
  disabled: i,
  value: o,
  defaultChecked: a,
  labelClassName: s,
  orientation: l
}) {
  const { ref: u, value: d = !1, onChange: f, onBlur: h } = vr({ name: e });
  return /* @__PURE__ */ c(
    Xu,
    {
      ref: u,
      name: e,
      checked: d,
      id: t,
      label: n,
      className: r,
      disabled: i,
      value: o,
      defaultChecked: a,
      labelClassName: s,
      orientation: l,
      inputProps: { onChange: f, onBlur: h }
    }
  );
}
function r7({
  name: e,
  id: t = e,
  label: n,
  className: r,
  disabled: i,
  value: o,
  defaultChecked: a,
  labelClassName: s,
  orientation: l
}) {
  const {
    ref: u,
    value: d,
    onChange: f,
    onBlur: h
  } = vr({ name: e, disabled: i, defaultValue: a ? o : void 0 });
  return /* @__PURE__ */ c(
    Yu,
    {
      ref: u,
      name: e,
      id: t,
      label: n,
      className: r,
      disabled: i,
      checked: d === o,
      value: o,
      labelClassName: s,
      orientation: l,
      inputProps: { onChange: f, onBlur: h }
    }
  );
}
function i7({
  open: e,
  defaultOpen: t,
  options: n,
  optionClassName: r,
  popoverClassName: i,
  name: o,
  id: a = o,
  label: s,
  hint: l,
  className: u,
  controlClassName: d,
  disabled: f,
  autoFocus: h,
  defaultValue: p,
  placeholder: b,
  shouldUnregister: g,
  state: v,
  validateOnMount: w,
  onOpen: m,
  onClose: N,
  renderSelectedOption: C
}) {
  const {
    ref: M,
    value: y = "",
    error: L,
    invalid: T,
    onChange: S,
    onBlur: R
  } = vr({ name: o, defaultValue: p, autoFocus: h, shouldUnregister: g, validateOnMount: w }), V = T ? "error" : v;
  return /* @__PURE__ */ c(ji, { label: s, className: d, state: V, hint: T ? L : l, children: /* @__PURE__ */ c(
    wa,
    {
      open: e,
      defaultOpen: t,
      options: n,
      ref: M,
      value: y,
      id: a,
      name: o,
      className: u,
      disabled: f,
      placeholder: b,
      state: V,
      optionClassName: r,
      popoverClassName: i,
      onSelect: S,
      onBlur: R,
      onOpen: m,
      onClose: () => {
        R == null || R(), N == null || N();
      },
      renderSelectedOption: C
    }
  ) });
}
function s4({ displayError: e = !1, ...t }) {
  const { error: n, value: r, onChange: i, onBlur: o, disabled: a, name: s, ref: l } = vr(t), u = /* @__PURE__ */ c("input", { ref: l, type: "hidden", name: s, disabled: a, value: r, onChange: i, onBlur: o });
  return e ? /* @__PURE__ */ c(ji, { hint: e ? n : "", state: e ? "error" : "default", children: u }) : u;
}
const l4 = ({
  attributes: e,
  providerItemProps: t,
  isSelected: n = !1,
  isSelectable: r = !0,
  onSelect: i,
  actionLabel: o = "Select",
  selectedLabel: a = "Selected"
}) => /* @__PURE__ */ x("div", { className: "bg-secondary-highlight h-[316px] overflow-hidden p-4 flex flex-col rounded justify-between", children: [
  /* @__PURE__ */ c(au, { ...t }),
  /* @__PURE__ */ c("div", { className: "w-full h-px bg-secondary-strokeLight" }),
  Object.entries(e).map(([s, l]) => /* @__PURE__ */ x(
    "div",
    {
      className: "text-sm flex flex-row justify-between first:mt-0 mt-1",
      children: [
        /* @__PURE__ */ c("div", { className: "text-accent-secondary", children: s }),
        /* @__PURE__ */ c("div", { className: "text-accent-primary font-medium", children: l })
      ]
    },
    s
  )),
  i && /* @__PURE__ */ c(
    ze,
    {
      className: "mt-4",
      onClick: i,
      disabled: !r,
      variant: n ? "contained" : "outlined",
      children: n ? a : o
    }
  )
] }), Ga = 8, c4 = 5, Xi = 640, u4 = 500;
function d4({ className: e, ...t }) {
  const n = Gt(Xi);
  return /* @__PURE__ */ c(
    n ? yn : Zr,
    {
      ...t,
      ...n ? {} : { dialogClassName: "h-[90vh] min-h-[400px] max-h-[720px] flex flex-col" },
      className: ee("w-[41.25rem] max-w-full", e)
    }
  );
}
const o7 = ({
  open: e,
  validators: t,
  columns: n,
  onClose: r,
  onSelect: i,
  title: o = "",
  description: a,
  confirmSelection: s = !1,
  onBack: l,
  onAdd: u,
  layout: d,
  defaultLayout: f = "list",
  onLayoutChange: h,
  isRowSelectable: p,
  gridItemMapper: b,
  filters: g
}) => {
  const [v, w] = ie(""), [m, N] = ie(null), [C, M] = zt({
    value: d,
    defaultValue: f,
    onStateChange: h
  });
  te(() => {
    e && (N(null), w(""));
  }, [e]);
  const L = /* @__PURE__ */ c(
    f4,
    {
      searchTerm: v,
      onClearSearch: () => {
        w("");
      },
      onSearchChange: w,
      filters: g,
      gridItemMapper: b,
      currentLayout: C ?? "list",
      onToggleLayout: () => M(C === "grid" ? "list" : "grid")
    }
  ), T = de(() => v.trim() ? t.filter(
    (R) => R.name.toLowerCase().includes(v.toLowerCase())
  ) : t, [t, v]), S = de(
    () => T.find((R) => R.id === m) || null,
    [T, m]
  );
  return /* @__PURE__ */ x(d4, { open: e, onClose: r, className: "w-[52rem]", children: [
    /* @__PURE__ */ c(Xr, { title: o, onClose: r, className: "text-accent-primary" }),
    a && /* @__PURE__ */ c("div", { className: "mt-4", children: /* @__PURE__ */ c(Q, { className: "text-accent-secondary", children: a }) }),
    L,
    /* @__PURE__ */ x(ur, { className: "mt-4 flex flex-col", style: { overflowY: "hidden" }, children: [
      /* @__PURE__ */ c(
        h4,
        {
          rows: T,
          currentLayout: C ?? "list",
          gridItemMapper: b,
          isRowSelectable: p,
          selectedId: m,
          onSelectRowId: N,
          confirmSelection: s,
          onSelect: i,
          onClose: r
        }
      ),
      /* @__PURE__ */ c(
        p4,
        {
          rows: T,
          currentLayout: C ?? "list",
          gridItemMapper: b,
          columns: n,
          selectedId: m,
          onSelectRowId: N,
          confirmSelection: s,
          onSelect: i,
          onClose: r,
          isRowSelectable: p
        }
      )
    ] }),
    /* @__PURE__ */ c(
      m4,
      {
        confirmSelection: s,
        onBack: l,
        selectedRow: S,
        onAdd: u,
        onClose: r,
        clearSelection: () => N(null)
      }
    )
  ] });
}, f4 = Ri(({
  searchTerm: e,
  onClearSearch: t,
  onSearchChange: n,
  filters: r,
  gridItemMapper: i,
  currentLayout: o,
  onToggleLayout: a
}) => /* @__PURE__ */ x("div", { className: "mt-4 flex flex-col md:flex-row gap-4", children: [
  /* @__PURE__ */ c("div", { className: "flex-1", children: /* @__PURE__ */ c(
    zi,
    {
      placeholder: "Search",
      wrapperClassName: "h-full",
      id: "validator-selector-search",
      value: e,
      onChange: (l) => n(l.target.value),
      prefix: e ? /* @__PURE__ */ c(
        "button",
        {
          onClick: t,
          className: "opacity-60 hover:opacity-100 transition-opacity",
          children: /* @__PURE__ */ c(n6, { size: 18, className: "text-secondary-strokeDark" })
        }
      ) : /* @__PURE__ */ c("span", { className: "text-secondary-strokeDark", children: /* @__PURE__ */ c(s0, { size: 20 }) }),
      className: "w-full"
    }
  ) }),
  r != null && r.slot ? /* @__PURE__ */ c("div", { className: "w-full md:w-[200px]", children: r.slot }) : r != null && r.options && r.options.length > 0 ? /* @__PURE__ */ c("div", { className: "w-full md:w-[200px]", children: /* @__PURE__ */ c(
    wa,
    {
      options: r.options,
      onSelect: (l) => {
        var u;
        return (u = r == null ? void 0 : r.onSelect) == null ? void 0 : u.call(r, l);
      },
      placeholder: r.placeholder ?? "Select Status",
      value: e ? "" : r.value,
      disabled: !!e || r.disabled,
      renderSelectedOption: r.renderSelectedOption,
      className: ee("h-10", r.className)
    }
  ) }) : null,
  i ? /* @__PURE__ */ c("div", { className: "flex items-center gap-2 text-secondary-strokeDark/50", children: /* @__PURE__ */ c(sa, { onClick: a, children: /* @__PURE__ */ c("div", { className: "text-accent-primary", children: o === "grid" ? /* @__PURE__ */ c(e6, { size: 24 }) : /* @__PURE__ */ c(y6, { size: 20 }) }) }) }) : null
] })), h4 = Ri(({ rows: e, currentLayout: t, gridItemMapper: n, isRowSelectable: r, selectedId: i, onSelectRowId: o, confirmSelection: a, onSelect: s, onClose: l }) => t === "grid" && n ? /* @__PURE__ */ c("div", { className: "grid grid-cols-2 gap-4 w-full flex-1 min-h-0 overflow-auto", children: e.map((u, d) => {
  const f = n(u, d), h = r ? r(u) : !0;
  return /* @__PURE__ */ c(
    l4,
    {
      providerItemProps: f.providerItemProps,
      attributes: f.attributes,
      isSelected: i === u.id,
      isSelectable: h,
      actionLabel: a ? void 0 : "Add",
      onSelect: () => {
        h && (a ? o(u.id) : (s(u), l()));
      }
    },
    u.id
  );
}) }) : null), p4 = Ri(({ rows: e, currentLayout: t, gridItemMapper: n, columns: r, selectedId: i, onSelectRowId: o, confirmSelection: a, onSelect: s, onClose: l, isRowSelectable: u }) => t === "grid" && n ? null : /* @__PURE__ */ c(
  ef,
  {
    data: e,
    columns: r,
    className: "w-full",
    wrapperClassName: "w-full flex-1 min-h-0 overflow-auto",
    fluid: !0,
    selectedRow: i ?? void 0,
    onSelectedRowChange: (d) => o(d),
    onRowSelect: (d) => {
      if (!d) {
        o(null);
        return;
      }
      a ? o(d.id) : (s(d), l());
    },
    isRowSelectable: u
  }
)), m4 = Ri(({ confirmSelection: e, onBack: t, selectedRow: n, onAdd: r, onClose: i, clearSelection: o }) => e ? /* @__PURE__ */ x(dr, { className: "flex mt-4 justify-between", children: [
  t ? /* @__PURE__ */ c(ze, { variant: "outlined", onClick: t, children: "Back" }) : /* @__PURE__ */ c("div", {}),
  /* @__PURE__ */ c(
    ze,
    {
      variant: "contained",
      onClick: () => {
        n && r && (r(n), o(), i());
      },
      disabled: !n,
      children: "Add"
    }
  )
] }) : null), a7 = ({
  fieldName: e,
  currencyIcon: t,
  currencyName: n,
  displayBalance: r,
  placeholder: i = "Enter Amount",
  balanceDetails: o,
  prefix: a,
  autoFocus: s = !0,
  decimals: l,
  enableMaxButton: u
}) => {
  const d = vu({ name: e, defaultValue: "" }), { setValue: f } = gr(), h = parseFloat(d || "0"), p = eu(h, (o == null ? void 0 : o.price) ?? 0, {
    zeroDisplay: "$0.00"
  }), b = (w) => {
    const m = w.target.value;
    f(e, m, {
      shouldValidate: !0,
      shouldDirty: !0,
      shouldTouch: !0
    });
  }, g = () => {
    if ((o == null ? void 0 : o.balance) !== void 0) {
      const w = Number(o.balance), m = o.decimals !== void 0 ? Dl(w, o.decimals).toString() : w.toString();
      f(e, m, {
        shouldValidate: !0,
        shouldDirty: !0,
        shouldTouch: !0
      });
    }
  };
  let v;
  return o && (v = `${Dl(Number(o.balance), o.decimals ?? Ga)} ${o.symbol}`, a && (v = `${a}: ${v}`)), /* @__PURE__ */ x(He, { children: [
    /* @__PURE__ */ c(s4, { name: e, defaultValue: "" }),
    /* @__PURE__ */ c(wn, { className: "flex w-full flex-col content-center justify-between gap-4", children: /* @__PURE__ */ c(
      ja,
      {
        amount: d,
        currencyIcon: t,
        currencyName: n,
        placeholder: i,
        displayBalance: r,
        balanceDetails: o,
        autoFocus: s,
        onChange: b,
        amountUsd: p,
        subtitle: v,
        maxDecimals: l,
        ...u && { onMaxClick: g }
      }
    ) })
  ] });
};
function g4({ items: e, onRemove: t, showChain: n = !0 }) {
  const r = de(() => e, [e]);
  return r.length === 0 ? null : /* @__PURE__ */ c("div", { className: "flex flex-col gap-8", children: r.map(({ bsnId: i, bsnName: o, bsnLogoUrl: a, provider: s }) => /* @__PURE__ */ c(
    au,
    {
      bsnId: i,
      bsnName: o,
      bsnLogoUrl: a,
      provider: s,
      onRemove: t,
      showChain: n
    },
    `${i}-${s.rank}`
  )) });
}
function s7({ max: e, items: t = [], actionText: n, onAdd: r, onRemove: i, showChain: o = !0 }) {
  const a = de(() => t.length, [t]);
  return /* @__PURE__ */ c(wn, { children: /* @__PURE__ */ x("div", { className: "flex w-full flex-col gap-4", children: [
    /* @__PURE__ */ c("div", { className: "flex flex-row", children: /* @__PURE__ */ x("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
      /* @__PURE__ */ c("span", { className: "text-sm sm:text-base", children: n }),
      /* @__PURE__ */ c(D5, { counter: a, max: e, onAdd: r })
    ] }) }),
    a > 0 && /* @__PURE__ */ c(g4, { items: t, onRemove: i, showChain: o })
  ] }) });
}
function Fr({ title: e, children: t, className: n, hint: r }) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: ee(
        "flex flex-row items-center justify-between text-accent-primary",
        r && "items-start",
        n
      ),
      children: [
        /* @__PURE__ */ c(Q, { as: "div", variant: "body1", children: e }),
        r ? /* @__PURE__ */ x("div", { className: "flex flex-col items-end", children: [
          /* @__PURE__ */ c(Q, { as: "div", className: "flex items-center gap-2", children: t }),
          /* @__PURE__ */ c(Q, { as: "div", variant: "body2", className: "text-accent-secondary", children: r })
        ] }) : /* @__PURE__ */ c(Q, { as: "div", className: "flex items-center gap-2", children: t })
      ]
    }
  );
}
function v4({ value: e, onEdit: t, title: n = "Network Fee Rate", className: r }) {
  return /* @__PURE__ */ x(Fr, { title: n, className: r, children: [
    /* @__PURE__ */ x("span", { children: [
      e,
      " sats/vB"
    ] }),
    t && /* @__PURE__ */ c(ze, { size: "small", variant: "outlined", className: "h-6 w-6 pl-1 text-secondary-strokeDark", onClick: t, children: /* @__PURE__ */ c(H6, { size: 16, className: "text-secondary-strokeDark" }) })
  ] });
}
function b4({ amount: e, coinSymbol: t, hint: n, title: r, className: i, decimals: o = Ga }) {
  let a;
  return typeof e == "number" ? e === 0 ? a = "0" : a = e.toFixed(o).replace(/\.?0+$/, "") : a = e, /* @__PURE__ */ x(Fr, { title: r ?? `${t} Network Fee`, hint: n, className: i, children: [
    a,
    " ",
    t
  ] });
}
function y4({ amount: e, coinSymbol: t, hint: n, title: r, className: i, decimals: o = c4 }) {
  const a = typeof e == "number" ? e.toFixed(o) : e;
  return /* @__PURE__ */ x(Fr, { title: r ?? `${t} Network Fee`, hint: n, className: i, children: [
    a,
    " ",
    t
  ] });
}
function x4({ total: e, coinSymbol: t, hint: n, title: r = "Total", className: i, decimals: o = Ga }) {
  let a;
  return typeof e == "number" ? e === 0 ? a = "0" : a = e.toFixed(o).replace(/\.?0+$/, "") : a = e, /* @__PURE__ */ x("div", { className: ee("flex flex-row items-start justify-between text-accent-primary", i), children: [
    /* @__PURE__ */ c(Q, { variant: "body1", className: "font-bold", children: r }),
    /* @__PURE__ */ x("div", { className: "flex flex-col items-end justify-center", children: [
      /* @__PURE__ */ x(Q, { variant: "body1", className: "font-bold", children: [
        a,
        " ",
        t
      ] }),
      n && /* @__PURE__ */ c(Q, { variant: "body1", className: "text-sm text-accent-secondary", children: n })
    ] })
  ] });
}
function l7({
  className: e,
  feeRate: t,
  onFeeRateEdit: n,
  feeAmount: r,
  coinSymbol: i,
  feeAmountHint: o,
  total: a,
  totalHint: s,
  bbnFeeAmount: l,
  bbnCoinSymbol: u,
  bbnFeeAmountHint: d,
  bbnFeeDecimals: f
}) {
  return /* @__PURE__ */ c(wn, { className: ee("flex w-full flex-col content-center justify-between gap-4", e), children: /* @__PURE__ */ x("div", { className: "flex flex-col gap-6", children: [
    t !== void 0 && /* @__PURE__ */ c(v4, { value: t, onEdit: n }),
    r !== void 0 && i !== void 0 && /* @__PURE__ */ c(b4, { amount: r, coinSymbol: i, hint: o }),
    l !== void 0 && u ? /* @__PURE__ */ c(
      y4,
      {
        amount: l,
        coinSymbol: u,
        hint: d,
        decimals: f
      }
    ) : null,
    a !== void 0 && i !== void 0 && /* @__PURE__ */ c("div", { className: "divider my-1" }),
    a !== void 0 && i !== void 0 && /* @__PURE__ */ c(x4, { total: a, coinSymbol: i, hint: s })
  ] }) });
}
const C4 = ({
  data: e,
  headers: t,
  className: n
}) => {
  const r = Xt(), i = {
    gridTemplateColumns: `repeat(${t.length}, minmax(0, 1fr))`
  };
  return /* @__PURE__ */ c(wn, { className: H("bbn-simple-table-section", n), children: /* @__PURE__ */ x("div", { className: "bbn-simple-table", children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: "bbn-simple-table-header",
        style: i,
        children: t.map((o, a) => /* @__PURE__ */ c(Q, { variant: "caption", className: "bbn-simple-table-header-cell", children: o }, `${r}-header-${o}-${a}`))
      }
    ),
    /* @__PURE__ */ c("div", { className: "bbn-simple-table-body", children: e.map((o, a) => /* @__PURE__ */ c(
      "div",
      {
        className: "bbn-simple-table-row",
        style: i,
        children: t.map((s, l) => /* @__PURE__ */ c(
          "div",
          {
            className: "bbn-simple-table-cell",
            children: o[l]
          },
          `${r}-cell-${a}-${l}`
        ))
      },
      `${r}-row-${a}`
    )) })
  ] }) });
};
function w4({ className: e, ...t }) {
  const r = Gt(Xi) ? yn : Zr;
  return /* @__PURE__ */ c(r, { ...t, className: ee("w-[41.25rem] max-w-full", e) });
}
const c7 = ({
  open: e,
  processing: t = !1,
  onClose: n,
  onProceed: r,
  bsns: i,
  finalityProviders: o,
  details: a,
  visibleFields: s,
  warnings: l,
  proceedLabel: u = "Proceed to Signing"
}) => {
  const d = [
    { label: "Stake Amount", value: a.stakeAmount },
    { label: "Fee Rate", value: a.feeRate },
    { label: "Transaction Fees", value: a.transactionFees },
    {
      label: "Term",
      value: /* @__PURE__ */ x(He, { children: [
        a.term.blocks,
        /* @__PURE__ */ c("br", {}),
        /* @__PURE__ */ c("span", { className: "text-md text-secondary", children: a.term.duration })
      ] })
    },
    { label: "Unbonding", value: a.unbonding },
    { label: "Unbonding Fee", value: a.unbondingFee }
  ], f = s && s.length > 0 ? d.filter((b) => s.includes(b.label)) : d, p = !o || o.length === 0 ? [
    ["Validator"],
    ...i.map((b, g) => [
      /* @__PURE__ */ x(
        "div",
        {
          className: "flex w-full items-center gap-2 py-1",
          children: [
            b.icon,
            /* @__PURE__ */ c(Q, { variant: "body2", className: "font-medium", children: b.name })
          ]
        },
        `validator-${g}`
      )
    ])
  ] : [
    ["BSNs", "Finality Provider"],
    ...i.map((b, g) => {
      const v = o[g];
      return [
        /* @__PURE__ */ x(
          "div",
          {
            className: "flex w-full items-center gap-2 py-1",
            children: [
              b.icon,
              /* @__PURE__ */ c(Q, { variant: "body2", className: "font-medium", children: b.name })
            ]
          },
          `bsn-${g}`
        ),
        v ? /* @__PURE__ */ x(
          "div",
          {
            className: "flex w-full items-center gap-2 py-1",
            children: [
              v.icon,
              /* @__PURE__ */ c(Q, { variant: "body2", className: "font-medium", children: v.name })
            ]
          },
          `fp-${g}`
        ) : /* @__PURE__ */ c("div", {}, `fp-${g}`)
      ];
    })
  ];
  return /* @__PURE__ */ x(w4, { open: e, onClose: n, children: [
    /* @__PURE__ */ c(Xr, { title: "Preview", onClose: n, className: "text-accent-primary" }),
    /* @__PURE__ */ x(ur, { className: "no-scrollbar mb-8 mt-4 flex max-h-[calc(100vh-12rem)] flex-col gap-4 overflow-y-auto text-accent-primary", children: [
      /* @__PURE__ */ c(C4, { headers: p[0], data: p.slice(1) }),
      /* @__PURE__ */ c("div", { className: "flex flex-col", children: f.map((b, g) => /* @__PURE__ */ x("div", { className: "flex flex-row items-center justify-between py-3", children: [
        /* @__PURE__ */ c(Q, { variant: "body1", className: "text-secondary font-normal", children: b.label }),
        /* @__PURE__ */ c(Q, { variant: "body1", className: "text-right font-normal", children: b.value })
      ] }, g)) }),
      /* @__PURE__ */ c("div", { className: "border-divider w-full border-t" }),
      /* @__PURE__ */ x("div", { className: "pt-2", children: [
        /* @__PURE__ */ c(qr, { variant: "h6", className: "text-primary mb-2", children: "Attention!" }),
        l.map((b, g) => /* @__PURE__ */ c(Q, { variant: "body2", className: "text-secondary", children: b }, g))
      ] })
    ] }),
    /* @__PURE__ */ x(dr, { className: "flex flex-col gap-4 pb-8 pt-0 sm:flex-row", children: [
      /* @__PURE__ */ c(ze, { variant: "contained", color: "primary", onClick: r, className: "w-full sm:flex-1 sm:order-2", disabled: t, children: t ? "Processing..." : u }),
      /* @__PURE__ */ c(ze, { variant: "outlined", color: "primary", onClick: n, className: "w-full sm:flex-1 sm:order-1", children: "Cancel" })
    ] })
  ] });
};
function N4({
  actions: e
}) {
  return /* @__PURE__ */ c("div", { className: "mt-4 sm:mt-6 flex gap-2", children: e.map((t, n) => /* @__PURE__ */ c(
    ze,
    {
      variant: t.variant || "outlined",
      className: `sm:bbn-btn-medium flex-1 ${t.className || ""}`,
      onClick: t.onClick,
      fluid: !0,
      children: t.label
    },
    `${t.label}-${n}`
  )) });
}
function _4({
  formattedAmount: e,
  icon: t,
  iconAlt: n,
  chainName: r,
  chainIcon: i,
  chainIconAlt: o
}) {
  return /* @__PURE__ */ x("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
      t && (typeof t == "string" ? /* @__PURE__ */ c(
        "img",
        {
          src: t,
          alt: n || "icon",
          className: "w-6 h-6 sm:w-8 sm:h-8"
        }
      ) : t),
      /* @__PURE__ */ c("span", { className: "text-base sm:text-lg font-medium text-accent-primary", children: e })
    ] }),
    r && /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ c("span", { className: "text-base sm:text-lg font-medium text-accent-primary", children: r }),
      i && (typeof i == "string" ? /* @__PURE__ */ c(
        "img",
        {
          src: i,
          alt: o || "chain icon",
          className: "w-6 h-6 sm:w-8 sm:h-8"
        }
      ) : i)
    ] })
  ] });
}
function M4({ item: e, className: t }) {
  return /* @__PURE__ */ x("div", { className: ee("flex items-center gap-2 min-w-0", t), children: [
    /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-primary font-medium truncate flex items-center", children: e.name }),
    e.icon && /* @__PURE__ */ c("div", { className: "flex items-center w-4 h-4 flex-shrink-0 justify-center text-xs sm:text-sm", children: typeof e.icon == "string" ? /* @__PURE__ */ c(
      "img",
      {
        src: e.icon,
        alt: e.iconAlt || e.name,
        className: "w-full h-full rounded-full object-cover"
      }
    ) : e.icon })
  ] });
}
function ia({ label: e, value: t, collapsible: n = !1, nestedDetails: r }) {
  const [i, o] = ie(!1), a = () => {
    o(!i);
  };
  return n ? /* @__PURE__ */ x("div", { className: "space-y-3", children: [
    /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-2 min-w-0 overflow-x-auto", children: [
      /* @__PURE__ */ x("div", { className: "flex items-center gap-2 flex-shrink-0", children: [
        /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-secondary", children: e }),
        /* @__PURE__ */ c(
          "button",
          {
            onClick: a,
            className: "w-5 h-5 flex-shrink-0 hover:opacity-70 transition-opacity",
            "aria-label": i ? "Collapse" : "Expand",
            children: i ? /* @__PURE__ */ c(c0, { size: 20, variant: "secondary" }) : /* @__PURE__ */ c(u0, { size: 20, variant: "secondary" })
          }
        )
      ] }),
      /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-primary font-medium text-right min-w-0 overflow-x-auto whitespace-nowrap", children: t })
    ] }),
    i && r && /* @__PURE__ */ c("div", { className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto", children: r.map((s, l) => /* @__PURE__ */ c(
      ia,
      {
        label: s.label,
        value: s.value,
        collapsible: s.collapsible,
        nestedDetails: s.nestedDetails
      },
      l
    )) })
  ] }) : /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-2 min-w-0 overflow-x-auto", children: [
    /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-secondary flex-shrink-0", children: e }),
    /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-primary font-medium text-right min-w-0 overflow-x-auto whitespace-nowrap", children: t })
  ] });
}
function L4({
  details: e,
  optionalDetails: t,
  listItems: n
}) {
  const r = t && t.length > 0, i = n && n.length > 0;
  return /* @__PURE__ */ x("div", { className: "space-y-3 sm:space-y-4 overflow-x-auto", children: [
    /* @__PURE__ */ c("div", { className: "space-y-4 sm:space-y-6", children: e.map((o, a) => /* @__PURE__ */ c(
      ia,
      {
        label: o.label,
        value: o.value,
        collapsible: o.collapsible,
        nestedDetails: o.nestedDetails
      },
      a
    )) }),
    i && /* @__PURE__ */ c("div", { className: "space-y-3 sm:space-y-4", children: n.map((o, a) => /* @__PURE__ */ c(
      "div",
      {
        className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto",
        children: /* @__PURE__ */ x("div", { className: "flex justify-between items-start gap-2", children: [
          /* @__PURE__ */ c("span", { className: "text-xs sm:text-sm text-accent-secondary", children: o.label }),
          /* @__PURE__ */ c("div", { className: "flex flex-wrap gap-2", children: o.items.map((s, l) => /* @__PURE__ */ c(M4, { item: s }, s.id || l)) })
        ] })
      },
      a
    )) }),
    r && /* @__PURE__ */ c("div", { className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto", children: t.map((o, a) => /* @__PURE__ */ c(
      ia,
      {
        label: o.label,
        value: o.value,
        collapsible: o.collapsible,
        nestedDetails: o.nestedDetails
      },
      a
    )) })
  ] });
}
function u7({ data: e, className: t }) {
  return /* @__PURE__ */ x(
    "div",
    {
      className: `w-full bg-secondary-highlight p-3 sm:p-4 rounded flex flex-col justify-between ${t || ""}`,
      children: [
        /* @__PURE__ */ x("div", { className: "space-y-3 sm:space-y-4", children: [
          /* @__PURE__ */ c(
            _4,
            {
              formattedAmount: e.formattedAmount,
              icon: e.icon,
              iconAlt: e.iconAlt,
              chainName: e.chainName,
              chainIcon: e.chainIcon,
              chainIconAlt: e.chainIconAlt
            }
          ),
          /* @__PURE__ */ c(
            L4,
            {
              details: e.details,
              optionalDetails: e.optionalDetails,
              listItems: e.listItems
            }
          ),
          e.secondaryActions && e.secondaryActions.length > 0 && /* @__PURE__ */ c(N4, { actions: e.secondaryActions })
        ] }),
        e.primaryAction && /* @__PURE__ */ c(
          ze,
          {
            variant: "outlined",
            className: `mt-4 ${e.primaryAction.className || ""}`,
            onClick: e.primaryAction.onClick,
            fluid: e.primaryAction.fullWidth !== !1,
            children: e.primaryAction.label
          }
        )
      ]
    }
  );
}
function A4({ className: e, ...t }) {
  const r = Gt(Xi) ? yn : Zr;
  return /* @__PURE__ */ c(r, { ...t, className: ee("w-[41.25rem] max-w-full", e) });
}
const d7 = ({
  open: e,
  processing: t = !1,
  title: n,
  onClose: r,
  onProceed: i,
  tokens: o,
  transactionFees: a
}) => /* @__PURE__ */ x(A4, { open: e, onClose: r, children: [
  /* @__PURE__ */ c(Xr, { title: n, className: "text-accent-primary" }),
  /* @__PURE__ */ c(ur, { className: "no-scrollbar mb-[40px] mt-8 flex max-h-[calc(100vh-12rem)] flex-col overflow-y-auto text-accent-primary", children: /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ c("div", { className: "max-h-[300px] overflow-y-auto", children: o.map((s, l) => {
      var u, d;
      return /* @__PURE__ */ x("div", { children: [
        /* @__PURE__ */ c(Fr, { title: s.name, hint: (u = s.amount) == null ? void 0 : u.usd, children: /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
          s.icon,
          (d = s.amount) == null ? void 0 : d.token
        ] }) }),
        l < o.length - 1 && /* @__PURE__ */ c("div", { className: "h-4" })
      ] }, `token-${l}`);
    }) }),
    a.token && (isNaN(parseFloat(a.token)) || parseFloat(a.token) > 0) && /* @__PURE__ */ x(He, { children: [
      /* @__PURE__ */ c("div", { className: "py-6", children: /* @__PURE__ */ c("div", { className: "border-divider w-full border-t" }) }),
      /* @__PURE__ */ c(Fr, { title: "Transaction Fees", hint: a.usd, children: a.token })
    ] })
  ] }) }),
  /* @__PURE__ */ x(dr, { className: "flex flex-col gap-4 pt-0 sm:flex-row", children: [
    /* @__PURE__ */ c(
      ze,
      {
        variant: "contained",
        color: "primary",
        onClick: i,
        className: "w-full sm:order-2 sm:flex-1",
        disabled: t,
        children: t ? "Processing..." : "Proceed"
      }
    ),
    /* @__PURE__ */ c(ze, { variant: "outlined", color: "primary", onClick: r, className: "w-full sm:order-1 sm:flex-1", children: "Cancel" })
  ] })
] }), f7 = ({ rewards: e, onClick: t, disabled: n }) => /* @__PURE__ */ x(wn, { className: "flex w-full flex-col content-center justify-between gap-4", children: [
  e.map((r, i) => {
    var s;
    const o = Number.parseFloat(String(r.amount)), a = eu(
      o,
      ((s = r.balanceDetails) == null ? void 0 : s.price) ?? 0,
      { zeroDisplay: "$0.00" }
    );
    return /* @__PURE__ */ c(
      ja,
      {
        amount: r.amount,
        currencyIcon: r.currencyIcon,
        currencyName: r.currencyName,
        placeholder: r.placeholder ?? "Enter Amount",
        displayBalance: r.displayBalance,
        balanceDetails: r.balanceDetails,
        autoFocus: !1,
        onChange: () => {
        },
        onKeyDown: () => {
        },
        amountUsd: a,
        disabled: !0,
        subtitle: r.chainName
      },
      i
    );
  }),
  /* @__PURE__ */ c(ze, { onClick: t, disabled: n, children: "Claim" })
] }), h7 = ({
  totalAmount: e,
  totalSymbol: t,
  btcRewardAmount: n,
  btcSymbol: r,
  babyRewardAmount: i,
  babySymbol: o,
  coStakingAmount: a,
  avatarUrl: s,
  onClaim: l,
  onStakeMore: u,
  claimDisabled: d,
  stakeMoreCta: f
}) => /* @__PURE__ */ x("div", { className: "bbn-co-staking-rewards", children: [
  /* @__PURE__ */ x("div", { className: "bbn-co-staking-rewards-header", children: [
    s && /* @__PURE__ */ c(on, { url: s, size: "large", alt: t }),
    e,
    " ",
    t
  ] }),
  /* @__PURE__ */ x("div", { className: "bbn-co-staking-rewards-items", children: [
    /* @__PURE__ */ c(
      So,
      {
        title: `${r} staking`,
        amount: n,
        symbol: t,
        caption: `Rewards earned by staking ${r}`
      }
    ),
    /* @__PURE__ */ c(
      So,
      {
        title: `${o} staking`,
        amount: i,
        symbol: t,
        caption: `Rewards earned from staking ${o}`
      }
    ),
    a && /* @__PURE__ */ c(
      So,
      {
        title: "Co-staking",
        amount: a,
        symbol: t,
        caption: `Bonus rewards for staking both ${r} and ${o} together`
      }
    )
  ] }),
  /* @__PURE__ */ x("div", { className: "bbn-co-staking-rewards-actions", children: [
    /* @__PURE__ */ c(
      ze,
      {
        fluid: !0,
        size: "medium",
        variant: u ? "outlined" : "contained",
        onClick: l,
        disabled: d,
        children: "Claim Rewards"
      }
    ),
    u && /* @__PURE__ */ c(ze, { fluid: !0, size: "medium", onClick: u, children: f })
  ] })
] }), E4 = ({ size: e = "md" }) => /* @__PURE__ */ c("div", { className: {
  sm: "mt-2",
  md: "mt-4",
  lg: "mt-6"
}[e] }), S4 = () => /* @__PURE__ */ c("svg", { width: "29", height: "28", viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c(
  "path",
  {
    d: "M24.9127 15.3708C24.9711 14.9333 25.0002 14.4812 25.0002 14C25.0002 13.5333 24.9711 13.0667 24.8982 12.6292L27.8586 10.325C28.1211 10.1208 28.194 9.72708 28.0336 9.43542L25.2336 4.59375C25.0586 4.27292 24.694 4.17083 24.3732 4.27292L20.8877 5.67292C20.1586 5.11875 19.3857 4.65208 18.5252 4.30208L18.0002 0.597916C17.9419 0.247916 17.6502 0 17.3002 0H11.7002C11.3502 0 11.0732 0.247916 11.0148 0.597916L10.4898 4.30208C9.62941 4.65208 8.84191 5.13333 8.12732 5.67292L4.64191 4.27292C4.32107 4.15625 3.95649 4.27292 3.78149 4.59375L0.996075 9.43542C0.821075 9.74167 0.879408 10.1208 1.17107 10.325L4.13149 12.6292C4.05857 13.0667 4.00024 13.5479 4.00024 14C4.00024 14.4521 4.02941 14.9333 4.10232 15.3708L1.14191 17.675C0.879408 17.8792 0.806491 18.2729 0.966908 18.5646L3.76691 23.4062C3.94191 23.7271 4.30649 23.8292 4.62732 23.7271L8.11274 22.3271C8.84191 22.8812 9.61482 23.3479 10.4752 23.6979L11.0002 27.4021C11.0732 27.7521 11.3502 28 11.7002 28H17.3002C17.6502 28 17.9419 27.7521 17.9857 27.4021L18.5107 23.6979C19.3711 23.3479 20.1586 22.8812 20.8732 22.3271L24.3586 23.7271C24.6794 23.8438 25.044 23.7271 25.219 23.4062L28.019 18.5646C28.194 18.2437 28.1211 17.8792 27.844 17.675L24.9127 15.3708ZM14.5002 19.25C11.6127 19.25 9.25024 16.8875 9.25024 14C9.25024 11.1125 11.6127 8.75 14.5002 8.75C17.3877 8.75 19.7502 11.1125 19.7502 14C19.7502 16.8875 17.3877 19.25 14.5002 19.25Z",
    fill: "currentColor"
  }
) }), Lu = () => /* @__PURE__ */ c("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }), k4 = ({ children: e, className: t = "" }) => /* @__PURE__ */ c(Q, { variant: "body1", className: H("px-7 pb-6 text-accent-primary md:hidden", t), children: e }), O4 = ({
  background: e = "none",
  backgroundClassName: t = "",
  className: n = "",
  children: r
}) => /* @__PURE__ */ c("div", { className: H((() => {
  switch (e) {
    case "secondary":
      return "mx-[21px] rounded-lg bg-secondary-highlight md:mx-0 md:bg-transparent";
    case "custom":
      return t;
    default:
      return "";
  }
})(), n), children: r }), zr = ({ children: e }) => /* @__PURE__ */ c(He, { children: e }), Au = ({
  icon: e,
  suffix: t,
  onClick: n,
  disabled: r = !1,
  selected: i = !1,
  className: o = "",
  toggle: a,
  children: s
}) => {
  const l = ae.Children.toArray(s), u = l.find(
    (p) => typeof p == "string" || ae.isValidElement(p) && p.type !== zr
  ), d = l.find(
    (p) => ae.isValidElement(p) && p.type === zr
  ), f = typeof u == "string" ? u : "", h = n && !a ? /* @__PURE__ */ c(Lu, {}) : void 0;
  return /* @__PURE__ */ c(
    X1,
    {
      icon: e,
      name: f,
      description: d ? d.props.children : void 0,
      onClick: n,
      disabled: r,
      selected: i,
      className: o,
      suffix: t || h,
      toggle: a
    }
  );
}, T4 = ({ icon: e, className: t = "", children: n }) => {
  const r = ae.Children.toArray(n), i = r.find(
    (l) => typeof l == "string" || ae.isValidElement(l) && l.type !== zr
  ), o = r.find(
    (l) => ae.isValidElement(l) && l.type === zr
  ), a = r.filter((l) => ae.isValidElement(l) && l.type === Au);
  return /* @__PURE__ */ c(
    q5,
    {
      icon: e,
      name: typeof i == "string" ? i : "",
      description: o ? o.props.children : void 0,
      className: t,
      suffix: /* @__PURE__ */ c(Lu, {}),
      children: a
    }
  );
}, V4 = ({ children: e, className: t = "" }) => /* @__PURE__ */ c("div", { className: t, children: e }), H4 = ({
  trigger: e,
  open: t,
  onOpenChange: n,
  placement: r = "bottom-end",
  className: i,
  offset: o = [0, 8],
  mobileMode: a = "drawer",
  children: s
}) => /* @__PURE__ */ c(
  $a,
  {
    trigger: e || /* @__PURE__ */ c(
      "button",
      {
        className: "flex h-10 w-10 items-center justify-center rounded-lg text-accent-secondary transition-colors hover:bg-accent-primary/10",
        "aria-label": "Settings menu",
        children: /* @__PURE__ */ c(S4, {})
      }
    ),
    open: t,
    onOpenChange: n,
    placement: r,
    className: H("relative", i),
    offset: o,
    mobileMode: a,
    children: s
  }
), rt = H4;
rt.Title = k4;
rt.Group = O4;
rt.Item = Au;
rt.SubMenu = T4;
rt.Description = zr;
rt.CustomContent = V4;
rt.Spacer = E4;
const Eu = "https://babylonlabs.io/terms-of-use", Su = "https://babylonlabs.io/privacy-policy", R4 = [
  { label: "Terms of Use", url: Eu },
  { label: "Privacy Policy", url: Su }
], p7 = ({
  theme: e,
  setTheme: t,
  trigger: n,
  open: r,
  onOpenChange: i,
  mobileMode: o = "drawer"
}) => {
  const [a, s] = ie(
    e || "system"
  ), u = Gt() && o === "popover", d = bc();
  te(() => {
    e && s(e);
  }, [e]);
  const f = a === "light", h = (w) => {
    const m = w ? "light" : "dark";
    s(m), t(m);
  }, p = (w) => {
    if (d) {
      window.location.assign(w);
      return;
    }
    window.open(w, "_blank", "noopener,noreferrer");
  }, b = () => p(Eu), g = () => p(Su), v = () => f ? "Light mode" : "Dark mode";
  return u ? /* @__PURE__ */ c(rt, { trigger: n, open: r, onOpenChange: i, mobileMode: o, children: /* @__PURE__ */ x("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ x("div", { className: "flex w-[220px] items-center gap-4", children: [
      /* @__PURE__ */ c("div", { className: "flex size-10 shrink-0 items-center justify-center text-accent-primary", children: /* @__PURE__ */ c(t6, { size: 24 }) }),
      /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-1 items-center gap-2", children: [
        /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-1 flex-col", children: [
          /* @__PURE__ */ c("span", { className: "text-sm leading-[1.43] tracking-[0.17px] text-accent-secondary", children: "Theme" }),
          /* @__PURE__ */ c("span", { className: "text-xs leading-[1.66] tracking-0.4 text-accent-primary", children: v() })
        ] }),
        /* @__PURE__ */ c(_a, { value: f, onChange: h, "aria-label": "Theme" })
      ] })
    ] }),
    /* @__PURE__ */ c("hr", { className: "w-full border-secondary-strokeLight" }),
    R4.map(({ label: w, url: m }) => /* @__PURE__ */ x(
      "a",
      {
        href: m,
        target: d ? void 0 : "_blank",
        rel: "noopener noreferrer",
        className: "relative flex w-[220px] items-center justify-between text-sm leading-[1.43] tracking-[0.17px] text-accent-primary before:absolute before:-inset-y-2 before:inset-x-0",
        children: [
          w,
          /* @__PURE__ */ c(r6, { size: 24 })
        ]
      },
      m
    ))
  ] }) }) : /* @__PURE__ */ x(rt, { trigger: n, open: r, onOpenChange: i, mobileMode: o, children: [
    /* @__PURE__ */ c(rt.Title, { children: "Settings" }),
    /* @__PURE__ */ c(rt.Group, { background: "secondary", children: /* @__PURE__ */ x(
      rt.Item,
      {
        icon: /* @__PURE__ */ c(f0, {}),
        toggle: {
          value: f,
          onChange: h
        },
        children: [
          "Theme",
          /* @__PURE__ */ c(rt.Description, { children: v() })
        ]
      }
    ) }),
    /* @__PURE__ */ x(rt.Group, { children: [
      /* @__PURE__ */ c(rt.Item, { onClick: b, children: "Terms of Use" }),
      /* @__PURE__ */ c(rt.Item, { onClick: g, children: "Privacy Policy" })
    ] })
  ] });
};
function ku(e) {
  return typeof e == "number" ? e : parseFloat(e);
}
function Ql(e) {
  const t = ku(e);
  return !Number.isFinite(t) || t === 0 ? "" : t.toLocaleString("en-US", {
    maximumFractionDigits: 20,
    useGrouping: !1
  });
}
function m7({
  amount: e,
  currencyIcon: t,
  currencyName: n,
  currencySlot: r,
  onAmountChange: i,
  sliderValue: o,
  sliderMin: a,
  sliderMax: s,
  sliderStep: l = 1,
  sliderSteps: u,
  sliderSnapToSteps: d,
  onSliderChange: f,
  onSliderStepsChange: h,
  sliderVariant: p = "primary",
  sliderActiveColor: b,
  sliderBackgroundColor: g,
  sliderDisabled: v = !1,
  leftField: w,
  rightField: m,
  onMaxClick: N,
  maxPosition: C = "left",
  maxButtonClassName: M,
  disabled: y = !1,
  readOnly: L = !1,
  className: T,
  inputClassName: S
}) {
  var U;
  const [R, V] = ie(() => Ql(e));
  te(() => {
    const D = ku(e), z = parseFloat(R);
    Number.isFinite(z) && z === D || !Number.isFinite(z) && !Number.isFinite(D) || V(Ql(e));
  }, [e]);
  const A = (D) => {
    (D.key === "ArrowUp" || D.key === "ArrowDown") && D.preventDefault();
  }, E = (D) => {
    const z = tu(D.target.value);
    if (z === void 0) {
      D.target.value = R;
      return;
    }
    V(z), D.target.value = z, i == null || i(D);
  }, P = g || (b ? `color-mix(in srgb, ${b} 20%, white)` : void 0);
  return /* @__PURE__ */ x("div", { className: H("flex w-full flex-col gap-4", T), children: [
    /* @__PURE__ */ x("div", { className: "flex w-full items-center justify-between gap-2", children: [
      r ?? /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ c("img", { src: t, alt: n, className: "h-10 w-10" }),
        /* @__PURE__ */ c("span", { className: "whitespace-nowrap text-lg text-accent-primary", children: n })
      ] }),
      /* @__PURE__ */ c(
        "input",
        {
          type: "text",
          inputMode: "decimal",
          value: R,
          onChange: E,
          onKeyDown: A,
          disabled: y,
          readOnly: L || !i,
          placeholder: "0",
          className: ee(
            "w-2/3 bg-transparent text-right text-lg text-accent-primary outline-none",
            S
          )
        }
      )
    ] }),
    /* @__PURE__ */ c(
      "div",
      {
        className: H(
          P && "[&_.bbn-slider]:[--slider-inactive-color:var(--slider-bg-color)] dark:[&_.bbn-slider]:[--slider-inactive-color:#5a5a5a]"
        ),
        style: P ? { "--slider-bg-color": P } : void 0,
        children: /* @__PURE__ */ c(
          of,
          {
            value: o,
            min: a,
            max: s,
            step: l,
            steps: u,
            snapToSteps: d,
            onChange: f,
            onStepsChange: h,
            variant: p,
            activeColor: b,
            disabled: y || v
          }
        )
      }
    ),
    /* @__PURE__ */ x("div", { className: "flex flex-wrap items-center justify-between gap-x-4 gap-y-2 text-sm", children: [
      w && /* @__PURE__ */ x("div", { className: "flex min-w-0 items-center gap-2", children: [
        N && C === "left" && ((U = w.label) == null ? void 0 : U.toLowerCase()) === "max" ? /* @__PURE__ */ x(
          "button",
          {
            type: "button",
            onClick: N,
            disabled: y,
            className: "flex min-w-0 items-center gap-2 text-left text-accent-secondary transition-colors hover:text-accent-primary disabled:cursor-not-allowed disabled:opacity-50",
            children: [
              /* @__PURE__ */ c(
                "span",
                {
                  className: ee(
                    "cursor-pointer rounded-[8px] bg-transparent px-2 py-0.5 text-xs tracking-[0.4px] hover:opacity-90 dark:bg-primary-contrast [@media(pointer:coarse)]:flex [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:items-center [@media(pointer:coarse)]:px-3",
                    M
                  ),
                  children: "Max"
                }
              ),
              /* @__PURE__ */ c("span", { className: "min-w-0 break-words", children: w.value })
            ]
          }
        ) : /* @__PURE__ */ x("span", { className: "min-w-0 break-words text-accent-secondary", children: [
          w.label && `${w.label}: `,
          w.value
        ] }),
        w.tooltip && /* @__PURE__ */ c(kr, { tooltip: w.tooltip })
      ] }),
      m && /* @__PURE__ */ x("div", { className: "ml-auto flex min-w-0 items-center gap-2 text-accent-secondary", children: [
        /* @__PURE__ */ x("span", { className: "min-w-0 break-words", children: [
          m.label && `${m.label}: `,
          m.value
        ] }),
        m.tooltip && /* @__PURE__ */ c(kr, { tooltip: m.tooltip }),
        N && C === "right" && /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            onClick: N,
            disabled: y,
            className: "flex items-center gap-2 transition-colors hover:text-accent-primary disabled:cursor-not-allowed disabled:opacity-50",
            children: /* @__PURE__ */ c(
              "span",
              {
                className: ee(
                  "cursor-pointer rounded-[8px] bg-transparent px-2 py-0.5 text-xs tracking-[0.4px] hover:opacity-90 dark:bg-primary-contrast [@media(pointer:coarse)]:flex [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:items-center [@media(pointer:coarse)]:px-3",
                  M
                ),
                children: "Max"
              }
            )
          }
        )
      ] })
    ] })
  ] });
}
const D4 = {
  card: {
    container: "bg-[#F9F9F9] dark:bg-[#2F2F2F] rounded-[4px] p-3 flex-1 md:p-4",
    header: "gap-2.5 mb-2 md:mb-3",
    icon: "w-8 h-8 md:w-10 md:h-10",
    addressRow: "gap-1",
    copyButton: "p-1 rounded hover:bg-[#d7e1e7] dark:hover:bg-[#252525] transition-colors h-6 w-6 hover:opacity-80"
  },
  row: {
    container: "",
    header: "gap-4",
    icon: "",
    addressRow: "gap-1.5 min-h-6",
    copyButton: "h-6 hover:opacity-80"
  }
}, P4 = (e) => /wallet$/i.test(e) ? e : `${e} Wallet`, Ho = ({
  layout: e = "card",
  walletType: t,
  walletName: n,
  walletIcon: r,
  walletIconBackground: i,
  address: o,
  isCopied: a,
  onCopy: s,
  className: l,
  onDisconnect: u,
  disconnectLabel: d,
  balances: f,
  coinSymbol: h,
  isBalanceLoading: p = !1,
  hasUnconfirmedTransactions: b = !1,
  formatBalance: g
}) => {
  const w = g || ((T) => h ? `${T.toLocaleString(void 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8
  })} ${h}` : T.toString()), m = (T, S = !1) => p || S ? /* @__PURE__ */ c(Na, { size: 20, className: "text-accent-primary" }) : T === void 0 ? /* @__PURE__ */ c(Q, { className: "text-accent-secondary text-sm", children: "N/A" }) : /* @__PURE__ */ c(Q, { variant: "body1", className: "text-accent-primary !text-sm", children: w(T) }), N = () => /* @__PURE__ */ x(He, { children: [
    (f == null ? void 0 : f.staked) !== void 0 && /* @__PURE__ */ x("div", { className: "flex flex-col mb-1", children: [
      /* @__PURE__ */ c(
        Q,
        {
          variant: "body1",
          className: "text-accent-secondary font-medium !text-xs",
          children: "Staked Balance"
        }
      ),
      /* @__PURE__ */ c("div", { "data-testid": "staked-balance", children: m(f.staked) })
    ] }),
    (f == null ? void 0 : f.stakable) !== void 0 && /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ c(
        Q,
        {
          variant: "body1",
          className: "text-accent-secondary font-medium !text-xs",
          children: "Stakable Balance"
        }
      ),
      /* @__PURE__ */ c("div", { className: "flex items-center gap-2", "data-testid": "stakable-balance", children: m(f.stakable, p || b) })
    ] })
  ] }), C = () => /* @__PURE__ */ c(He, { children: (f == null ? void 0 : f.available) !== void 0 && /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ c(
      Q,
      {
        variant: "body1",
        className: "text-accent-secondary font-medium !text-xs",
        children: "Balance"
      }
    ),
    /* @__PURE__ */ c("div", { "data-testid": "babylon-balance", children: m(f.available) })
  ] }) }), M = () => /* @__PURE__ */ c(He, { children: (f == null ? void 0 : f.available) !== void 0 && /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ c(
      Q,
      {
        variant: "body1",
        className: "text-accent-secondary font-medium !text-xs",
        children: "Balance"
      }
    ),
    /* @__PURE__ */ c("div", { "data-testid": "ethereum-balance", children: m(f.available) })
  ] }) }), y = D4[e], L = e === "row";
  return /* @__PURE__ */ c("div", { className: H(y.container, l), children: /* @__PURE__ */ x("div", { className: "flex flex-col w-full", children: [
    /* @__PURE__ */ x("div", { className: H("flex items-center", y.header), children: [
      /* @__PURE__ */ c(
        qu,
        {
          alt: n || t,
          url: r || "",
          background: i,
          className: H(y.icon, "flex-shrink-0")
        }
      ),
      /* @__PURE__ */ x("div", { className: "flex flex-1 flex-col items-start min-w-0", children: [
        L ? /* @__PURE__ */ c(Q, { variant: "caption", className: "text-accent-primary leading-[1.66]", children: n ? P4(n) : `${t} Wallet` }) : /* @__PURE__ */ x(
          Q,
          {
            variant: "body1",
            className: "text-accent-primary font-medium text-xs",
            children: [
              t,
              " Wallet"
            ]
          }
        ),
        /* @__PURE__ */ x("div", { className: H("flex items-center", y.addressRow), children: [
          a ? /* @__PURE__ */ c(Q, { className: H("text-accent-secondary text-xs", L && "tracking-0.4 leading-[1.66]"), children: "Copied ✓" }) : /* @__PURE__ */ c(
            nu,
            {
              className: H("text-accent-secondary text-xs", L && "leading-[1.66]"),
              size: L ? "caption" : void 0,
              value: o,
              symbols: L ? 5 : 6
            }
          ),
          /* @__PURE__ */ c(
            "button",
            {
              onClick: s,
              "aria-label": `Copy ${t} wallet address`,
              className: H(
                "relative flex flex-shrink-0 items-center justify-center before:absolute before:left-1/2 before:top-1/2 before:size-10 before:-translate-x-1/2 before:-translate-y-1/2",
                y.copyButton
              ),
              children: L ? /* @__PURE__ */ c(Er, { size: 10, variant: "secondary" }) : /* @__PURE__ */ c(Er, { size: 14, className: "md:w-4 md:h-4" })
            }
          )
        ] })
      ] }),
      u && /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          onClick: u,
          "aria-label": d ?? `Disconnect ${t} wallet`,
          className: "flex-shrink-0 self-start text-xs font-medium text-error-main transition-opacity hover:opacity-80",
          children: "Disconnect"
        }
      )
    ] }),
    f && h && /* @__PURE__ */ x("div", { className: "space-y-2", children: [
      t === "Bitcoin" && N(),
      t === "Babylon" && C(),
      t === "Ethereum" && M()
    ] })
  ] }) });
}, Ya = ({
  trigger: e,
  btcAddress: t,
  bbnAddress: n,
  ethAddress: r,
  selectedWallets: i,
  onDisconnect: o,
  perChainDisconnect: a = !1,
  connectAction: s,
  forceOpen: l = !1,
  onOpenChange: u,
  btcBalances: d,
  bbnBalances: f,
  ethBalances: h,
  btcCoinSymbol: p,
  bbnCoinSymbol: b,
  ethCoinSymbol: g,
  balancesLoading: v = !1,
  hasUnconfirmedTransactions: w = !1,
  formatBalance: m,
  settingsSection: N,
  className: C,
  mobileMode: M = "dialog",
  copy: y
}) => {
  var he, X, re, $, oe, pe, Le, Ie, Be;
  const { copyToClipboard: L, isCopied: T } = qi({ timeout: y == null ? void 0 : y.timeout }), S = (y == null ? void 0 : y.isCopied) ?? T, R = (y == null ? void 0 : y.copyToClipboard) ?? L, [V, A] = ie(l), P = Gt() && M === "popover", U = P ? "row" : "card", z = [t, n, r].filter(Boolean).length === 1 ? "Disconnect Wallet" : "Disconnect Wallets", I = we((me) => {
    A(me), u == null || u(me);
  }, [u]), Y = we(() => {
    A(!1), o();
  }, [o]), Z = we(
    (me) => () => {
      A(!1), o(me);
    },
    [o]
  ), ne = we(() => {
    A(!1), s == null || s.onClick();
  }, [s]), fe = (me) => {
    if (!(!m || !me))
      return (Ae) => m(Ae, me);
  }, Me = p || "BTC", Ce = b || "BABY", ke = g || "ETH";
  return /* @__PURE__ */ c(
    $a,
    {
      trigger: e,
      open: V,
      onOpenChange: I,
      mobileMode: M,
      className: H(
        P ? "w-[253px]" : "shadow-lg border border-[#38708533] bg-surface dark:border-[#404040] rounded-lg",
        C
      ),
      children: /* @__PURE__ */ x("div", { className: H("w-full text-primary-main", P ? "flex flex-col gap-4" : "p-4 space-y-6"), children: [
        /* @__PURE__ */ x("div", { className: H("flex w-full", P ? "flex-col gap-4" : "flex-row gap-2 md:flex-col"), children: [
          t && /* @__PURE__ */ c(
            Ho,
            {
              layout: U,
              walletType: "Bitcoin",
              walletName: (he = i.BTC) == null ? void 0 : he.name,
              walletIcon: (X = i.BTC) == null ? void 0 : X.icon,
              walletIconBackground: (re = i.BTC) == null ? void 0 : re.iconBackground,
              address: t,
              isCopied: S("btc"),
              onCopy: () => R("btc", t),
              balances: d,
              coinSymbol: Me,
              isBalanceLoading: v,
              hasUnconfirmedTransactions: w,
              formatBalance: fe(Me),
              onDisconnect: a ? Z("BTC") : void 0
            }
          ),
          n && /* @__PURE__ */ c(
            Ho,
            {
              layout: U,
              walletType: "Babylon",
              walletName: ($ = i.BBN) == null ? void 0 : $.name,
              walletIcon: (oe = i.BBN) == null ? void 0 : oe.icon,
              walletIconBackground: (pe = i.BBN) == null ? void 0 : pe.iconBackground,
              address: n,
              isCopied: S("bbn"),
              onCopy: () => R("bbn", n),
              balances: f,
              coinSymbol: Ce,
              isBalanceLoading: v,
              formatBalance: fe(Ce),
              onDisconnect: a ? Z("BBN") : void 0
            }
          ),
          r && /* @__PURE__ */ c(
            Ho,
            {
              layout: U,
              walletType: "Ethereum",
              walletName: (Le = i.ETH) == null ? void 0 : Le.name,
              walletIcon: (Ie = i.ETH) == null ? void 0 : Ie.icon,
              walletIconBackground: (Be = i.ETH) == null ? void 0 : Be.iconBackground,
              address: r,
              isCopied: S("eth"),
              onCopy: () => R("eth", r),
              balances: h,
              coinSymbol: ke,
              isBalanceLoading: v,
              formatBalance: fe(ke),
              onDisconnect: a ? Z("ETH") : void 0
            }
          )
        ] }),
        s && /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            onClick: ne,
            "data-testid": s["data-testid"],
            className: "flex w-full items-center justify-center rounded-[4px] bg-[#F9F9F9] p-3 text-sm font-medium text-accent-primary transition-opacity hover:opacity-80 dark:bg-[#2F2F2F] md:p-4",
            children: s.label
          }
        ),
        N,
        /* @__PURE__ */ c("div", { className: P ? void 0 : "pt-2", children: /* @__PURE__ */ c(
          nc,
          {
            onClick: Y,
            fluid: !0,
            className: P ? "rounded-lg !bg-error-dark hover:!bg-error-dark/90 font-normal tracking-[0.17px]" : void 0,
            children: z
          }
        ) })
      ] })
    }
  );
}, oa = ({
  icon: e,
  title: t,
  status: n,
  value: r,
  onChange: i,
  className: o,
  tooltip: a,
  infoIcon: s
}) => /* @__PURE__ */ x("div", { className: H(
  "flex items-center justify-between w-full p-3 md:p-0 md:mb-0",
  o
), children: [
  /* @__PURE__ */ x("div", { className: "flex items-center gap-4", children: [
    e,
    /* @__PURE__ */ x("div", { className: "flex flex-col", children: [
      s && a ? /* @__PURE__ */ x(
        Q,
        {
          as: "span",
          variant: "body2",
          className: "text-accent-primary font-medium",
          children: [
            t,
            /* @__PURE__ */ c(
              kr,
              {
                tooltip: a,
                placement: "bottom",
                attachToChildren: !0,
                offset: [20, 8],
                children: /* @__PURE__ */ c("span", { className: "inline-block align-middle text-accent-secondary cursor-pointer ml-1", children: s })
              }
            )
          ]
        }
      ) : /* @__PURE__ */ c(
        kr,
        {
          tooltip: a,
          attachToChildren: !!a,
          placement: "bottom",
          children: /* @__PURE__ */ c(
            Q,
            {
              as: "span",
              variant: "body2",
              className: "text-accent-primary font-medium",
              children: t
            }
          )
        }
      ),
      /* @__PURE__ */ c(Q, { className: "text-accent-secondary !text-xs", children: n })
    ] })
  ] }),
  /* @__PURE__ */ c(
    _a,
    {
      value: r,
      onChange: i
    }
  )
] }), Ou = ({
  title: e,
  value: t,
  isCopied: n,
  onCopy: r,
  className: i,
  icon: o
}) => /* @__PURE__ */ c("div", { className: H(
  "flex items-center justify-between w-full p-3 md:p-0 md:mb-0",
  i
), children: /* @__PURE__ */ c("div", { className: "flex flex-col w-full", children: /* @__PURE__ */ x("div", { className: "flex items-center gap-4", children: [
  o && /* @__PURE__ */ c("div", { className: "flex-shrink-0", children: o }),
  /* @__PURE__ */ x("div", { className: "flex w-full", children: [
    /* @__PURE__ */ x("div", { className: "flex flex-col w-full", children: [
      /* @__PURE__ */ c(
        Q,
        {
          variant: "body2",
          className: "text-accent-primary font-medium text-sm",
          children: e
        }
      ),
      /* @__PURE__ */ c("div", { className: "flex items-center justify-between w-full", children: /* @__PURE__ */ c("div", { className: "flex-1 min-w-0", children: n ? /* @__PURE__ */ c(Q, { className: "text-accent-secondary !text-xs truncate whitespace-nowrap", children: "Copied ✓" }) : /* @__PURE__ */ c(
        nu,
        {
          className: "text-accent-secondary !text-xs",
          value: t,
          symbols: 6
        }
      ) }) })
    ] }),
    /* @__PURE__ */ c(
      "button",
      {
        onClick: r,
        className: "flex-shrink-0 ml-3 p-1 rounded hover:bg-surface-tertiary transition-colors h-6 w-6 flex items-center justify-center hover:opacity-80 self-center",
        children: /* @__PURE__ */ c(Er, { size: 16 })
      }
    )
  ] })
] }) }) }), g7 = ({
  ordinalsExcluded: e,
  onIncludeOrdinals: t,
  onExcludeOrdinals: n,
  publicKeyNoCoord: r,
  showInscriptionsToggle: i = !0,
  copy: o,
  ...a
}) => {
  const { copyToClipboard: s, isCopied: l } = qi({ timeout: o == null ? void 0 : o.timeout }), u = (o == null ? void 0 : o.isCopied) ?? l, d = (o == null ? void 0 : o.copyToClipboard) ?? s, f = /* @__PURE__ */ x("div", { className: "flex w-full flex-col rounded-lg bg-neutral-100 md:gap-8 md:border-none md:bg-transparent", children: [
    i && /* @__PURE__ */ c(
      oa,
      {
        icon: /* @__PURE__ */ c(Nr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ c(lc, {}) }),
        title: "Using Inscriptions",
        status: e ? "Off" : "On",
        value: !e,
        onChange: (h) => h ? t() : n()
      }
    ),
    /* @__PURE__ */ c(
      Ou,
      {
        title: "Bitcoin Public Key",
        value: r,
        isCopied: u("publicKey"),
        onCopy: () => d("publicKey", r),
        icon: /* @__PURE__ */ c(Nr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ c(sc, {}) }),
        className: i ? "rounded-b-lg rounded-t-none md:rounded-none" : "rounded-lg md:rounded-none"
      }
    )
  ] });
  return /* @__PURE__ */ c(Ya, { ...a, copy: o, settingsSection: f });
}, v7 = ({
  ordinalsExcluded: e,
  onIncludeOrdinals: t,
  onExcludeOrdinals: n,
  linkedDelegationsVisibility: r,
  onDisplayLinkedDelegations: i,
  publicKeyNoCoord: o,
  copy: a,
  ...s
}) => {
  const { copyToClipboard: l, isCopied: u } = qi({ timeout: a == null ? void 0 : a.timeout }), d = (a == null ? void 0 : a.isCopied) ?? u, f = (a == null ? void 0 : a.copyToClipboard) ?? l, h = /* @__PURE__ */ x("div", { className: "flex flex-col w-full bg-neutral-100 rounded-lg md:bg-transparent md:border-none md:gap-8", children: [
    /* @__PURE__ */ c(
      oa,
      {
        icon: /* @__PURE__ */ c(Nr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ c(lc, {}) }),
        title: "Using Inscriptions",
        status: e ? "Off" : "On",
        value: !e,
        onChange: (p) => p ? t() : n()
      }
    ),
    /* @__PURE__ */ c(
      oa,
      {
        icon: /* @__PURE__ */ c(Nr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ c(l0, {}) }),
        title: /* @__PURE__ */ x(He, { children: [
          "Linked Wallet",
          /* @__PURE__ */ c("br", { className: "hidden md:block" }),
          /* @__PURE__ */ c("span", { className: "md:hidden", children: " " }),
          "Stakes"
        ] }),
        status: r ? "On" : "Off",
        value: r,
        onChange: i,
        tooltip: "Linked Wallet Stakes show all stakes created with the same Bitcoin wallet, even if different BABY wallets were used. It helps you track and manage them in one place.",
        infoIcon: /* @__PURE__ */ c(mn, { size: 14, variant: "secondary" })
      }
    ),
    /* @__PURE__ */ c(
      Ou,
      {
        title: "Bitcoin Public Key",
        value: o,
        isCopied: d("publicKey"),
        onCopy: () => f("publicKey", o),
        icon: /* @__PURE__ */ c(Nr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ c(sc, {}) }),
        className: "rounded-b-lg rounded-t-none md:rounded-none"
      }
    )
  ] });
  return /* @__PURE__ */ c(
    Ya,
    {
      ...s,
      copy: a,
      settingsSection: h
    }
  );
}, b7 = (e) => /* @__PURE__ */ c(Ya, { ...e, settingsSection: null });
function I4({ className: e, ...t }) {
  const r = Gt(Xi) ? yn : Zr;
  return /* @__PURE__ */ c(r, { ...t, className: ee("w-[41.25rem] max-w-full", e) });
}
const y7 = ({
  open: e,
  onClose: t,
  title: n = "Unbonding",
  description: r,
  reward: i,
  amountUsd: o = "",
  onChange: a = () => {
  },
  onKeyDown: s = () => {
  },
  disabled: l = !1,
  warningText: u,
  actionButtonText: d = "Unbond",
  onActionClick: f
}) => /* @__PURE__ */ x(I4, { open: e, onClose: t, children: [
  /* @__PURE__ */ c(Xr, { title: n, onClose: t, className: "text-accent-primary" }),
  /* @__PURE__ */ x(
    ur,
    {
      style: { maxHeight: u4 },
      className: "no-scrollbar mt-4 flex flex-col gap-6 overflow-y-auto text-accent-primary",
      children: [
        r && /* @__PURE__ */ c("div", { children: /* @__PURE__ */ c(Q, { variant: "body2", className: "text-accent-secondary whitespace-pre-line", children: r }) }),
        /* @__PURE__ */ c(wn, { className: "flex w-full flex-col content-center justify-between gap-4", children: /* @__PURE__ */ c(
          ja,
          {
            amount: i.amount,
            currencyIcon: i.currencyIcon,
            currencyName: i.currencyName,
            placeholder: i.placeholder ?? "Enter Amount",
            displayBalance: i.displayBalance,
            balanceDetails: i.balanceDetails,
            autoFocus: !1,
            onChange: a,
            onKeyDown: s,
            amountUsd: o,
            disabled: l,
            subtitle: `Staked: ${i.stakedAmount || 0} ${i.stakedTokenName || i.currencyName}`
          }
        ) }),
        u && /* @__PURE__ */ c(g6, { children: u })
      ]
    }
  ),
  d && /* @__PURE__ */ c(dr, { className: "flex justify-end mt-[80px]", children: /* @__PURE__ */ c(
    ze,
    {
      onClick: f,
      children: d
    }
  ) })
] });
export {
  q4 as Accordion,
  W4 as AccordionDetails,
  U4 as AccordionSummary,
  u7 as ActivityCard,
  N4 as ActivityCardActionSection,
  _4 as ActivityCardAmountSection,
  L4 as ActivityCardDetailsSection,
  t8 as ActivityIcon,
  M4 as ActivityListItem,
  ja as AmountItem,
  m7 as AmountSlider,
  a7 as AmountSubsection,
  p8 as AttributeList,
  on as Avatar,
  zu as AvatarGroup,
  y4 as BBNFeeAmount,
  c4 as BBN_DECIMAL_PLACES,
  b4 as BTCFeeAmount,
  v4 as BTCFeeRate,
  Ga as BTC_DECIMAL_PLACES,
  b7 as BabyWalletMenu,
  R5 as Badge,
  H8 as Banner,
  sc as BitcoinPublicKeyIcon,
  v7 as BtcBabyWalletMenu,
  g7 as BtcEthWalletMenu,
  Y4 as BugReportIcon,
  ze as Button,
  k8 as Callout,
  tf as Card,
  X2 as Cell,
  uc as CheckIcon,
  Xu as Checkbox,
  n7 as CheckboxField,
  d0 as ChevronLeftIcon,
  G4 as ChevronRightIcon,
  m8 as Chip,
  g8 as ChipButton,
  Fn as CloseIcon,
  So as CoStakingAmountItem,
  h7 as CoStakingRewardsSubsection,
  c0 as CollapseIcon,
  U2 as Column,
  P8 as ConfirmationDialog,
  Z8 as ConnectButton,
  iu as Container,
  zc as Copy,
  Er as CopyIcon,
  d8 as CoreUIProvider,
  D5 as CounterButton,
  P6 as DEFAULT_SOCIAL_LINKS,
  Zr as Dialog,
  ur as DialogBody,
  dr as DialogFooter,
  Xr as DialogHeader,
  l8 as DiscordIcon,
  T8 as DismissibleSubSection,
  nu as DisplayHash,
  r8 as ExploreIcon,
  Fr as FeeItem,
  l7 as FeesSection,
  K4 as FilterIcon,
  au as FinalityProviderItem,
  Fl as FinalityProviderLogo,
  s7 as FinalityProviderSubsection,
  j8 as Footer,
  J8 as Form,
  ji as FormControl,
  h8 as FullScreenDialog,
  i8 as GithubIcon,
  z8 as Header,
  qr as Heading,
  s4 as HiddenField,
  kr as Hint,
  B8 as Icon,
  sa as IconButton,
  mn as InfoIcon,
  zi as Input,
  v8 as KeyValueList,
  x8 as LineChart,
  l0 as LinkWalletIcon,
  a8 as LinkedinIcon,
  n8 as LiquidationsIcon,
  C8 as List,
  T5 as ListItem,
  Na as Loader,
  e8 as LoansIcon,
  u8 as LockIcon,
  M6 as Logo,
  _6 as LogoMark,
  u4 as MAX_WINDOW_HEIGHT,
  s8 as MailIcon,
  Y8 as MarketStatCard,
  $a as Menu,
  W1 as MenuDrawer,
  X1 as MenuItem,
  yn as MobileDialog,
  L6 as MobileLogo,
  A6 as MobileNavOverlay,
  $8 as Nav,
  F8 as NavItem,
  O8 as Notification,
  l6 as NotificationActionButton,
  e7 as NumberField,
  u0 as OpenIcon,
  J4 as OverviewIcon,
  is as PauseIcon,
  ei as Popover,
  Ur as Portal,
  c7 as PreviewModal,
  I8 as ProgressDialog,
  X4 as ProviderAvatar,
  K8 as ProviderCard,
  Yu as Radio,
  r7 as RadioField,
  mc as ResponsiveDialog,
  d7 as RewardsPreviewModal,
  f7 as RewardsSubsection,
  f8 as ScrollLocker,
  b8 as SeizureMap,
  wa as Select,
  i7 as SelectField,
  z2 as SelectWithIcon,
  rt as SettingMenu,
  V4 as SettingMenuCustomContent,
  zr as SettingMenuDescription,
  O4 as SettingMenuGroup,
  Au as SettingMenuItem,
  T4 as SettingMenuSubMenu,
  k4 as SettingMenuTitle,
  q8 as Sidebar,
  W8 as SidebarBrandLockup,
  U8 as SidebarItem,
  of as Slider,
  ou as SmallLogo,
  p7 as StandardSettingsMenu,
  N8 as StatItem,
  X8 as StatusBadge,
  D8 as Step,
  N6 as Stepper,
  q5 as SubMenu,
  _8 as SubMenuItem,
  wn as SubSection,
  W2 as TABLE_STYLE_PRESETS,
  ef as Table,
  l4 as TableElement,
  M8 as Tabs,
  o8 as TelegramIcon,
  R8 as TestingBanner,
  Q as Text,
  t7 as TextField,
  f0 as ThemeIcon,
  Nr as ThemedIcon,
  h0 as ThreeDotsMenuIcon,
  y8 as Timeline,
  _a as Toggle,
  V8 as TopBanner,
  x4 as Total,
  y7 as UnbondingModal,
  lc as UsingInscriptionIcon,
  Z4 as ValidatorAvatar,
  o7 as ValidatorSelector,
  G8 as VaultDetailCard,
  Q4 as VaultsIcon,
  Xi as WINDOW_BREAKPOINT,
  nc as WalletDisconnectButton,
  qu as WalletIcon,
  Ya as WalletMenu,
  Ho as WalletMenuCard,
  Ou as WalletMenuInfoItem,
  oa as WalletMenuSettingItem,
  g6 as Warning,
  cc as WarningIcon,
  c8 as XIcon,
  eu as calculateTokenValueInCurrency,
  A8 as createBalanceFormatter,
  E8 as formatAmount,
  Y5 as formatCurrency,
  Je as iconColorVariants,
  v0 as isTouchFirstNow,
  Dl as maxDecimals,
  S8 as parseAmount,
  tu as sanitizeNumericInput,
  B6 as splitAmountUnit,
  Gh as timelineMinPlotHeight,
  L8 as toKebabCase,
  la as toPixels,
  jc as trim,
  $2 as useClickOutside,
  zt as useControlledState,
  qi as useCopy,
  fc as useCoreUI,
  H5 as useDrawerAnimation,
  vr as useField,
  Q8 as useFieldState,
  gr as useFormContext,
  mu as useFormState,
  q2 as useFrozenColumns,
  Gt as useIsMobile,
  bc as useIsTouchFirst,
  B2 as useMemoizedArray,
  U1 as useMenuContext,
  Wr as useModalManager,
  w8 as useReducedMotion,
  $c as useResizeObserver,
  j2 as useTableScroll,
  Z2 as useTableSort,
  vu as useWatch
};
//# sourceMappingURL=index.es.js.map
